//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.19.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import {mergeMap as _observableMergeMap, catchError as _observableCatch, mergeMap, switchMap} from "rxjs/operators";
import {
  Observable,
  throwError as _observableThrow,
  of as _observableOf,
  catchError,
  throwError,
  map
} from 'rxjs';
import {Injectable, Inject, Optional, InjectionToken} from '@angular/core';
import {HttpClient, HttpErrorResponse, HttpHeaders, HttpResponse, HttpResponseBase} from "@angular/common/http";
import {LoonStaat, Werkgever, Werknemer, LoonAangifteDto, MemoriaalBoeking} from './api.bokkz.salaris';
import {Bezwaarschrift} from "./api.bokkz.bezwaar";
import {MumaEntity} from "./api.bokkz.muma";

export const BOKKZ_BASE_URL = new InjectionToken<string>('BOKKZ_BASE_URL');
export const BOKKZ_SERVICE_URL = new InjectionToken<string>('BOKKZ_SERVICE_URL');


@Injectable({
  providedIn: 'root'
})
export class BokkzClient {
  private http: HttpClient;
  private baseUrl: string;
  private serviceUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient,
              @Optional() @Inject(BOKKZ_BASE_URL) baseUrl?: string,
              @Optional() @Inject(BOKKZ_SERVICE_URL) serviceUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    this.serviceUrl = serviceUrl !== undefined && serviceUrl !== null ? serviceUrl : "";
  }

  getStatus(): Observable<boolean> {
    let url = `${this.baseUrl}/api/v1/sst/status`;

    let options = {
      headers: new HttpHeaders({
        'Accept': 'application/json'
      }),
      observe: 'response' as 'body',
      responseType: 'json' as 'json'
    };
    return this.http.get<boolean>(url, options).pipe(
      map((response) => {
        return response;
      }),
      catchError((error: HttpErrorResponse) => {
        return this.handleStatusError(error);
      })
    );
  }

  private handleStatusError(error: HttpErrorResponse): Observable<never> {
    if (error.error instanceof ErrorEvent) {
      // Client-side error
      console.error('An error occurred:', error.error.message);
    } else {
      // Server-side error
      console.error(
        `Backend returned code ${error.status}, ` +
        `body was: ${error.error}`);
    }
    // Return an observable with a user-facing error message
    return throwError('Something bad happened; please try again later.');
  }


  /**
   * @return default response
   */
  getAdministrations(): Observable<AdminEntity[]> {
    let url_ = this.baseUrl + "/api/v1/sst/administrations";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetAdministrations(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetAdministrations(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<AdminEntity[]>;
        }
      } else
        return _observableThrow(response_) as any as Observable<AdminEntity[]>;
    }));
  }

  protected processGetAdministrations(response: HttpResponseBase): Observable<AdminEntity[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let resultdefault: any = null;
        resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AdminEntity[];
        return _observableOf(resultdefault);
      }));
    }
  }

  /**
   * @return default response
   */
  getAdministration(id: string): Observable<AdminEntity[]> {
    let url_ = this.baseUrl + "/api/v1/sst/administration/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetAdministrations_1(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetAdministrations_1(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<AdminEntity[]>;
        }
      } else
        return _observableThrow(response_) as any as Observable<AdminEntity[]>;
    }));
  }

  protected processGetAdministrations_1(response: HttpResponseBase): Observable<AdminEntity[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status !== 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          const errorText = _responseText || `Request failed with status ${status}`;
          try {
            const errorObj = JSON.parse(errorText);
            return _observableThrow(() => errorObj);
          } catch {
            return _observableThrow(() => new Error(errorText));
          }
        })
      );
    }

    return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
      let resultdefault: any = null;
      resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AdminEntity[];
      return _observableOf(resultdefault);
    }));
  }

  /**
   * @param body (optional)
   * @return default response
   */
  postAdministrations(id: string, body?: AdminEntity | undefined): Observable<AdminEntity[]> {
    let url_ = this.baseUrl + "/api/v1/sst/administrations/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Accept": "application/json"
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processPostAdministrations(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processPostAdministrations(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<AdminEntity[]>;
        }
      } else
        return _observableThrow(response_) as any as Observable<AdminEntity[]>;
    }));
  }

  protected processPostAdministrations(response: HttpResponseBase): Observable<AdminEntity[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let resultdefault: any = null;
        resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AdminEntity[];
        return _observableOf(resultdefault);
      }));
    }
  }

  /**
   * @return default response
   */
  getAllJaarstukken(taxPayerId: string): Observable<JaarrekeningEntity[]> {
    let url_ = this.baseUrl + "/api/v1/sst/jaarstukken/{taxPayerId}";
    if (taxPayerId === undefined || taxPayerId === null)
      throw new Error("The parameter 'taxPayerId' must be defined.");
    url_ = url_.replace("{taxPayerId}", encodeURIComponent("" + taxPayerId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetAllJaarstukken(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetAllJaarstukken(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<JaarrekeningEntity[]>;
        }
      } else
        return _observableThrow(response_) as any as Observable<JaarrekeningEntity[]>;
    }));
  }

  protected processGetAllJaarstukken(response: HttpResponseBase): Observable<JaarrekeningEntity[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let resultdefault: any = null;
        resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as JaarrekeningEntity[];
        return _observableOf(resultdefault);
      }));
    }
  }

  /**
   * @return default response
   */
  getAllowance(clientId: string, allowanceId: string): Observable<AllowanceEntity> {
    let url_ = this.baseUrl + "/api/v1/sst/allowance/{clientId}/{allowanceId}";
    if (clientId === undefined || clientId === null)
      throw new Error("The parameter 'clientId' must be defined.");
    if (allowanceId === undefined || allowanceId === null)
      throw new Error("The parameter 'allowanceId' must be defined.");
    url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
    url_ = url_.replace("{allowanceId}", encodeURIComponent("" + allowanceId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetAllowance(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetAllowance(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<AllowanceEntity>;
        }
      } else
        return _observableThrow(response_) as any as Observable<AllowanceEntity>;
    }));
  }

  protected processGetAllowance(response: HttpResponseBase): Observable<AllowanceEntity> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let resultdefault: any = null;
        resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AllowanceEntity;
        return _observableOf(resultdefault);
      }));
    }
  }

  /**
   * @return default response
   */
  getApproval(id: string): Observable<ApprovalEntity> {
    let url_ = this.baseUrl + "/api/v1/sst/approval/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetApproval(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetApproval(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<ApprovalEntity>;
        }
      } else
        return _observableThrow(response_) as any as Observable<ApprovalEntity>;
    }));
  }

  protected processGetApproval(response: HttpResponseBase): Observable<ApprovalEntity> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let resultdefault: any = null;
        resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApprovalEntity;
        return _observableOf(resultdefault);
      }));
    }
  }

  /**
   * @return default response
   */
  getClient(id: string): Observable<ClientEntity> {
    let url_ = this.baseUrl + "/api/v1/sst/client/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetClient(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetClient(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<ClientEntity>;
        }
      } else
        return _observableThrow(response_) as any as Observable<ClientEntity>;
    }));
  }

  protected processGetClient(response: HttpResponseBase): Observable<ClientEntity> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let resultdefault: any = null;
        resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ClientEntity;
        return _observableOf(resultdefault);
      }));
    }
  }

  /**
   * @return default response
   */
  getClientAddons(ids: string[]): Observable<ClientAddons[]> {
    let url_ = this.baseUrl + "/api/v1/sst/client/taxid";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      body: ids,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Accept": "application/json"
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetClientDuplicates(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetClientDuplicates(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<ClientAddons[]>;
        }
      } else
        return _observableThrow(response_) as any as Observable<ClientAddons[]>;
    }));
  }

  protected processGetClientDuplicates(response: HttpResponseBase): Observable<ClientAddons[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let resultdefault: any = null;
        resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ClientAddons[];
        return _observableOf(resultdefault);
      }));
    }
  }

  /**
   * @return default response
   */
  getSamenvoegResponse(request: SamenvoegRequest): Observable<Aangifte> {
    let url_ = this.serviceUrl + "/api/v1/ib/samenvoegen";
      // let url_ = "https://test.leukermakkelijker.nl/api/v1/ib/samenvoegen";

      url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      body: request,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Accept": "application/json"
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetSamenvoegResponse(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetSamenvoegResponse(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<Aangifte>;
        }
      } else
        return _observableThrow(response_) as any as Observable<Aangifte>;
    }));
  }

  protected processGetSamenvoegResponse(response: HttpResponseBase): Observable<Aangifte> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let resultdefault: any = null;
        resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Aangifte;
        return _observableOf(resultdefault);
      }));
    }
  }

  /**
   * @return default response
   */
  deleteClient(clientEntity: ClientEntity): Observable<Response> {
    if (!clientEntity || clientEntity.id == null) {
      throw new Error("The parameter 'clientEntity.id' must be defined.");
    }

    let url_ = this.baseUrl + "/api/v1/sst/client/{id}";
    url_ = url_.replace("{id}", encodeURIComponent("" + clientEntity.id));
    url_ = url_.replace(/[?&]$/, "");

    const options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("delete", url_, options_).pipe(
      _observableMergeMap((response_: any) => {
        return this.processDeleteClient(response_);
      }),
      _observableCatch((response_: any) => {
        if (response_ instanceof HttpResponseBase) {
          try {
            return this.processDeleteClient(response_ as any);
          } catch (e) {
            return _observableThrow(e) as any as Observable<Response>;
          }
        } else {
          return _observableThrow(response_) as any as Observable<Response>;
        }
      })
    );
  }

  protected processDeleteClient(response: HttpResponseBase): Observable<Response> {
    const status = response.status;
    const responseBlob = response instanceof HttpResponse ? response.body :
      (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    if (status === 200 || status === 204) {
      return _observableOf(response as any);
    } else {
      return _observableThrow(response);
    }
  }

  /**
   * @return default response
   */
  getClientsMigrated(): Observable<ClientEntity[]> {
      let url_ = this.baseUrl + "/api/v1/sst/clientsMigrated";
      url_ = url_.replace(/[?&]$/, "");

      let options_: any = {
          observe: "response",
          responseType: "blob",
          headers: new HttpHeaders({
              "Accept": "application/json"
          })
      };

      return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
          return this.processGetClients(response_);
      })).pipe(_observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
              try {
                  return this.processGetClients(response_ as any);
              } catch (e) {
                  return _observableThrow(e) as any as Observable<ClientEntity[]>;
              }
          } else
              return _observableThrow(response_) as any as Observable<ClientEntity[]>;
      }));
  }



    getClients(): Observable<ClientEntity[]> {
    let url_ = this.baseUrl + "/api/v1/sst/clients";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetClients(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetClients(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<ClientEntity[]>;
        }
      } else
        return _observableThrow(response_) as any as Observable<ClientEntity[]>;
    }));
  }

  protected processGetClients(response: HttpResponseBase): Observable<ClientEntity[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let resultdefault: any = null;
        resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ClientEntity[];
        return _observableOf(resultdefault);
      }));
    }
  }

  /**
   * @return default response
   */
  getDividendTax(clientId: string, year: string): Observable<DividendTaxEntity> {
    let url_ = this.baseUrl + "/api/v1/sst/dividendtax/{clientId}/{year}";
    if (clientId === undefined || clientId === null)
      throw new Error("The parameter 'clientId' must be defined.");
    if (year === undefined || year === null)
      throw new Error("The parameter 'year' must be defined.");
    url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
    url_ = url_.replace("{year}", encodeURIComponent("" + year));
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetDividendTax(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetDividendTax(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<DividendTaxEntity>;
        }
      } else
        return _observableThrow(response_) as any as Observable<DividendTaxEntity>;
    }));
  }

  protected processGetDividendTax(response: HttpResponseBase): Observable<DividendTaxEntity> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let resultdefault: any = null;
        resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DividendTaxEntity;
        return _observableOf(resultdefault);
      }));
    }
  }

  /**
   * @return default response
   */
  getCorporateTax(clientId: string, corporateTaxId: string): Observable<CorporateTaxEntity> {
    let url_ = this.baseUrl + "/api/v1/sst/corporatetax/{clientId}/{corporateTaxId}";
    if (clientId === undefined || clientId === null)
      throw new Error("The parameter 'clientId' must be defined.");
    if (corporateTaxId === undefined || corporateTaxId === null)
      throw new Error("The parameter 'corporateTaxId' must be defined.");
    url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
    url_ = url_.replace("{corporateTaxId}", encodeURIComponent("" + corporateTaxId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetCorporateTax(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetCorporateTax(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<CorporateTaxEntity>;
        }
      } else
        return _observableThrow(response_) as any as Observable<CorporateTaxEntity>;
    }));
  }

  protected processGetCorporateTax(response: HttpResponseBase): Observable<CorporateTaxEntity> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let resultdefault: any = null;
        resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CorporateTaxEntity;
        return _observableOf(resultdefault);
      }));
    }
  }

  /**
   * @return default response
   */
  deleteCorporateTax(clientId: string, corporateTaxId: string): Observable<CorporateTaxEntity> {
    let url_ = this.baseUrl + "/api/v1/sst/corporatetax/{clientId}/{corporateTaxId}";
    if (clientId === undefined || clientId === null)
      throw new Error("The parameter 'clientId' must be defined.");
    if (corporateTaxId === undefined || corporateTaxId === null)
      throw new Error("The parameter 'corporateTaxId' must be defined.");
    url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
    url_ = url_.replace("{corporateTaxId}", encodeURIComponent("" + corporateTaxId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processDeleteCorporateTax(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processDeleteCorporateTax(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<CorporateTaxEntity>;
        }
      } else
        return _observableThrow(response_) as any as Observable<CorporateTaxEntity>;
    }));
  }

  protected processDeleteCorporateTax(response: HttpResponseBase): Observable<CorporateTaxEntity> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let resultdefault: any = null;
        resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CorporateTaxEntity;
        return _observableOf(resultdefault);
      }));
    }
  }

  getDossierItem(clientId: string, itemId: string) {
    let url = this.baseUrl + "/api/v1/sst/dossierItem/{clientId}/{itemId}";
    if (itemId === undefined || itemId === null)
      throw new Error("The parameter 'clientId' must be defined.");
    if (clientId === undefined || clientId === null)
      throw new Error("The parameter 'itemId' must be defined.");
    url = url.replace("{itemId}", encodeURIComponent("" + itemId));
    url = url.replace("{clientId}", encodeURIComponent("" + clientId));
    url = url.replace(/[?&]$/, "");

    const options_: {
      observe: 'response';
      responseType: 'blob';
      headers: HttpHeaders;
    } = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };
    return this.http.request("get", url, options_).pipe(
      catchError((error: any) => {
        // If the error is an HttpResponseBase, process it
        if (error instanceof HttpErrorResponse) {
          return this.handleBlobError(error);
        } else {
          return _observableThrow(error);
        }
      }),
      switchMap(response => this.blobToJson(response.body as Blob)),
      map(json => json as DossierItemEntity)
    );
  }

  deleteDossierItem(clientId: string, dossierItemId: number): Observable<number> {
    let url = this.baseUrl + "/api/v1/sst/dossierItem/{clientId}/{dossierItemId}";
    if (dossierItemId === undefined || dossierItemId === null)
      throw new Error("The parameter 'dossierItemId' must be defined.");
    if (clientId === undefined || clientId === null)
      throw new Error("The parameter 'clientId' must be defined.");
    url = url.replace("{clientId}", encodeURIComponent("" + clientId));
    url = url.replace("{dossierItemId}", encodeURIComponent("" + dossierItemId));
    url = url.replace(/[?&]$/, "");

    const options_: {
      observe: 'response';
      responseType: 'blob';
      headers: HttpHeaders;
    } = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };
    return this.http.request("delete", url, options_).pipe(
      catchError((error: any) => {
        // Handle error
        return this.handleDeleteError(error);
      }),
      switchMap(response => this.blobToJson(response.body as Blob)),
      map(json => json as number)
    );
  }

  private handleDeleteError(error: any): Observable<never> {
    if (error instanceof HttpErrorResponse) {
      // Server-side error occurred
      console.error('Backend returned status code:', error.status);
      console.error('Response body:', error.message);
    } else {
      // Client-side or network error occurred
      console.error('An error occurred:', error.message);
    }
    // Return an observable with a user-facing error message
    return _observableThrow('Something bad happened; please try again later.');
  }

  private handleError(error: HttpErrorResponse) {
    // Handle the error appropriately here
    return throwError(() => new Error('Something went wrong with the request.'));
  }

  /**
   * @return default response
   */
  getDossierItems(clientId: string): Observable<DossierItem[]> {
    let url_ = this.baseUrl + "/api/v1/sst/dossierItems/{clientId}";
    if (clientId === undefined || clientId === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetDossierItems(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetDossierItems(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<DossierItem[]>;
        }
      } else
        return _observableThrow(response_) as any as Observable<DossierItem[]>;
    }));
  }

  protected processGetDossierItems(response: HttpResponseBase): Observable<DossierItem[]> {
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let resultdefault: any = null;
        resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DossierItem[];
        return _observableOf(resultdefault);
      }));
    }
  }

  postDossierItem(id: string, body?: DossierItemEntity | undefined): Observable<DossierItemEntity> {
    let url_ = this.baseUrl + "/api/v1/sst/dossierItem/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "json", // Changed to 'json' to directly parse JSON response
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Accept": "application/json"
      })
    };

    return this.http.request("post", url_, options_).pipe(
      _observableMergeMap((response_: any) => {
        return this.processPostDossierItems(response_);
      }),
      _observableCatch((response_: any) => {
        if (response_ instanceof HttpResponseBase) {
          try {
            return this.processPostDossierItems(response_ as any);
          } catch (e) {
            return _observableThrow(e) as any as Observable<DossierItemEntity>;
          }
        } else
          return _observableThrow(response_) as any as Observable<DossierItemEntity>;
      })
    );
  }

  protected processPostDossierItems(response: HttpResponseBase): Observable<DossierItemEntity> {
    const status = response.status;
    if (response instanceof HttpResponse) {
      const responseJson = response.body;
      if (status === 200 || status === 201) { // Check for success statuses
        let result: DossierItemEntity = responseJson as DossierItemEntity;
        return _observableOf(result);
      } else {
        // Handle other status codes appropriately
        return _observableThrow('Unexpected response status: ' + status);
      }
    } else {
      // Handle case where response is not an HttpResponse
      return _observableThrow('Unexpected response type');
    }
  }

  /**
   * @return default response
   */
  getDossiers(clientId: string): Observable<DossierItem[]> {
    let url_ = this.baseUrl + "/api/v1/sst/dossiers/{clientId}";
    if (clientId === undefined || clientId === null)
      throw new Error("The parameter 'clientId' must be defined.");
    url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetDossiers(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetDossiers(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<DossierItem[]>;
        }
      } else
        return _observableThrow(response_) as any as Observable<DossierItem[]>;
    }));
  }

  protected processGetDossiers(response: HttpResponseBase): Observable<DossierItem[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let resultdefault: any = null;
        resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DossierItem[];
        return _observableOf(resultdefault);
      }));
    }
  }

  /**
   * @return default response
   */
  getGiftTax(clientId: string, giftTaxId: string): Observable<GiftTaxEntity> {
    let url_ = this.baseUrl + "/api/v1/sst/gifttax/{clientId}/{giftTaxId}";
    if (clientId === undefined || clientId === null)
      throw new Error("The parameter 'clientId' must be defined.");
    if (giftTaxId === undefined || giftTaxId === null)
      throw new Error("The parameter 'giftTaxId' must be defined.");
    url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
    url_ = url_.replace("{giftTaxId}", encodeURIComponent("" + giftTaxId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetGiftTax(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetGiftTax(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<GiftTaxEntity>;
        }
      } else
        return _observableThrow(response_) as any as Observable<GiftTaxEntity>;
    }));
  }

  protected processGetGiftTax(response: HttpResponseBase): Observable<GiftTaxEntity> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let resultdefault: any = null;
        resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GiftTaxEntity;
        return _observableOf(resultdefault);
      }));
    }
  }

  /**
   * @return default response
   */
  getSbaOverzicht(): Observable<ServiceBerichtEntity[]> {
    let url_ = this.baseUrl + "/api/v1/sst/intermediary/sba";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetAllSba(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetAllSba(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<ServiceBerichtEntity[]>;
        }
      } else
        return _observableThrow(response_) as any as Observable<ServiceBerichtEntity[]>;
    }));
  }

  protected processGetAllSba(response: HttpResponseBase): Observable<ServiceBerichtEntity[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let resultdefault: any = null;
        resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ServiceBerichtEntity[];
        return _observableOf(resultdefault);
      }));
    }
  }

  /**
   * @param body (optional)
   * @return default response
   */
  postOneSba(body?: ServiceBerichtEntity | undefined): Observable<ServiceBerichtEntity> {
    let url_ = this.baseUrl + "/api/v1/sst/intermediary/sba/";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Accept": "application/json"
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processPostOneSba(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processPostOneSba(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<ServiceBerichtEntity>;
        }
      } else
        return _observableThrow(response_) as any as Observable<ServiceBerichtEntity>;
    }));
  }

  protected processPostOneSba(response: HttpResponseBase): Observable<ServiceBerichtEntity> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let resultdefault: any = null;
        resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ServiceBerichtEntity;
        return _observableOf(resultdefault);
      }));
    }
  }

  /**
   * @return default response
   */
  getTakenOverzicht(): Observable<DossierItemEntity[]> {
    let url_ = this.baseUrl + "/api/v1/sst/intermediary/todos";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetTakenOverzicht(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetTakenOverzicht(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<DossierItemEntity[]>;
        }
      } else
        return _observableThrow(response_) as any as Observable<DossierItemEntity[]>;
    }));
  }

  protected processGetTakenOverzicht(response: HttpResponseBase): Observable<DossierItemEntity[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let resultdefault: any = null;
        resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DossierItemEntity[];
        return _observableOf(resultdefault);
      }));
    }
  }

  /**
   * @return default response
   */
  getTakenOverzichtCount(): Observable<number> {
    let url_ = this.baseUrl + "/api/v1/sst/intermediary/todos/count";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetTakenOverzichtCount(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetTakenOverzichtCount(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<number>;
        }
      } else
        return _observableThrow(response_) as any as Observable<number>;
    }));
  }

  protected processGetTakenOverzichtCount(response: HttpResponseBase): Observable<number> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let resultdefault: any = null;
        resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
        return _observableOf(resultdefault);
      }));
    }
  }

  /**
   * @param body (optional)
   * @return default response
   */
  getIbBerekening(body?: Aangifte | undefined): Observable<AangifteBerekening> {
    let url_ = this.baseUrl + "/api/v1/sst/ibBerekening";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Accept": "application/json"
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetIbBerekening(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetIbBerekening(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<AangifteBerekening>;
        }
      } else
        return _observableThrow(response_) as any as Observable<AangifteBerekening>;
    }));
  }

  protected processGetIbBerekening(response: HttpResponseBase): Observable<AangifteBerekening> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let resultdefault: any = null;
        resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AangifteBerekening;
        return _observableOf(resultdefault);
      }));
    }
  }

  /**
   * @param body (optional)
   * @return default response
   */
  getIbOptimalisatie(body?: Aangifte | undefined): Observable<Aangifte> {
    let url_ = this.baseUrl + "/api/v1/sst/ibOptimalisatie";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Accept": "application/json"
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetIbOptimalisatie(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetIbOptimalisatie(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<Aangifte>;
        }
      } else
        return _observableThrow(response_) as any as Observable<Aangifte>;
    }));
  }

  protected processGetIbOptimalisatie(response: HttpResponseBase): Observable<Aangifte> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let resultdefault: any = null;
        resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Aangifte;
        return _observableOf(resultdefault);
      }));
    }
  }

  /**
   * @param body (optional)
   * @return default response
   */
  getIbRapport(body?: Aangifte | undefined): Observable<AangifteRapport> {
    let url_ = this.baseUrl + "/api/v1/sst/ibRapport";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Accept": "application/json"
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetIbRapport(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetIbRapport(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<AangifteRapport>;
        }
      } else
        return _observableThrow(response_) as any as Observable<AangifteRapport>;
    }));
  }

  protected processGetIbRapport(response: HttpResponseBase): Observable<AangifteRapport> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let resultdefault: any = null;
        resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AangifteRapport;
        return _observableOf(resultdefault);
      }));
    }
  }

  /**
   * @return default response
   */
  getIncomeTax(clientId: string, year: string): Observable<IncomeTaxEntity> {
    let url_ = this.baseUrl + "/api/v1/sst/incometax/{clientId}/{year}";
    if (clientId === undefined || clientId === null)
      throw new Error("The parameter 'clientId' must be defined.");
    if (year === undefined || year === null)
      throw new Error("The parameter 'incomeTaxId' must be defined.");
    url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
    url_ = url_.replace("{year}", encodeURIComponent("" + year));
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetIncomeTax(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetIncomeTax(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<IncomeTaxEntity>;
        }
      } else
        return _observableThrow(response_) as any as Observable<IncomeTaxEntity>;
    }));
  }

  protected processGetIncomeTax(response: HttpResponseBase): Observable<IncomeTaxEntity> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let resultdefault: any = null;
        resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as IncomeTaxEntity;
        return _observableOf(resultdefault);
      }));
    }
  }

  /**
   * @return default response
   */
  deleteIncomeTax(clientId: string, year: string): Observable<IncomeTaxEntity> {
    let url_ = this.baseUrl + "/api/v1/sst/incometax/{clientId}/{year}";
    if (clientId === undefined || clientId === null)
      throw new Error("The parameter 'clientId' must be defined.");
    if (year === undefined || year === null)
      throw new Error("The parameter 'incomeTaxId' must be defined.");
    url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
    url_ = url_.replace("{year}", encodeURIComponent("" + year));
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processDeleteIncomeTax(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processDeleteIncomeTax(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<IncomeTaxEntity>;
        }
      } else
        return _observableThrow(response_) as any as Observable<IncomeTaxEntity>;
    }));
  }

  protected processDeleteIncomeTax(response: HttpResponseBase): Observable<IncomeTaxEntity> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let resultdefault: any = null;
        resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as IncomeTaxEntity;
        return _observableOf(resultdefault);
      }));
    }
  }

  /**
   * @return default response
   */
  getIntermediary(): Observable<IntermediaryEntity> {
    let url_ = this.baseUrl + "/api/v1/sst/intermediary";
    url_ = url_.replace(/[?&]$/, "");

    const options_: {
      observe: 'response';
      responseType: 'blob';
      headers: HttpHeaders;
    } = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(
      catchError((error: any) => {
        // If the error is an HttpResponseBase, process it
        if (error instanceof HttpErrorResponse) {
          return this.handleBlobError(error);
        } else {
          return _observableThrow(error);
        }
      }),
      switchMap(response => this.blobToJson(response.body as Blob)),
      map(json => json as IntermediaryEntity)
    );
  }

  protected handleBlobError(error: HttpErrorResponse): Observable<never> {
    return new Observable<never>((observer) => {
      const reader = new FileReader();
      reader.onload = () => {
        const errorText = reader.result as string;
        console.log('intermediary status', error.status);
        observer.error({
          message: errorText || 'Unknown error',
          status: error.status
        });
      };
      reader.onerror = () => {
        observer.error({
          message: 'Error reading blob',
          status: error.status
        });
      };
      reader.readAsText(error.error);
    });
  }

  private blobToJson(blob: Blob): Observable<any> {
    const reader = new FileReader();
    return new Observable(observer => {
      reader.onload = () => {
        try {
          const json = JSON.parse(reader.result as string);
          observer.next(json);
          observer.complete();
        } catch (err) {
          observer.error(err);
        }
      };
      reader.onerror = (err) => {
        observer.error(err);
      };
      reader.readAsText(blob);
    });
  }


  /**
   * @param body (optional)
   * @return default response
   */
  postIntermediary(body?: IntermediaryEntity | undefined): Observable<IntermediaryEntity> {
    let url_ = this.baseUrl + "/api/v1/sst/intermediary";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Accept": "application/json"
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processPostIntermediary(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processPostIntermediary(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<IntermediaryEntity>;
        }
      } else
        return _observableThrow(response_) as any as Observable<IntermediaryEntity>;
    }));
  }

  protected processPostIntermediary(response: HttpResponseBase): Observable<IntermediaryEntity> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let resultdefault: any = null;
        resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as IntermediaryEntity;
        return _observableOf(resultdefault);
      }));
    }
  }

  /**
   * @return default response
   */
  getJaarstukken(clientId: string, jaarstukkenId: string): Observable<JaarrekeningEntity> {
    let url_ = this.baseUrl + "/api/v1/sst/jaarstukken/{clientId}/{jaarstukkenId}";
    if (clientId === undefined || clientId === null)
      throw new Error("The parameter 'clientId' must be defined.");
    url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
    url_ = url_.replace("{jaarstukkenId}", encodeURIComponent("" + jaarstukkenId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetJaarstukken(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetJaarstukken(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<JaarrekeningEntity>;
        }
      } else
        return _observableThrow(response_) as any as Observable<JaarrekeningEntity>;
    }));
  }

  protected processGetJaarstukken(response: HttpResponseBase): Observable<JaarrekeningEntity> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let resultdefault: any = null;
        resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as JaarrekeningEntity;
        return _observableOf(resultdefault);
      }));
    }
  }

  /**
   * @param body (optional)
   * @return default response
   */
  getKolommenbalans(body?: EnrichAangifte | undefined): Observable<any> {
    let url_ = this.baseUrl + "/api/v1/sst/balans";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Accept": "application/json"
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetKolommenbalans(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetKolommenbalans(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<any>;
        }
      } else
        return _observableThrow(response_) as any as Observable<any>;
    }));
  }

  protected processGetKolommenbalans(response: HttpResponseBase): Observable<any> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let resultdefault: any = null;
        resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
        return _observableOf(resultdefault);
      }));
    }
  }

  /**
   * @param body (optional)
   * @return default response
   */
  getObBerekening(body?: IcpAangifte | undefined): Observable<BtwAangifte> {
    let url_ = this.baseUrl + "/api/v1/sst/obBerekening";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Accept": "application/json"
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetObBerekening(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetObBerekening(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<BtwAangifte>;
        }
      } else
        return _observableThrow(response_) as any as Observable<BtwAangifte>;
    }));
  }

  protected processGetObBerekening(response: HttpResponseBase): Observable<BtwAangifte> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let resultdefault: any = null;
        resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BtwAangifte;
        return _observableOf(resultdefault);
      }));
    }
  }

  /**
   * @param body (optional)
   * @return default response
   */
  getPdfRapport(body?: PdfRequest | undefined): Observable<string> {
    let url_ = this.serviceUrl + "/api/v1/pdf/sst";
      // let url_ =  "http://localhost:666/api/v1/pdf/sst";

      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Accept": "application/json"
      })
    };

    return this.http.request("post", url_, options_).pipe(
      _observableMergeMap((response: any) => this.processGetPdfRapport(response)),
      _observableCatch((error: any) => {
        if (error instanceof HttpResponseBase) {
          try {
            return this.processGetPdfRapport(error as any);
          } catch (e) {
            return _observableThrow(e) as Observable<string>;
          }
        } else {
          return _observableThrow(error) as Observable<string>;
        }
      })
    );
  }

  protected processGetPdfRapport(response: HttpResponseBase): Observable<string> {
    const status = response.status;
    const responseBlob = response instanceof HttpResponse ? response.body :
      (response as any).error instanceof Blob ? (response as any).error : undefined;

    if (status === 200) {
      return this.blobToText(responseBlob).pipe(
        _observableMergeMap((responseText: string) => _observableOf(responseText)),
        _observableCatch((error: any) => _observableThrow('Error converting Blob to text: ' + error))
      );
    } else {
      return this.blobToText(responseBlob).pipe(
        _observableMergeMap((responseText: string) => _observableThrow(`Unexpected server response: ${status} - ${responseText}`)),
        _observableCatch((error: any) => _observableThrow('Error processing error response Blob: ' + error))
      );
    }
  }

  protected blobToText(blob: Blob): Observable<string> {
    return new Observable<string>((observer) => {
      const reader = new FileReader();
      reader.onload = (event: any) => {
        observer.next(event.target.result);
        observer.complete();
      };
      reader.onerror = (event: any) => {
        observer.error(event.target.error);
      };
      reader.readAsText(blob);
    });
  }

  /**
   * @return default response
   */
  getPostponement(year: number): Observable<UitstelEntity> {
    let url_ = this.baseUrl + "/api/v1/sst/postponement/{year}";
    if (year === undefined || year === null)
      throw new Error("The parameter 'year' must be defined.");
    url_ = url_.replace("{year}", encodeURIComponent("" + year));
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetPostponement(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetPostponement(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<UitstelEntity>;
        }
      } else
        return _observableThrow(response_) as any as Observable<UitstelEntity>;
    }));
  }

  protected processGetPostponement(response: HttpResponseBase): Observable<UitstelEntity> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let resultdefault: any = null;
        resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UitstelEntity;
        return _observableOf(resultdefault);
      }));
    }
  }

  /**
   * @return default response
   */
  getReservation(id: string, financialResult: number, zelfstandigenaftrek: boolean, startDate: string, endDate: string, rechtsvorm: string): Observable<Reservation> {
    let url_ = this.baseUrl + "/api/v1/sst/reservation/{id}/{financialResult}/{zelfstandigenaftrek}/{startDate}/{endDate}/{rechtsvorm}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (financialResult === undefined || financialResult === null)
      throw new Error("The parameter 'financialResult' must be defined.");
    url_ = url_.replace("{financialResult}", encodeURIComponent("" + financialResult));
    if (zelfstandigenaftrek === undefined || zelfstandigenaftrek === null)
      throw new Error("The parameter 'zelfstandigenaftrek' must be defined.");
    url_ = url_.replace("{zelfstandigenaftrek}", encodeURIComponent("" + zelfstandigenaftrek));
    if (startDate === undefined || startDate === null)
      throw new Error("The parameter 'startDate' must be defined.");
    url_ = url_.replace("{startDate}", encodeURIComponent("" + startDate));
    if (endDate === undefined || endDate === null)
      throw new Error("The parameter 'endDate' must be defined.");
    url_ = url_.replace("{endDate}", encodeURIComponent("" + endDate));
    if (rechtsvorm === undefined || rechtsvorm === null)
      throw new Error("The parameter 'rechtsvorm' must be defined.");
    url_ = url_.replace("{rechtsvorm}", encodeURIComponent("" + rechtsvorm));
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetReservation(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetReservation(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<Reservation>;
        }
      } else
        return _observableThrow(response_) as any as Observable<Reservation>;
    }));
  }

  protected processGetReservation(response: HttpResponseBase): Observable<Reservation> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let resultdefault: any = null;
        resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Reservation;
        return _observableOf(resultdefault);
      }));
    }
  }

  /**
   * @param body (optional)
   * @return default response
   */
  getSwBerekening(body?: AangifteSchenkbelasting | undefined): Observable<SbBerekening> {
    let url_ = this.baseUrl + "/api/v1/sst/swBerekening";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Accept": "application/json"
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetSwBerekening(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetSwBerekening(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<SbBerekening>;
        }
      } else
        return _observableThrow(response_) as any as Observable<SbBerekening>;
    }));
  }

  protected processGetSwBerekening(response: HttpResponseBase): Observable<SbBerekening> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let resultdefault: any = null;
        resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SbBerekening;
        return _observableOf(resultdefault);
      }));
    }
  }

  /**
   * @param key (optional)
   * @return default response
   */
  getSwagger(key?: string | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/v1/sst/openapi";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "key": key !== undefined && key !== null ? "" + key : "",
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetSwagger(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetSwagger(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processGetSwagger(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return _observableOf(null as any);
      }));
    }
  }

  /**
   * @param body (optional)
   * @return default response
   */
  getTslBerekening(body?: Toeslagen | undefined): Observable<ToeslagenBerekening> {
    let url_ = this.baseUrl + "/api/v1/sst/tslBerekening";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Accept": "application/json"
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetTslBerekening(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetTslBerekening(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<ToeslagenBerekening>;
        }
      } else
        return _observableThrow(response_) as any as Observable<ToeslagenBerekening>;
    }));
  }

  protected processGetTslBerekening(response: HttpResponseBase): Observable<ToeslagenBerekening> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let resultdefault: any = null;
        resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ToeslagenBerekening;
        return _observableOf(resultdefault);
      }));
    }
  }

  /**
   * @return default response
   */
  getValueAddedTax(clientId: string, valueAddedTaxId: string): Observable<ValueAddedTaxEntity> {
    let url_ = this.baseUrl + "/api/v1/sst/valueaddedtax/{clientId}/{valueAddedTaxId}";
    if (clientId === undefined || clientId === null)
      throw new Error("The parameter 'clientId' must be defined.");
    if (valueAddedTaxId === undefined || valueAddedTaxId === null)
      throw new Error("The parameter 'valueAddedTaxId' must be defined.");
    url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
    url_ = url_.replace("{valueAddedTaxId}", encodeURIComponent("" + valueAddedTaxId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetValueAddedTax(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetValueAddedTax(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<ValueAddedTaxEntity>;
        }
      } else
        return _observableThrow(response_) as any as Observable<ValueAddedTaxEntity>;
    }));
  }

  protected processGetValueAddedTax(response: HttpResponseBase): Observable<ValueAddedTaxEntity> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let resultdefault: any = null;
        resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValueAddedTaxEntity;
        return _observableOf(resultdefault);
      }));
    }
  }

  /**
   * @param body (optional)
   * @return default response
   */
  getVpbBerekening(body?: VpbAangifte | undefined): Observable<VpbBerekening> {
    let url_ = this.baseUrl + "/api/v1/sst/vpbBerekening";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Accept": "application/json"
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetVpbBerekening(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetVpbBerekening(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<VpbBerekening>;
        }
      } else
        return _observableThrow(response_) as any as Observable<VpbBerekening>;
    }));
  }

  protected processGetVpbBerekening(response: HttpResponseBase): Observable<VpbBerekening> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let resultdefault: any = null;
        resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VpbBerekening;
        return _observableOf(resultdefault);
      }));
    }
  }

  /**
   * @param body (optional)
   * @return default response
   */
  getVpbPdfRapport(body?: PdfRequest | undefined): Observable<string> {
    let url_ = this.baseUrl + "/api/v1/sst/vpbPdfRapport";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Accept": "application/json"
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetVpbPdfRapport(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetVpbPdfRapport(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<string>;
        }
      } else
        return _observableThrow(response_) as any as Observable<string>;
    }));
  }

  protected processGetVpbPdfRapport(response: HttpResponseBase): Observable<string> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let resultdefault: any = null;
        resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
        return _observableOf(resultdefault);
      }));
    }
  }

  /**
   * @return default response
   */
  getZvwAanslag(): Observable<AanslagZwv> {
    let url_ = this.baseUrl + "/api/v1/sst/zvwAanslag";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetZvwAanslag(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetZvwAanslag(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<AanslagZwv>;
        }
      } else
        return _observableThrow(response_) as any as Observable<AanslagZwv>;
    }));
  }

  protected processGetZvwAanslag(response: HttpResponseBase): Observable<AanslagZwv> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let resultdefault: any = null;
        resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AanslagZwv;
        return _observableOf(resultdefault);
      }));
    }
  }

  /**
   * @param body (optional)
   * @return default response
   */
  postAllowance(sstRelationId: string, sendToAuthorities: boolean, body?: AllowanceEntity | undefined): Observable<AllowanceEntity> {
    let url_ = this.baseUrl + "/api/v1/sst/allowance/{sstRelationId}/{sendToAuthorities}";
    if (sstRelationId === undefined || sstRelationId === null)
      throw new Error("The parameter 'sstRelationId' must be defined.");
    if (sendToAuthorities === undefined || sendToAuthorities === null)
      throw new Error("The parameter 'sendToAuthorities' must be defined.");
    url_ = url_.replace("{sendToAuthorities}", encodeURIComponent("" + sendToAuthorities));
    url_ = url_.replace("{sstRelationId}", encodeURIComponent("" + sstRelationId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Accept": "application/json"
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processPostAllowance(response_);
    }))

      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpErrorResponse) {
            return _observableThrow(response_);
          }
          return _observableThrow(response_);
        })
      );
  }

  protected processPostAllowance(response: HttpResponseBase): Observable<AllowanceEntity> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let resultdefault: any = null;
        resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AllowanceEntity;
        return _observableOf(resultdefault);
      }));
    }
  }

  /**
   * @param body (optional)
   * @return default response
   */
  postApproval(body?: ApprovalEntity | undefined): Observable<ApprovalEntity> {
    let url_ = this.baseUrl + "/api/v1/sst/approval";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Accept": "application/json"
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processPostApproval(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processPostApproval(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<ApprovalEntity>;
        }
      } else
        return _observableThrow(response_) as any as Observable<ApprovalEntity>;
    }));
  }

  protected processPostApproval(response: HttpResponseBase): Observable<ApprovalEntity> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let resultdefault: any = null;
        resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApprovalEntity;
        return _observableOf(resultdefault);
      }));
    }
  }

    sendError(body?: Object): Observable<any> {
        let url_ = this.baseUrl + "/api/v1/sst/error";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response" as const,
            responseType: "json" as const,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(
            mergeMap((response_: any) => {
                return this.processErrorResponse(response_);
            }),
            catchError((response_: any) => {
                if (response_ instanceof HttpErrorResponse) {
                    // Handle HTTP error response
                    return _observableThrow(response_.error);
                } else {
                    // Handle unexpected errors
                    return _observableThrow(response_);
                }
            })
        );
    }

    private processErrorResponse(response: HttpResponse<any>): Observable<any> {
        const status = response.status;
        if (status === 200 || status === 201) {
            return this.parseErrorResponse(response);
        } else {
            // Handle other status codes as errors
            return _observableThrow(new Error('An unexpected server error occurred.'));
        }
    }

    private parseErrorResponse(response: HttpResponse<any>): Observable<any> {
        const responseBody = response.body;
        if (responseBody) {
            const result = responseBody as ClientEntity;
            return new Observable<any>((observer) => {
                observer.next(result);
                observer.complete();
            });
        } else {
            return _observableThrow(new Error('No response body.'));
        }
    }

  /**
   * @param body (optional)
   * @return default response
   */
  postClient(body?: ClientEntity): Observable<ClientEntity> {
    let url_ = this.baseUrl + "/api/v1/sst/client";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response" as const,
      responseType: "json" as const,
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Accept": "application/json"
      })
    };

    return this.http.request("post", url_, options_).pipe(
      mergeMap((response_: any) => {
        return this.processPostClient(response_);
      }),
      catchError((response_: any) => {
        if (response_ instanceof HttpErrorResponse) {
          // Handle HTTP error response
          return _observableThrow(response_.error);
        } else {
          // Handle unexpected errors
          return _observableThrow(response_);
        }
      })
    );
  }

  private processPostClient(response: HttpResponse<any>): Observable<ClientEntity> {
    const status = response.status;
    if (status === 200 || status === 201) {
      return this.parseResponse(response);
    } else {
      // Handle other status codes as errors
      return _observableThrow(new Error('An unexpected server error occurred.'));
    }
  }

  private parseResponse(response: HttpResponse<any>): Observable<ClientEntity> {
    const responseBody = response.body;
    if (responseBody) {
      const result = responseBody as ClientEntity;
      return new Observable<ClientEntity>((observer) => {
        observer.next(result);
        observer.complete();
      });
    } else {
      return _observableThrow(new Error('No response body.'));
    }
  }


  /**
   * @param body (optional)
   * @return default response
   */
  postCorporateTax(clientId: string, sendToAuthorities: boolean, provisional: boolean, body?: CorporateTaxEntity | undefined): Observable<CorporateTaxEntity> {
    let url_ = this.baseUrl + "/api/v1/sst/corporatetax/{clientId}/{sendToAuthorities}/{provisional}";
    if (clientId === undefined || clientId === null)
      throw new Error("The parameter 'clientId' must be defined.");
    url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
    if (sendToAuthorities === undefined || sendToAuthorities === null)
      throw new Error("The parameter 'sendToAuthorities' must be defined.");
    url_ = url_.replace("{sendToAuthorities}", encodeURIComponent("" + sendToAuthorities));
    if (provisional === undefined || provisional === null)
      throw new Error("The parameter 'provisional' must be defined.");
    url_ = url_.replace("{provisional}", encodeURIComponent("" + provisional));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Accept": "application/json"
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processPostCorporateTax(response_);
    }))
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpErrorResponse) {
            return _observableThrow(response_);
          }
          return _observableThrow(response_);
        })
      );
  }

  protected processPostCorporateTax(response: HttpResponseBase): Observable<CorporateTaxEntity> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status >= 200 && status < 300) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let resultdefault: any = null;
        resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CorporateTaxEntity;
        return _observableOf(resultdefault);
      }));
    } else {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        const error = _responseText === "" ? "An error occurred" : _responseText;
        return _observableThrow(new Error(error));
      }));
    }
  }

  /**
   * @param clientId
   * @param sendToAuthorities
   * @param body (optional)
   * @return default response
   */
  postDividendTax(clientId: string, sendToAuthorities: boolean, body?: DividendTaxEntity | undefined): Observable<DividendTaxEntity> {
    let url_ = this.baseUrl + "/api/v1/sst/dividendtax/{clientId}/{sendToAuthorities}";
    if (clientId === undefined || clientId === null)
      throw new Error("The parameter 'clientId' must be defined.");
    if (sendToAuthorities === undefined || sendToAuthorities === null)
      throw new Error("The parameter 'sendToAuthorities' must be defined.");
    url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
    url_ = url_.replace("{sendToAuthorities}", encodeURIComponent("" + sendToAuthorities));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Accept": "application/json"
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processPostDividendTax(response_);
    }))
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpErrorResponse) {
            return _observableThrow(response_);
          }
          return _observableThrow(response_);
        })
      );
  }

  protected processPostDividendTax(response: HttpResponseBase): Observable<DividendTaxEntity> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status >= 200 && status < 300) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let resultdefault: any = null;
        resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DividendTaxEntity;
        return _observableOf(resultdefault);
      }));
    } else {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        const error = _responseText === "" ? "An error occurred" : _responseText;
        return _observableThrow(new Error(error));
      }));
    }
  }

  /**
   * @param body (optional)
   * @return default response
   */
  postGiftTax(cliendId: string, sendToAuthorities: boolean, body?: GiftTaxEntity | undefined): Observable<GiftTaxEntity> {
    let url_ = this.baseUrl + "/api/v1/sst/gifttax/{cliendId}/{sendToAuthorities}";
    if (cliendId === undefined || cliendId === null)
      throw new Error("The parameter 'cliendId' must be defined.");
    if (sendToAuthorities === undefined || sendToAuthorities === null)
      throw new Error("The parameter 'sendToAuthorities' must be defined.");
    url_ = url_.replace("{cliendId}", encodeURIComponent("" + cliendId));
    url_ = url_.replace("{sendToAuthorities}", encodeURIComponent("" + sendToAuthorities));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Accept": "application/json"
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processPostGiftTax(response_);
    }))
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpErrorResponse) {
            return _observableThrow(response_);
          }
          return _observableThrow(response_);
        })
      );
  }

  protected processPostGiftTax(response: HttpResponseBase): Observable<GiftTaxEntity> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let resultdefault: any = null;
        resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GiftTaxEntity;
        return _observableOf(resultdefault);
      }));
    }
  }

  /**
   * @param sstRelatieId
   * @param sendToAuthorities
   * @param partner
   * @param provisional
   * @param owr
   * @param body (optional)
   * @return default response
   */
  postIncomeTax(sstRelatieId: string, sendToAuthorities: boolean, partner: boolean, provisional: boolean, owr: boolean, body?: IncomeTaxEntity | undefined): Observable<IncomeTaxEntity> {
    let url_ = this.baseUrl + "/api/v1/sst/incometax/{sstRelatieId}/{sendToAuthorities}/{partner}/{provisional}/{owr}";
    if (sstRelatieId === undefined || sstRelatieId === null)
      throw new Error("The parameter 'sstRelatieId' must be defined.");
    url_ = url_.replace("{sstRelatieId}", encodeURIComponent("" + sstRelatieId));
    if (sendToAuthorities === undefined || sendToAuthorities === null)
      throw new Error("The parameter 'sendToAuthorities' must be defined.");
    url_ = url_.replace("{sendToAuthorities}", encodeURIComponent("" + sendToAuthorities));
    if (partner === undefined || partner === null)
      throw new Error("The parameter 'partner' must be defined.");
    url_ = url_.replace("{partner}", encodeURIComponent("" + partner));
    if (provisional === undefined || provisional === null)
      throw new Error("The parameter 'provisional' must be defined.");
    url_ = url_.replace("{provisional}", encodeURIComponent("" + provisional));
    if (owr === undefined || owr === null)
      throw new Error("The parameter 'owr' must be defined.");
    url_ = url_.replace("{owr}", encodeURIComponent("" + owr));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Accept": "application/json"
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processPostIncomeTax(response_);
    }))
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpErrorResponse) {
            return _observableThrow(response_);
          }
          return _observableThrow(response_);
        })
      );
  }

  protected processPostIncomeTax(response: HttpResponseBase): Observable<IncomeTaxEntity> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }

    // Check if the response status is not in the success range (200-299)
    if (status < 200 || status >= 300) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let errorResponse = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
          // Explicitly throw an error for non-success responses
          return _observableThrow({
            status: status,
            message: errorResponse || 'An error occurred'
          });
        })
      );
    } else {
      // Handle successful responses
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let resultdefault: any = null;
          resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as IncomeTaxEntity;
          return _observableOf(resultdefault);
        })
      );
    }
  }

  /**
   * @param body (optional)
   * @return default response
   */
  postMumaRequest(taxpayerId: string, body?: MumaRequest | undefined): Observable<void> {
    let url_ = this.baseUrl + "/api/v1/sst/machtiging/{taxpayerId}";
    if (taxpayerId === undefined || taxpayerId === null)
      throw new Error("The parameter 'taxpayerId' must be defined.");
    url_ = url_.replace("{taxpayerId}", encodeURIComponent("" + taxpayerId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Accept": "application/json"
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processPostMumaRequest(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processPostMumaRequest(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processPostMumaRequest(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return _observableOf(null as any);
      }));
    }
  }

  /**
   * @param pki (optional)
   * @param password (optional)
   * @return default response
   */
  postPkiCertificate(pki?: any | undefined, password?: string | undefined): Observable<IntermediaryEntity> {
    let url_ = this.baseUrl + "/api/v1/sst/intermediary/pki";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = new FormData();
    if (pki === null || pki === undefined)
      throw new Error("The parameter 'pki' cannot be null.");
    else
      content_.append("pki", pki);
    if (password === null || password === undefined)
      throw new Error("The parameter 'password' cannot be null.");
    else
      content_.append("password", password.toString());

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processPostPkiCertificate(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processPostPkiCertificate(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<IntermediaryEntity>;
        }
      } else
        return _observableThrow(response_) as any as Observable<IntermediaryEntity>;
    }));
  }

  protected processPostPkiCertificate(response: HttpResponseBase): Observable<IntermediaryEntity> {
    const status = response.status;
    const responseBlob = response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }

    if (status === 200 || status === 201) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result: any = null;
        result = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as IntermediaryEntity;
        return _observableOf(result);
      }));
    } else if (status !== 200 && status !== 201) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let errorResponse: any = _responseText === "" ? null : JSON.parse(_responseText);
        return _observableThrow(errorResponse);
      }));
    } else {
      return _observableOf<IntermediaryEntity>(<any>null);
    }
  }

  /**
   * @param body (optional)
   * @return default response
   */
  postPostponement(clientId: string, sendToAuthorities: boolean, body?: UitstelGegevens | undefined): Observable<UitstelEntity> {
    let url_ = this.baseUrl + "/api/v1/sst/postponement/{clientId}/{sendToAuthorities}";
    if (clientId === undefined || clientId === null)
      throw new Error("The parameter 'clientId' must be defined.");
    url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
    if (sendToAuthorities === undefined || sendToAuthorities === null)
      throw new Error("The parameter 'sendToAuthorities' must be defined.");
    url_ = url_.replace("{sendToAuthorities}", encodeURIComponent("" + sendToAuthorities));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Accept": "application/json"
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processPostPostponement(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processPostPostponement(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<UitstelEntity>;
        }
      } else
        return _observableThrow(response_) as any as Observable<UitstelEntity>;
    }));
  }

  protected processPostPostponement(response: HttpResponseBase): Observable<UitstelEntity> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let resultdefault: any = null;
        resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UitstelEntity;
        return _observableOf(resultdefault);
      }));
    }
  }

  /**
   * @param body (optional)
   * @return default response
   */
  postValueAddedTax(sstRelationId: string, sendToAuthorities: boolean, body?: ValueAddedTaxEntity | undefined): Observable<ValueAddedTaxEntity> {
    let url_ = this.baseUrl + "/api/v1/sst/valueaddedtax/{sstRelationId}/{sendToAuthorities}";
    if (sstRelationId === undefined || sstRelationId === null)
      throw new Error("The parameter 'sstRelationId' must be defined.");
    if (sendToAuthorities === undefined || sendToAuthorities === null)
      throw new Error("The parameter 'sendToAuthorities' must be defined.");
    url_ = url_.replace("{sendToAuthorities}", encodeURIComponent("" + sendToAuthorities));
    url_ = url_.replace("{sstRelationId}", encodeURIComponent("" + sstRelationId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Accept": "application/json"
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processPostValueAddedTax(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processPostValueAddedTax(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<ValueAddedTaxEntity>;
        }
      } else
        return _observableThrow(response_) as any as Observable<ValueAddedTaxEntity>;
    }));
  }

  protected processPostValueAddedTax(response: HttpResponseBase): Observable<ValueAddedTaxEntity> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let resultdefault: any = null;
        resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValueAddedTaxEntity;
        return _observableOf(resultdefault);
      }));
    }
  }

  /**
   * @return default response
   */
  deleteValueAddedTax(sstRelationId: string, year: string): Observable<ValueAddedTaxEntity> {
    let url_ = this.baseUrl + "/api/v1/sst/valueaddedtax/{sstRelationId}/{year}";
    if (sstRelationId === undefined || sstRelationId === null)
      throw new Error("The parameter 'sstRelationId' must be defined.");
    if (year === undefined || year === null)
      throw new Error("The parameter 'year' must be defined.");
    url_ = url_.replace("{sstRelationId}", encodeURIComponent("" + sstRelationId));
    url_ = url_.replace("{year}", encodeURIComponent("" + year));
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processDeleteValueAddedTax(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processDeleteValueAddedTax(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<ValueAddedTaxEntity>;
        }
      } else
        return _observableThrow(response_) as any as Observable<ValueAddedTaxEntity>;
    }));
  }

  protected processDeleteValueAddedTax(response: HttpResponseBase): Observable<ValueAddedTaxEntity> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let resultdefault: any = null;
        resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValueAddedTaxEntity;
        return _observableOf(resultdefault);
      }));
    }
  }

  /**
   * @return default response
   */
  getExternalGrammar(path: string): Observable<FileResponse> {
    let url_ = this.baseUrl + "/application.wadl/{path}";
    if (path === undefined || path === null)
      throw new Error("The parameter 'path' must be defined.");
    url_ = url_.replace("{path}", encodeURIComponent("" + path));
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetExternalGrammar(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetExternalGrammar(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<FileResponse>;
        }
      } else
        return _observableThrow(response_) as any as Observable<FileResponse>;
    }));
  }

  protected processGetExternalGrammar(response: HttpResponseBase): Observable<FileResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    {
      const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
      let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
      let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
        fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
      }
      return _observableOf({fileName: fileName, data: responseBlob as any, status: status, headers: _headers});
    }
  }

  /**
   * @return default response
   */
  getWadl(): Observable<FileResponse> {
    let url_ = this.baseUrl + "/application.wadl";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetWadl(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetWadl(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<FileResponse>;
        }
      } else
        return _observableThrow(response_) as any as Observable<FileResponse>;
    }));
  }

  protected processGetWadl(response: HttpResponseBase): Observable<FileResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    {
      const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
      let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
      let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
        fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
      }
      return _observableOf({fileName: fileName, data: responseBlob as any, status: status, headers: _headers});
    }
  }

}

export interface PdfNettoLoonRegel {
    omschrijving?: string;
    iban?: string;
    bedrag?: number;

    [key: string]: any;
}

export interface PdfNettoLonenOverzicht {
    uitersteBetaaldatum?: string;
    betalingskenmerk?: string;
    nettoLonen?: PdfNettoLoonRegel[];

    [key: string]: any;
}

export interface AdminEntity {
  id?: number;
  name?: string;
  administrationId?: string;
  providerId: string;
  environmentId: string;
  taxPayerId?: ClientEntity;
  clientId?: ClientEntity;
  rgs?: string;

  [key: string]: any;
}

export interface ClientEntity {
  id?: number;
  sstCode?: number;
  sstRelationId?: string;
  sstPrimaryAdminId?: string;
  typeClient?: string;
  rechtsvorm?: string;
  aanspreekTitel?: string;
  voorletters?: string;
  tussenvoegsel?: string;
  achternaam?: string;
  roepnaam?: string;
  name?: string;
  geboortedatum?: Date,
  adminEntities?: AdminEntity[];
  taxId?: string;
  taxIdIncomeTax?: string;
  taxIdVat?: string;
  taxIdWageTax?: string;
  taxIdCorporateTax?: string;
  valueAddedTax?: boolean;
  postponement?: boolean;
  corporateTax?: boolean;
  incomeTax?: boolean;
  wageTax?: boolean;
  kvkId?: string;
  classificatie?: string;
  sbiCode?: string;
  machtigingStatus?: ClientEntityMachtigingStatus;
  machtigingStatusOb?: ClientEntityMachtigingStatusOb;
  machtigingStatusTsg?: ClientEntityMachtigingStatusTsg;
  machtigingStatusToelichting?: string;
  machtigingStatusToelichtingOb?: string;
  machtigingStatusToelichtingTsg?: string;
  userIdGemachtigde?: number;
  deadline?: Date;
  deadlineToelichting?: string;
  dossierItem?: DossierItemEntity;
  street?: string;
  houseNumber?: number;
  numberAddition?: string;
  postalCode?: string;
  place?: string;
  phone?: string;
  mobile?: string;
  email?: string;
  website?: string;
  deleted?: boolean;

  [key: string]: any;
}

export interface ClientAddons {
  sstRelationId?: string;
  taxId?: string;
  hasValidTaxId?: boolean;
  hasDuplicateTaxIds?: boolean;
  duplicatetaxIds?: number;
  hasPostponement?: boolean;
  couldHavePostponement?: boolean;
  activeMumas?: number;
  hasMumaToActivate?: boolean;

  [key: string]: any;

}

export interface DividendTaxEntity {
  id?: number;
  name?: string;
  taxPayerFiscalNumber: string;
  sstRelationId: string;
  year?: number;
  aangifte?: Dividendbelasting;
  lastOpeningDate?: Date;
  submissionDate?: Date;

  [key: string]: any;
}

export interface DossierItemEntity {
  id?: number;
  clientId?: number;
  clientName?: string;
  sstRelationId?: string;
  sstPrimaryAdminId?: string;
  title?: string;
  creator?: string;
  dateCreation?: Date;
  dateDeadline?: Date;
  hasDeadline?: boolean;
  isChecked?: boolean;
  opmerkingen?: string;
  attachment?: string[] | boolean;
  nameAttachment?: string;
  checked?: boolean;
  type?: string;
  year?: string;

  [key: string]: any;
}

export interface JaarrekeningEntity {
  id?: number;
  year?: number;
  sstAdminId?: string;
  toelichtingen?: Toelichtingen;
  kolommenbalans?: Kolommenbalans;
  dateCreation?: Date;
  lastOpeningDate?: Date;
  submissionDate?: Date;
  taxPayerId?: ClientEntity;

  [key: string]: any;
}

export interface Kolommenbalans {
  getKolommembalansResponseResults?: KolommenbalansResult[];
  kolommenbalansTotalResponseResult?: KolommenbalansTotalResults;

  [key: string]: any;
}

export interface KolommenbalansResult {
  publicIdentifier?: string;
  balans?: string;
  hoofdGrootboekRubriek?: string;
  rubriek?: string;
  rekeningCode?: number;
  rubriekId?: number;
  grootboekFunctieId?: number;
  nummer?: number;
  omschrijving?: string;
  debetWinstenverlies?: number;
  creditWinstenverlies?: number;
  debetBalans?: number;
  creditBalans?: number;
  debetProefSaldiBalans?: number;
  creditProefSaldiBalans?: number;
  rgsCode?: string;

  [key: string]: any;
}

export interface KolommenbalansTotalResults {
  totalDebetProefSaldiBalans?: number;
  totalCreditProefSaldiBalans?: number;
  totalDebetWinstenverlies?: number;
  totalCreditWinstenverlies?: number;
  totalDebetBalans?: number;
  totalCreditBalans?: number;
  resultDebetWinstenverlies?: number;
  resultCreditWinstenverlies?: number;
  resultDebetBalans?: number;
  resultCreditBalans?: number;
  totalResultDebetWinstenverlies?: number;
  totalResultCreditWinstenverlies?: number;
  totalResultDebetBalans?: number;
  totalResultCreditBalans?: number;

  [key: string]: any;
}

export interface ToelichingenAangifteIb {
  aanbiedingsBrief?: string;

  [key: string]: any;
}

export interface Toelichtingen {
  jaar?: number;
  toelichingenAangifteIb?: ToelichingenAangifteIb;
  toelichtingenVpb?: ToelichtingenVpb;
  toelichtingenJaarrekening?: ToelichtingenJaarrekening;

  [key: string]: any;
}

export interface ToelichtingenJaarrekening {
  naamDocument?: string;
  samenStellingVerklaring?: string;
  datumOpmaakJaarstukken?: Date;
  datumVaststellingJaarstukken?: Date;
  startDatumVerslaglegging?: Date;
  eindDatumVerslaglegging?: Date;
  naamOnderneming?: string;
  rechtsvorm?: string;
  zetel?: string;
  kvkNummer?: string;
  sbiCode?: string;
  locatieVanDeActiviteiten?: string;
  omschrijvingVanDeActiviteiten?: string;
  toelichtingContinuiteit?: string;
  toelichtingGebeurtenissenNaBalansdatum?: string;
  toelichtingConsolidatie?: string;
  algemeneGrondslagenVerslaglegging?: string;
  algemeneGrondslagenBepalingResultaat?: string;
  toelichtingImmaterieleVasteActiva?: string;
  waarderingImmaterieleVasteActiva?: string;
  toelichtingMaterieleVasteActiva?: string;
  waarderingMaterieleVasteActiva?: string;
  toelichtingFinancieleVasteActiva?: string;
  waarderingFinancieleVasteActiva?: string;
  toelichtingVoorraad?: string;
  waarderingVoorraad?: string;
  toelichtingKortlopendeVorderingen?: string;
  waarderingKortlopendeVorderingen?: string;
  toelichtingLanglopendeVorderingen?: string;
  waarderingLanglopendeVorderingen?: string;
  toelichtingEffecten?: string;
  waarderingEffecten?: string;
  toelichtingLiquideMiddelen?: string;
  waarderingLiquideMiddelen?: string;
  toelichtingEigenVermogen?: string;
  toelichtingGestortEnOpgevraagdAandelenKapitaal?: string;
  toelichtingAgio?: string;
  toelichtingWettelijkeReserves?: string;
  toelichtingFiscaleReserves?: string;
  toelichtingGarantieVoorzieningen?: string;
  waarderingGarantieVoorzieningen?: string;
  toelichtingOverigeVoorzieningen?: string;
  waarderingOverigeVoorzieningen?: string;
  toelichtingLanglopendeSchulden?: string;
  waarderingLanglopendeSchulden?: string;
  toelichtingKortlopendeSchulden?: string;
  waarderingKortlopendeSchulden?: string;
  toelichtingOmzet?: string;
  waarderingOmzet?: string;
  toelichtingOverigeBaten?: string;
  waarderingOverigeBaten?: string;
  toelichtingInkoopKosten?: string;
  waarderingInkoopKosten?: string;
  toelichtingPersoneelsKosten?: string;
  waarderingPersoneelsKosten?: string;
  toelichtingAfschrijvingen?: string;
  waarderingAfschrijvingen?: string;
  toelichtingOverigeKosten?: string;
  waarderingOverigeKosten?: string;
  toelichtingResultaatDeelnemingen?: string;
  waarderingResultaatDeelnemingen?: string;
  toelichtingBijzondereBatenEnLasten?: string;
  waarderingBijzondereBatenEnLasten?: string;
  toelichtingFinancieleBatenEnLasten?: string;
  waarderingFinancieleBatenEnLasten?: string;
  toelichtingBelastingen?: string;
  waarderingBelastingen?: string;
  toelichtingNietUitDeBalansBlijkendeVerplichtingen?: string;
  gemiddeldAantalWerknemersNederland?: number;
  gemiddeldAantalWerknemersBuitenland?: number;
  wettelijkeVrijstelling?: string;
  statutaireBepalingen?: string;
  resultaatBestemming?: string;
  datumOndertekening?: Date;
  naamOndertekenaar?: string;
  plaatsOndertekening?: string;

  [key: string]: any;
}

export interface ToelichtingenVpb {
  naamDocument?: string;
  aanbiedingsBrief?: string;

  [key: string]: any;
}

export interface AllowanceEntity {
  id?: number;
  name?: string;
  taxPayerFiscalNumber?: string;
  sstRelationId?: string;
  year?: number;
  toeslagen?: Toeslagen;
  lastOpeningDate?: Date;
  submissionDate?: Date;
  clientId?: number;

  [key: string]: any;
}

export interface Dividendbelasting {
  contactPersoon: ContactPersoon;
  dienstverlener?: Dienstverlener;
  /** DividendPaymentTotal */
  bedragDividenduitkering: number;
  /** DividendMadeAvailableDate */
  datumBeschikbaarstelling: Date;
  datumIndieningAangifte: Date;
  /** FiscalInvestmentInstitutionIndication */
  fiscaleBeleggingsinstelling: boolean;
  inhoudingsplichtige?: Fonds;
  aangifteDb?: AangifteDb;
  opgaafDb?: OpgaafDb;

  [key: string]: any;
}

/** WithholdingAgent or SubFund */
export interface Fonds {
  /** WithholdingAgentIdentificationNumber */
  rsinInhoudingsplichtige: string;
  /** WithholdingAgentName */
  naamInhoudingsplichtige: string;
  /** InternationalSecuritiesIdentificationNumber */
  isinEffectNumber?: string;

  [key: string]: any;
}

/** SubstantialInterestRevenueEntitlement */
export interface Gerechtigde {
  /** RevenueEntitlementIdentification */
  fiscaalNummerGerechtigde: string;
  /** RevenueEntitlementName */
  naamGerechtigde: string;
  /** RevenueEntitlementDividendPayment */
  dividendGerechtigde: number;
  /** RevenueEntitlementInterestSize */
  percentageBelang?: number;
  /** IndicationQualificationDisposalRevenueEntitlement */
  indicatieKwalificatieBeschikking: boolean;
  /** SharesNumber */
  aantalAandelen?: number;
  /** DividendPaymentPerShare */
  dividendPerAandeel?: number;

  [key: string]: any;
}

/** WithholdingExemption */
export interface InhoudingsVrijstelling {
  /** WithholdingExemption */
  bedragInhoudingsvrijstelling: number;
  /** StatementArticle1abIndication */
  indicatieVerklaringArt1ab?: boolean;
  /** StatementArticle1acIndication */
  indicatieVerklaringArt1ac?: boolean;
  /** PurchaseArticle4cIndication */
  indicatieInkoopArtikel4c?: boolean;
  /** ShareType */
  omschrijvingAandelenInkoop?: string;
  /** NominalCapitalPaidUp */
  opAandelenGestortKapitaal?: number;
  /** PurchaseOwnShares */
  bedragInkoopEigenAandelen?: number;
  /** StatementArticle1acIndication */
  opbrengstGerechtigden: Gerechtigde[];

  [key: string]: any;
}

/** LiquidationPayment */
export interface LiquidatieUitkering {
  /** LiquidationPaymentTotal */
  bedragDividenduitkering: number;
  /** ShareCapitalAveragePaidUp */
  gemiddeldGestortKapitaal: number;

  [key: string]: any;
}

export interface OpgaafDb {
  /** ExemptedDividendPaymentTotal */
  bedragDividenduitkering: number;
  /** NominalPaidUpCapitalTotal */
  bedragNominaalGestortKapitaal: number;
  /** VotingSharesNumberTotal */
  totaalAantalStemgerechtigdeAandelen: number;
  opgaafSpecificaties: OpgaafSpecificatie[];

  [key: string]: any;
}

/** DividendSpecification */
export interface DividendSpecificatie {
  subfund?: Fonds;
  /** DividendPaymentFormAmount */
  bedragDividenduitkering: number;
  /** UntaxedProhibitionExtraterritorialLevy */
  bedragOnbelastVerbodExtraterritorialeHeffing?: number;
  liquidatieUitkering?: LiquidatieUitkering;
  inhoudingsVrijstelling?: InhoudingsVrijstelling;
  belastVerdragsTarief?: BelastVerdragsTarief;
  belastNormaalTarief?: BelastNormaalTarief;
  afdrachtsVermindering?: AfdrachtsVermindering;

  [key: string]: any;
}

export interface AangifteDb {
  /** DividendTaxTaxReturnIdentificationNumber */
  aangifteNummer: string;
  volgNummer: string;
  /** DividendTaxToBePaid */
  verschuldigdeBelasting: number;
  /** SharePremiumBonusSharesPayment */
  bedragAgioInBonusaandelen?: number;
  /** SharePremiumMoneyPayment */
  bedragAgioInGeld?: number;
  /** SharePremiumBeforeDividendPayment */
  standAgioVoorUitkering?: number;
  /** PurchaseSharesExemptedWrongly */
  bedragTenOnrechteVrijgesteldeInkoopAandelen?: number;
  /** DividendSpecification */
  dividendSpecificaties?: DividendSpecificatie[];

  [key: string]: any;
}

/** ContributionReductions */
export interface AfdrachtsVermindering {
  /** DividendTaxReductionArticle11 */
  bedragVerminderingArtikel11?: number;
  /** DividendTaxWithheldArticle11a */
  bedragIngehoudenBelastingArtikel11a?: number;
  /** DividendTaxForeignWithheldArticle11a */
  bedragIngehoudenBuitenlandseBronbelasting?: number;
  /** DividendTaxWithheldArticle12 */
  bedragIngehoudenBelastingArtikel12?: number;
  /** ContributionReductionArticle12 */
  bedragVerminderingArtikel12?: number;

  [key: string]: any;
}

/** OrdinaryRate */
export interface BelastNormaalTarief {
  /** PaymentOrdinaryRate */
  bedragBelastNormaalTarief: number;
  /** SubstantialInterestRevenueEntitlement */
  aanmerkelijkBelangHouders?: Gerechtigde[];

  [key: string]: any;
}

/** SettlementRate */
export interface BelastVerdragsTarief {
  /** ConventionApplicationAmount */
  bedragMetVerdragstoepassing: number;
  /** LandCode ISO 3166 */
  landCode: string;
  /** ConventionPercentage */
  verdragsPercentage: number;
  /** ConventionApplicationAuthorisationIndication */
  indicatieVergunningVerdragstoepassing: boolean;
  /** IB92UniversalIndication */
  indicatieIB92Universeel: boolean;
  /** IB96USAIndication */
  indicatieIB96Usa: boolean;
  /** Form6166Indication */
  indicatieForm6166: boolean;
  /** TaxDuePerDividend */
  belastingPerDividend?: number;

  [key: string]: any;
}

export interface OpgaafSpecificatie {
  /** HybridEntityParticipantUnderlyingIndication */
  indicatieAchterliggendePartijIsHybrideEntiteit: boolean;
  /** HybridEntityIndication */
  indicatieHybrideEntiteit: boolean;
  /** ExemptedDividendPayment */
  bedragVrijgesteldeUitkering: number;
  /** NominalPaidUpCapital */
  bedragNominaalGestortKapitaal: number;
  /** VotingSharesNumber */
  aantalStemgerechtigdeAandelen: number;
  /** VotingRightsPercentage */
  percentageStemrechten: number;
  /** RevenueEntitlementIdentificationNumber */
  fiscaalNummerGerechtigde: string;
  /** RevenueEntitlementReportName */
  naamGerechtigde: string;
  /** StreetNameAbroad */
  straatGerechtigde: string;
  /** HouseNumberAbroad */
  huisNummerGerechtigde: string;
  /** PostalCodeAbroad */
  postCodeGerechtigde: string;
  /** PlaceOfResidenceAbroad */
  woonplaatsGerechtigde: string;
  /** CountryCodeISO */
  landCode: string;

  [key: string]: any;
}

/** IncomeAndHouseHold */
export interface GezinEninkomenPerMaand {
  /** PreliminaryRefundHealthCareAllowance */
  maand: number;
  /** HasFiscalPartner */
  toeslagPartner: boolean;
  /** DateOIfBirthPartner */
  geboortedatumPartner?: Date;
  /** TaxIdentificationNumberPartner */
  bsnPartner?: string;
  /** AllowanceIncomeAmountTaxPayer */
  toetsinkomenAangever: number;
  /** AllowanceIncomeAmountPartner */
  toetsinkomenPartner?: number;
  /** AllowanceWealthTaxPayer */
  toetsvermogenAangever?: number;
  /** AllowanceWealthPartner */
  toetsvermogenPartner?: number;
  /** TaxPayerHasHealthCareInsurance */
  aangeverHeeftZorgverzekering: boolean;
  /** PartnerHasHealthCareInsurance */
  partnerHeeftZorgverzekering?: boolean;

  [key: string]: any;
}

/** RentAllowanceSpecific */
export interface Huurtoeslag {
  huurwoningen?: Woning[];
  /** PreliminaryRefundRentAllowance */
  alOntvangenHuurtoeslag?: number;

  [key: string]: any;
}

/** Children */
export interface Kind {
  /** ChildName */
  voornaam?: string;
  /** ChildDateOfBirth */
  geboortedatum: Date;
  /** ChildDateOfDecease */
  datumOverlijden?: Date;
  /** ChildTaxIdentificationNumber */
  bsn?: string;
  /** Staat het kind ten minste 6 maanden ingeschreven op het adres van de aangever? */
  ingeschrevenOpAdresAangever: boolean;
  /** Staat het kind ten minste 6 maanden ingeschreven op het adres van de partner? */
  ingeschrevenOpAdresPartner?: boolean;
  /** Only submit if FALSE.equals(ingeschrevenOpAdresAangever). Relevant voor de berekening van de IACK */
  bijExWoonAdres?: boolean;
  /** Only submit if FALSE.equals(ingeschrevenOpAdresAangever). Relevant voor de berekening van de IACK */
  coOuderschap?: boolean;
  /** Only submit if FALSE.equals(ingeschrevenOpAdresAangever). Relevant voor de berekening van de IACK */
  tenMinsteDrieDagenPerWeekWoonachtig?: boolean;
  /** Only relevant for allowences (Toeslagen) */
  ouderOntvangtKinderbijslag?: boolean;
  /** Only relevant for allowences (Toeslagen) */
  onderhoudBelangrijkeMate?: boolean;

  opvangPerKind?: OpvangPeriodes[];

  [key: string]: any;
}

/** DayCareSpecific */
export interface Kinderopvangtoeslag {
  /** WorkingHoursPerWeekFirstParent */
  aantalWerkurenPerWeekEersteOuder: number;
  /** WorkingHoursPerWeekSecondParent */
  aantalWerkurenPerWeekTweedeOuder?: number;
  /** FirstParentIsStudent */
  eersteOuderStudeert: boolean;
  /** SecondParentIsStudent */
  tweedeOuderStudeert?: boolean;
  /** PreliminaryRefundDayCareAllowance */
  alOntvangenKOT?: number;

  [key: string]: any;
}

/** ChildDependendAllowanceSpecific */
export interface Kindgebondenbudget {
  /** PreliminaryRefundChildDependendAllowance */
  alOntvangenKGB?: number;

  [key: string]: any;
}

/** InhabitantSpecification */
export interface Medebewoner {
  /** InhabitantName */
  naam?: string;
  /** InhabitantDateOfBirth */
  geboortedatum: Date;
  /** InhabitantIdentificationNumber */
  bsn: string;
  /** InhabitantIncome */
  inkomen: number;
  /** InhabitantWealth */
  toetsvermogen: number;
  periodeSamenwonend: Periode;

  [key: string]: any;
}

/** DayCareSpecificPresentation */
export interface OpvangPeriodes {
  /** DayCareMonthlyHours */
  urenPerMaand: number;
  periodeOpvang: Periode;
  /** DayCareHourlyRate */
  uurprijs: number;
  /** KindOfDayCare */
  opvangVorm: OpvangPeriodesOpvangVorm;
  /** DayCareSort */
  soortOpvang: OpvangPeriodesSoortOpvang;
  /** DayCareCenterNamel */
  naamKinderopvanginstelling: string;
  /** www.landelijkregisterkinderopvang.nl */
  identificatienummerInstelling: string;

  [key: string]: any;
}

/** only if SOORT starts with CORRECTIE */
export interface Periode {
  /** yyyy-MM-dd */
  begindatum?: Date;
  /** yyyy-MM-dd */
  einddatum?: Date;

  [key: string]: any;
}

export interface Toeslagen {
  verzendGegevens?: VerzendGegevens;
  /** FiscalYear */
  berekeningsjaar?: number;
  /** DateOfBirth */
  geboortedatumAanvrager?: Date;
  /** TaxIdentificationNumber */

  aanvrager?: PersoonToeslagen;

  bsn?: string;
  /** Children */
  kinderen?: Kind[];
  /** IncomeAndHouseHold */
  inkomensgegevens?: GezinEninkomenPerMaand[];
  zorgtoeslag?: Zorgtoeslag;
  huurtoeslag?: Huurtoeslag;
  kot?: Kinderopvangtoeslag;
  kgb?: Kindgebondenbudget;

  [key: string]: any;
}

/** IdentificationDetails */
export interface VerzendGegevens {
  /** UniqueMessageId */
  kenmerk: string;
  /** TaxConsultantNumber */
  beconNummer?: string;
  /** MessageSourceIdentification */
  bronidentificatie?: string;
  /** CommencingDate */
  ingangsdatumWijziging: Date;
  /** RequestType */
  actie: VerzendGegevensActie;

  [key: string]: any;
}

export interface Woning {
  bewoondePeriode: Periode;
  /** HouseNumberNL */
  huisnummer: string;
  /** HouseNumberAddition */
  huisnummerToevoeging?: string;
  /** PostalCode */
  postcode: string;
  /** PlaceOfResidence */
  woonplaats?: string;
  /** PlainRent */
  kaleHuurprijsPerMaand: number;
  /** Energycosts */
  energiekostenPerMaand?: number;
  /** Caretakercosts */
  huismeersterkostenPerMaand?: number;
  /** ServiceRecreationRoomCosts */
  algemeneservicePerMaand?: number;
  /** Cleaningcosts */
  schoonmaakkostenPerMaand?: number;
  /** ReceivedRentalAllowanceForHighEquity */
  kreegHuursubsidieHoogVermogen?: boolean;
  uitzonderingVoorRekenhuurVanToepassing?: boolean;
  /** InhabitantSpecification */
  medebewoners?: Medebewoner[];
  aangepasteWoning?: boolean;

  [key: string]: any;
}

/** HealthInsuranceSpecific */
export interface Zorgtoeslag {
  /** PreliminaryRefundHealthCareAllowance */
  alOntvangenZorgtoeslag?: number;

  [key: string]: any;
}

export interface ApprovalEntity {
  id?: number;
  emailFrom?: string;
  nameFrom?: string;
  officeFrom?: string;
  emailTo?: string;
  nameTo?: string;
  message?: string;
  attachmentName?: string;
  attachmentPdf?: string;
  attachmentJson?: any;
  securityCode?: string;
  href?: string;
  dateCreation?: Date;
  dateExpriration?: Date;
  send?: boolean;
  dateApproval?: Date;
  approved?: boolean;
  processed?: boolean;
  messageDisapproval?: string;
  documentType?: string;
  documentYear?: string;
  documentId?: string;

  [key: string]: any;
}

/** Specification shareholders */
export interface Aandeelhouder {
  /** ShareholderDirectorLargeShareholderIdentificationNumber */
  bsnNatuurlijkPersoon?: string;
  /** ShareholderName */
  naamAandeelhouder?: string;
  adresAandeelhouder?: Adres;
  /** ShareholderOrdinarySharesNominalValue */
  nominaleWaardeGewoneAandelen?: number;
  /** ShareholderPrefenceSharesNominalValue */
  nominaleWaardePreferenteAandelen?: number;
  /** ShareholderPrioritySharesNominalValue */
  nominaleWaardePrioriteitsAandelen?: number;
  /** ShareholderIssuedCapitalPercentage */
  percentageNominaleKapitaal?: number;
  /** ShareholderDirectorLargeShareholderDividendSubjectToDividendTax */
  ontvangenDividend?: number;
  /** ShareholderClaimTaxpayerOnShareholder */
  vorderingOpAandeelhouder?: number;
  /** ShareholderInterestReceived */
  ontvangenRenteVanAandeelhouder?: number;
  /** ShareholderTaxpayerDebtToShareholder */
  schuldAanAandeelhouder?: number;
  /** ShareholderInterestPaid */
  betaaldeRenteAanAandeelhouder?: number;
  /** ShareholderInformalCapitalSizeThroughOrByThisShareholder */
  infokapStortingDoorAandeelhouder?: number;

  [key: string]: any;
}

/** InnovationboxBusinessAssetsSpecification */
export interface Activum {
  /** InnovationBoxBusinessAssetsDescription */
  omschrijving: string;
  /** InnovationBoxBusinessAssetsProductionCosts */
  voortbrengingskosten: number;

  [key: string]: any;
}

/** AddressRecipientAlimony */
export interface Adres {
  /** StreetName */
  straat?: string;
  /** HouseNumberNL */
  huisNummer?: number;
  /** HouseNumberAddition */
  huisNummerToevoeging?: string;
  /** PostalCode */
  postcode?: string;
  /** PlaceOfResidence */
  woonplaats?: string;
  /** ISO 3166 land codes 3-characters */
  landCode?: string;

  [key: string]: any;
}

/** AgriculturalActivitiesSpecification */
export interface AgrarischeActiviteiten {
  /** AgriculturalActivitiesBusinessName */
  naamOnderneming: string;
  /** AgriculturalEnterpriseType */
  aardActiviteiten: string;
  /** NationalAgriculturalStandardsDeviationExists */
  afwijkingVanLandbouwnormen: boolean;
  specificatieAfwijkingLandbouwnormen?: OmschrijvingEnBedrag;
  /** SoilBelgiumOrGemanyExists */
  landbouwGrondenInBelgieOfDuitsland: boolean;
  /** DisposalLandInConnectionWithAgriculturalActivitiesExists */
  vervreemdingVanGrond: boolean;
  /** DisposalPropertiesExists */
  vervreemdingOnroerendeZaken: boolean;
  /** DisposalPropertiesFiscalReserveWriteOffExists */
  vervreemdingOnroerendeZakenAfgeboekteReserve: boolean;
  /** DisposalLandToFarmerExists */
  vervreemdingAgrarischeGrondAanAgrarier: boolean;
  /** DemolitionInConnectionWithPurchaseOrDisposalLandToFarmerExists */
  opstallenGeslooptInVerbandMetVervreemding: boolean;
  /** ProductionRightsFiscalBegin */
  productierechtenFiscaalBegin?: number;
  /** ProductionRightsFiscalEnd */
  productierechtenFiscaalEnd?: number;
  /** ProductionRightsPurchaseOrProductionCostsFiscal */
  productierechtenFiscaalAanschaffingskosten?: number;
  /** AnimalsFiscalBegin */
  dierenFiscaalBegin?: number;
  /** AnimalsFiscalEnd */
  dierenFiscaalEnd?: number;
  /** AnimalsPurchaseOrProductionCostsFiscalAmount */
  dierenFiscaalAanschaffingskosten?: number;
  /** AnimalsResidualValueFiscal */
  dierenFiscaalRestwaarde?: number;
  /** PlantsAndSeedsAndStandsFiscalBegin */
  plantEnPootgoedFiscaalBegin?: number;
  /** PlantsAndSeedsAndStandsFiscalEnd */
  plantEnPootgoedFiscaalEnd?: number;
  /** PlantsSeedsAndStandsPurchaseOrProductionCostsFiscalAmount */
  plantEnPootgoedFiscaalAanschaffingskosten?: number;
  /** PlantsAndSeedsAndStandsResidualValueFiscal */
  plantEnPootgoedFiscaalRestwaarde?: number;
  /** PlantsAndSeedsAndStandsFiscalBegin */
  overigeActivaLandbouwBegin?: number;
  /** PlantsAndSeedsAndStandsFiscalEnd */
  overigeActivaLandbouwEnd?: number;
  /** PlantsAndSeedsAndStandsFiscal */
  overigeActivaLandbouwAanschaffingskosten?: number;
  /** PlantsAndSeedsAndStandsFiscal */
  overigeActivaLandbouwRestwaarde?: number;
  /** StockAnimalsFiscalBegin */
  voorraadDierenFiscaalBegin?: number;
  /** StockAnimalsFiscalEnd */
  voorraadDierenFiscaalEnd?: number;
  /** FlowerBulbsFiscalBegin */
  voorraadBoelbollenFiscaalBegin?: number;
  /** FlowerBulbsFiscalEnd */
  voorraadBoelbollenFiscaalEnd?: number;
  /** MushroomsFiscalBegin */
  voorraadChampignonsFiscaalBegin?: number;
  /** MushroomsFiscalEnd */
  voorraadChampignonsFiscaalEnd?: number;
  /** FieldEquipmentFiscalBegin */
  voorraadVeldinventarisFiscaalBegin?: number;
  /** FieldEquipmentFiscalEnd */
  voorraadVeldinventarisFiscaalEnd?: number;
  /** AgriculturalStockOtherFiscalBegin */
  voorraadOverigeLandbouwFiscaalBegin?: number;
  /** AgriculturalStockOtherFiscalEnd */
  voorraadOverigeLandbouwFiscaalEnd?: number;
  /** AgrarianNatureManagementSubsidyFiscal */
  subsidieNatuurbeheer?: number;
  /** WorkThirdPartiesFiscal */
  werkVoorDerden?: number;
  /** CartageFiscal */
  voergeldFiscaal?: number;
  /** ProductionRightsDepreciationFiscal */
  afschrijvingProductierechten?: number;
  vervreemdingGrond?: VervreemdingGrond;

  [key: string]: any;
}

/** General questions */
export interface AlgemeneVragen {
  /** RequestExplicitDecisionTaxAdministrationExists */
  verzoekExplicietStandpunt: boolean;
  /** RequestExplicitDecisionTaxAdministrationDescription */
  toelichtingAangifte?: string;
  /** FunctionalCurrencySchemeExists */
  regelingFunctioneleValuta: boolean;
  /** InnovationBoxUsed */
  gebruikInnovatiebox: boolean;
  /** HoldingOrFinancialOrLicenceActivitiesExists */
  internationaleHoustervennootschap: boolean;
  /** InvestmentInstitutionsDecreeApplicationExists */
  toepassingBesluitBeleggingsinstellingen: boolean;
  /** ProfitDeterminationAndReserveInsurersDecreeApplicationExists */
  toepassingBesluitWinstbepalingVerzekeraars: boolean;
  /** BusinessActivitiesChangeExists */
  activiteitenOndernemingGewijzigd: boolean;
  /** AssetsAndOrLiabilitiesValuationSystemChangeCorporationTaxExists */
  wijzigingWaarderingsstelsel: boolean;
  /** BusinessAssetsRandomDepreciationNetherlandsCorporationtaxExists */
  willekeurigAfschijven: boolean;
  /** PensionSchemeNewOrChangedExists */
  nieuweOfGewijzigdePensioenregeling: boolean;
  /** PensionClaimReducedExists */
  pensioenaanspraakVerminderd: boolean;
  /** DisposalConversionDepreciatedReceivableExists */
  vervreemdingAfgewaardeerdeVordering: boolean;
  /** DisposalSharesParticipatingInterestAtShareMergerOrSplitOffOrMergerExists */
  vervreemdeAandelenMetFiscaleClaim?: boolean;
  /** DeductableLossCurrencyParticipationAndParticipatingInterestExemption */
  aftrekValutaverliesOpDeelnemingen: boolean;
  /** DivisionShareCapitalChanged */
  verdelingAandelenkapitaalGewijzigd: boolean;
  /** SetoffLossConstraintTransferYear */
  beperkingVerliesverrekeningInOverdrachtsjaar: boolean;
  /** EarnOutSchemeExists */
  earnOutRegeling: boolean;
  /** CounterEvidenceSchemeLimitationInterestDeductionApplicationExists */
  toepassingTegenbewijsRenteaftrek: boolean;
  /** DebtsAffiliatedEntitiesOutsideTaxEntity */
  schulden10aBuitenFiscaleEenheid: boolean;
  /** CompensatingLevyInterestDebtReceiver */
  compenserendeHeffing10aSchulden: boolean;
  /** KnowledgeCompensatingLevyInterestReceiver */
  kennisCompenserende10aHeffingOntvanger: boolean;
  /** QualificationTaxableProfitExists */
  kwalificatieBelastbareWinst: boolean;
  /** QualificationTaxableProfitClaimsAndDebtsBalanceEntitiesAffiliatedWithTaxpayer */
  saldoVorderingenEnSchuldenVerbondenLichamen: number;
  /** LegalActionForeignShareholderOrLegalPersonExists */
  rechtshandelingenMetBuitenlandseAandeelhouders: boolean;
  /** LegalActionForeignShareholderOrLegalPersonMaterialImmaterialAssetsPaidAmount */
  betaaldBedragVoorActiva: number;
  /** BusinessReorganisationOrTransfersLocalFile */
  lokaalDossierBedrijfsreorganisatieOfAfdrachten: boolean;
  /** FiscalTransparantEntityBenefit */
  belangInFiscaalTransparanteEntiteit: boolean;
  /** TrustCapitalCreationOrTrustCapitalShareholderExists */
  vermogenAfgezonderdInApv: boolean;

  [key: string]: any;
}

/** LiquidAssetsTotalFiscal */
export interface BalansActiva {
  /** Description */
  omschrijving?: string;
  /** Balance Start Book Yeay */
  openingsbalans?: number;
  /** Balance End Book Yeay */
  slotbalans?: number;
  /** Nominal Value Or Purchase Or Production Costs */
  nominaleWaardeOfKostenprijs?: number;

  [key: string]: any;
}

/** balance sheet and profit and loss accounts of all fiscal unity members */
export interface BalansEnResultatenrekening {
  /** BusinessName */
  naamVennootschap: string;
  boekjaarVennootschap?: Periode;
  /** FiscalNumber */
  fiscaalNummer: string;
  /** BusinessActivitiesDescription */
  omschrijvingActiviteiten: string;
  /** SubsidiaryTaxEntityExists */
  dochtermaatschappijFiscaleEenheid: boolean;
  /** AgriculturalActivitiesExist */
  agrarischeActiviteiten: boolean;
  /** AdministrationIdentifier */
  administratieId?: string;
  /** GoodwillFiscal */
  goodwill?: BalansActiva[];
  /** IntangibleFixedAssetsOtherFiscal */
  overigeImmaterieleActiva?: BalansActiva[];
  /** BuildingsAndLandFiscal */
  gebouwenEnTerreinen?: BalansGebouwen[];
  /** MachinesAndInstallationsFiscal */
  machinesEnInstallaties?: BalansMVA[];
  /** FixedAssetsOtherFiscal */
  andereVasteActiva?: BalansMVA[];
  /** ParticipatingInterests */
  deelnemingen?: BalansActiva[];
  /** LongTermReceivablesGroupCompaniesFiscal */
  vorderingenLangGroepsmaatschappijen?: BalansActiva[];
  /** LongTermReceivablesParticipatingInterestCompaniesFiscal */
  vorderingenLangParticipanten?: BalansActiva[];
  /** FinancialFixedAssetsOtherFiscal */
  overigeFinancieelVasteActiva?: BalansActiva[];
  /** StockTotalFiscal */
  voorraden?: BalansActiva[];
  /** WorkInProgressFiscal */
  onderhandenWerk?: BalansActiva[];
  /** TradeAccountsReceivableFiscal */
  vorderingDebiteuren?: BalansActiva[];
  /** ValueAddedTaxReceivablesFiscal */
  vorderingenOmzetbelasting?: BalansOmzetbelasting[];
  /** ShortTermReceivablesGroupCompaniesFiscal */
  vorderingenKortGroepsmaatschappijen?: BalansActiva[];
  /** ShortTermReceivablesParticipatingInterestCompaniesFiscal */
  vorderingenKortParticipanten?: BalansActiva[];
  /** ReceivablesOtherFiscal */
  vorderingenOverig?: BalansActiva[];
  /** SecuritiesFiscal */
  effecten?: BalansActiva[];
  /** LiquidAssetsTotalFiscal */
  liquideMiddelen?: BalansActiva[];
  /** PaidCalledUpCapitalFiscal */
  gestortEnOpgevraagdKapitaal?: BalansPassiva[];
  /** InformalCapitalFiscal */
  informeelKapitaal?: BalansPassiva[];
  /** SharePremiumFiscal */
  agioreserve?: BalansPassiva[];
  /** RetainedProfitsFiscal */
  winstreserves?: BalansPassiva[];
  /** EqualizationReserveCostsFiscal */
  kostenEgalisatieReserve?: BalansVoorziening[];
  /** ReinvestmentReserveFiscal */
  herinvesteringsReserve?: BalansVoorziening[];
  /** Reinvestment Reserve End Of Year Specification */
  specificatieHerinvesteringsreserve?: Herinvesteringsreserve[];
  /** CompartmentReserveTaxed */
  compartimenteringsreserve?: BalansVoorziening[];
  /** TaxReservesOtherFiscal */
  overigeReserves?: BalansVoorziening[];
  /** WarrantyProvisionFiscal */
  garantieVoorzieningen?: BalansVoorziening[];
  /** ProvisionAnnuityPensionAndRightOfStanding */
  pensioenVoorzieningen?: BalansPassiva[];
  /** OldAgeObligation */
  oudedagsVoorzieningen?: BalansPassiva[];
  /** ProvisionsOtherFiscal */
  overigeVoorzieningen?: BalansVoorziening[];
  /** ConvertibleLoansFiscal */
  schuldenLanglopendConvertibles?: BalansPassiva[];
  /** BondsFiscal */
  schuldenLanglopendObligaties?: BalansPassiva[];
  /** LongTermDebtsGroupCompanies */
  schuldenLanglopendGroepsmaatschappijen?: BalansPassiva[];
  /** LongTermDebtsParticipatingInterestCompanies */
  schuldenLanglopendParticipanten?: BalansPassiva[];
  /** PayablesCreditInstitutionFiscal */
  schuldenLanglopendKredietinstellingen?: BalansPassiva[];
  /** LongTermDebtsOther */
  schuldenLanglopendOverig?: BalansPassiva[];
  /** AccountsPayableSuppliersTradeCreditors */
  crediteuren?: BalansPassiva[];
  /** ValueAddedTaxPayablesFiscal */
  schuldenOmzetbelasting?: BalansOmzetbelasting[];
  /** WageTaxDebt */
  schuldenLoonheffingen?: BalansPassiva[];
  /** ShortTermDebtsGroupCompanies */
  schuldenKortlopendGroepsmaatschappijen?: BalansPassiva[];
  /** ShortTermDebtsParticipatingInterestCompanies */
  schuldenKortlopendParticipanten?: BalansPassiva[];
  /** ShortTermDebtsOther */
  schuldenKortlopendOverig?: BalansPassiva[];
  /** TurnoverNetFiscal */
  nettoOmzet?: ResultatenRekening[];
  /** StockAndWorkInProgressChangeFiscal */
  wijzigingOnderhandenWerk?: ResultatenRekening[];
  /** CapitalizedProductionOwnBusinessFiscal */
  geactiveerdeProductieEigenBedrijf?: ResultatenRekening[];
  /** RevenuesOtherFiscal */
  overigeOpbrengsten?: ResultatenRekening[];
  /** RawAncillaryMaterialsPurchasePriceSalesFiscal */
  inkoopwaardeVerkopen?: ResultatenRekening[];
  /** OutsourcedWorkCostsAndOtherExternalCostsFiscal */
  kostenUitbesteedWerk?: ResultatenRekening[];
  /** WagesSalariesFiscal */
  lonenEnSalarissen?: ResultatenRekening[];
  /** SocialSecurityCostsFiscal */
  socialeLasten?: ResultatenRekening[];
  /** PensionCostsFiscal */
  pensioenLasten?: ResultatenRekening[];
  /** PersonnelCostsOtherFiscal */
  overigePersoneelskosten?: ResultatenRekening[];
  /** BenefitsAndWageSubsidiesReceivedFiscal */
  ontvangenVergoedingenEnSubsidies?: ResultatenRekening[];
  /** GoodwillDepreciationFiscal */
  afschrijvingenGoodwill?: ResultatenRekening[];
  /** IntangibleFixedAssetsOtherDepreciation */
  afschrijvingOverigeImmaterieleActiva?: ResultatenRekening[];
  /** CompanyBuildingsDepreciationFiscal */
  afschrijvingenGebouwen?: ResultatenRekening[];
  /** MachineryDepreciationFiscal */
  afschrijvingenMachines?: ResultatenRekening[];
  /** TangibleFixedAssetsOtherDepreciation */
  afschrijvingenOverig?: ResultatenRekening[];
  /** CarAndTransportCostsFiscal */
  autoEnTransportKosten?: ResultatenRekening[];
  /** AccommodationCostsFiscal */
  huisvestingsKosten?: ResultatenRekening[];
  /** MaintenanceOtherTangibleFixedAssetsFiscal */
  onderhoudsKosten?: ResultatenRekening[];
  /** SalesCostsFiscal */
  verkoopKosten?: ResultatenRekening[];
  /** CostOtherFiscal */
  overigeKosten?: ResultatenRekening[];
  /** RevenuesOtherReceivablesFiscal */
  financieleBaten?: ResultatenRekening[];
  /** InterestExpenditureEtcCostsDebtsFiscal */
  financieleLasten?: ResultatenRekening[];
  /** ParticipatingInterestResultTotalFiscal */
  resultaatDeelnemingen?: ResultatenRekening[];
  /** ExtraordinaryIncomeBusiness */
  buitengewoneBaten?: ResultatenRekening[];
  /** ExtraordinaryExpenditureBusiness */
  buitengewoneLasten?: ResultatenRekening[];

  [key: string]: any;
}

/** BuildingsAndLandFiscal */
export interface BalansGebouwen {
  /** Description */
  omschrijving?: string;
  /** Balance Start Book Yeay */
  openingsbalans?: number;
  /** Balance End Book Yeay */
  slotbalans?: number;
  /** Nominal Value Or Purchase Or Production Costs */
  nominaleWaardeOfKostenprijs?: number;
  /** Residual Value */
  restwaarde?: number;
  /** Building For Own Use */
  inEigenGebruik?: boolean;
  /** Soil Value */
  bodemwaarde?: number;

  [key: string]: any;
}

/** FixedAssetsOtherFiscal */
export interface BalansMVA {
  /** Description */
  omschrijving?: string;
  /** Balance Start Book Yeay */
  openingsbalans?: number;
  /** Balance End Book Yeay */
  slotbalans?: number;
  /** Nominal Value Or Purchase Or Production Costs */
  nominaleWaardeOfKostenprijs?: number;
  /** Residual Value */
  restwaarde?: number;

  [key: string]: any;
}

/** ValueAddedTaxPayablesFiscal */
export interface BalansOmzetbelasting {
  /** Description */
  omschrijving?: string;
  /** Balance Start Book Yeay */
  openingsbalans?: number;
  /** Balance End Book Yeay */
  slotbalans?: number;
  /** Nominal Value Or Purchase Or Production Costs */
  nominaleWaardeOfKostenprijs?: number;
  /** ValueAddedTaxPayableOrReceivablePartThisFinancialyear */
  ditBoekjaar?: number;
  /** ValueAddedTaxPayableOrReceivablePartPreviousFinancialyear */
  vorigeBoekjaar?: number;
  /** ValueAddedTaxPayableOrReceivablePartPrecedingPreviousFinancialyear */
  oudereBoekjaren?: number;

  [key: string]: any;
}

/** ShortTermDebtsOther */
export interface BalansPassiva {
  /** Description */
  omschrijving?: string;
  /** Balance Start Book Year */
  openingsbalans?: number;
  /** Balance End Book Year */
  slotbalans?: number;

  [key: string]: any;
}

/** ProvisionsOtherFiscal */
export interface BalansVoorziening {
  /** Description */
  omschrijving?: string;
  /** Balance Start Book Year */
  openingsbalans?: number;
  /** Balance End Book Year */
  slotbalans?: number;
  /** Provision Description */
  toelichting?: string;
  /** ProvisionAllocationAmount */
  dotatie?: number;
  /** ProvisionWithdrawal */
  onttrekking?: number;

  [key: string]: any;
}

/** Tax amount payable */
export interface BelastingBedrag {
  functioneleValuta?: FunctioneleValuta;
  /** PensionOrEarlyRetirementProvisionCausingTaxIncreaseAmount */
  grondslagVermeederingWegensAfkoopPensioen?: number;
  /** ComplianceRequirementsInstitutionsAndVentureCapitalCausingTaxIncreasePercentage */
  percentageVermeerderingStatusverliesVrijstelling?: number;
  /** ComplianceRequirementsInstitutionsAndVentureCapitalCausingTaxIncreaseAmount */
  grondslagVermeederingStatusverliesVrijstelling?: number;
  /** RightGivingEntitlementToPeriodicPaymentsCausingTaxIncreaseAmount */
  grondslagVermeerderingBelastingStamrecht?: number;
  /** ParticipatingInterestSetoffCalculatedAmount */
  berekendeDeelnemingsverrekening?: number;
  /** TaxationElsewhereDeduction */
  aftrekEldersBelast?: number;
  /** TaxForeignBusinessProfitSettled */
  aftrekEldersBelastVrijstellingBuitenlandseWinst?: number;
  /** DividendTaxTotal */
  dividendbelasting?: number;
  /** GamblingtaxTotal */
  kansspelbelasting?: number;
  /** PreliminaryTaxAssessment */
  voorlopigeAanslag?: number;

  [key: string]: any;
}

/** DoubleTaxationAvoidanceSettlementInnovationboxSpecification */
export interface BronheffingInnovatiebox {
  /** ISO 3166 */
  landcode: string;
  /** DoubleTaxationAvoidanceSettlementInnovationboxGrossRoyalties */
  brutoRoyalties?: number;
  /** DoubleTaxationAvoidanceSettlementInnovationboxRoyaltiesDeductibleCosts */
  aftrekbareKosten?: number;
  /** DoubleTaxationAvoidanceSettlementInnovationboxDeductibleTax */
  verrekenbareBronheffing: number;
  /** DoubleTaxationAvoidanceSettlementInnovationboxForwardShiftingPreviousYears */
  voortgewenteldeBronheffingVoorgaandeJaren?: number;

  [key: string]: any;
}

/** ResultsAbroad */
export interface Bronheffingen {
  /** CostsDeductionForeignTaxInsteadOfOffset */
  kostenaftrekInPlaatsVanVerrekening: boolean;
  /** DoubleTaxationAvoidanceSetoffMethodWaiveJointMethod */
  afzienVanGezamenlijkeMethode: boolean;
  /** DoubleTaxationAvoidanceFixedEstablishment */
  verrekeningBronbelastingVasteInrichting: boolean;
  /** DoubleTaxationAvoidanceSetoffMethodSpecification */
  buitenlandsebronheffingen?: Buitenlandsebronheffing[];
  /** DoubleTaxationAvoidanceSettlementInnovationboxSpecification */
  bronheffingInnovatiebox?: BronheffingInnovatiebox[];
  buitenlandseBeleggingsOnderneming?: BuitenlandseBeleggingsOnderneming;

  [key: string]: any;
}

/** DoubleTaxationAvoidanceForeignProfitSetoffMethod */
export interface BuitenlandseBeleggingsOnderneming {
  /** SetoffActualLeviedTaxRequest */
  verzoekVerrekeningGehevenBelasting: boolean;
  /** ProfitLowTaxationInvestmentCompanyEuroFunctionalCurrency */
  winstBeleggingsonderneming: number;
  /** ForwardShiftingForeignResultNegativeNotSettled */
  voortwentelingNietVerrekendBuitenlandsNegatiefResultaat?: number;
  /** ActualLeviedForeignTax */
  daadwerkelijkGehevenBelasting: number;
  /** ForwardShiftingForeignTaxNotSettled */
  voortwentelingNietVerrekendeBelasting: number;

  [key: string]: any;
}

/** DoubleTaxationAvoidanceSetoffMethodSpecification */
export interface Buitenlandsebronheffing {
  /** ISO 3166 */
  landcode: string;
  /** DoubleTaxationAvoidanceSetoffMethodGrossDividend */
  brutoDividend?: number;
  /** DoubleTaxationAvoidanceSetoffMethodGrossInterest */
  brutoRente?: number;
  /** DoubleTaxationAvoidanceSetoffMethodGrossRoyalties */
  brutoRoyalties?: number;
  /** DoubleTaxationAvoidanceSetoffMethodOtherGrossAmounts */
  overigeBrutoBerdragen?: number;
  /** DoubleTaxationAvoidanceSetoffMethodDeductibleCosts */
  aftrekbareKosten?: number;
  /** DoubleTaxationAvoidanceSetoffMethodNonRecoverableTaxAmount */
  verrekenbareBronheffing: number;
  /** DoubleTaxationAvoidanceSetoffMethodCarryForwardAmount */
  voortgewenteldeBronheffingVoorgaandeJaren?: number;

  [key: string]: any;
}

export interface CorporateTaxEntity {
  id?: number;
  name?: string;
  sstAdminId?: string;
  sstRelationId?: string;
  taxPayerFiscalNumber: string;
  taxPayerFiscalUnityNumber?: string;
  year?: number;
  taxType?: string;
  aangifte?: VpbAangifte;
  lastOpeningDate?: Date;
  submissionDate?: Date;
  submissionHerinnering?: boolean;
  submissionAanmaning?: boolean;
  clientId?: ClientEntity;

  [key: string]: any;
}

/** Specification participations */
export interface Deelneming {
  /** ParticipatingInterestName */
  naam: string;
  /** ParticipatingInterestIdentificationNumber */
  fiscaalNummer?: string;
  /** ParticipatingInterestPercentageInterest */
  percentageAandelenbezit: number;
  /** InterestParticipatingInterestNominalValue */
  nominaleWaardeAandelenbezit?: number;
  /** ParticipatingInterestSacrificedAmount */
  opgeofferdBedrag?: number;
  /** SheetValuationParticipatingInterestBalance */
  balanswaardering?: number;
  /** ParticipatingInterestBenefits */
  voordelenBoekjaar: number;
  /** ParticipatingInterestReceivableAmount */
  vorderingOpDeelneming?: number;
  /** InterestReceivedFromParticipatingInterest */
  renteOntvangenVanDeelneming?: number;
  /** ParticipatingInterestPayableAmount */
  schuldAanDeelneming?: number;
  /** InterestPaidToParticipatingInterest */
  renteBetaaldAanDeelneming?: number;
  situatiesDeelneming: SituatiesDeelneming;

  [key: string]: any;
}

export interface Dividenduitkering {
  /** yyyy-MM-dd, ProfitDistributionSubjectToDividendDate */
  datumUitkering: Date;
  /** yyyy-MM-dd, DividendTaxReturnDate */
  datumAangifteDividendbelasting?: Date;
  /** DividendTaxWithheldAmount */
  ingehoudenDividendbelasting: number;
  /** ProfitDistributionAmount */
  bedragDividenduitkering: number;

  [key: string]: any;
}

/** Specification fiscal unity */
export interface FiscaleEenheid {
  /** SubsidiariesJoiningTaxEntitySpecification */
  specificatieVoeging?: Voeging[];
  /** SubsidiariesRemovalTaxEntitySpecification */
  specificatieOntvoeging?: Ontvoeging[];
  /** TaxEntityTerminationDissolutionSettlementSubsidiariesSpecification */
  specificatieOntbinding?: Ontbinding[];

  [key: string]: any;
}

/** Functional currency */
export interface FunctioneleValuta {
  /** ISO code Euro foreign exchange rates 3-characters */
  valutaCode: string;
  /** ExchangeRateFinancialYearFunctionalCurrencySchemeAverage */
  gemiddeldeKoersFunctioneleValuta: number;
  /** FunctionalCurrencySchemeCurrencyFactor */
  valutaFactorFunctioneleValuta: number;

  [key: string]: any;
}

/** Holding And Licencing And Financing And Other Activities Specification */
export interface HFLOActiviteiten {
  /** HoldingActivitiesRevenues */
  opbrengstenHoudsteractiviteiten?: number;
  /** LicencingActivitiesRevenues */
  opbrengstenLicentieactiviteiten?: number;
  /** FinancingActivitiesRevenues */
  opbrengstenFinancieringsactiviteiten?: number;
  /** OtherActivitiesRevenues */
  opbrengstenOverigeactiviteiten?: number;
  /** HoldingActivitiesCosts */
  kostenHoudsteractiviteiten?: number;
  /** LicencingActivitiesCosts */
  kostenLicentieactiviteiten?: number;
  /** FinancingActivitiesCosts */
  kostenFinancieringsactiviteiten?: number;
  /** ActivitiesOtherCosts */
  kostenOverigeactiviteiten?: number;
  /** CommercialActivitiesGroupRelatedActivities */
  werkzaamhedenBinnenConcernverband?: boolean;
  /** CommercialActivitiesInterestOrRoyaltyGuidelineAppeal */
  beroepOpVerdragOfRichtlijn?: boolean;
  /** CommercialActivitiesRequirementsPresenceNetherlands */
  vereisteAanwezigheidInNederland?: boolean;

  [key: string]: any;
}

/** Reinvestment Reserve End Of Year Specification */
export interface Herinvesteringsreserve {
  /** ReinvestmentReserveDisposedBusinessAssetDescription */
  omschrijving: string;
  /** ReinvestmentReserveDisposedBusinessAssetYear */
  jaarVanVervreemding: number;
  /** ReinvestmentReserveDisposedBusinessAssetBookProfit */
  boekwinst: number;
  /** ReinvestmentReserveDisposedBusinessAssetDepreciationPercentage */
  afschrijvingspercentage: number;
  /** ReinvestmentReserveDisposedBusinessAssetBookValueAtTransferTime */
  boekwaardeOpVervreemdingsmoment: number;

  [key: string]: any;
}

/** Identifaction tax payer */
export interface Identificatie {
  /** LegalPersonName */
  naamLichaam: string;
  /** FiscalNumber */
  fiscaalNummer: string;
  /** IncomeTaxReturnSignatureInitials */
  voorlettersOndertekenaar?: string;
  /** IncomeTaxReturnSignaturePrefix */
  tussenvoegselOndertekenaar?: string;
  /** IncomeTaxReturnSignatureSurname */
  achternaamOndertekenaar?: string;
  /** IncomeTaxReturnSignatureFunctionSignatory */
  functieOndertekenaar?: string;
  /** IncomeTaxReturnSignatureTelephoneNumber */
  telefoonnummerOndertekenaar?: string;
  /** TaxConsultantNumber */
  beconnummer?: string;
  /** TaxReturnConcernsTaxEntity */
  aangifteFiscaleEenheid: boolean;

  [key: string]: any;
}

/** Specification innovation box assets and profits */
export interface Innovatiebox {
  /** InnovationboxBusinessAssetsSpecification */
  activumInInnovatiebox: Activum[];
  /** InnovationBoxStatementAgreement */
  vaststellingsOvereenkomst: boolean;
  /** InnovationBoxFlatRateArrangementExists */
  forfaitaireRegeling: boolean;
  /** InnovationBoxBalanceThresholdEndFinancialYear */
  saldoInTeLopenVoortbrengingskosten: number;
  /** InnovationBoxBenefitsExceedingThreshold */
  voordelenBovenDrempel?: number;
  /** InnovationBoxBenefitAfterwardsNoPrerogative */
  winstUitVoordelenNietToegewezen?: number;

  [key: string]: any;
}

/** BusinessAssetInvestmentSpecification */
export interface Investering {
  /** BusinessAssetEnvironmentalEnergyInvestmentDescription */
  omschrijving: string;
  /** BusinessAssetEnvironmentalEnergyInvestmentFinancialYearAmount */
  totaleInvesteringInBoekjaar: number;
  /** BusinessAssetMaximumInvestmentAmount */
  maximaleInvesteringBedragBedrijfsMiddel?: number;
  /** yyyy-MM-dd, TaxEntitBusinessAssetEnvironmentalEnergyInvestmentFinancialYearAmountyJoiningDate */
  datumIngebruikname?: Date;
  /** BusinessAssetEnvironmentalEnergyInvestmentPaidThisFinancialYear */
  bedragBetaaldInBoekjaar?: number;
  /** BusinessAssetEnvironmentalEnergyInvestmentNotificationNumber */
  meldingsNummer?: string;
  /** BusinessAssetEnvironmentalInvestmentLetter */
  miaLetter?: string;
  claimKia: boolean;
  claimEia: boolean;
  claimMia: boolean;

  [key: string]: any;
}

/** Investments */
export interface Investeringen {
  /** BusinessAssetInvestmentSpecification */
  investeringslijst?: Investering[];
  /** InvestmentAllowanceSmallScaleCaribeanKingdomOfTheNetherlandsThisFinancialYear */
  kiaCaribischDeelVanNederland?: number;
  /** InvestmentAllowancesPreviousYearsTotal */
  investeringsaftrekUitVoorgaandeJaren?: number;
  /** ResearchAndDevelopmentDeduction */
  rdaAftrek?: number;
  /** DisinvestmentAdditionAmount */
  desinvesteringsbijtelling?: number;
  /** InvestmentDeductionCompanyTakeOverLegacy */
  investeringsaftrekBijOvernameUitNalatenschap?: boolean;

  [key: string]: any;
}

/** Corporation Tax Non Deductible Amounts */
export interface NietAftrekbareBedragen {
  dividenduitkeringen?: Dividenduitkering[];
  /** CorporationTaxWithdrawnFromEquityCapital */
  vennootschapsbelasting?: number;
  /** ForeignTaxAmountThisFinancialYearAppliedDoubleTaxAvoidance */
  buitenlandseWinstbelasting?: number;
  /** ProfitDistributionsByCooperationsNonDeductibelPart */
  nietAftrekbareUitdelingCooperatie?: number;
  /** ProfitDistributionOtherNonDeductibleAmount */
  andereUitdelingenVanWinst?: number;
  /** SupervisoryDirectorsFeesBalanceNonDeductiblePart */
  nietAftrekbareCommissarisbeloningen?: number;
  /** ProfitSharingBonusesNonDeductiblePart */
  nietAftrekbareTantiemes?: number;
  /** CapitalProvisionPaymentsNonDeductiblePart */
  nietAftrekbareKapitaalsvergoedingen?: number;
  /** ResultTemporarilyPurchasedSharesEmployeeOptionsTotal */
  resultaatTijdelijkIngekochteAandelen?: number;
  /** CostsUponTaxEntityPurchaseRemainingSharesSubsidiaryInTaxEntityTotal */
  kostenFiscaleEenheidAankoopResterendeBelang?: number;

  [key: string]: any;
}

/** Object Exemption Foreign Business Profits */
export interface ObjectVrijstelling {
  /** ISO 3166 */
  vestigingsland: string;
  /** ForeignBusinessProfitEuroFunctionalCurrency */
  buitenlandseWinst: number;
  /** LossBefore1January2012ToOvertake */
  inTeHalenVerliezen?: number;
  /** LossCessationForeignCompany */
  stakingsverlies?: number;
  /** ForeignBusinessProfitBalanceCumulative */
  saldoBuitenlandseOndernemingswinsten: number;

  [key: string]: any;
}

/** TaxSparingCreditBox2 */
export interface OmschrijvingEnBedrag {
  /** Description */
  omschrijving?: string;
  /** Amount */
  bedrag?: number;

  [key: string]: any;
}

/** TaxEntityTerminationDissolutionSettlementSubsidiariesSpecification */
export interface Ontbinding {
  /** SubsidiaryName */
  naamDochter: string;
  /** SettlementDateSubsidiariesTerminationFromTaxentityByDissolutionAndSettlement */
  ontbindingsdatum: Date;
  /** SettlementSubsidiaryUnpaidDebts */
  onbetaaldGeblevenSchulden: number;

  [key: string]: any;
}

/** SubsidiariesRemovalTaxEntitySpecification */
export interface Ontvoeging {
  /** SubsidiaryName */
  naamDochter: string;
  /** SubsidiaryRemovedSacrificedAmount */
  voorDochterOpgeofferdeBedrag: number;
  /** MutualReceivableOccasionRemovingSubsidiaryTaxEntityValuation */
  waarderingOnderlingeVorderingDochter?: number;
  /** MutualDebtOccasionRemovingSubsidiaryTaxEntityValuation */
  waarderingOnderlingSchuldDochter?: number;
  /** MutualReceivableOtherCompanyValuation */
  waarderingOnderlingeVorderingAndereMaatschappij?: number;
  /** MutualDebtOtherCompanyValuation */
  waarderingOnderlingeSchuldAndereMaatschappij?: number;
  /** ApplicationArticle15aiExists */
  toepassing15ai: boolean;
  /** CapitalComponentOwnedNewOwnerArticle15aiExists */
  vermogensbestanddeel15aiInBezitOvernemer?: boolean;
  /** CapitalComponentNotOwnedNewOwnerArticle15aiExists */
  vermogensbestanddeel15aiInBezitOverdrager?: boolean;
  /** CapitalComponentOccasionRemovalSubsidiaryTaxEntityCommercialValue */
  wevVermogensbestanddeelBijOntvoeging?: number;
  /** CapitalComponentAtUseCounterEvidenceValuation */
  waarderingVermogensbestanddeelBijTegenbewijs?: number;
  /** CapitalComponentOccasionRemovalSubsidiaryBookValue */
  boekwaardeVermogensbestanddeelBijOntvoeging?: number;
  /** TaxEntityProfitTransferCapitalComponent */
  winstFEdoorOverdrachtVermogensbestanddeel?: number;
  /** ReinvestmentReserveBuildUpByNewOwnerExists */
  vormingHIRdoorOvernemerVanToepassing?: boolean;
  /** ReinvestmentReserveUsageByNewOwnerExists */
  aanwendingHIRdoorOvernemer?: boolean;
  /** ProfitTaxEntityDueToFormingReinvestmentReserveNewOwner */
  winstFEvanwegeVrijvalHIR?: number;
  /** ReplacingBusinessAssetsOccasionRemovalSubsidiaryTaxEntityCommercialValue */
  wevVervangendeBedrijfsmiddelBijOntvoeging?: number;
  /** ReplacingBusinessAssetsOccasionRemovalSubsidiaryBookValue */
  boekwaardeVervangendeBedrijfsmiddelBijOntvoeging?: number;
  /** ProfitRevaluationReplacingBusinessAssetsOccasionRemovalSubsidiaryTaxEntity */
  winstFeDoorHerwaarderingVervangendeBedrijfsmiddel?: number;
  /** ReinvestmentReserveOccasionRemovingSubsidiaryTaxEntityExists */
  hirOpBalansOntvoegdeDochter?: boolean;
  /** ReinvestmentReserveReplacementIntentionOccasionRemovingSubsidiaryTaxEntityExists */
  vervangingsvoornemenOntvoegdeDochter?: boolean;

  [key: string]: any;
}

/** Interest Deduction Limitation Generic Calculation */
export interface RenteAftrekBeperking {
  /** PublicPrivateCollaborationParticipation */
  participatieInPPS?: boolean;
  /** InterestCostsPreviouslyCapitalizedInterest */
  renteKostenVoorheenGeactiveerdeRente?: number;
  /** CostsOnDebtsCorrection */
  correctieOpSomKostenSchulden?: number;
  /** ReceivablesOnRevenuesTotalCorrection */
  correctieOpSomOpbrengstenVanVorderingen?: number;
  /** InterestOnMoneyLoansProductionCostsActivated */
  renteVoortbrengingskostenGeactiveerd?: number;
  /** InterestNonDeductibleAcquisitionDebts */
  nietAftrekbareRenteOvernameschulden?: number;
  /** PreviouslyTemporisedInterestThisFinancialYearDeductible */
  inBoekjaarAfrekbareVoorheenGetemporiseerdeRente?: number;
  /** Test */
  vergoedingenEnWaardemutatiesArtikel10b?: number;
  /** HybridMismatchesInterestNeutralization */
  renteInNeutraliseringHybridMismatch?: number;
  /** ObjectExemptionInterest */
  renteInObjectVrijstelling?: number;
  /** TangibleAndIntangibleFixedAssetsValuationChanges */
  waardeveranderingVasteActiva?: number;
  /** InterestTransferForwardShiftingPreviousYears */
  teVerrekenenRenteUitVoorgaandeJaren?: number;
  /** InterestToBeSettledPreviousYearsTaxEntityCompanyIdentificationNumberInterestPlaced */
  rsinMoedermaatschappijGestaldeRente?: string;
  /** InterestToBeSettledPreviousYearsTaxEntityInterestCompanyToBeSettledThisFinancialYearStartDate */
  startBoekjaarMoederTeVerrekenenRente?: Date;
  /** InterestToBeSettledPreviousYearsTaxEntityInterestCompanyToBeSettledThisFinancialYearEndDate */
  eindeBoekjaarMoederTeVerrekenenRente?: Date;
  /** InterestToBeSettledPreviousYearsTaxEntityInterestCompanyToBeSettledThisFinancialYear */
  verrekendeRenteMaatschappijDitBoekjaar?: number;

  [key: string]: any;
}

/** ExtraordinaryExpenditureBusiness */
export interface ResultatenRekening {
  /** Description */
  omschrijving?: string;
  /** Amount */
  bedrag?: number;

  [key: string]: any;
}

/** InterestsWithParticipatingInterestSpecification */
export interface SituatiesDeelneming {
  /** ParticipatingInterestJoiningOrRemovalTaxEntityExists */
  dochterIsGevoegdofOntvoegd?: boolean;
  /** yyyy-MM-dd, TaxEntityJoiningDate */
  voegingsdatum?: Date;
  /** yyyy-MM-dd, TaxEntityRemovalDate */
  ontvoegingsdatum?: Date;
  /** ParticipatingInterestObtainmentEnlargementExists */
  belangIsVerworvenOfVergroot?: boolean;
  /** ParticipatingInterestObtainmentEnlargementPercentage */
  percentageVerwerving?: number;
  /** ParticipatingInterestObtainmentEnlargementNominalValue */
  nominaleWaardeVerworvenBelang?: number;
  /** ParticipatingInterestObtainmentEnlargementSacrificedAmount */
  opgeofferdBedragVerworvenBelang?: number;
  /** ParticipatingInterestObtainedAffiliatedPerson */
  belangIsVerworvenVanVerbondenPersoon?: boolean;
  /** ParticipatingInterestObtainedGrossBenefits */
  brutoVoordelenVerworvenDeelneming?: number;
  /** ParticipatingInterestObtainmentEnlargementCosts */
  kostenVerwervingDeelneming?: number;
  /** ParticipatingInterestAlienationDiminutionExists */
  belangIsVerkochtOfVerkleind?: boolean;
  /** ParticipatingInterestAlienationDiminutionPercentage */
  percentageVervreemding?: number;
  /** ParticipatingInterestAlienationDiminutionNominalValue */
  nominaleWaardeVereemdeBelang?: number;
  /** ParticipatingInterestAlienationDiminutionRevenue */
  opbrengstVervreemdeBelang?: number;
  /** ParticipatingInterestAlienationAffiliatedPerson */
  belangIsVervreemdAanVerbondenPersoon?: boolean;
  /** ParticipatingInterestAlienationGrossBenefits */
  brutoVoordelenVervreemdeDeelneming?: number;
  /** ParticipatingInterestAlienationCosts */
  kostenVervreemdingDeelneming?: number;
  /** ParticipatingInterestLiquidationExists */
  deelnemingIsGeliquideerd?: boolean;
  /** yyyy-MM-dd, InterestsWithParticipatingInterestSettlementDate */
  vereffeningsdatum?: Date;
  /** ParticipatingInterestLiquidationLoss */
  liquidatieverlies?: number;
  /** ParticipatingInterestQualificationAsNotQualified */
  nietKwalificerendeBeleggingsdeelneming?: boolean;
  /** ParticipatingInterestApplicationValuationInstructionArticle13aApplied */
  waarderingsvoorschift13aVpbToegepast?: boolean;
  /** ParticipatingInterestEconomicValue */
  wevDeelneming?: number;
  /** ParticipatingInterestValueAtTimeOfShareChangeToBelowTwentyFivePercent */
  wevDeelnemingOpMomentDalingOnder25?: number;
  /** ParticipatingInterestPercentageFallenBelowTwentyFivePercent */
  percentageIsGedaaldOnder25?: boolean;
  /** ParticipatingInterestEngrossmentBenefit */
  bruteringVoordeel?: number;
  /** ParticipatingInterestEuropeanUnitProfitPaymentPartBenefit */
  deelnemingIsEUenVoordeelIsWinstuitkering?: boolean;
  /** ParticipatingInterestEngrossmentAndSetoffWithEffectiveTaxExists */
  bruteringEnVerrekeningMetEffectieveBelasting?: boolean;
  /** ParticipatingInterestDifferentSetoffWithAlreadyTaxedBenefitExists */
  afwijkendeVerrekening?: boolean;
  /** ParticipatingInterestHiddenDividendReceived */
  verkaptDividendOntvangen?: boolean;
  /** DividendHidden */
  bedragVerkaptVoordeel?: number;
  /** DividendHiddenOpinionDescription */
  omschrijvingVerkaptVoordeel?: string;
  /** DividendHiddenFinalParentCompanyName */
  naamUiteindelijkeMoeder?: string;
  adresUiteindelijkeMoeder?: Adres;
  /** ParticipatingInterestBenefitNotNoticedDirectly */
  directeDeelnemingDeedVerkapteUitdeling?: boolean;
  /** BenefitNotNoticedLegalPersonName */
  naamVennootschapDieVoordeelLietOntgaan?: string;
  adresVennootschapDieVoordeelLietOntgaan?: Adres;

  [key: string]: any;
}

/** Loss compensation */
export interface Verliescompensatie {
  /** TaxableProfitChangeInterestsCount */
  winstVoorTijdstipBelangenwijziging?: number;
  /** ProfitAfterMomentChangeInterests */
  winstNaTijdstipBelangenwijziging?: number;
  /** SettlementLossPreviousFinancialYear */
  imputatieVerliesVorigBoekjaar?: number;
  /** LossesToBeSetoffThisYearNotBeingHoldingLosses */
  teVerrekenenGewoneVerliezen?: OmschrijvingEnBedrag[];
  /** HoldingLossesCorporationTaxActToBeSetoffThisYear */
  teVerrekenenHoudsterverliezen?: OmschrijvingEnBedrag[];
  /** SetoffLossThisTaxYear */
  verrekeningVerliesDitBoekjaar?: number;
  samenStellingVerliezenFiscaleEenheid?: VerliezenFiscaleEenheid[];

  [key: string]: any;
}

export interface VerliezenFiscaleEenheid {
  /** CompanyIdentificationNumber */
  rsinMaatschappijVerlies: string;
  /** LossesToBeSettledTaxEntityThisFinancialYearStart */
  startBoekjaarVerlies: Date;
  /** LossesToBeSettledTaxEntityThisFinancialYearEnd */
  eindBoekjaarVerlies: Date;
  /** LossesToBeSettledTaxEntityThisFinancialYearCompany */
  teVerrekenenVerlies: number;
  /** LossesToBeSettledTaxEntityThisFinancialYearCompany */
  teVerrekenenVerliesNaarVorigBoekjaar?: number;

  [key: string]: any;
}

/** Specification innovation box assets and profits */
export interface Vermogensvergelijking {
  /** CapitalContributionsTotal */
  stortingen?: OmschrijvingEnBedrag[];
  /** CapitalChangesAndWithdrawals */
  onttrekkingen?: OmschrijvingEnBedrag[];
  /** ExemptedProfit */
  vrijgesteldeWinstbestanddelen?: OmschrijvingEnBedrag[];
  /** PenaltiesNonDeductible */
  nietAftrekbareBoetes?: OmschrijvingEnBedrag[];
  /** ExemptedProfit */
  beperktAftrekbareKosten?: OmschrijvingEnBedrag[];
  /** CostsAndWagesAndPenaltiesNonDeductibleOrSubjectToRestrictedDeductionTotal */
  fictievePersoneelskosten?: number;
  /** ProfitANBIFundRaisingActivities */
  fondswerversWinst?: number;
  /** InterestAndRoyaltiesNonDeductiblePaidOrReceivedWithinTheGroupTotal, Article 8c */
  saldoRenteEnRoyaltiesDoorstroomvennootschappen?: number;
  /** InterestLoanNonDeductibleTotal, Article 10a */
  nietAftrekbareRente?: OmschrijvingEnBedrag[];
  /** ParticipationInterestExcessiveNonDeductibleInterest, up to 2019 */
  bovenmatigeDeelnemingsrente?: OmschrijvingEnBedrag[];
  /** InterestNonDeductibleAcquisitionDebts, up to 2019 */
  renteOvernameschulden?: OmschrijvingEnBedrag[];
  /** PreviouslyTemporisedInterestThisFinancialYearDeductible, up to 2019 */
  aftrekGetemporiseerdeRente?: OmschrijvingEnBedrag[];
  /** InterestDeductionLimitationGeneric, from 2019 */
  generiekeRenteAftrekBeperking?: number;
  /** AdditionConversionPermanentEstablishmentIntoParticipatingInterestTotal */
  toevoegingAanWinstOpGrondVanArtikel13c?: number;
  /** BenefitNonExemptedAtShareMergerOrSplitOfOrMergerTotal */
  toevoegingAanWinstOpGrondVanArtikel13h?: number;
  /** BenefitNonExempted */
  toevoegingAanWinstOpGrondVanArtikel13lid17?: number;
  /** LossEngrossmentLowTaxationForeignInvestmentCompany */
  verliesbruteringBuitenlandseBeleggingsonderneming?: number;
  /** GiftsCultural */
  giftenAanCultureleInstellingen?: OmschrijvingEnBedrag[];
  /** GiftsOther */
  giftenAanOverigeInstellingen?: OmschrijvingEnBedrag[];

  [key: string]: any;
}

/** LandDisposalSpecification */
export interface VervreemdingGrond {
  /** LandRegistryDetailsMunicipality */
  gemeenteAanduiding: string;
  /** LandRegistryDetailsSectionNumber */
  sectieEnNummer: string;
  /** LandRegistryDetailsArea */
  oppervlakte: string;
  /** LandDisposalDate, format YYYY-mm-DD */
  datumVervreemding: Date;
  /** ParcelDisposedSalesPrice */
  verkoopprijs: number;
  /** SectionSoldBookValue */
  boekwaarde: number;

  [key: string]: any;
}

/** SubsidiariesJoiningTaxEntitySpecification */
export interface Voeging {
  /** SubsidiaryName */
  naamDochtervennootschap: string;
  /** DebtValuationBalanceSheetSubsidiary */
  waarderingSchuldBalansDochter?: number;
  /** BalanceSheetOtherCompanyReceivableValuation */
  waarderingVorderingBalansAndereMaatschappij?: number;
  /** TaxedDebtExpirationSubsidiary */
  belasteVrijvalSchuldBijDochter?: number;
  /** DebtValuationBalanceSheetOtherCompany */
  waarderingSchuldOpBalansAndereMaatschappij?: number;
  /** BalanceSheetSubsidiaryReceivableValuation */
  waarderingVorderingOpBalansDochter?: number;
  /** TaxedDebtExpirationOtherCompany */
  belasteVrijvalSchuldAndereMaatschappij?: number;
  /** ParticipatingInterestSubsidiaryCommercialValue */
  wevDeelnemingInDochter?: number;
  /** ParticipatingInterestSubsidiaryBalanceSheetParentCompanyValuation */
  boekwaardeDeelnemingInDochter?: number;
  /** EquityCapitalFiscalSubsidiary */
  fiscaalVermogenDochter?: number;
  /** RevaluationSubsidiaryInPreviousTaxreturnParent */
  herwaarderingDochterDoorMoeder?: number;
  /** CapitalLeapParentTimeOfJoin */
  vermogenssprongMoederBijVoeging?: number;

  [key: string]: any;
}

export interface VpbAangifte {
  /** A = resident, C = foreign (not available yet) */
  biljetSoort: string;
  boekjaar: Periode;
  identificatie: Identificatie;
  algemeneVragen?: AlgemeneVragen;
  vragenFiscaleEenheid?: VragenFiscaleEenheid;
  balansEnResultatenrekening: BalansEnResultatenrekening;
  vermogensvergelijking: Vermogensvergelijking;
  verliescompensatie?: Verliescompensatie;
  belastingBedrag?: BelastingBedrag;
  renteAftrekBeperking?: RenteAftrekBeperking;
  specificatieInnovatiebox?: Innovatiebox;
  /** Object Exemption Foreign Business Profits */
  specificatieObjectvrijstelling?: ObjectVrijstelling[];
  /** Specification shareholders */
  specificatieAandeelhouders?: Aandeelhouder[];
  /** Agricultural Activities Specification */
  specificatieAgrarischeActiviteiten?: AgrarischeActiviteiten[];
  /** Business Assets Random Depreciation Netherlands Specification */
  specificatieWillekeurigeAfschrijving?: WillekeurigeAfschrijving[];
  specificatieBronheffingen?: Bronheffingen;
  /** Specification participations */
  specificatieDeelnemingen?: Deelneming[];
  specificatieFiscaleEenheid?: FiscaleEenheid;
  specificatieHflo?: HFLOActiviteiten;
  specificatieInvesteringen?: Investeringen;
  /** ShippingProfit */
  specificatieScheepvaartwinst?: Zeescheepvaart[];
  specificatieNietAftrekbareBedragen?: NietAftrekbareBedragen;
  /** balance sheet and profit and loss accounts of all fiscal unity members */
  enkelvoudigeResultatenFiscaleEenheid?: BalansEnResultatenrekening[];

  [key: string]: any;
}

/** General questions fiscal unity */
export interface VragenFiscaleEenheid {
  /** JoiningExistingSubsidiariesExists */
  voegingMetBestaandeDochtermaatschappijen: boolean;
  /** RemovalSubsidiariesExists */
  ontvoegingVanDochtermaatschappijen: boolean;
  /** SubsidiariesTerminationDissolutionSettlementSubsidiariesExists */
  beeindigingDoorliquidatieDochter: boolean;
  /** RequestTransferLossesDisjoinedSubsidiaryExists */
  verzoekMeegevenVerliezenOntvoegdeDochter: boolean;
  /** RequestNonDivisionUnitTaxPurposesUponLegalMerger */
  verzoekNietVerbrekenJuridischeFusie: boolean;
  /** RequestTransferLossesAcquiringLegalPerson */
  verzoekMeegevenVerliezenVerkrijger: boolean;
  /** RequestNonDivisionUnitTaxPurposesUponDisappearingSubsidiaryLegalMerger */
  verzoekNietVerbrekenBijVerdwijnendeDochter: boolean;
  /** RequestTransferLossesDisappearingSubsidiaryAcquringParty */
  verzoekMeegevenVerliezenvanVerdwijnendeDochter: boolean;
  /** RequestTransferDistributionLosses */
  verzoekMeegevenUitdelingstekort: boolean;

  [key: string]: any;
}

/** Business Assets Random Depreciation Netherlands Specification */
export interface WillekeurigeAfschrijving {
  /** BusinessAssetsRandomDepreciationNetherlandsDescription */
  omschrijving: string;
  /** BusinessAssetsRandomDepreciationNetherlandsAmount */
  bedragAfschrijving: number;
  /** BusinessAssetsRandomDepreciationNetherlandsBookValue */
  boekwaardeEindeBoekkjaar: number;

  [key: string]: any;
}

/** ProfitOnBaseOffAnualStatementShipping */
export interface Zeescheepvaart {
  /** WorksInNetherlandsForOtherParty */
  verrichtBeheerVoorAnder: boolean;
  /** ShipName */
  naamSchip: string;
  /** ShipFlag */
  vlagSchip: string;
  /** NetTonnageShip */
  nettoTonnageSchip: number;
  /** ShipExploitationDaysCount */
  aantalDagenExploitatie: number;
  /** ShipParticipatingInterestPercentage */
  percentageDeelnameInSchip: number;
  /** ShipHasDutchFlagAfter2008 */
  schipVaartNa2008OnderNLVlagEnTonnageregime?: boolean;
  /** ShipWas5YearsPriorToDutchFlagNotRegisteredInEUorEER */
  schipVoerin5JaarVoorTonnageOnderVlagDerdeLand?: boolean;
  /** ShipProfitFinancialStatement */
  winstVoorDitSchipVolgensJaarrekening?: number;

  [key: string]: any;
}

export interface DossierItem {
  id?: string;
  clientId?: string,
  type?: string;
  soort?: string;
  jaar?: string;
  actie?: string;
  deadline?: Date;
  open?: Date;
  attachment?: boolean

  [key: string]: any;
}

/** BusinessCapital */
export interface APV {
  /** GiftTrustCapitalIdentificationNumber */
  rsinAPV?: string;
  /** GiftTrustCapitalName */
  naamAPV: string;
  /** TrustCapitalLegalForm */
  rechtsvorm: string;
  /** ISO 3166 land codes 3-characters */
  landCodeApv: string;
  /** GiftTrustCapitalValue */
  waardeOvergedragenAandeel: number;

  [key: string]: any;
}

export interface AangifteSchenkbelasting {
  aangever: Persoon;
  /** SignatureDate */
  datumOndertekening: Date;
  /** SignaturePlaceOfResidence */
  plaatsOndertekening: string;
  contactPersoon: ContactPersoon;
  begiftigde: Begiftigde;
  schenker: Persoon;
  /** Donation */
  schenking: Schenking[];
  /** ExcessiveInheritanceInterestPaidDuringLifeIndication */
  bovenmatigeErfrechtelijkeRenteBijLevenUitbetaald: boolean;
  /** ResidenceClauseInPartnershipContractIndication */
  verblijvingBedingInMaatschapsContract: boolean;
  /** UsefructInterestFreeLoanNaturalPersonIndication */
  vruchtgebruikRentelozeLening: boolean;
  /** SpecialSituationsOtherIndication */
  andereBijzondereSituatieVanToepassing: boolean;

  [key: string]: any;
}

/** Recipient */
export interface Begiftigde {
  /** NotaryNumber */
  protocolNummerNotaris?: string;
  /** TaxConsultantNumber */
  beconnummer?: string;
  /** IdentificationNumber */
  bsn?: string;
  /** Initials */
  voorletters?: string;
  /** Prefix */
  tussenvoegsel?: string;
  /** Surname */
  achternaam?: string;

  indicatieEerdereSchenking?: boolean;
  /** DonorDateOfBirth */
  geboortedatum?: Date;
  /** InstitutionName */
  instellingnaam?: string;
  /** RecipientPartnerIdentificationNumber */
  bsnPartner?: string;
  /** RecipientPartnerDateOfBirth */
  geboorteDatumPartner?: Date;

  [key: string]: any;
}

/** Declarant */
export interface ContactPersoon {
  /** NotaryNumber */
  protocolNummerNotaris?: string;
  /** TaxConsultantNumber */
  beconnummer?: string;
  /** IdentificationNumber */
  bsn?: string;
  /** Initials */
  voorletters?: string;
  /** Prefix */
  tussenvoegsel?: string;
  /** Surname */
  achternaam?: string;
  /** DonorDateOfBirth */
  geboortedatum?: Date;
  /** InstitutionName */
  instellingnaam?: string;
  /** ContactEmailAddress */
  emailadres?: string;
  /** ContactTelephoneNumber */
  telefoonnummer?: string;
  adres?: Adres;

  [key: string]: any;
}

/** Intermediairy */
export interface Dienstverlener {
  /** TaxIdentificationNumber */
  rsinDienstverlener?: string;
  /** TaxConsultantNumber */
  beconNummer?: string;
  /** Surname */
  naamDienstverlener?: string;

  [key: string]: any;
}

/** Stock */
export interface Effecten {
  /** Description */
  omschrijving?: string;
  /** GiftStockValue */
  bedrag: number;
  /** StockType */
  soortEffecten: EffectenSoortEffecten;

  [key: string]: any;
}

export interface GiftTaxEntity {
  id?: number;
  name?: string;
  taxPayerFiscalNumber: string;
  year?: number;
  aangifte?: AangifteSchenkbelasting;
  lastOpeningDate?: Date;
  submissionDate?: Date;
  taxPayerId?: ClientEntity;

  [key: string]: any;
}

/** NotaryConvenant */
export interface NotarieleAkte {
  /** NotaryConvenantCreationDate */
  datumAkte: Date;
  /** CentralDigitalRepertoryNumber */
  cdrNummer: string;
  /** NotaryNumber */
  notarisProtocolnummer: string;
  /** NotaryName */
  naamNotariskantoor: string;
  adresNotariskantoor: Adres;

  [key: string]: any;
}

/** BusinessCapital */
export interface OndernemingSB {
  /** BusinessIdentificationNumber */
  rsinOnderneming: string;
  adresOnderneming: Adres;
  /** BusinessName */
  naamOnderneming: string;
  /** GiftBusinessLegalForm */
  rechtsvorm: OndernemingSBRechtsvorm;
  /** GiftBusinessSuccessionFacilitiesObjectiveBusinessGoingConcernValue */
  goingConcernWaarde: number;
  /** GiftBusinessSuccessionFacilitiesObjectiveBusinessLiquidationValue */
  liquidatieWaarde: number;
  /** BusinessCapitalGiftPrice */
  waardeOndernemingsVermogen: number;
  /** BusinessSuccessionAgreementInvestmentCapitalValue */
  waardeBeleggingsVermogen?: number;
  /** BusinessCapitalOtherHiddenReservesCommonShareValue */
  stilleReservesInOndernemingsVermogen?: number;
  /** DeferredTaxTransferredPart */
  latenteInkomstenBelasting: number;
  /** BusinessSuccessionFacilitiesPremeditationHasTakenPlaceIndication */
  voorOverlegHeeftPlaatsgevonden: boolean;
  /** BusinessSuccessionFacilitiesGratifiedDemandOfPosessionBusinessSuccessionIndication */
  verzoekToepassenBorInIb: boolean;
  /** RequestAppliancePassOverSchemeIncomeTaxBusinessIndication */
  verzoekToepassenBorInSw: boolean;
  /** TestatorPartnerCommonPart */
  aandeelInOnderneming?: number;
  /** BusinessSuccessionAgreementOriginalAcquisitionValue */
  verkrijgingsPrijs: number;
  opvolger: Opvolger;

  [key: string]: any;
}

/** ImmovableProperty */
export interface OnroerendeZaakSB {
  /** GiftImmovablePropertyCommercialValue */
  waardeEconomischVerkeer?: number;
  /** GiftImmovablePropertyLawValue */
  wozwaarde?: number;
  /** GiftImmovablePropertyAnnualGroundLeaseValue */
  waardeErfpachtcanon?: number;
  /** ImmovablePropertyGroundLeaseEnddate */
  eindDatumErfpacht?: Date;
  /** ImmovablePropertyResidenceIndication */
  onroerendeZaakIsWoning?: boolean;
  /** ImmovablePropertyHiredOutEntirelyIndication */
  onroerendeZaakIsVerhuurd?: boolean;
  /** GiftImmovablePropertyLargerPartHouseSeparatelySaleableIndication */
  verhuurdeWoningIsDeelVanGroterGeheel?: boolean;
  /** GiftImmovablePropertyLandRegistryDesignation */
  kadastraleAanduiding?: string;
  /** GiftImmovablePropertyAnnualRentValue */
  waardeJaarlijkseHuur?: number;
  /** GiftImmovablePropertyMarketCompliantRentIndication */
  huurIsMarktconform?: boolean;
  /** GiftImmovablePropertySurfaceSquareMetresHiredOut */
  verhuurdOppervlakte?: number;
  /** GiftImmovablePropertySurfaceSquareMetresTotal */
  totaleOppervlakte?: number;
  /** GiftImmovablePropertyEstateSceneryLawIndication */
  indicatieNSW?: boolean;
  adres: Adres;
  /** GiftImmovablePropertyTransferredPartNumerator */
  tellerOvergedragenAandeel: number;
  /** GiftImmovablePropertyTransferredPartDenominator */
  noemerOvergedragenAandeel: number;
  /** GiftImmovablePropertyPurchasePrice */
  koopsom?: number;
  /** GiftImmovablePropertyRemittedPurchasePrice */
  kwijtgescholdenKoopsom?: number;
  /** GiftImmovablePropertyLowerPurchasePriceThanMarketValueIndication */
  koopsomLagerDanMarktwaarde?: boolean;
  /** ImmovablePropertyTenantRecipientIndication */
  koperWasHuurderOnroerendeZaak?: boolean;
  /** GiftImmovablePropertyTransferTaxPayedGiftPart */
  betaaldeOverdrachtsbelasting?: number;
  /** GiftImmovablePropertyExposedValue */
  waardeBloteEigendom?: number;

  [key: string]: any;
}

/** BusinessSuccessor */
export interface Opvolger {
  /** NotaryNumber */
  protocolNummerNotaris?: string;
  /** TaxConsultantNumber */
  beconnummer?: string;
  /** IdentificationNumber */
  bsn?: string;
  /** Initials */
  voorletters?: string;
  /** Prefix */
  tussenvoegsel?: string;
  /** Surname */
  achternaam?: string;
  /** DonorDateOfBirth */
  geboortedatum?: Date;
  /** InstitutionName */
  instellingnaam?: string;
  /** BusinessSuccessionFacilitiesPreservedTaxAssessmentRequestIndication */
  verzoekConserverendeAanslag?: boolean;
  /** BusinessSuccessionAgreementObjectiveCompanyTransferredValueNumerator */
  tellerOvergedragenAandeel?: number;
  /** BusinessSuccessionAgreementObjectiveCompanyTransferredValueDenominator */
  noemerOvergedragenAandeel?: number;
  /** BusinessSuccessionFacilitiesOriginalAcquisitionValue */
  waardeTegenPrestatie?: number;

  [key: string]: any;
}

/** PeriodicalBenefit */
export interface PU {
  /** GiftBenefitPeriod */
  uitkeringsPeriode: PUUitkeringsPeriode;
  /** GiftBenefitAmount */
  uitkeringsbedrag: number;
  /** GiftPeriodicFirstDate */
  datumEersteUitkering: Date;
  /** GiftPeriodicLastDate */
  datumLaatsteUitkering?: Date;
  /** GiftLonglivedDependenceIndication */
  afhankelijkVanLeven?: boolean;
  /** TaxLeviedOnPeriodicPaymentIndication */
  inkomstenBelastingGeheven?: boolean;
  /** GiftPeriodicalBenefitIdentificationNumber */
  bsnEersteVanLevenAfhankelijke?: string;
  /** PersonWhoseLifeDateOfBirth */
  geboorteDatumEersteVanLevenAfhankelijke?: Date;
  /** GiftPeriodicalBenefitIdentificationNumber */
  bsnTweedeVanLevenAfhankelijke?: string;
  /** PersonWhoseLifeDateOfBirth */
  geboorteDatumTweedeVanLevenAfhankelijke?: Date;

  [key: string]: any;
}

export interface Persoon {
  /** FullName */
  roepnaam?: string;
  /** Initials */
  voorletters?: string;
  /** Prefix */
  tussenvoegsels?: string;
  /** Surname */
  achternaam?: string;
  /** TaxIdentificationNumber */
  bsn?: string;
  /** DateOfBirth */
  geboortedatum?: Date;
  /** DateOfDecease */
  overlijdensdatum?: Date;
  /** ISO 3166 land codes 3-characters */
  landCodeNationaliteit?: string;

  [key: string]: any;
}

/** RecipientAlimony */
export interface PersoonToeslagen {
  /** FullName */
  roepnaam?: string;
  /** Initials */
  voorletters?: string;
  /** Prefix */
  tussenvoegsels?: string;
  /** Surname */
  achternaam?: string;

  /** TaxIdentificationNumber */

  [key: string]: any;
}

/** GiftMovableProperty */
export interface RoerendeZaak {
  /** Description */
  omschrijving?: string;
  /** Amount */
  bedrag: number;
  /** GiftMovablePropertyType */
  soortRoerendeZaak: RoerendeZaakSoortRoerendeZaak;

  [key: string]: any;
}

/** Donation */
export interface Schenking {
  /** GiftDate */
  datumSchenking: Date;
  /** GiftRecipientDonorRelationCode */
  relatieBegiftigdeMetSchenker: SchenkingRelatieBegiftigdeMetSchenker;
  /** GiftRevocableGiftIndication */
  herroepelijkeSchenking: boolean;
  /** GiftTaxPayerIndication */
  schenkerBetaaltDeSchenkbelasting: boolean;
  /** GiftExtensionPartnerConceptIndication */
  uitbreidingBegripSchenker: boolean;
  contanten?: OmschrijvingEnBedrag;
  effecten?: Effecten;
  onroerendeZaken?: OnroerendeZaakSB;
  ondernemingen?: OndernemingSB;
  apv?: APV;
  periodiekeUitkering?: PU;
  roerendeZaak?: RoerendeZaak;
  schuldigerkenning?: SchenkingOpPapier;
  kwijtscheldingSchuld?: OmschrijvingEnBedrag;
  vruchtgebruik?: Vruchtgebruik;
  overige?: OmschrijvingEnBedrag;
  vrijstellingen: Vrijstellingen;
  notarieleAkte?: NotarieleAkte;
  belastingBetaaldInAnderLand?: number;
  landCodeBetaaldInAnderLand?: string;
  heffingsgrondslagOverdrachtsbelasting?: number;
  betaaldeOverdrachtsbelasting?: number;
  indicatieSchenkerVorigeEigenaar?: boolean;
  datumJuridischeLevering?: Date;

  [key: string]: any;
}

/** DebtRecognitionOutOfGenerosity */
export interface SchenkingOpPapier {
  /** DonationsOnPaperDescription */
  omschrijving?: string;
  /** DonationsOnPaperAmount */
  bedrag: number;
  /** DonationsOnPaperInterestPercentage */
  rentePercentage: number;
  /** DonationsOnPaperInterestType */
  enkelvoudigeRente: boolean;
  /** DonationsOnPaperDeedDate */
  datumAkte?: Date;
  /** DonationsOnPaperImmediatelyCollectableDate */
  datumOpeisbaar: Date;

  [key: string]: any;
}

/** ExemptionUse */
export interface Vrijstellingen {
  /** GiftExemptionOneOffIncreased */
  eenmaligVerhoogdeVrijstelling: boolean;
  /** GiftExemptionOwnHouseOneOffIncreased */
  eenmaligVerhoogdeVrijstellingEigenWoning: boolean;
  /** OwnHouseAlreadyInvestedAmount */
  bedragAlBetaaldEigenWoning?: number;
  /** OwnHouseToBeInvestedAmount */
  bedragNogTeBestedenEigenWoning?: number;
  /** GiftExemptionExpensiveStudyIncreased */
  verhoogdeVrijstellingStudie: boolean;
  /** ExpensiveStudyAlreadyInvestedAmount */
  bedragAlBetaaldDureStudie?: number;
  /** ExpensiveStudyToBeInvestedAmount */
  bedragNogTeBestedenDureStudie?: number;
  /** GiftExemptionDebtor */
  vrijstellingSchuldenaar: boolean;
  /** GiftExemptionNaturalObligation */
  vrijstellingNatuurlijkeVerbintenis: boolean;
  /** GiftExemptionANBIOrSBBI */
  vrijstellingAnbiOfSbbi: boolean;
  /** GiftExemptionByKingAndRelativesByMarriage */
  vrijstellingSchenkingDoorKoning: boolean;
  /** GiftExemptionByStateProvinceOrMunicipal */
  vrijstellingSchenkingDoorStaat: boolean;
  /** ExemptionAcquisitionTaxedByIncomeTax */
  vrijstellingSchenkingBelastInIB: boolean;
  /** ExemptionPaymentToRelativesEmployee */
  vrijstellingSchenkingAanNabestaandeWerknemer: boolean;
  /** GiftExemptionOther */
  vrijstellingOverig?: string;

  [key: string]: any;
}

/** Usufruct */
export interface Vruchtgebruik {
  /** Description */
  omschrijving: string;
  /** GiftUsufructValue */
  bedrag: number;
  /** CapitalToBeMaintainedValue */
  stamKapitaal: number;

  [key: string]: any;
}

export interface AanslagIb {
  /** FiscalYear */
  aangifteJaar?: number;
  /** TaxIdentificationNumber */
  bsn?: string;
  /** bd-i-ext1:FiscalPartnerTaxpayerIdentificationNumber */
  bsnFiscaalPartner?: string;
  /** NoticeOfAssessmentNumber */
  aanslagnummer?: string;
  /** NoticeOfAssessmentDate */
  dagtekeningAanslag?: Date;
  /** TypeOfAssessment */
  aanslagSoort?: AanslagIbAanslagSoort;
  /** TaxType */
  middel?: string;
  middeling?: AanslagMiddeling;
  /** bd-i:TaxpayerNameAddress1 */
  naw1Belastingplichtige?: string;
  /** bd-i:TaxpayerNameAddress2 */
  naw2Belastingplichtige?: string;
  /** bd-i:TaxpayerNameAddress3 */
  naw3Belastingplichtige?: string;
  /** bd-i:TaxpayerNameAddress4 */
  naw4Belastingplichtige?: string;
  /** bd-i:TaxpayerNameAddress5 */
  naw5Belastingplichtige?: string;
  /** bd-i-ext1:TaxConsultantNameAddress1 */
  naw1Gemachtigde?: string;
  /** bd-i-ext1:TaxConsultantNameAddress2 */
  naw2Gemachtigde?: string;
  /** bd-i-ext1:TaxConsultantNameAddress3 */
  naw3Gemachtigde?: string;
  /** bd-i-ext1:TaxConsultantNameAddress4 */
  naw4Gemachtigde?: string;
  /** bd-i-ext1:TaxConsultantNameAddress5 */
  naw5Gemachtigde?: string;
  /** bd-i-ext1:TaxAssessmentOfficialFinal */
  ambtshalveDefinitieveAanslag?: boolean;
  /** bd-i-ext1:TaxAssessmentProvisionalFirst */
  eersteVoorlopigAanslag?: boolean;
  /** bd-i-ext1:TaxAssessmentProvisionalManual */
  voorlopigeAanslagHandmatig?: boolean;
  /** bd-i-ext1:TaxAssessmentProvisionalCancellation */
  vernietigingVoorlopigeAanslag?: boolean;
  /** bd-i-ext1:TaxAssessmentProvisionalRequest */
  verzoekVoorlopigeAanslag?: boolean;
  /** bd-i-ext1:TaxAssessmentProvisionalFirstBasisTaxReturn */
  eersteVoorlopigeAanslagObvAangifte?: boolean;
  /** bd-i:TaxAssessmentProvisionalAutomatic */
  automatischeVA?: boolean;
  /** bd-i-ext1:TaxReturnFirmCorrection */
  stelligeCorrectieOpAangifte?: boolean;
  /** bd-i-ext1:TaxReturnCorrection */
  correctieOpAangifte?: boolean;
  /** bd-i-ext1:WageTaxFirmCorrectionIndication */
  indicatieStelligeCorrectieOpLoonheffing?: boolean;
  /** bd-i-ext1:NoIncomeStatementFirmCorrectionIndication */
  indicatieStelligeCorrectieGeenInkomensverklaring?: boolean;
  /** bd-i-ext1:NoIncomeStatementOneOrBothFirmCorrectionIndication */
  indicatieStelligeCorrectieGeenInkomensverklaringOfBeide?: boolean;
  /** bd-i-ext1:SelfEmployedPersonsAllowanceNotRealizedFirmCorrectionSettlementIndication */
  indicatieStelligeCorrVerrekeningNietGerealiseerdeZelfstandigenaftrek?: boolean;
  /** bd-i-ext1:PersonDependentDeductionRemainderNotDeclaredFirmCorrectionIndication */
  indicatieStelligeCorrectieRestantPgaNietInAangifte?: boolean;
  /** bd-i-ext1:YoungDisabledPersonDeductionFirmCorrectionIndication */
  indicatieStelligeCorrectieJonggehandicaptenkorting?: boolean;
  /** bd-i-ext1:SupplementaryElderlyPersonDeductionFirmCorrectionIndication */
  indicatieStelligeCorrectieAlleenstaandeOuderenkorting?: boolean;
  /** bd-i-ext1:ObjectionDeadlineDate */
  uitersteDatumBezwaar?: Date;
  /** bd-i-ext1:AppealDeadlineDate */
  uitersteDatumBeroep?: Date;
  /** bd-i-ext1:DisposalType */
  soortBeschikking?: string;
  /** bd-i-ext1:SettlementType */
  soortAfhandeling?: string;
  /** bd-i-ext1:ObjectionSatisfied */
  tegemoetkomingBezwaar?: string;
  /** bd-i:DateOfBirth */
  geboortedatumAangever?: Date;
  /** bd-i:QualifyingForeignTaxpayer */
  kwalificerendeBuitenlandseBelastingplichtige?: boolean;
  /** bd-i:CompetentUnitNumber */
  eenheidBelastingdienst?: string;
  /** bd-i-ext1:FiscalYearMinusOne */
  belastingjaarMinusEen?: number;
  /** bd-i-ext1:PresentationMainCalculationCode */
  codePresentatieHoofdberekeningSturing?: number;
  /** bd-i-ext1:TaxationElementsChangedIndication */
  indicatieGewijzigdeHeffingsgrondslagen?: string;
  /** bd-i-ext1:RequestOfficialyReductionFinalAssessmentIndication */
  indicatieVerzoekAmbtshalveVerminderingDefinitieveAanslagToegekend?: number;
  /** bd-i-ext1:ExemptedSalary */
  nietInNederlandBelastbaarInkomen?: number;
  /** bd-i:IncomeOtherActivities */
  inkomstenUitOverigeWerkzaamheden?: number;
  /** bd-i-ext1:PeriodicCashBenefits */
  periodiekeUitkeringen?: number;
  /** bd-i-ext1:SumOfOtherIncome */
  somVanAndereInkomsten?: number;
  /** bd-i-ext1:TravelDeductionAmount */
  reisaftrek?: number;
  /** bd-i-ext1:IncomeProvisionExpensesTotal */
  totaalUitgavenVoorInkomensvoorzieningen?: number;
  /** bd-i-ext1:DoublePosition */
  dubbeleDienstbetrekking?: boolean;
  /** bd-i-ext1:IncomePresentEmploymentAbroad */
  buitenlandsLoonTegenwoordigArbeid?: number;
  /** bd-i-ext1:IncomePresentEmploymentTotal */
  loonTegenwoordigeArbeidTotaal?: number;
  /** bd-i-ext1:IncomePreviousEmploymentAbroad */
  buitenlandsLoonVroegereArbeid?: number;
  /** bd-i-ext1:RedemptionsAnnuitiesCoveredByWageTaxTotal */
  lijfrenteAfkoopsommenTotaalOnderLH?: number;
  /** bd-i-ext1:IncomePreviousEmploymentTotal */
  loonVroegereArbeidTotaal?: number;
  /** bd-i-ext1:OwnerOccupiedHouseBenefits */
  voordelenEigenWoning?: number;
  /** bd-i-ext1:OwnerOccupiedHouseDeductibleCostsTotal */
  aftrekbarKostenEigenWoninTotaal?: number;
  /** bd-i-ext1:OwnerOccupiedHouseTaxableIncome */
  belastbareInkomstenEigenWoning?: number;
  /** bd-i-ext1:OwnerOccupiedHouseTaxableIncomeTaxpayerShare */
  aangeverdeelBelastbareInkomstenEigenWoning?: number;
  /** bd-i:OwnHouseDeductibleNonOrMinorAcquisitionDebtPartyFilingTaxReturnPartAmount */
  aftrekGeenOfGeringeEigenwoningschuldAangever?: number;
  /** bd-i-ext1:OwnHouseDeductibleNonOrMinorAcquisitionDebtDeductionAppliedPercentage */
  percentageToegepasteAftrekGeenOfGeringeEigenwoningschuld?: number;
  /** bd-i-ext1:OwnHouseDeductibleNonOrMinorAcquisitionDebtDeductionApplied */
  toegepasteAftrekGeenOfGeringeEigenwoningschuldAangever?: number;
  /** bd-i:TaxableProfit */
  belastbareWinst?: number;
  /** bd-i:SelfEmployedPersonsAllowanceAmount */
  zelfstandigenaftrek?: number;
  /** bd-i:BeginningEntrepeneurDeductionAmount */
  startersaftrek?: number;
  /** bd-i:SelfEmployedPersonsAllowanceNotRealizedAmount */
  nietGerealiseerderZelfstandigenAftrek?: number;
  /** bd-i:SelfEmployedPersonsAllowanceAmountPreviousYears */
  inAanmerkingTeNemenZelfstandigenaftrek?: number;
  /** bd-i-ext1:SelfEmployedPersonsAllowanceNotRealizedPreviousYearsState */
  standNietGerealiseerdeZelfstandigenaftrekVoorgJaren?: number;
  /** bd-i-ext1:SelfEmployedPersonsAllowanceRealized */
  zelfstandigenaftrekGerealiseerd?: number;
  /** bd-i-ext1:SelfEmployedPersonsAllowanceAmountPreviousYears */
  volgendJaarTeVerrekenenNietGerealiseerdeZelfstandigenaftrek?: number;
  /** bd-i-ext1:IncomeBox1 */
  inkomenBox1?: number;
  /** bd-i-ext1:TaxableIncomeEmploymentOwnerOccupiedHouse */
  belastbaarInkomenUitWerkEnWoning?: number;
  /** bd-i-ext1:IncomeTaxBox1 */
  inkomstenbelastingBox1?: number;
  /** bd-i-ext1:TaxBox1 */
  belastingBox1?: number;
  /** bd-i-ext1:TaxBox1MindTrustee */
  inkomstenbelastingBox1Gemoedsbezwaarde?: number;
  /** bd-i-ext1:IncomeTaxBracket3 */
  inkomstenbelasting1eSchijf?: number;
  /** bd-i-ext1:IncomeTaxBracket2 */
  inkomstenbelasting2eSchijf?: number;
  /** bd-i-ext1:IncomeTaxBracket1 */
  inkomstenbelasting3eSchijf?: number;
  /** bd-i-ext1:DeductionCostsRateAdjustmentPercentage */
  percentageTariefsaanpassingAftrekposten?: number;
  /** bd-i-ext1:DeductionCostsRateAdjustmentBase */
  grondslagTariefsaanpassingAftrekposten?: number;
  /** bd-i-ext1:DeductionCostsRateAdjustment */
  tariefsaanpassingAftrekposten?: number;
  /** bd-i-ext1:IncomeTaxOtherRate1Box1 */
  inkomstenbelastingAnderTarief1Box1?: number;
  /** bd-i-ext1:IncomeTaxOtherRate2Box1 */
  inkomstenbelastingAnderTarief2Box1?: number;
  /** bd-i-ext1:TaxationElsewhereBox1Deduction */
  aftrekEldersBelastBox1?: number;
  /** bd-i-ext1:WithholdingTaxBox1AbroadDeduction */
  aftrekBuitenlandseBronheffingBox1?: number;
  /** bd-i-ext1:LimitedRateBox1Reduction */
  verminderingBeperktTariefBox1?: number;
  /** bd-i-ext1:TaxationElsewhereBox1Abroad */
  buitenlandsInkomenBox1EldersBelast?: number;
  /** bd-i-ext1:TaxationElsewhereBox1IncomeTotal */
  inkomenTotaalBox1EldersBelastBuitenlandseBelpl?: number;
  /** bd-i-ext1:ContributionBaseIncomeReduced */
  herleidPremieInkomen?: number;
  /** bd-i-ext1:ContributionBaseIncome */
  premieInkomen?: number;
  /** bd-i-ext1:SocialInsuranceContributionBalance */
  saldoPremiesVolksverzekeringen?: number;
  /** bd-i-ext1:SocialInsuranceRatePercentage */
  tariefpercentagePremieVolksverzekeringen?: number;
  /** bd-i:ExemptedWagesInternationalOrganisationSocialInsuranceObligationAmount */
  bedragPremieplichtNietVrijgesteldInkomenInternationaleOrganisatie?: number;
  /** bd-i-ext1:TaxableIncomeSubstantialInterest */
  belastbaarInkomenAanmerkelijkBelang?: number;
  /** bd-i:TaxationElsewhereBox2 */
  eldersBelastInkomenBox2?: number;
  /** bd-i-ext1:WithholdingTaxBox2Abroad */
  buitenlandseBronheffingBox2?: number;
  /** bd-i-ext1:LimitedRateBox2Reduction */
  verminderingBeperktTariefBox2?: number;
  /** bd-i-ext1:TaxBox2 */
  belastingBox2?: number;
  /** bd-i-ext1:TaxBox2FixedRatePart */
  belastingBox2VastTariefDeel?: number;
  /** bd-i-ext1:TaxAmountOtherRate1Box2 */
  belastingBedragAnderTarief1Box2?: number;
  /** bd-i-ext1:TaxAmountOtherRate2Box2 */
  belastingBedragAnderTarief2Box2?: number;
  /** bd-i-ext1:TaxableIncomeSubstantialInterestBracket1 */
  belastbaarInkomenAanmerkelijkBelangEersteSchijf?: number;
  /** bd-i-ext1:TaxSubstantialInterestBracket1 */
  belastingAanmerkelijkBelangEersteSchijf?: number;
  /** bd-i-ext1:TaxableIncomeSubstantialInterestBracket2 */
  belastbaarInkomenAanmerkelijkBelangTweedeSchijf?: number;
  /** bd-i-ext1:TaxSubstantialInterestBracket2 */
  belastingAanmerkelijkBelangTweedeSchijf?: number;
  /** bd-i-ext1:CapitalYieldTaxBaseTaxpayer */
  rendementsgrondslagBinnenlandseBelastingplichtige?: number;
  /** bd-i:AssetsAndLiabilitiesPrivateTaxFreeAllowance */
  heffingsvrijVermogenBinnenlandseBelastingplichtige?: number;
  /** bd-i:SavingsAndInvestmentsTaxBase */
  grondslagSparenEnBeleggenBinnenlandseBelastingplichtige?: number;
  /** bd-i:SavingsAndInvestmentsTaxBaseTaxpayerPartyShare */
  aangeverdeelGrondslagSparenEnBeleggenBinnenlandseBelastingplichtige?: number;
  /** bd-i-ext1:CapitalYieldTaxBaseTaxpayer */
  rendementsgrondslagBuitenlandseBelastingplichtige?: number;
  /** bd-i:AssetsAndLiabilitiesPrivateTaxFreeAllowance */
  heffingsvrijVermogenBuitenlandseBelastingplichtige?: number;
  /** bd-i:SavingsAndInvestmentsTaxBase */
  grondslagSparenEnBeleggenBuitenlandseBelastingplichtige?: number;
  /** bd-i:SavingsAndInvestmentsTaxBaseTaxpayerPartyShare */
  aangeverdeelGrondslagSparenEnBeleggenBuitenlandseBelastingplichtige?: number;
  /** bd-i-ext1:SavingsAndInvestmentsBenefitsDecrease */
  voordeelSparenBeleggenBuitenlandseBelastingplichtigeVermindering?: number;
  /** bd-i:SavingsAndInvestmentsBenefits */
  voordeelSparenBeleggenBuitenlandseBelastingpichtige?: number;
  /** bd-i:TaxLiabilityNumberOfMonths */
  aantalMaandenBinnenlandseBelastingplicht?: number;
  /** bd-i:TaxLiabilityNumberOfMonths */
  aantalMaandenBuitenlandseBelastingplicht?: number;
  /** bd-i-ext1:SavingsAndInvestmentsBenefitsPeriodReduction */
  voordeelSparenEnBeleggenBinnenlandseBelastingplichtigeTijdHerleid?: number;
  /** bd-i-ext1:SavingsAndInvestmentsBenefitsPeriodReduction */
  voordeelSparenEnBeleggenBuitenlandseBelastingplichtigeTijdHerleid?: number;
  /** bd-i:SavingsAndInvestmentsBenefits */
  voordeelUitSparenEnBeleggenAangever?: number;
  /** TaxableIncomeBox3 */
  belastbaarInkomenBox3?: number;
  /** bd-i-ext1:CapitalYieldTaxBaseCapitalTest */
  rendementsGrondslagVermogensToets?: number;
  /** bd-i-ext1:CapitalYieldTaxBaseCapitalTestRelevance */
  relevantieRendementsgrondslagVermogenstoets?: number;
  /** bd-i-ext1:CapitalYieldTaxBaseCapitalTestExpiredDisposalIndication */
  indicatieVervallenBeschikkingRendementsgrondslagVermogenstoets?: boolean;
  /** bd-i:GreenInvestmentsExemptionBeforeAllocation */
  vrijstellingGroeneBeleggingenVoorToerekening?: number;
  /** bd-i-ext1:GreenInvestmentsExemptionCapitalTest */
  vrijstellingGroeneBeleggingenVermogensToets?: number;
  /** bd-i-ext1:GreenInvestmentsExemptionRelevance */
  relevantieVrijstellingGroeneBeleggingen?: number;
  /** bd-i-ext1:GreenInvestmentsExemptionExpiredDisposalIndication */
  indicatieVervallenBeschikkingVermogenstoetsVrijstellingGroeneBeleggingen?: boolean;
  /** bd-i-ext1:YieldTaxableTaxpayerPartyShare */
  aangeverdeelBelastbaarRendementBinnenlandseBelastingplichtige?: number;
  /** bd-i-ext1:YieldTaxablePartPercentageTaxpayerPartyShare */
  percentageAangeverdeelBelastbaarRendementBinnenlandseBelastingplichtige?: number;
  /** bd-i-ext1:YieldPropertyMinusDebtsTotal */
  totaalRendementBezittingenMinSchuldenBinnenlandseBelastingplichtige?: number;
  /** bd-i-ext1:YieldPropertyTotal */
  rendementTotaalBezittingenBinnenlandseBelastingplichtige?: number;
  /** bd-i-ext1:YieldDeductibleDebts */
  rendementAftrekbareSchuldenBinnenlandseBelastingplichtige?: number;
  /** bd-i-ext1:YieldDebtsTotal */
  rendementSchuldenTotaalBinnenlandseBelastingplichtige?: number;
  /** bd-i-ext1:YieldAssetBankAccountSavings */
  rendementBankEnSpaartegoedenNL?: number;
  /** bd-i-ext1:YieldAssetBankAccountSavings */
  rendementBankEnSpaartegoedenBuitenland?: number;
  /** bd-i-ext1:YieldStock */
  rendementEffecten?: number;
  /** bd-i-ext1:YieldCash */
  rendementContantGeld?: number;
  /** bd-i-ext1:YieldMoneyLendReceivablesOther */
  rendementUitgeleendGeldEnOverigeVorderingen?: number;
  /** bd-i-ext1:YieldImmovableProperty */
  rendementOnroerendeZakenInNLBinnenlandseBelastingplichtige?: number;
  /** bd-i-ext1:YieldImmovableProperty */
  rendementOnroerendeZzakenBuitenlandVanBinnenlandseBelastingplichtige?: number;
  /** bd-i-ext1:YieldCapitalInsurance */
  rendementKapitaalverzekeringen?: number;
  /** bd-i-ext1:YieldPeriodicPaymentsRightsValue */
  rendementRechtenPeriodiekeUitkeringenVerstrekkingen?: number;
  /** bd-i-ext1:YieldOtherProperty */
  rendementOverigeBezittingenBinnenlandseBelastingplichtige?: number;
  /** bd-i-ext1:YieldNetAnnuityRetirementTaxable */
  rendementBelastbareNettolijfrenteNettopensioen?: number;
  /** bd-i-ext1:YieldDebtImmovableProperty */
  rendementSchuldOnroerendeZakenNLBinnenlandseBelastingplichtige?: number;
  /** bd-i-ext1:YieldDebtImmovableProperty */
  rendementSchuldOnroerendeZakenInBuitenland?: number;
  /** bd-i-ext1:YieldDebtOtherProperty */
  rendementSchuldOverigeBezittingenBinnenlandseBelastingplichtige?: number;
  /** bd-i-ext1:YieldDebtsOther */
  rendementAndereSchuld?: number;
  /** bd-i-ext1:YieldDebtThresholdCorrection */
  correctieRendementSchuldendrempelBinnenlandsBelastingplichtige?: number;
  /** bd-i-ext1:YieldForfaitAssetBankAccountSavingsPercentage */
  percentageForfaitairRendementBankEnSpaartegoedNL?: number;
  /** bd-i-ext1:YieldForfaitAssetBankAccountSavingsPercentage */
  percentageForfaitairRendementbankEnSpaartegoedBuitenland?: number;
  /** bd-i-ext1:YieldForfaitStockPercentage */
  percentageForfaitairRendementEffecten?: number;
  /** bd-i-ext1:YieldForfaitCashPercentage */
  percentageForfaitairRendementContanGgeld?: number;
  /** bd-i-ext1:YieldForfaitMoneyLendReceivablesOtherPercentage */
  percentageForfaitairRendementUitgeleendGeldEnOverigeVorderingen?: number;
  /** bd-i-ext1:YieldForfaitImmovablePropertyPercentage */
  percentageForfaitairRendementOnroerendeZakenInNLBinnenlandseBelastingplichtige?: number;
  /** bd-i-ext1:YieldForfaitImmovablePropertyPercentage */
  percentageForfaitairRendementOnroerendeZakenInBuitenlandBinnenlandseBelastingplichtige?: number;
  /** bd-i-ext1:YieldForfaitCapitalInsurancePercentage */
  percentageForfaitairRendementKapitaalverzekeringen?: number;
  /** bd-i-ext1:YieldForfaitPeriodicPaymentsRightsValuePercentage */
  percentageForfaitairRendementRechtPeriodiekeUitkeringenEnVerstrekkingen?: number;
  /** bd-i-ext1:YieldForfaitOtherPropertyPercentage */
  percentageForfaitairRendementOverigeBezittingenBinnenlandseBelastingplichtige?: number;
  /** bd-i-ext1:YieldForfaitNetAnnuityRetirementTaxablePercentage */
  percentageForfaitairRendementNettoLijfrentePensioenBelast?: number;
  /** bd-i-ext1:YieldForfaitDebtImmovablePropertyPercentage */
  percentageForfaitairRendementSchuldOnroerendeZakenNLBinnenlandseBelastingplichtige?: number;
  /** bd-i-ext1:YieldForfaitDebtImmovablePropertyPercentage */
  percentageForfaitairRendementSchuldOnroerendeZakenBuitenlandBinnenlandseBelastingplichtige?: number;
  /** bd-i-ext1:YieldForfaitDebtOtherPropertyPercentage */
  percentageForfaitairRendementSchuldOverigeBezittingenBinnenlandseBelastingplichtige?: number;
  /** bd-i-ext1:YieldForfaitDebtsOtherPercentage */
  percentageForfaitairRendementAndereSchulden?: number;
  /** bd-i-ext1:YieldTaxablePartPercentageTaxpayerPartyShare */
  percentageAangeverdeelBelastbaarRendementBuitenlandseBelastingplichtige?: number;
  /** bd-i-ext1:YieldTaxableTaxpayerPartyShare */
  aangeverdeeBbelastbaarRendementBuitenlandseBelastingplichtige?: number;
  /** bd-i-ext1:YieldPropertyMinusDebtsTotal */
  totaalRendementBezittingenMinSchuldenBuitenlandseBelastingplichtige?: number;
  /** bd-i-ext1:YieldPropertyTotal */
  rendementTotaalBezittingenBuitenlandseBelastingplichtige?: number;
  /** bd-i-ext1:YieldDeductibleDebts */
  rendementAftrekbareSchuldenBuitenlandseBelastingplichtige?: number;
  /** bd-i-ext1:YieldDebtsTotal */
  rendementSchuldenTotaalBuitenlandseBelastingplichtige?: number;
  /** bd-i-ext1:YieldImmovableProperty */
  rendementOnroerendeZakenNLBuitenlandseBelastingplichtige?: number;
  /** bd-i-ext1:YieldOtherProperty */
  rendementOverigeBezittingenBuitenlandseBelastingplichtige?: number;
  /** bd-i-ext1:YieldDebtImmovableProperty */
  rendementSchuldOnroerendeZakenNLBuitenlandseBelastingplichtige?: number;
  /** bd-i-ext1:YieldDebtOtherProperty */
  rendementrendementSchuldOverigeBezittingenBuitenlandseBelastingplichtige?: number;
  /** bd-i-ext1:YieldDebtThresholdCorrection */
  correctieRendementSchuldendrempelBuitenlandseBelastingplichtige?: number;
  /** bd-i-ext1:YieldForfaitImmovablePropertyPercentage */
  percentageForfaitairRendementOnroerendeZakenNLBuitenlandseBelastingplichtige?: number;
  /** bd-i-ext1:YieldForfaitOtherPropertyPercentage */
  percentageForfaitairRendementOverigeBezittingenBuitenlandseBelastingplichtige?: number;
  /** bd-i-ext1:YieldForfaitDebtImmovablePropertyPercentage */
  percentageForfaitairRendementschuldOnroerendeZakenNLBuitenlandseBelastingplichtige?: number;
  /** bd-i-ext1:YieldForfaitDebtOtherPropertyPercentage */
  percentageForfaitairRendementSchuldOverigebezittingenBuitenlandseBelastingplichtige?: number;
  /** bd-i-ext1:PropertyTotal */
  totaalBezittingenBuitenlandseBelastingplichtige?: number;
  /** bd-i:ImmovablePropertyTotal */
  totaalOnroerendeZakenNLBuitenlandseBelastingplichtige?: number;
  /** bd-i:PropertyOtherTotal */
  totaalOverigeBezittingenBuitenlandseBelastingplichtige?: number;
  /** bd-i-ext1:PropertyTotal */
  totaalBezittingenBinnenlandseBelastingplichtige?: number;
  /** bd-i:AssetBankAccountSavingsCertificatesEtcBalance */
  saldiBankrekEnSpaartegoedenEnBewijzenEtc?: number;
  /** bd-i:AssetBankAccountSavingsCertificatesEtcBalance */
  totaalSaldiBankEnSpaartegoedenBuitenland?: number;
  /** bd-i:StockTotal */
  totaalEffectenbezit?: number;
  /** bd-i:CashValueTotal */
  totaalwaardeContantGeld?: number;
  /** bd-i:MoneyLendReceivablesOtherTotal */
  totaalUitgeleendGeldEnAndereVorderingen?: number;
  /** bd-i:ImmovablePropertyTotal */
  totaalOnroerendeZakenNLBinnenlandseBelastingplichtige?: number;
  /** bd-i-ext1:GreenInvestmentsExemptionRelevance */
  totaalOnroerendeZakenBuitenlandBinnenlandseBelastingplichtige?: number;
  /** bd-i:CapitalInsuranceNonExemptedPartTotal */
  totaalNietVrijgesteldDeelKapitaalverzekeringen?: number;
  /** bd-i:PeriodicPaymentsRightsValue */
  rechtenOpPeriodiekeUitkeringenEnVerstrekkingen?: number;
  /** bd-i:PropertyOtherTotal */
  totaalOverigeBezittingenBinnenlandseBelastingplichtige?: number;
  /** bd-i:TaxableIncomeNetAnnuityRetirement */
  sanctieNettolijfrentePpensioenBijNietToegestaneHandeling?: number;
  /** bd-i:ThresholdDebtsAmount */
  drempelbedragSchuldenBuitenlandseBelastingplichtige?: number;
  /** bd-i-ext1:DebtsTotal */
  schuldenTotaalBuitenlandseBelastingplichtige?: number;
  /** bd-i:ImmovablePropertyDebtsTotal */
  schuldenTotaalOnroerendeZakenNLBuitenlandseBelastingplichtige?: number;
  /** bd-i:PropertyOtherDebtsTotal */
  schuldenTotaalOverigeBezittingenBuitenlandseBelastingplichtige?: number;
  /** bd-i-ext1:DeductableDebts */
  aftrekbareSchuldenBinnenlandseBelastingplichtige?: number;
  /** bd-i-ext1:DeductableDebts */
  aftrekbareSchuldenBuitenlandseBelastingplichtige?: number;
  /** bd-i:ThresholdDebtsAmount */
  drempelbedragSchuldenBinnenlandsBelastingplichtige?: number;
  /** bd-i-ext1:DebtsTotal */
  schuldenTotaalBinnenlandseBelastingplichtige?: number;
  /** bd-i:ImmovablePropertyDebtsTotal */
  schuldenTotaalOnroerendeZakenNLBinnenlandseBelastingplichtige?: number;
  /** bd-i:ImmovablePropertyDebtsTotal */
  schuldenTotaalOnroerendZakenBuitenlandBinnenlandseBelastingplichtige?: number;
  /** bd-i:PropertyOtherDebtsTotal */
  schuldenTotaalOverigeBezittingenBinnenlandseBelastingplichtige?: number;
  /** bd-i:DebtsOtherTotal */
  totaalAndereSchulden?: number;
  /** bd-i-ext1:SavingsAndInvestmentsBenefitsRateYieldClass1 */
  tariefVoordeelSparenEnBeleggenRendementsklasseI?: number;
  /** bd-i-ext1:SavingsAndInvestmentsBenefitsRateYieldClass2 */
  tariefVoordeelSparenEnBeleggenRendementsklasseII?: number;
  /** bd-i-ext1:SavingsAndInvestmentsTaxBaseYieldClass1TaxBracket1Percentage */
  percentageGrondslagSparenBeleggenRendementsklIschijf1?: number;
  /** bd-i-ext1:SavingsAndInvestmentsTaxBaseYieldClass2TaxBracket1Percentage */
  percentageGrondslagSparenBeleggenRendementsklIIschijf1?: number;
  /** bd-i-ext1:SavingsAndInvestmentsTaxBaseYieldClass1TaxBracket2Percentage */
  percentageGrondslagSparenBeleggenRendementsklISchijf2?: number;
  /** bd-i-ext1:SavingsAndInvestmentsTaxBaseYieldClass2TaxBracket2Percentage */
  percentageGrondslagSparenBeleggenRendementsklIISchijf2?: number;
  /** bd-i-ext1:SavingsAndInvestmentsTaxBaseYieldClass2TaxBracket3Percentage */
  percentageGrondslagSparenBeleggenRendementsklIISchijf3?: number;
  /** bd-i-ext1:SavingsAndInvestmentsBenefitsBracketRate */
  voordeelSparenBeleggenBinnenlandseBelplSchijventarief?: number;
  /** bd-i-ext1:SavingsAndInvestmentsBaseBracket1 */
  grondslagSparenBeleggenBinnenlandseBelplSch1?: number;
  /** bd-i-ext1:SavingsAndInvestmentsBaseYieldClass1Bracket1 */
  grondslagSparenBeleggenBinnenlandseBelplKlasseISch1?: number;
  /** bd-i-ext1:SavingsAndInvestmentsBenefitsYieldClass1Bracket1 */
  voordeelSparenBeleggenBinnenlandseBelplKlasseISch1?: number;
  /** bd-i-ext1:SavingsAndInvestmentsBaseYieldClass2Bracket1 */
  grondslagSparenBeleggenBinnenlandseBelplKlasseIISch1?: number;
  /** bd-i-ext1:SavingsAndInvestmentsBenefitsYieldClass2Bracket1 */
  voordeelSparenBeleggenBinnenlandseBelplKlasseIISch1?: number;
  /** bd-i-ext1:SavingsAndInvestmentsBaseBracket2 */
  grondslagSparenBeleggenBinnenlandseBelplSch2?: number;
  /** bd-i-ext1:SavingsAndInvestmentsBaseYieldClass1Bracket2 */
  grondslagSparenBeleggenBinnenlandseBelplKlasseISch2?: number;
  /** bd-i-ext1:SavingsAndInvestmentsBenefitsYieldClass1Bracket2 */
  voordeelSparenBeleggenBinnenlandseBelplKlasseISch2?: number;
  /** bd-i-ext1:SavingsAndInvestmentsBaseYieldClass2Bracket2 */
  grondslagSparenBeleggenBinnenlandseBelplKlasseIISch2?: number;
  /** bd-i-ext1:SavingsAndInvestmentsBenefitsYieldClass2Bracket2 */
  voordeelSparenBeleggenBinnenlandseBelplKlasseIISch2?: number;
  /** bd-i-ext1:SavingsAndInvestmentsBaseBracket3 */
  grondslagSparenBeleggenBinnenlandseBelplSch3?: number;
  /** bd-i-ext1:SavingsAndInvestmentsBaseYieldClass2Bracket3 */
  grondslagSparenBeleggenBinnenlandseBelplKlasseIISch3?: number;
  /** bd-i-ext1:SavingsAndInvestmentsBenefitsYieldClass2Bracket3 */
  voordeelSparenBeleggenBinnenlandseBelplKlasseIISch3?: number;
  /** bd-i-ext1:TaxationElsewhereBox3 */
  aftrekEldersBelastBox3?: number;
  /** bd-i-ext1:IncomeTaxBox3 */
  inkomstenbelastingBox3?: number;
  /** bd-i-ext1:TaxBox3 */
  belastingBox3?: number;
  /** bd-i-ext1:WithholdingTaxBox3AbroadPreviousYearsToBeSetoff */
  nogTeVerrekenenBuitenlandseBronheffingBox3VoorgaandeJaren?: number;
  /** bd-i-ext1:WithholdingTaxBox3AbroadToBeSetoff */
  teVerrekenenBuitenlandseBronheffingBox3?: number;
  /** bd-i-ext1:WithholdingTaxBox3AbroadSettled */
  verrekendeBuitenlandseBronheffingBox3?: number;
  /** bd-i-ext1:WithholdingTaxBox3AbroadToBeSetoffFinalScore */
  eindstandTeVerrekenenBuitenlandseBronheffingBox3?: number;
  /** bd-i-ext1:TaxBox3FixedRatePart */
  belastingBox3VastTariefDeel?: number;
  /** bd-i-ext1:TaxAmountOtherRate1Box3 */
  belastingBedragAnderTarief1Box3?: number;
  /** bd-i-ext1:TaxAmountOtherRate2Box3 */
  belastingBedragAnderTarief2Box3?: number;
  /** bd-i:MaintenanceObligationsPeriodicPaymentsPartyFilingTaxReturnPart */
  aftrekOnderhoudsverplichtingen?: number;
  /** bd-i:ExtraordinaryExpenditureHealthDeductibleAmountPartyFilingTaxReturnPart */
  aftrekSpecifiekeZorgkosten?: number;
  /** bd-i:WeekendExpensesDisabledPersonsPartyFilingTaxReturnAmount */
  weekenduitgavenGehandicaptenAftrekbaarAangever?: number;
  /** bd-i:TrainingExpensesDeductionPartyFilingTaxReturnPart */
  aftrekScholingsuitgaven?: number;
  /** bd-i:GiftsBalanceDeductibleTotalPartyFilingTaxReturn */
  aftrekGiften?: number;
  /** bd-i:PersonDependentDeductionRemainderPreviousYears */
  restantPersoonsgebondenAftrek?: number;
  /** bd-i-ext1:PersonDependentRemainderDeductionToBeSettledPreviousYears */
  teVerrekenenPersoonsgebondeAftrekVoorgaandeJaren?: number;
  /** bd-i-ext1:PersonDependentRemainderDeductionToBeSettled */
  teVerrekenenPersoonsgebondenAftrek?: number;
  /** bd-i-ext1:PersonDependentRemainderDeductionSettledWithIncomeBox1 */
  verrekendePersoonsgebondenAftrekMetInkomenBox1?: number;
  /** bd-i-ext1:PersonDependentRemainderDeductionSettledWithIncomeBox2 */
  verrekendePersoonsgebondenAftrekMetInkomenBox2?: number;
  /** bd-i-ext1:PersonDependentRemainderDeductionSettledWithIncomeBox3 */
  verrekendePersoonsgebondenAftrekMetInkomenBox3?: number;
  /** bd-i-ext1:PersonDependentRemainderDeductionToBeSettledNextYears */
  persoonsgebondenAftrekNogTeVerrekenenVolgendeJaren?: number;
  /** bd-i-ext1:PersonDependentRemainderDeductionToBeSettledFromThisYear */
  persoonsgebondenAftrekNogTeVerrekenenUitDitJaar?: number;
  /** bd-i-ext1:PersonDependentRemainderDeductionRevisedToNihilIndication */
  indicatieHerzieningRestantPgaNaarNihil?: boolean;
  /** bd-i-ext1:TaxCreditsCombined */
  gecombineerdeHeffingsKorting?: number;
  /** bd-i-ext1:IncomeOverallChangeEffectOnTaxCredits */
  wijzigingVerzamelinkomenEffectOpHeffingskortingen?: boolean;
  /** bd-i-ext1:GeneralTaxCreditCalculated */
  algemeneHeffingskortingBerekend?: number;
  /** bd-i-ext1:EmployedPersonsTaxCreditTaxReturn */
  arbeidsKortingBerekend?: number;
  /** bd-i-ext1:EmployedPersonsTaxCreditCalculated */
  arbeidskortingVolgensAangifte?: number;
  /** bd-i-ext1:IncomeDependentCombinationTaxCreditCalculated */
  inkomensafhankelijkeCombinatiekortingBerekend?: number;
  /** bd-i-ext1:YoungDisabledPersonsTaxCreditCalculated */
  jonggehandicaptenkortingBerekend?: number;
  /** bd-i-ext1:ParentsTaxCreditCalculated */
  ouderenKortingBerekend?: number;
  /** bd-i-ext1:SupplementaryElderlyPersonsTaxCredit */
  alleenstaandeOuderenKortingBerekend?: number;
  /** bd-i-ext1:LifecycleLeaveReductionCalculated */
  levensLoopVerlofKorting?: number;
  /** bd-i-ext1:GreenInvestmentDiscountCalculated */
  groeneBeleggingenKortingBerekend?: number;
  /** bd-i-ext1:TaxCreditsNonPayablePart */
  nietUitbetaalbaaDeelHeffingskortingen?: number;
  /** bd-i-ext1:IncomeLevyCombined */
  gecombineerdeInkomensheffing?: number;
  /** bd-i-ext1:TaxCreditsPotentionalPayment */
  potentieleUitbetalingHeffingskortingen?: number;
  /** bd-i-ext1:TaxCreditsUnusedPayment */
  uitbetalingOnbenutteHeffingskortingen?: boolean;
  /** bd-i-ext1:TaxCredit */
  heffingskorting?: number;
  /** bd-i-ext1:TaxCreditsPayment */
  uitbetalingHeffingskortingen?: number;
  /** bd-i-ext1:TaxCreditsStandard */
  standaardHeffingskortingen?: number;
  /** bd-i-ext1:TaxCreditsDeviatingPotentionalPayment */
  afwijkendePotentieleUitbetalingHeffingskortingen?: number;
  /** bd-i-ext1:TaxPartnerApplied */
  toegepasteBelastingPartner?: number;
  /** bd-i-ext1:LossYearForBackwardSettoffLoss */
  verliesJaarAchterwaartseVerliesVerrekening?: number;
  /** bd-i-ext1:BusinessLossToBeSetoffPreviousYears */
  nogTeVerrekenenOndernemingsVerliezenVoorgaandeJaren?: number;
  /** bd-i-ext1:BusinessLossAchieved */
  geledenOndernemingsVerlies?: number;
  /** bd-i-ext1:BusinessLossSettled */
  verrekendOndernemingsVerlies?: number;
  /** bd-i-ext1:BusinessLossToBeSettledBox1FinalScore */
  eindstandTeVerrekenenOndernemingsverliesBox1?: number;
  /** bd-i-ext1:BusinessLossNotToBeSettledAfterThisYear */
  naDitJaarNietMeerTeVerrekenenOndernemingsVerliezen?: number;
  /** bd-i-ext1:LossExclusiveOfBusinessLossToBeSettledPreviousYears */
  nogTeVerrekenenVerliesExclOndernVerliesVoorgJr?: number;
  /** bd-i-ext1:LossExclusiveOfBusinessLossBox1Achieved */
  geledenVerliesBox1ExclOndernemingsverlies?: number;
  /** bd-i-ext1:LossExclusiveOfBusinessLossBox1Settled */
  verrekendVerliesBox1ExclOndernemingsverlies?: number;
  /** bd-i-ext1:LossExclusiveOfBusinessLossToBeSettledBox1FinalScore */
  eindstandTeVerrekenenVerliesBox1ExclOndernverlies?: number;
  /** bd-i-ext1:LossExclusiveOfBusinessLossBox1NotToBeSettled */
  nietVerrekenbaarVerliesBox1ExclOndernemingsverlies?: number;
  /** bd-i-ext1:TaxableIncomeWorkAndHouseAfterCarryBack */
  belastbaarInkomenBox1NaCarryBack?: number;
  /** bd-i-ext1:LossBox1CarryBackToBeSettled */
  nogTeVerrekenVerliesBox1CarryBack?: number;
  /** bd-i-ext1:LossBox1CarryBackSettled */
  verrekendVerliesBox1CarryBack?: number;
  /** bd-i-ext1:LossBox1CarryBackFinalScore */
  eindstandVerliesBox1CarryBack?: number;
  /** bd-i-ext1:LossNotToBeSettledAfterThisYear */
  naDitJaarNietMeerVerrekenbaarVerlies?: number;
  /** bd-i-ext1:IncomeEmploymentOwnerOccupiedHouseLossYear */
  inkomenUitWerkEnWoningVerliesJaar?: number;
  /** bd-i-ext1:LossBox1SettledTotal */
  totaalVerrekendVerliesBox1?: number;
  /** bd-i-ext1:LossBox1SettledTotalCarryback */
  totaalVerrekendVerliesBox1CarryBack?: number;
  /** bd-i-ext1:LossToBeSettledBox2PreviousYears */
  nogTeVerrekenenVerliesBox2VoorgaandeJaren?: number;
  /** bd-i-ext1:LossBox2Achieved */
  geledenVerliesBox2?: number;
  /** bd-i-ext1:LossBox2Settled */
  verrekendVerliesBox2?: number;
  /** bd-i-ext1:LossBox2ToBeSettledFinalScore */
  eindstandTeVerrekenenVerliesBox2?: number;
  /** bd-i-ext1:LossBox2CarryBackFinalScore */
  eindstandVerliesBox2CarryBack?: number;
  /** bd-i-ext1:TaxableIncomeBox2AfterCarryBack */
  belastbaarInkomenBox2NaCarryBack?: number;
  /** bd-i-ext1:IncomeSubstantialInterestYearLoss */
  inkomenAanmerkelijkBelangVerliesJaar?: number;
  /** bd-i-ext1:LossNotToBeSettledAfterThisYearBox2 */
  naDitJaarNietMeerTeVerrekenVerliesBox2?: number;
  /** bd-i-ext1:TaxReductionsTransitionalArrangementGermany */
  verminderingDuitslandOvergangsregeling?: number;
  /** bd-i:OverallIncome */
  verzamelinkomen?: number;
  /** bd-i-ext1:OverallIncomeChange */
  wijzigingVerzamelinkomen?: boolean;
  /** bd-i:SurchargeNotAdequateNoticeTaxReturn */
  verhogingBijNietTijdigeAangifte?: number;
  /** bd-i-ext1:TaxAssessmentAmountAfterCheckTaxAssessmentRestriction */
  bedragVanDeAanslagNaToetsingAanslaggrens?: number;
  /** bd-i-ext1:TaxAssessmentAmountIncludingNegativeTaxAssessment */
  bedragVanDeAanslagInclNegatieveVoorlopigeAanslag?: number;
  /** bd-i-ext1:EstablishedAmountPreviously */
  eerderVastgesteldBedrag?: number;
  /** bd-i-ext1:EstablishedBackDutyPreviously */
  eerderVastgesteldeNavordering?: number;
  /** bd-i-ext1:ProvisionalRefundProvidedPreviously */
  eerderVerleendeVoorlopigeTeruggaven?: number;
  /** bd-i-ext1:TaxAssessmentAmountWithInterest */
  bedragAanslagMetRente?: number;
  /** bd-i-ext1:TaxAssessmentsAmountPreviouslyTotal */
  totaalEerdereAanslagen?: number;
  /** bd-i-ext1:TaxAssessmentAmountPreviously */
  bedragAanslagEerder?: number;
  /** bd-i-ext1:TaxAssessmentAmountWithInterestPreviously */
  vorigBedragAanslagMetRente?: number;
  /** bd-i-ext1:ProvisionalTaxAssessmentAmountNew */
  nieuwBedragVanDeVoorlopigeAanslag?: number;
  /** bd-i:MisdemeanourPenalty */
  vergrijpBoete?: number;
  /** bd-i:SurchargeNotAdequateNoticeTaxReturn */
  verzuimBoete?: number;
  /** bd-i-ext1:TaxInterestPreviouslyTaxAssessment */
  belastingrenteInEerdereAanslagen?: number;
  /** bd-i-ext1:TaxInterestCalculated */
  belastingrenteBerekend?: number;
  /** bd-i-ext1:TaxInterestCharged */
  belastingrenteInRekeningGebracht?: number;
  /** bd-i:TaxInterestCompensate */
  vergoedeBelastingrente?: number;
  /** bd-i-ext1:TaxInterestChargedReduction */
  verminderingInRekeningGebrachteBelastingrente?: number;
  /** bd-i:RevisionInterestCalculatedAmount */
  revisierente?: number;
  /** bd-i-ext1:TaxAssesmentAmountExclusiveOfTaxInterestCompensate */
  saldoExclusiefVergoedeBelastingrente?: number;
  /** bd-i-ext1:TaxAssesmentsPreviousAmountsExclusiveOfTaxInterestCompensate */
  saldoEerdereAanslagenExclVergoedeBelastingrente?: number;
  /** bd-i:TaxAssessmentAmountToBeReceivedToBePaidBalance */
  teBetalenTerugTeOntvangen?: number;
  /** bd-i-ext1:TaxCreditLossSubstantialInterestToBeSetoffPreviousYears */
  teVerrekenenBelastingkortingVerliesABVoorgaandeJaren?: number;
  /** bd-i-ext1:TaxCreditLossSubstantialInterestSettled */
  verrekendeBelastingkortingVerliesAanmerkelijkBelang?: number;
  /** bd-i-ext1:TaxCreditLossSubstantialInterestToBeSettledNextYears */
  nogTeVerrekekenenBelastingkortingVerliesABVolgendeJaren?: number;
  /** bd-i-ext1:TaxOnGamesOfChanceDividendTotal */
  verrekendeDividendEnKansspelbelasting?: number;
  /** bd-i-ext1:WageTaxPremiumToBeSettled */
  teVerrekenenLoonbelastingPremieVolksverzekeringen?: number;
  /** bd-i:WageTaxArtistsAndSportsProfessionals */
  loonheffingArtiestenBeroepssporters?: number;
  /** bd-i:WageTaxOnWagesInBusinesIncome */
  loonheffingOverInWinstOpgenomenLoon?: number;
  /** bd-i-ext1:WageTaxRaisedOnTheBaseOfCommonCompensationSettlement */
  loonheffingVerhoogdOgvAlgemeneCompensatieregeling?: number;
  /** bd-i-ext1:WageTaxRaisedOnTheBaseOfSpecialCompensationSettlement */
  loonheffingVerhoogdOgvBijzondereCompensatieregeling?: number;
  /** bd-i-ext1:CompensationSettlementGermany */
  compensatieregelingDuitsland?: number;
  /** bd-i:NoticeOfAssessmentMultipleTermsExpiringDate */
  uitersteBetaalDatumMeerdereTermijnen?: Date;
  /** bd-i:NoticeOfAssessmentExpiringDateFirstAndOnly */
  uitersteBetaalDatum?: Date;
  /** NoticeOfAssessmentExpiringDateLastPeriod */
  uitersteBetaalDatumLaatsteTermijn?: Date;
  /** bd-i-ext1:ProvisionalTaxReturnPaymentNumberOfMonthlyPayments */
  aantalMaandtermijnenBetalingVoorlopigeAanslag?: number;

  [key: string]: any;
}

/** Averaging */
export interface AanslagMiddeling {
  /** AveragingPeriodFirstYear 639449 */
  eersteJaarTijdvakMiddeling: number;
  /** AveragingPeriodSecondYear 1762693 */
  tweedeJaarTijdvakMiddeling: number;
  /** AveragingPeriodLastYear 639450 */
  derdeJaarTijdvakMiddeling: number;
  /** AveragingRequestReceivedInTime */
  tijdigOntvangenVerzoekMiddeling: boolean;
  /** TaxableIncomeEmploymentOwnerOccupiedHouseAveragingYearMinusTwo */
  belastbaarInkomenUitWerkEnWoningMiddelingsjaarMin2: number;
  /** TaxableIncomeEmploymentOwnerOccupiedHouseAveragingYearMinusOne */
  belastbaarInkomenUitWerkEnWoningMiddelingsjaarMin1: number;
  /** TaxableIncomeEmploymentOwnerOccupiedHouseAveragingYear */
  belastbaarInkomenUitWerkEnWoningMiddelingsjaar: number;
  /** ContributionBaseIncomeReducedAveragingYearMinusTwo */
  herleidPremieInkomenMiddelingsjaarMin2: number;
  /** ContributionBaseIncomeReducedAveragingYearMinusOne */
  herleidPremieInkomenMiddelingsjaarMin1: number;
  /** ContributionBaseIncomeReducedAveragingYear */
  herleidPremieInkomenMiddelingsjaar: number;
  /** IncomeTaxLeviedAveragingYearMinusTwo */
  gehevenInkomstenBelastingMiddelingsjaarMin2: number;
  /** IncomeTaxLeviedAveragingYearMinusOne */
  gehevenInkomstenBelastingMiddelingsjaarMin1: number;
  /** IncomeTaxLeviedAveragingYear */
  gehevenInkomstenBelastingMiddelingsjaar: number;
  /** SocialInsurancePremiumsLeviedAveragingYearMinusTwo */
  gehevenPremiesMiddelingsjaarMin2: number;
  /** SocialInsurancePremiumsLeviedAveragingYearMinusOne */
  gehevenPremiesMiddelingsjaarMin1: number;
  /** SocialInsurancePremiumsLeviedAveragingYear */
  gehevenPremiesMiddelingsjaar: number;
  /** IncomeTaxAndSocialInsurancePremiumsLeviedAveragingYearMinusTwo */
  gehevenIbPvMiddelingsjaarMin2: number;
  /** IncomeTaxAndSocialInsurancePremiumsLeviedAveragingYearMinusOne */
  gehevenIbPvMiddelingsjaarMin1: number;
  /** IncomeTaxAndSocialInsurancePremiumsLeviedAveragingYear */
  gehevenIbPvMiddelingsjaar: number;
  /** TaxableIncomeEmploymentOwnerOccupiedHouseAverageAveragingYear */
  gemiddeldBelastbaarInkomen: number;
  /** ContributionBaseIncomeAverageAveragingYearYearMinusTwo */
  gemiddeldPremieInkomenMiddelingsjaarMin2: number;
  /** ContributionBaseIncomeAverageAveragingYearYearMinusOne */
  gemiddeldPremieInkomenMiddelingsjaarMin1: number;
  /** ContributionBaseIncomeAverageAveragingYear */
  gemiddeldPremieInkomenMiddelingsjaar: number;
  /** TaxableIncomeAverageRecalulatedAveragingYearMinusTwo */
  herrekendeIbGemiddBelastbaarInkomenMiddelingsjaarMin2: number;
  /** TaxableIncomeAverageRecalulatedAveragingYearMinusOne */
  herrekendeIbGemiddBelastbaarInkomenMiddelingsjaarMin1: number;
  /** TaxableIncomeAverageRecalulatedAveragingYear */
  herrekendeIbGemiddBelastbaarInkomenMiddelingsjaar: number;
  /** SocialInsurancePremiumsAverageContributionBaseIncomeRecalulatedAveragingYearMinusTwo */
  herrekendePvGemiddeldPremieInkomenMiddelingsjaarMin2: number;
  /** SocialInsurancePremiumsAverageContributionBaseIncomeRecalulatedAveragingYearMinusOne */
  herrekendePvGemiddeldPremieInkomenMiddelingsjaarMin1: number;
  /** SocialInsurancePremiumsAverageContributionBaseIncomeRecalulatedAveragingYear */
  herrekendePvGemiddeldPremieInkomenMiddelingsjaar: number;
  /** IncomeTaxAndSocialInsurancePremiumsRecalculatedAveragingYearMinusTwo */
  herrekendeIbPvMiddelingsjaarMin2: number;
  /** IncomeTaxAndSocialInsurancePremiumsRecalculatedAveragingYearMinusOne */
  herrekendeIbPvMiddelingsjaarMin1: number;
  /** IncomeTaxAndSocialInsurancePremiumsRecalculatedAveragingYear */
  herrekendeIbPvMiddelingsjaar: number;
  /** IncomeTaxAndSocialInsurancePremiumsLeviedAveragingPeriodTotal */
  somGehevenIbPvMiddelingstijdvak: number;
  /** IncomeTaxAndSocialInsurancePremiumsRecalculatedAveragingPeriodTotal */
  somHerrekendeIbPvMiddelingstijdvak: number;
  /** IncomeTaxAndSocialInsurancePremiumsLeviedRecalculatedAveragingPeriodDifference */
  verschilHerrekendeEnGehevenIbPv: number;
  /** CorrectionUpToLeviedIncomeTax */
  correctieTotAanGehevenBelasting?: number;
  /** DifferenceAfterCorrectionUpToLeviedIncomeTax */
  verschilNaCorrectieTotAanGehevenInkomstenbelasting: number;
  /** AveragingThreshold */
  drempelMiddeling: number;
  /** AveragingRefundBeforeCorrectionDoubleTaxationAvoidance */
  middelingsTeruggaafVoorCorrectieDubbeleBelasting: number;
  /** CorrectionRelatedToDoubleTaxationAvoidance */
  correctieInVerbandMetVoorkomingDubbeleBelasting?: number;
  /** AveragingRefund */
  middelingsTeruggaaf: number;
  /** AveragingRefundPrevious */
  vorigeMiddelingsTeruggaaf?: number;
  /** TaxAssessmentsAmountPreviouslyTotal */
  totaalEerdereAanslagen?: number;
  /** TaxAssessmentAmountToBeReceivedToBePaidBalance */
  teBetalenTerugTeOntvangen?: number;
  /** ObjectionSatisfied */
  tegemoetkomingBezwaar?: string;
  /** AveragingObjectionDeadlineDate */
  uitersteDatumBezwaarMiddeling: Date;

  [key: string]: any;
}

export interface AangifteBerekening {
  partnerBerekening?: AangifteBerekening;
  box1?: Box1Berekening;
  box2?: Box2Berekening;
  box3?: Box3Berekening;
  premieVolksverzekeringen?: number;
  gecombineerdeInkomensheffing?: number;
  opbouwPGA?: OpbouwPGA;
  heffingskortingen?: HeffingskortingenBerekening;
  verrekendeBelastingKortingBox2?: number;
  alBetaaldeLoonbelasting?: number;
  alBetaaldeDividendbelasting?: number;
  voorlopigeAanslag?: number;
  aanslaggrens?: number;
  verschuldigdeInkomstenbelasting?: number;
  verschuldigdeZVW?: number;
  nietToegerekendePga?: number;
  verzamelinkomen?: number;

  [key: string]: any;
}

export interface Wetgeving {
  box1PercentageSchijf1?: number;
  box1PercentageSchijf2?: number;
  box1PercentageSchijf3?: number;
  tariefsaanpassingAftrekEigenWoning?: number;
  maxInkomen1eSchijf?: number;
  maxInkomen2eSchijf?: number;
  maxInkomen3eSchijf?: number;
  box3Percentage?: number;

  [key: string]: any;
}

export interface Box1Berekening {
  inkomen?: number;
  persoonsgebondenAftrek?: number;
  belastbaarInkomen?: number;
  inkomstenbelasting?: number;
  conserverendeAanslag?: number;
  opbouwInkomen?: OpbouwInkomenBox1;

  [key: string]: any;
}

export interface Box2Berekening {
  inkomen?: number;
  persoonsgebondenAftrek?: number;
  belastbaarInkomen?: number;
  inkomstenbelasting?: number;
  conserverendeAanslag?: number;
  opbouwInkomen?: OpbouwInkomenBox2;

  [key: string]: any;
}

export interface Box3Berekening {
  inkomen?: number;
  persoonsgebondenAftrek?: number;
  belastbaarInkomen?: number;
  inkomstenbelasting?: number;
  opbouwInkomen?: OpbouwInkomenBox3;

  [key: string]: any;
}

export interface HeffingskortingenBerekening {
  totaal?: number;
  opbouw?: OpbouwHeffingskortingen;

  [key: string]: any;
}

export interface OpbouwHeffingskortingen {
  algemeneHeffingskorting?: number;
  arbeidskorting?: number;
  inkomensafhankelijkeCombinatieKorting?: number;
  ouderenkorting?: number;
  alleenstaandeOuderenkorting?: number;
  wajong?: number;
  grondslagGroeneBeleggingen?: number;
  groeneBeleggingen?: number;
  levensloopverlof?: number;
  werkbonus?: number;
  vutkorting?: number;
  maximering?: number;
  verhogingPartner?: number;
  voldoetAanVoorwaardenUitbetalingAlgemeneHeffingskorting?: boolean;
  voldoetAanVooraardenBijzondereVerhogingHeffingskorting?: boolean;

  [key: string]: any;
}

export interface OpbouwInkomenBox1 {
  winstUitOnderneming?: number;
  belastbaarloon?: number;
  resultaatUitOverigeWerkzaamheden?: number;
  periodiekeUitkeringen?: number;
  inkomstenUitEigenWoning?: number;
  saldoEigenWoning?: number;
  negatieveUitgavenVoorInkomensvoorzieningen?: number;
  negatievePersoonsgebondenAftrek?: number;
  overigeInkomsten?: number;
  aftrekWegensGeenOfGeringeEigenWoningSchuld?: number;
  uitgavenVoorInkomensvoorzieningen?: number;
  verrekendVerlies?: number;
  teConserverenInkomen?: number;

  [key: string]: any;
}

export interface OpbouwInkomenBox2 {
  teConserverenInkomen?: number;
  inkomenUitAanmerkelijkBelang?: number;
  verrekendVerlies?: number;
  saldoAanmerkelijkBelang?: number;

  [key: string]: any;
}

export interface OpbouwInkomenBox3 {
  voordeelUitSparenEnBeleggen?: number;
  forfaitairVoordeelUitSparenEnBeleggen?: number;
  werkelijkVoordeelUitSparenEnBeleggen?: number;
  grondslagNaVerdeling?: number;
  grondslagSparenEnBeleggen?: number;
  rendementsGrondslagNaVerdeling?: number;
  rendementsGrondslag?: number;

  [key: string]: any;
}

export interface OpbouwPGA {
  restantPgaVoorgaandeJaren?: number;
  onderhoudsverplichtingen?: number;
  specifiekeZorgkosten?: number;
  weekenduitgaven?: number;
  scholingsuitgaven?: number;
  monumentenpanden?: number;
  aftrekbareGiften?: number;
  kwijtscheldingDurfkapitaal?: number;
  aandeelPartnerPga?: number;

  [key: string]: any;
}

/** Tax payer */
export interface Aangever {
  /** FullName */
  roepnaam?: string;
  /** Initials */
  voorletters?: string;
  /** Prefix */
  tussenvoegsels?: string;
  /** Surname */
  achternaam: string;
  /** TaxIdentificationNumber */
  bsn?: string;
  /** DateOfBirth */
  geboortedatum: Date;
  /** DateOfDecease */
  overlijdensdatum?: Date;
  /** ISO 3166 land codes 3-characters */
  landCodeNationaliteit?: string;
  /** Marital status - enum */
  burgerlijkeStaat: AangeverBurgerlijkeStaat;
  /** Living together, not married, situation */
  samenwoonSituatie?: AangeverSamenwoonSituatie;
  /** Relationship situation if changed during the year */
  relatiegegevens?: Relatiegegevens[];

  [key: string]: any;
}

export interface Aangifte {
  /** PrefilledTaxReturnIncomeUseWatermark */
  waterMerkVia?: string;
  /** P = resident, F = deceased, C = foreign, M = migration */
  biljetSoort: string;
  /** Tax year */
  aangifteJaar: number;
  aangever: Aangever;
  vertegenwoordiger?: Vertegenwoordiger;
  partnerAangifte?: Aangifte;
  /** If partnerAangifte is present, indicate whether tax payer and partner submit a joint return */
  gezamenlijkeAangifte?: boolean;
  /** Children */
  kinderen?: Kind[];
  verdeling?: Verdeling;
  box1?: Box1InkomenUitWerkEnWoning;
  box2?: Box2InkomenUitAanmerkelijkBelang;
  box3?: Box3InkomenUitSparenEnBeleggen;
  persoonsgebondenAftrek?: PersoonsgebondenAftrek;
  heffingskortingen?: Heffingskortingen;
  voorheffingen?: Voorheffingen;
  premieplicht?: Premieplicht;
  buitenlandseBelastingplicht?: BuitenlandseBelastingplicht;
  /** Trust Capital */
  apvLijst?: Apv[];
  teConserverenInkomen?: ConserverendInkomen;
  verliescompensatie?: VerliescompensatieIb;

  [key: string]: any;
}

/** ListOfSubstantialInterestCompanies */
export interface AanmerkelijkBelang {
  omschrijving?: string;
  aantalAandelen: number;
  landCode?: string;
  reguliereVoordelen?: number;
  aftrekbareKosten?: number;
  fictieveReguliereVoordelen?: number;
  maximumBedragSchuldenBijVennootschappen?: number;
  eerderInHeffingBetrokkenSchuldBijVennootschappen?: number;
  schuldenVennootschappenBijImmigratie?: number;
  totaalSchuldenBijVennootschappen?: number;
  schuldenAangeverBijVennootschappen?: number;
  schuldenPartnerBijVennootschappen?: number;
  eigenWoningSchuldenBijVennootschappen?: number;
  schuldenVerbondenPersonenBijVennootschappen?: number;
  eigenWoningSchuldenVerbondenPersonenBijVennootschappen?: number;
  toerekeningSchuldenVerbondenPersonenAanAbHouder?: number;
  overdrachtsprijs?: number;
  toerekenbareVerkrijgingsprijs?: number;
  verzoekDoorschuivenVerkrijgingsPrijs?: boolean;
  vennootschapBevatBeleggingsVermogen?: boolean;

  [key: string]: any;
}

export interface VerbondenPersonenMetAanmerkelijkBelang {

}

/** PreservedIncomeProvisionsClaimSpecification */
export interface Aanspraken {
  /** PreservedIncomeDescription */
  omschrijving: string;
  /** PreservedIncomePolicyNumber */
  polisnummer: string;
  /** PreservedIncomeClaimInOwnManagement */
  indicatieEigenBeheer: boolean;
  /** PreservedIncomeClaimFairValue */
  indicatieWEV: boolean;
  /** PreservedIncomeClaimPremiumsPaid */
  indicatieBetaaldePremies: boolean;
  /** PreservedIncomeClaim */
  teConserverenInkomen: number;

  [key: string]: any;
}

/** NameAndAddressMainenanceRecipient */
export interface AlimentatieGerechtigde {
  adresAlimentatieGerechtigde?: Adres;
  gegevensAlimentatieGerechtigde: Persoon;

  [key: string]: any;
}

/** Trust Capital */
export interface Apv {
  /** TrustCapitalName */
  omschrijving: string;
  /** TrustCapitalCountry */
  landCode: string;
  /** TrustCapitalLegalForm */
  rechtsvorm: string;
  /** TrustCapitalOwnBusiness */
  apvDrijftOnderneming: boolean;
  /** TrustCapitalLegalForm */
  activiteiten?: string;
  /** TrustCapitalSubjectToTaxation */
  apvIsOnderworpen?: boolean;
  /** IncomeFromWorkAndOwnHouseRelatedToTrustCapital */
  inkomenBox1VanwegeAPV: number;
  /** SubstantialInterestBenefitRelatedToTrustCapital */
  inkomenBox2VanwegeAPV: number;
  /** SubstantialInterestCommercialValueRelatedToTrustCapital */
  waardeBox2AandelenVanwegeAPV?: number;
  /** AssetsMinusDebtsBox3RelatedToTrustCapital */
  waardeBox3Apv: number;
  /** TrustCapitalEquityValue */
  eigenVermogenVanApv: number;
  /** TrustCapitalUnMarketableAssetsValue */
  waardeIncouranteBezittingen: number;
  /** TrustCapitalMarketableAssetsValue */
  waardeCouranteBezittingen: number;

  [key: string]: any;
}

/** TaxableWages */
export interface Box1BelastbaarLoon {
  /** PresentWorkHomeCountry */
  loonUitTegenwoordigeDienstbetrekking?: LoonUitTegenwoordigeDienstbetrekking[];
  /** PensionAnnuityBenefitsOther */
  loonUitVroegereDienstbetrekking?: Loon[];
  /** IncomePreviousWorkAbroadWithoutDutchWageTax */
  loonUitBuitenlandseDienstbetrekkingOfPensioen?: LoonBuitenland[];
  /** ExemptedWagesInternationalOrganisationPreviousWork */
  vrijgesteldLoonInternationaleOrganisatie?: LoonInternationaleOrganisatie[];
  /** TravelDeduction */
  reisAftrekOV?: ReisAftrekOV[];
  /** Boolean that indicates whether or not a tax payer has two or more employers simultaneously */
  dubbelePositie?: boolean;

  [key: string]: any;
}

/** IncomeOtherBenefitCapitalInsurance */
export interface Box1BelastbareInkomstenOpBasisVanOvergangsrecht {
  /** IncomeOtherInterestBefore2001 */
  inkomstenOverigRenteVoor2001?: number;
  /** IncomeOtherBefore2001 */
  inkomstenOverigRestVoor2001?: number;
  /** IncomeOtherOwnHouseInsuranceTaxable */
  inkomstenOverigBelastbaarKapitaalverzekering?: number;

  [key: string]: any;
}

/** TaxableIncomeFromOwnHouse */
export interface Box1BelastbareInkomstenUitEigenWoning {
  eigenWoningen?: OnroerendeZaak[];
  leningen?: Lening[];
  restschuldEigenWoningen?: Lening[];
  /** OwnHouseTemporaryLetIncome */
  huurinkomstenEigenWoningen?: OmschrijvingEnBedrag[];
  /** OwnHouseTemporaryLetDeductibleCosts */
  kostenVerhuurEigenWoningen?: OmschrijvingEnBedrag[];
  /** OwnHouseTaxableBenefitCapitalInsuranceSavingsAccountParticipatingInterestAccount */
  belastDeelKapitaalverzekeringEigenWoningen?: number;
  /** Art. 3.123a, lid 4, Wet IB 2001. */
  renteInVoorgaandeJarenBetaaldVoorDitJaar?: number;
  /** Art. 3.123a, lid 4, Wet IB 2001. */
  renteInDitJaarVoorAndereJaren?: number;

  [key: string]: any;
}

/** TaxablePeriodicalPayments */
export interface Box1BelastbarePeriodiekeUitkeringenEnVerstrekkingen {
  /** PeriodicPaymentsAlimony */
  ontvangenAlimentatie?: OmschrijvingEnBedrag[];
  /** AlimonyDeductibleCosts */
  aftrekbareKostenAlimentatie?: OmschrijvingEnBedrag[];
  /** PeriodicPaymentsOtherTotalAmount */
  inkomstenPeriodiekeUitkeringen?: OmschrijvingEnBedrag[];
  /** PeriodicPaymentsDeductibleCosts */
  aftrekbareKostenPeriodiekeUitkeringen?: OmschrijvingEnBedrag[];
  /** RevisionInterestCalculatedAmount */
  revisierente?: number;

  [key: string]: any;
}

/** Box1IncomeFromLabourAndOwnHouse */
export interface Box1InkomenUitWerkEnWoning {
  winstUitOnderneming?: Box1WinstUitOnderneming;
  belastbaarLoon?: Box1BelastbaarLoon;
  resultaatUitOverigeWerkzaamheden?: Box1ResultaatUitOverigeWerkzaamheden;
  belastbarePeriodiekeUitkeringenEnVerstrekkingen?: Box1BelastbarePeriodiekeUitkeringenEnVerstrekkingen;
  belastbareInkomstenUitEigenWoning?: Box1BelastbareInkomstenUitEigenWoning;
  uitgavenVoorInkomensvoorzieningen?: Box1UitgavenVoorInkomensvoorzieningen;
  negatieveUitgavenVoorInkomensvoorzieningen?: Box1NegatieveUitgavenVoorInkomensvoorzieningen;
  negatievePersoonsgebondenAftrek?: Box1NegatievePersoonsgebondenAftrek;
  belastbareInkomstenOpBasisVanOvergangsrecht?: Box1BelastbareInkomstenOpBasisVanOvergangsrecht;

  [key: string]: any;
}

/** PersonDependentDeductionNegative */
export interface Box1NegatievePersoonsgebondenAftrek {
  /** MaintenanceObligationsRefundTotal */
  terugontvangenAlimentatie?: number;
  /** ExtraordinaryExpenditureHealthCareRefundTotal */
  inkomstenSpecifiekeZiektekosten?: number;
  /** StudyTrainingRefundExpenditureTotal */
  inkomstenOverigStudiekosten?: number;
  /** ListedBuildingReimbursedExpensesTotal */
  inkomstenOverigOnderhoudMonumentenpanden?: number;
  /** RefundGiftsTotal */
  inkomstenOverigGiften?: number;
  /** WaiverVentureCapitalLoansRefundTotal */
  inkomstenOverigTeruggekregenKwijtgescholdenDurfkapitaal?: number;

  [key: string]: any;
}

/** NegativeExpendituresIncomeProvisions */
export interface Box1NegatieveUitgavenVoorInkomensvoorzieningen {
  /** RefundPremiumsDisabledInsurancePremiumsExpenses */
  terugontvangenPremieAOV?: number;
  /** RefundPremiumsAndOtherNegativeIncomeProvisionExpenses */
  terugontvangenPremieLijfrente?: number;

  [key: string]: any;
}

/** TaxableIncomeFromOtherActivities */
export interface Box1ResultaatUitOverigeWerkzaamheden {
  /** ActivitiesWorkResultsGrossAmount */
  rowOpbrengsten?: JaarrekeningVenW[];
  /** ActivitiesWorkCosts */
  rowKosten?: JaarrekeningVenW[];
  /** FictitiousActivitiesResultGross */
  tbsOpbrengsten?: JaarrekeningVenW[];
  /** FictitiousActivitiesCosts */
  tbsKosten?: JaarrekeningVenW[];
  /** AssetsOtherInConnectionWithResultFromActivities */
  tbsBezittingen?: JaarrekeningBalans[];
  /** ImmovablePropertyInConnectionWithResultsFromActivities */
  tbsOnroerendeZaken?: JaarrekeningBalans[];
  /** DebtsInConnectionWithResultsFromActivities */
  tbsSchulden?: JaarrekeningBalans[];
  /** CeasingActivitiesPartlyTransferring */
  doorschuivenOfStakenActiviteiten?: boolean;

  [key: string]: any;
}

/** IncomeProvisionPremiums */
export interface Box1UitgavenVoorInkomensvoorzieningen {
  /** PremiumsAnnuities */
  lijfrentePremiesBetaald?: LijfrentePremie[];
  /** YearAndReservationSpace */
  jaarruimteGegevensPerJaar?: JaarruimteGegevens[];
  /** PremiumsAnnuitiesForDisabledChildren */
  lijfrentePremiesBetaaldKind?: LijfrentePremie[];
  /** PremiumsPrivateInsurancePolicies */
  lijfrentePremiesAOV?: LijfrentePremie[];
  /** PremiumsPrivateInsurancePolicies */
  lijfrentePremiesANW?: LijfrentePremie[];
  /** PremiumsSettlementOldAgeReserveDiscontinuationProfitTotal */
  lijfrentePremiesFOR?: LijfrentePremie[];

  [key: string]: any;
}

/** TaxableProfitFromEnterprises */
export interface Box1WinstUitOnderneming {
  /** Enterprises */
  ondernemingen: Onderneming[];
  /** OldAgeReserveBeginBookYear */
  oudedagsreserveBeginJaar?: number;
  /** IncreaseOldAgeReserve */
  forDotatie?: number;
  /** IncreaseOldAgeReserve */
  vrijvalFORIvmPremieLijfente?: number;
  restantZelfstandigenaftrekUitEerdereJaren?: OmschrijvingEnBedrag[];
  /** SelfEmployedPersonsAllowance */
  krijgtZelfstandigenAftrek?: boolean;
  /** BeginningEntrepeneurDeduction */
  krijgtStartersAftrek?: boolean;
  /** ResearchAndDevelopmentDeduction */
  krijgtSenOaftrek?: boolean;
  /** IncreasedResearchAndDevelopmentDeduction */
  krijgtVerhogingSenOAftrek?: boolean;
  /** ResearchAndDevelopmentNumber */
  speurOntwikkelaarVerklaringNummer?: string;
  /** CoWorkingPartnersDeductionHours */
  meewerkUren?: number;
  /** EntrepeneurStartingDeductionOccupationalDisability */
  krijgtStartersAftrekBijArbeidsOngeschiktheid?: boolean;
  /** EntrepeneurStartingDeductionOccupationalDisability */
  aantalKerenStartersaftrekBijAOToegepastInAfgelopenVijfJaar?: number;
  /** DiscontinuationDeduction */
  krijgtStakingsaftrek?: boolean;
  /** DiscontinuationDeductionClaimedBefore */
  bedragEerdereBenutteStakingsaftrek?: number;

  [key: string]: any;
}

/** Art. 4.12 Wet IB 2001. */
export interface Box2InkomenUitAanmerkelijkBelang {
  /** ListOfSubstantialInterestCompanies */
  aanmerkelijkBelang?: AanmerkelijkBelang[];

  [key: string]: any;
}

/** Artikel 5.3 Wet IB 2001. */
export interface Box3InkomenUitSparenEnBeleggen {
  berekenWerkelijkRendement?: boolean;
  /** AssetBankAccountSavingsCertificatesEtc */
  bankrekeningen?: Rekening[];
  /** Stock */
  beleggingsrekeningen?: Rekening[];
  /** GreenStockInvestments */
  groeneBeleggingen?: Rekening[];
  /** ImmovableProperty */
  overigeOnroerendeZaken?: OnroerendeZaak[];
  /** PeriodicPaymentsRights */
  periodiekeUitkeringen?: OmschrijvingEnBedrag[];
  /** ValueCashAndReceivables */
  vorderingenOfContantGeld?: OmschrijvingEnBedrag[];
  /** PropertyOther */
  overigeBezittingen?: OverigeBezitting[];
  /** CapitalInsuranceNonExemptedPart */
  nietVrijgesteldeKapitaalverzekeringen?: OmschrijvingEnBedrag[];
  /** Other debts, not debts for business or own house. */
  leningen?: Lening[];

  [key: string]: any;
}

/** Only if tax payer is not insured for social insurances */
export interface BuitenlandseBelastingplicht {
  /** EmigrationDate */
  emigratieDatum?: Date;
  /** ImmigrationDate */
  immigratieDatum?: Date;
  /** SettledAbroad */
  woonlandGegevens: Woonland[];
  /** QualifyingForeignTaxpayer */
  inwonerLandNonDiscriminatie: boolean;
  /** QualifyingForeignTaxpayerResidentCountry */
  woonlandVoldoetVoorKwalificatie: boolean;
  /** ResidentCountryQualificationNonDiscrimination */
  belastingplichtigeVoldoetAanVoorwaardenKwalificatie: boolean;
  migratieJaarGegevens?: MigratieJaarGegevens;
  wereldInkomen?: OpgaafWereldInkomen;

  [key: string]: any;
}

/** WithheldForeignDividendTax */
export interface BuitenlandseBronheffing {
  /** AccountNumber */
  rekeningNummer?: string;
  /** ISO 3166 */
  landCode?: string;
  /** ForeignInterest */
  buitenlandseRente?: number;
  /** ForeignInterestWithheldTax */
  bronbelastingOpRente?: number;
  /** ForeignDividendSubstantialInterest */
  buitenlandsDividendbox2?: number;
  /** ForeignDividendSubstantialInterestWithhedlTax */
  bronbelastingOpDividendbox2?: number;
  /** ForeignDividendPortfolioInvestments */
  buitenlandsDividendbox3?: number;
  /** ForeignDividendPortfolioInvestmentsWithheldTax */
  bronbelastingOpDividendbox3?: number;

  [key: string]: any;
}

/** Preserved Income */
export interface ConserverendInkomen {
  /** PreservedIncomeFromSubstantialInterest */
  teConserverenInkomenBox2?: OmschrijvingEnBedrag[];
  /** PreservedIncomePensionClaimSpecification */
  pensioenAanspraken?: Aanspraken[];
  /** PreservedIncomeCapitalInsuranceOwnHouseEmigrationSpecification */
  kewAanspraken?: Aanspraken[];
  /** PreservedIncomeAnnuityClaimSpecification */
  lijfrenteAanspraken?: Aanspraken[];
  /** PreservedIncomeProvisionsClaimSpecification */
  overigeAanspraken?: Aanspraken[];

  [key: string]: any;
}

/** Artikel 6.17, eerste lid, onderdeel f, Wet IB 2001. */
export interface Dieet {
  aandoening: DieetAandoening;
  periode: Periode;

  [key: string]: any;
}

/** Artikel 6.17, eerste lid, onderdeel g, Wet IB 2001. */
export interface ExtraUitgavenKledingEnBeddengoed {
  /** IllnessDurationLongerThanOneYear */
  duurZiekteMinimaalJaar: boolean;
  /** ExtraordinaryCostsHigherThanMaximumBracket */
  extraUitgavenKledingBeddengoedHogerDanMax: boolean;
  periode: Periode;

  [key: string]: any;
}

export interface Gift {
  /** Description */
  omschrijving?: string;
  /** Amount */
  bedrag?: number;
  /** CulturalCentre */
  cultureleAnbi: boolean;

  [key: string]: any;
}

export interface GiftPeriodiek {
  /** Description */
  omschrijving?: string;
  /** Amount */
  bedrag?: number;
  /** Transaction number. */
  transactienummer: number;
  /** RSIN */
  rsin: string;
  /** CulturalCentre */
  cultureleAnbi: boolean;

  [key: string]: any;
}

/** Art. 8.2 Wet IB 2001 */
export interface Heffingskortingen {
  /** Art. 8.2, onderdeel f, Wet IB 2001 (oud). Afgeschaft met ingang van 1 januari 2016. */
  ouderschapsverlofUrenOpgenomen?: number;
  /** Art. 8.2, onderdeel f, Wet IB 2001 (oud). Afgeschaft met ingang van 1 januari 2016. */
  ouderschapsverlofBelastbaarLoonVorigJaar?: number;
  /** Art. 8.2, onderdeel f, Wet IB 2001 (oud). Afgeschaft met ingang van 1 januari 2016. */
  ouderschapsverlofBelastbaarLoonTweeJaarGeleden?: number;
  /** Art. 8.2, onderdeel e, Wet IB 2001. Inkomensafhankelijke combinatiekorting (IACK). Als iemand wel een fiscaal partner heeft gedurende een gedeelte van het jaar, maar niet kiest voor fiscaal partnerschap, dan moeten we de geboortedatum en het arbeidsinkomen van de partner weten om te bepalen of er recht bestaat op IACK. */
  arbeidsInkomenPartner?: number;
  /** Art. 8.2, onderdeel e, Wet IB 2001. Inkomensafhankelijke combinatiekorting (IACK). Als iemand wel een fiscaal partner heeft gedurende een gedeelte van het jaar, maar niet kiest voor fiscaal partnerschap, dan moeten we de geboortedatum en het arbeidsinkomen van de partner weten om te bepalen of er recht bestaat op IACK. */
  verzamelInkomenPartner?: number;
  /** DateOfBirthPartner */
  geboortedatumPartner?: Date;
  /** Art. 8.2, onderdeel i, Wet IB 2001. De jonggehandicaptenkorting WAJONG). */
  krijgtWajong?: boolean;
  /** Art. 8.2, onderdeel k, Wet IB 2001. De alleenstaande ouderenkorting (voor AOW-ers met alleenstaanden AOW). */
  rechtOpAowAlleenstaande?: boolean;
  /** Art. 10a.11 Wet IB 2001. Overgangsbepaling levensloopverlofregeling. */
  levensloopVerlofGehad?: boolean;
  /** Art. 10a.11 Wet IB 2001. Overgangsbepaling levensloopverlofregeling. */
  levensloopverlofkortingToegepast?: number;
  /** Voor 2014 en 2015 geldt dit veld voor de berekening van de prepensioenkorting */
  bedragVutUitkering?: number;

  [key: string]: any;
}

/** WithheldDutchDividendTax */
export interface IngehoudenDividendbelasting {
  /** AccountNumber */
  rekeningNummer?: string;
  /** Dividend from substantial interests. */
  dividendBox2?: number;
  /** Portfolio dividends. */
  dividendBox3?: number;
  /** Substantial interest Dutch dividends withholding tax. */
  dividendbelastingBox2?: number;
  /** Portfolio Dutch dividends withholding tax. */
  dividendbelastingBox3?: number;

  [key: string]: any;
}

/** DebtsInConnectionWithResultsFromActivities */
export interface JaarrekeningBalans {
  omschrijving?: string;
  /** ValueStart */
  waardeOpening?: number;
  /** ValueStart */
  waardeSlot?: number;
  /** SoilValue */
  bodemwaarde?: number;
  /** OwnUseRealEstate */
  gebruikBinnenEigenOnderneming?: boolean;
  /** PurchasePrice */
  aanschafWaarde?: number;
  /** ResidualValue */
  restWaarde?: number;
  /** NominalValue */
  nominaleWaarde?: number;
  /** ValueAddedTaxThisBookYear */
  omzetbelastingDitBoekjaar?: number;
  /** ValueAddedTaxPreviousBookYear */
  omzetbelastingVorigBoekjaar?: number;
  /** ValueAddedTaxOlderBookYears */
  omzetbelastingOudereBoekjaren?: number;

  [key: string]: any;
}

/** BusinessInvestments */
export interface JaarrekeningInvesteringen {
  /** BusinessAssetDescription */
  omschrijving: string;
  /** BusinessAssetInitialStartingDate */
  datumIngebruikname?: Date;
  /** BusinessAssetTaxPayerShare */
  aandeelInInvesteringsBedrag?: number;
  /** ObtainEnergyInvestmentDeductions */
  claimEIA?: boolean;
  /** BusinessAssetEnergyInvestmentAmount */
  investeringsbedragEIA?: number;
  /** BusinessAssetEnergyInvestmentNotificationNumber */
  meldingsNummerEia?: string;
  /** ObtainForEnvironmentalInvestmentDeduction. */
  claimMIA?: boolean;
  /** BusinessAssetEnvironmentInvestmentAmount */
  investeringsbedragMIA?: number;
  /** BusinessAssetEnvironmentInvestmentNotificationNumber */
  meldingsNummerMia?: string;
  /** LetterOfEnvironmentInvestmentDeduction */
  miaLetter?: string;
  /** ObtainForSmallInvestmentDeduction. */
  claimKIA?: boolean;
  /** SmallInvestmentAmount */
  investeringsbedragKIA?: number;
  /** AmountPaidByTaxPayerInTaxYear */
  reedsBetaaldDoorAangever?: number;
  /** BaseDisinvestmentAddition */
  grondslagDesinvestering?: number;
  /** PercentageDisinvestmentAddition */
  percentageInvesteringsaftrek?: number;

  [key: string]: any;
}

/** FictitiousActivitiesCosts */
export interface JaarrekeningVenW {
  /** Description */
  omschrijving?: string;
  /** Amount */
  bedrag?: number;
  kostensoort?: JaarrekeningVenWKostensoort;

  [key: string]: any;
}

/** YearAndReservationSpace */
export interface JaarruimteGegevens {
  /** De jaarruimte betreft steeds de gegevens van het voorgaande kalenderjaar. Dus in een aangifte 2017 vul je de jaarruimte 2017 met daarin de winst, het loon etc. over 2016. */
  jaar: number;
  /** ProfitFromEnterprise */
  winstUitOnderneming?: number;
  /** AdditionToOldAgeReserve */
  toevoegingFor?: number;
  /** WithdrawelToOldAgeReserve */
  afnemingFor?: number;
  /** TaxableWage */
  belastbaarLoon?: number;
  /** TaxableResultFromOtherActivities */
  belastbaarROW?: number;
  /** TaxablePeriodicalPayments */
  belastbarePU?: number;
  /** FactorA */
  factorA?: number;
  /** PremiesNettoPensioen */
  premiesNettoPensioen?: number;
  /** AlreadyDeductedPremiumInThisYear */
  afgetrokkenPremie?: number;

  [key: string]: any;
}

export interface KostenGehandicaptKind {
  /** Name or initials */
  naam?: string;
  /** ChildDateOfBirth */
  geboortedatumKind: Date;
  /** NumberOfCaringDays */
  dagenVerzorging: number;
  /** NumberOfTravelDaysPerYear */
  dagenGereisd: number;
  /** SingleDistance */
  afstandEnkeleReis: number;
  /** ReceivedAllowance */
  vergoeding?: number;

  [key: string]: any;
}

export interface KwijtgescholdenDurfkapitaal {
  /** AmountWrittenOff */
  bedragKwijtgescholden: number;
  /** AmountWrittenOffEarlierYears */
  bedragReedsKwijtgescholdenDezeOndernemer: number;

  [key: string]: any;
}

/** Other debts, not debts for business or own house. */
export interface Lening {
  /** Description */
  omschrijving?: string;
  /** Amount */
  bedrag?: number;
  /** AccountNumber */
  rekeningNummer?: string;
  /** ISO 3166 */
  landCode: string;
  /** Qualifies for exemption for Green Investments */
  groenRekening?: boolean;
  aanwending?: LeningAanwending;
  geldVerstrekker: LeningGeldVerstrekker;
  /** ImmovablePropertyLawObjectNumberConnectedToThisDebt */
  wozNummerWaarLeningBijHoort?: number;
  /** PercentageBox1 */
  percentageBox1: number;
  /** PrincipalAmount0101 */
  hoofdsom0101?: number;
  /** PrincipalAmount3112 */
  hoofdsom3112?: number;
  /** Interest */
  rente?: number;
  /** LoanCosts */
  kosten?: OmschrijvingEnBedrag[];
  /** EmployeeReduction */
  personeelsKorting?: number;
  /** StartDateLoan */
  aanvangsDatum?: Date;
  /** EndDateLoan */
  eindDatum?: Date;
  /** PrincipalAmountOriginalLoan */
  oorspronkelijkeHoofdsom?: number;
  /** InterestPercentage */
  rentePercentageDecimalen?: number;
  aflossingsMethode?: LeningAflossingsMethode;
  naamLeninggever?: Persoon;
  adresLeninggever?: Adres;
  bijzondereWaardevermindering?: number;

  [key: string]: any;
}

/** PremiumsSettlementOldAgeReserveDiscontinuationProfitTotal */
export interface LijfrentePremie {
  /** Description */
  omschrijving?: string;
  /** Amount */
  bedrag?: number;
  /** PremiumsPrivateInsurancePolicyNumberAccountNumber */
  polisnummer?: string;

  [key: string]: any;
}

/** PensionAnnuityBenefitsOther */
export interface Loon {
  loon: OmschrijvingEnBedrag;
  /** Dutch wage tax withheld in Euro. */
  loonheffing: number;
  /** Only for internal usage Bokkz */
  loonsoort?: string;

  [key: string]: any;
}

/** IncomePreviousWorkAbroadWithoutDutchWageTax */
export interface LoonBuitenland {
  loon: OmschrijvingEnBedrag;
  /** Dutch wage tax withheld in Euro. */
  loonheffing: number;
  /** Only for internal usage Bokkz */
  loonsoort?: string;
  /** ISO 3166 land codes 3-characters */
  landCode: string;
  /** true = tegenwoordig, false = vroeger */
  loonUitTegenwoordigeBuitenlandseDienstbetrekking: boolean;
  /** Part of wage that is taxable in the Netherlands */
  belastDeelLoonInNederland: number;
  /** Withheld tax on foreign income that can be credited in the Netherlands */
  buitenlandseLoonheffing?: number;
  /** Income is taxable in the Netherlands based on the tax treaty */
  inkomenZitInNederlandseGrondslag: boolean;
  /** In de meeste gevallen geldt de vrijstellingsmethode, maar voor commissarissen, beroepssporters, bestuurders en artiesten geldt een verrekenmethode. True = verrekenmethode, false = vrijstellingsmethode (omdat vrijstellingsmethode default is) */
  pasVerrekenMethodeToe: boolean;
  /** Dutch health care premiums have to be paid on this income. */
  afdrachtZVWinNLmoetnog: boolean;
  /** Only for Belgium */
  benutAlgemeneCompensatieregeling?: boolean;
  /** Only for Belgium */
  benutBijzondereCompensatieregeling?: boolean;
  /** CompensationSettlementGermanyExists */
  compensatieregelingDuitsland?: boolean;
  /** Only for Belgium EmployerChange */
  veranderingVanWerkgever?: boolean;
  /** Tax withheld in Belgium or Germany */
  inBelgieOfDuitslandIngehoudenBelasting?: number;

  [key: string]: any;
}

/** ExemptedWagesInternationalOrganisationPreviousWork */
export interface LoonInternationaleOrganisatie {
  loon: OmschrijvingEnBedrag;
  /** Dutch wage tax withheld in Euro. */
  loonheffing: number;
  /** Only for internal usage Bokkz */
  loonsoort?: string;
  /** true = current, false = past */
  tegenwoordigeDienstbetrekking: boolean;
  /** ExemptedWagesInternationalOrganisationPresentWorkAmount */
  deelPremieloonVolksverzekeringen: number;
  /** If health care premiums are payable in the Netherlands. */
  afdrachtZVWinNLmoetnog: boolean;

  [key: string]: any;
}

/** PresentWorkHomeCountry */
export interface LoonUitTegenwoordigeDienstbetrekking {
  loon: OmschrijvingEnBedrag;
  /** Dutch wage tax withheld in Euro. */
  loonheffing: number;
  /** Only for internal usage Bokkz */
  loonsoort?: string;
  /** EmployedPersonsTaxCreditAmount */
  arbeidskorting: number;
  /** Part of wage that is taxable in the Netherlands */
  onbelastDeelLoonInNederland: number;

  [key: string]: any;
}

/** ResultsBusinessCollaboration */
export interface MaximumVerlies {
  /** JointEntitlementProfitClaimAmount */
  toetssaldoVoorgaandeJaren: number;
  /** ReferenceBalance */
  toetssaldoDitJaar: number;
  /** ReferenceCaptitalEndPreviousYear */
  toetsvermogenEindVorigJaar: number;
  /** MaximumLossProvisionContributions */
  stortingenDitJaar: number;
  /** MaximumLossProvisionWithdrawals */
  onttrekkingenDitJaar: number;
  /** MaximumLossProvisionWithdrawals */
  toetsvermogenEindDitJaar: number;
  /** ReferenceCapitalSumEndThisYearAndReferenceBalancesLastYearAndThisYear */
  totaalToetsvermogenEnToetssaldi: number;

  [key: string]: any;
}

/** SubstantialInterestBenefitsSharePartyFilingTaxReturnMigrationYear */
export interface MigratieInkomen {
  /** AmountDutchPeriod */
  bedragBinnenlandsePeriode: number;
  /** AmountForeignPeriod */
  bedragBuitenlandsePeriode: number;

  [key: string]: any;
}

/** MigrationYearSepcification */
export interface MigratieJaarGegevens {
  winstUitOndernemingMigratieJaar?: MigratieInkomen;
  loonUitTegenwoordigeDientbetrekkingMigratieJaar?: MigratieInkomen;
  loonUitVroegereDientbetrekkingMigratieJaar?: MigratieInkomen;
  reisAftrekMigratieJaar?: MigratieInkomen;
  resultaatOverigeWerkzaamhedenMigratieJaar?: MigratieInkomen;
  resultaatTbsMigratieJaar?: MigratieInkomen;
  /** FictitiousActivitiesResultMigrationYear */
  doorschuivenStakingTbsMigratieJaar?: boolean;
  aandeelEigenWoningMigratieJaar?: MigratieInkomen;
  periodiekeUitkingenMigratieJaar?: MigratieInkomen;
  uitgavenInkomensVoorzieningenMigratieJaar?: MigratieInkomen;
  negatievePersoonsgebondenAftrekMigratieJaar?: MigratieInkomen;
  negatieveUitgavenInkomensvoorzieningenMigratieJaar?: MigratieInkomen;
  inkomenAanmerkelijkBelangMigratieJaar?: MigratieInkomen;
  bezittingenBox3MigratieJaar?: MigratieInkomen;
  schuldenBox3MigratieJaar?: MigratieInkomen;
  aandeelGrondslagBox3MigratieJaar?: MigratieInkomen;
  aftrekEldersBelastInkomenBox1BuitenlandsePeriode?: OmschrijvingEnBedrag;
  aftrekEldersBelastInkomenBox2BuitenlandsePeriode?: OmschrijvingEnBedrag;
  ingehoudenDividendBelastingMigratieJaar?: MigratieInkomen;

  [key: string]: any;
}

/** Enterprises */
export interface Onderneming {
  /** Name of the enterprise */
  naam: string;
  /** Kind of activities */
  werkzaamheden: string;
  administratieId: string;
  /** LegalForm */
  ondernemingsvorm: Ondernemingsvorm;
  /** ISO 3166 land codes */
  landCode?: string;
  /** BalanceAndIncomestatementPersonalCondensedExists */
  invullenOpPersoonlijkNiveau?: boolean;
  /** BalanceAndIncomestatementCollaborationExists */
  invullenOpNiveauSamenwerkingsverband?: boolean;
  /** ProfitOnBaseOffAnualStatementFilmShippingLimitedPartnershipExists */
  invullenOpJaaropgaveCV?: boolean;
  /** ProfitOnBaseOffAnualStatementShipping */
  zeescheepvaart?: Zeescheepvaart[];
  /** StartDateEnterprise */
  startOnderneming?: Date;
  /** StopDateEnterprise */
  datumStaking?: Date;
  staking?: Staking;
  /** TaxIdentificationNumberEnterprise */
  rsin?: string;
  /** JoinEntitlementProfitClaim */
  medegerechtigdeOfSchuldeiser: boolean;
  /** ProfitClaim */
  winstUitHoofdeVanSchuldvordering: boolean;
  /** AgriculturalActivitiesExist */
  agrarischeActiviteiten: boolean;
  specificatieAgrarischeActiviteiten?: AgrarischeActiviteiten;
  /** AssetsAndOrLiabilitiesValuationSystemChangeIncomeTaxExists */
  waarderingsstelselGewijzigd: boolean;
  /** BusinessAssetsRandomDepreciationNetherlandsIncometaxExists */
  willekeurigAfgeschreven: boolean;
  /** CompensationExcludedFromTaxableProfitExists */
  schadeloosstellingBuitenWinstOm: boolean;
  boekjaar: Periode;
  /** BusinessProfits */
  wuoOpbrengsten?: JaarrekeningVenW[];
  /** BusinessProfitExemptedProfitComponents */
  wuoVrijgesteldeWinstbestanddelen?: JaarrekeningVenW[];
  /** ProfitCessation */
  wuoStakingswinsten?: JaarrekeningVenW[];
  /** BusinessFinancialIncome */
  financieleBaten?: JaarrekeningVenW[];
  /** ExtraordinaryIncomeBusiness */
  buitengewoneBaten?: JaarrekeningVenW[];
  /** BusinessExpenditure */
  wuoKosten?: JaarrekeningVenW[];
  /** BusinessFinancialExpenditure */
  financieleLasten?: JaarrekeningVenW[];
  /** ExtraordinaryExpenditureBusiness */
  buitengewoneLasten?: JaarrekeningVenW[];
  /** IntangibleAssets */
  immaterieleVasteActiva?: JaarrekeningBalans[];
  /** TangibleFixedAssets */
  materieleVasteActiva?: JaarrekeningBalans[];
  /** FinancialFixedAssets */
  financieleVasteActiva?: JaarrekeningBalans[];
  /** StockCurrentAssets */
  vlottendeActivaVoorraad?: JaarrekeningBalans[];
  /** Receivables */
  vlottendeActivaVorderingen?: JaarrekeningBalans[];
  /** Securities */
  effecten?: JaarrekeningBalans[];
  /** LiquidAssets */
  liquideMiddelen?: JaarrekeningBalans[];
  /** BusinessCapital */
  eigenVermogen?: JaarrekeningBalans[];
  /** Provisions */
  voorzieningen?: JaarrekeningBalans[];
  /** Reinvestment Reserve End Of Year Specification */
  specificatieHerinvesteringsreserve?: Herinvesteringsreserve[];
  /** LongTermDebts */
  langlopendeSchulden?: JaarrekeningBalans[];
  /** ShortTermDebts */
  kortlopendeSchulden?: JaarrekeningBalans[];
  /** BusinessInvestments */
  investeringen?: JaarrekeningInvesteringen[];
  /** InvestmentAllowancesPreviousYears */
  restantInvesteringsaftrek?: OmschrijvingEnBedrag[];
  /** CompensationExcludedFromTaxableProfitSpecification */
  schadeloosstellingBuitenWinst?: OmschrijvingEnBedrag[];
  /** CapitalChangesAndWithdrawals */
  onttrekkingOG?: SpecificatieOnroerendeZaken[];
  /** CapitalChangesAndWithdrawals */
  onttrekkingPriveGebruikWoning?: SpecificatiePriveGebruikWoning[];
  /** CapitalChangesAndWithdrawals */
  onttrekkingPriveGebruikAuto?: SpecificatiePriveGebruikAuto[];
  /** CapitalChangesAndWithdrawals */
  onttrekkingenOverig?: OmschrijvingEnBedrag[];
  /** CapitalChangesAndWithdrawals */
  stortingOG?: SpecificatieOnroerendeZaken[];
  /** CapitalContributions */
  stortingenOverig?: OmschrijvingEnBedrag[];
  /** CostsAndWagesAndPenaltiesNonDeductible */
  nietAftrekbareKosten?: OmschrijvingEnBedrag[];
  /** CostsAndWagesAndPenaltiesLimitedDeductible */
  beperktAftrekbareKosten?: OmschrijvingEnBedrag[];
  /** OldAgeTaxAllowanceStartAmount */
  beginstandFOR?: number;
  /** OldAgeTaxAllowanceAddition */
  dotatieFOR?: number;
  /** OldAgeTaxAllowanceWithdrawal */
  vrijvalFOR?: number;
  /** ReinvestmentReserveStartAmount */
  beginstandHIR?: OmschrijvingEnBedrag[];
  /** ReinvestmentReserveAddition */
  dotatieHIR?: number;
  /** ReinvestmentReserveWithdrawal */
  vrijvalHIR?: number;
  /** EqualizationReserveAmount */
  beginstandEgalisatiereserve?: OmschrijvingEnBedrag[];
  /** EqualizationReserveAddition */
  dotatieEgalisatiereserve?: number;
  /** EqualizationReserveWithdrawal */
  vrijvalEgalisatiereserve?: number;
  /** Business Assets Random Depreciation Netherlands Specification */
  specificatieWillekeurigeAfschrijving?: WillekeurigeAfschrijving[];
  resultaatSamenwerking?: ResultaatSamenwerking;
  maximumVerliesBepaling?: MaximumVerlies;

  [key: string]: any;
}

/** MaintenanceObligationOther */
export interface OnroerendeZaak {
  soortPand: boolean;
  adres: Adres;
  /** ImmovablePropertyLawValue */
  woz: number;
  wozPlusEen?: number;
  /** ImmovablePropertyLawObjectNumber */
  woznummer?: string;
  /** ObjectIsAppurtenanceToMainResidence */
  aanhorigheid?: boolean;
  /** e.g. 33.33 or 100.00 */
  percentageEigendom: number;
  bewoondePeriode?: Periode;
  leegstand?: OnroerendeZaakLeegstand;
  /** AcquisitionDate */
  datumGekocht?: Date;
  /** Only if datumGekocht is not null */
  aankoopkosten?: OmschrijvingEnBedrag[];
  /** AlienationDate */
  datumVerkocht?: Date;
  /** Only if datumVerkoop is not null */
  eigenWoningSchuldVerkochteWoning?: number;
  /** Only if datumVerkoop is not null */
  verkoopkosten?: OmschrijvingEnBedrag[];
  /** OwnHouseGroundLeaseBuildingPeriodicPaymentsAmount */
  betaaldeErfpachtCanon?: number;
  betaaldeErfpachtCanonEindeJaar?: number;
  verhuurdOfVerpacht?: VerhuurdOfVerpacht;
  verhuurdOfVerpachtOpEinddatum?: VerhuurdOfVerpacht;
  investeringen?: number;
  waardestijgingWOZwaardeWegensInvesteringen?: number;
  woning?: boolean;
  directRendement?: number;

  [key: string]: any;
}

/** EarningsPositionForeign */
export interface OpgaafWereldInkomen {
  /** TaxableProfitAbroad */
  winstUitOndernemingBuitenland?: number;
  /** WageHealthInsurancePaymentsAbroad */
  loonTegenwoordigeDienstbetrekkingBuitenland?: number;
  /** AowPensionAllowancesOtherAbroad */
  pensioenEnAndereUitkeringenBuitenland?: number;
  /** RedemptionsAnnuitiesAbroad */
  afkoopsomLijfrenteBuitenland?: number;
  /** ExemptedWagesInternationalOrganisationPresentWorkAbroad */
  vrijgesteldLoonTegenwoordigeArbeidBuitenland?: number;
  /** ExemptedWagesInternationalOrganisationPreviousWork */
  vrijgesteldLoonVroegereArbeidBuitenland?: number;
  /** IncomeOtherActivitiesAbroad */
  inkomstenOverigeWerkzaamhedenBuitenland?: number;
  /** IncomeAssetsMadeAvailableAbroad */
  inkomstenTerBeschikkingStellingBuitenland?: number;
  /** AlimonyRedemptionAbroad */
  ontvangenAlimentatieBuitenland?: number;
  /** PeriodicPaymentsRedemption */
  ontvangenPeriodiekeUitkeringenBuitenland?: number;
  /** TravelDeductionPublicTransportAbroad */
  reisAftrekOpenbaarVervoerBuitenland?: number;
  /** IncomeOtherTotal */
  overigeInkomstenBuitenland?: number;
  /** IncomeProvisionsDeductibleExpensesTotalAbroad */
  uitgavenVoorInkomensvoorzieningBuitenland?: number;
  /** IncomeProvisionExpensesNegative */
  negatieveUitgavenVoorInkomensvoorzieningBuitenland?: number;
  /** TaxableIncomeOwnerOccupiedHouseMainResidenceAbroad */
  saldoEigenWoningBuitenland?: number;
  /** TaxableIncomeOwnerOccupiedHouseMainResidenceAbroad */
  aandeelSaldoEigenWoningBuitenland?: number;
  /** OwnerOccupiesHouseDeductibleNonOrMinorAcquisitionDebtAbroad */
  aftrekGeenOfGeringeEigenWoningSchuldBuitenland?: number;
  /** OwnHouseDeductibleNonOrMinorAcquisitionDebtPartyFilingTaxReturnPartAmount */
  aandeelAftrekGeenOfGeringeEigenWoningSchuldBuitenland?: number;
  /** PersonDependentDeductionAbroad */
  persoonsGebondenAftrekBuitenland?: number;
  /** PersonDependentDeductionNegativeTotalAbroad */
  negatievePersoonsGebondenAftrekBuitenland?: number;
  /** SubstantialInterestBenefitsSharePartyFilingTaxReturn */
  voordeelAanmerkelijkBelangBuitenland?: number;
  /** SavingsAndInvestmentsTaxBasePartyShare */
  grondslagSparenEnBeleggenBuitenland?: number;
  /** SavingsAndInvestmentsBenefits */
  voordeelSparenEnBeleggenBuitenland?: number;
  /** TaxationElsewhereBox1 */
  eldersBelastInkomenBox1?: number;
  /** TaxationElsewhereBox2 */
  eldersBelastInkomenBox2?: number;
  /** IncomeRatioNetherlandsWorld */
  verhoudingInkomenNederlandWereld?: number;
  /** IncomeRatioJoinedNetherlandsWorld */
  gezamenlijkeVerhoudingInkomenNederlandWereld?: number;
  /** NoIncomeTaxMinorIncomeResidenceCountry */
  geenIbWoonlandGeringInkomen?: boolean;

  [key: string]: any;
}

/** PropertyOther */
export interface OverigeBezitting {
  /** Description */
  omschrijving?: string;
  /** Amount */
  bedrag?: number;
  soort?: OverigeBezittingSoort;
  nummer?: string;
  directRendement?: number;
  toenames?: number;
  afnames?: number;
  waardeEindJaar?: number

  [key: string]: any;
}

/** Art. 6.32 Wet IB 2001. */
export interface PGAAftrekbareGiften {
  gewoneGiften?: Gift[];
  periodiekeGiften?: GiftPeriodiek[];

  [key: string]: any;
}

/** Art. 6.3 Wet IB 2001. De PGA omvat onderhoudsverplichtingen. */
export interface PGAOnderhoudsverplichtingen {
  /** MaintenanceRelativesPeriodicPayments */
  periodiekBetaald?: number;
  /** MaintenanceRelativesRedemptionSum */
  betaaldeAfkoopsom?: number;
  /** MaintenanceRelativesPensionPremium */
  verrekeningPensioenrechten?: number;
  /** SocialAssistanceBenefitMaintenancePassedOn */
  bijstandEx?: number;
  /** MaintenanceObligationOther */
  overigeOnderhoudsverplichtingen?: number;
  bewoondeWoningVanExPartner?: OnroerendeZaak;
  exPartner: AlimentatieGerechtigde;

  [key: string]: any;
}

/** Art. 6.27 Wet IB 2001. */
export interface PGAScholingsuitgaven {
  /** Costs tax payer */
  uitgavenOpleidingenZonderStudiefinancieringAangever?: OmschrijvingEnBedrag[];
  /** Costs partner */
  uitgavenOpleidingenZonderStudiefinancieringPartner?: OmschrijvingEnBedrag[];
  /** Allowances tax payer */
  ontvangenVergoedingenAangever?: OmschrijvingEnBedrag[];
  /** Allowances partner */
  ontvangenVergoedingenPartner?: OmschrijvingEnBedrag[];
  /** Only for tax years up to and including 2016 */
  uitgavenOpleidingenMetStudiefinancieringAangever?: OmschrijvingEnBedrag[];
  /** Only for tax years up to and including 2016 */
  uitgavenOpleidingenMetStudiefinancieringPartner?: OmschrijvingEnBedrag[];
  /** Only for tax years up to and including 2016 */
  ontvangenStudiefinancieringAangever?: number;
  /** Only for tax years up to and including 2016 */
  ontvangenStudiefinancieringPartner?: number;
  /** Art. 10a.16 Wet IB 2001. Overgangsregeling voor aftrek van een prestatiebeurs */
  terugBetaaldePrestatiebeursAangever?: PrestatiebeursTerugBetaald[];
  /** Art. 10a.16 Wet IB 2001. Overgangsregeling voor aftrek van een prestatiebeurs */
  terugBetaaldePrestatiebeursPartner?: PrestatiebeursTerugBetaald[];
  /** standaardStudiePeriodeAangever */
  standaardStudiePeriodeAangever?: boolean;
  /** standaardStudiePeriodePartner */
  standaardStudiePeriodePartner?: boolean;

  [key: string]: any;
}

/** Art. 6.16 Wet IB 2001. */
export interface PGASpecifiekeZorgkosten {
  /** Artikel 6.17, eerste lid, onderdeel a, Wet IB 2001. */
  behandelKosten?: OmschrijvingEnBedrag[];
  /** Artikel 6.17, eerste lid, onderdeel c, Wet IB 2001. */
  reiskostenEigenZorg?: ReiskostenEigenZorg[];
  /** Artikel 6.17, eerste lid, onderdeel c, Wet IB 2001. */
  medicijnen?: OmschrijvingEnBedrag[];
  /** Artikel 6.17, eerste lid, onderdeel d, Wet IB 2001. */
  hulpmiddelen?: OmschrijvingEnBedrag[];
  /** Artikel 6.17, eerste lid, onderdeel e, Wet IB 2001. */
  kostenExtraGezinshulp?: OmschrijvingEnBedrag[];
  /** Artikel 6.17, eerste lid, onderdeel f, Wet IB 2001. */
  dieten?: Dieet[];
  /** Artikel 6.17, eerste lid, onderdeel g, Wet IB 2001. */
  extraUitgavenKledingEnBeddengoed?: ExtraUitgavenKledingEnBeddengoed[];
  /** Artikel 6.17, eerste lid, onderdeel h, Wet IB 2001. */
  reiskostenZorgGezinslid?: ReiskostenZorgGezinslid[];

  [key: string]: any;
}

/** Art. 6.31 Wet IB 2001. */
export interface PGAUitgavenVoorMonumentenPanden {
  monumentenkosten?: Rijksmonument[];

  [key: string]: any;
}

/** Art. 10a.9 Wet IB 2001. */
export interface PGAVerliezenOpDurfkapitaal {
  kwijtgescholdenDurfkapitaal?: KwijtgescholdenDurfkapitaal[];

  [key: string]: any;
}

/** Art. 6.25 Wet IB 2001. */
export interface PGAWeekendUitgavenGehandicapteKinderen {
  kostenGehandicaptKind?: KostenGehandicaptKind[];

  [key: string]: any;
}

/** Art. 6.2 e.v. Wet IB 2001. */
export interface PersoonsgebondenAftrek {
  /** Artikel 6.1 Wet IB 2001. De persoonsgebonden aftrek (PGA) bevat ook de PGA die in eerdere jaren niet in aanmerking is genomen. */
  restantPgaVoorgaandeJaren?: OmschrijvingEnBedrag[];
  /** Art. 6.3 Wet IB 2001. De PGA omvat onderhoudsverplichtingen. */
  pgaOnderhoudsverplichtingen?: PGAOnderhoudsverplichtingen[];
  pgaSpecifiekeZorgkosten?: PGASpecifiekeZorgkosten;
  pgaWeekendUitgavenGehandicapteKinderen?: PGAWeekendUitgavenGehandicapteKinderen;
  pgaScholingsuitgaven?: PGAScholingsuitgaven;
  pgaUitgavenVoorMonumentenPanden?: PGAUitgavenVoorMonumentenPanden;
  pgaAftrekbareGiften?: PGAAftrekbareGiften;
  pgaVerliezenOpDurfkapitaal?: PGAVerliezenOpDurfkapitaal;

  [key: string]: any;
}

/** Only if tax payer is not insured for social insurances */
export interface Premieplicht {
  periodeNietVerzekerdVoorAOWenANW?: Periode;
  periodeNietVerzekerdVoorWLZenWVZ?: Periode;
  /** DeductionPremiumIncome */
  verminderingPremieInkomen?: number;
  /** CorrectionPremiumIncome */
  correctiePremieInkomen?: number;

  [key: string]: any;
}

/** Art. 10a.16 Wet IB 2001. Overgangsregeling voor aftrek van een prestatiebeurs */
export interface PrestatiebeursTerugBetaald {
  /** StartYearCollegesOfWhichAmountNeedsToBeRepaid */
  onderwijsJaar: PrestatiebeursTerugBetaaldOnderwijsJaar;
  /** RepaidAmount */
  terugbetaaldeBedrag: number;
  /** MBO */
  mbo?: boolean;
  /** HBOorUniversity */
  hboWo?: boolean;
  periodeWaaroverTerugbetaaldMoetWordenInMaanden: Periode;

  [key: string]: any;
}

/** TravelDeduction */
export interface ReisAftrekOV {
  /** CommutingExpensesLocationOfActivities */
  omschrijving: string;
  /** CommutingExpensesDistance */
  afstandEnkeleReis: number;
  /** CommutingExpensesDaysPerWeekCount */
  aantalDagenPerWeek: number;
  periodeVanReizen: Periode;
  /** TravelAllowanceReceived */
  vergoedingWerkgever: number;

  [key: string]: any;
}

/** Artikel 6.17, eerste lid, onderdeel c, Wet IB 2001. */
export interface ReiskostenEigenZorg {
  /** AdditionalTravelCostsOwnCar */
  extraReisKostenZiekteInvaliditeit?: number;
  /** PaidAmountsForCommunalTrainBusOrTaxi */
  uitgavenOpenbaarVervoerEnOverigVervoer?: number;
  /** DistanceToHospital */
  aantalKilometersNaartArtsZiekenhuis?: number;
  /** price per kilometer in euro centils, e.g. € 1.00 = 100 */
  prijsPerKilometerInCenten?: number;

  [key: string]: any;
}

/** Artikel 6.17, eerste lid, onderdeel h, Wet IB 2001. */
export interface ReiskostenZorgGezinslid {
  /** Description */
  omschrijving?: string;
  /** NumberOfVisits */
  aantalBezoeken?: number;
  /** TravelledDistance */
  afstandRetour?: number;
  /** TravelCostsTrainOrBus */
  werkelijkeKostenOV?: number;

  [key: string]: any;
}

/** GreenStockInvestments */
export interface Rekening {
  /** Description */
  omschrijving?: string;
  /** Amount */
  bedrag?: number;
  /** AccountNumber */
  rekeningNummer?: string;
  /** ISO 3166 */
  landCode: string;
  /** Qualifies for exemption for Green Investments */
  groenRekening?: boolean;
  directRendement?: number;
  valutaResultaat?: number;
  stortingen?: number;
  onttrekkingen?: number;
  waardeEindJaar?: number;

  [key: string]: any;
}

/** Relationship situation if changed during the year */
export interface Relatiegegevens {
  /** Description */
  omschrijving?: string;
  /** DateDeceasePartner */
  datumOverlijdenPartner?: Date;
  /** DateDivorce */
  datumScheiding?: Date;
  periodeIngeschrevenOpZelfdeAdres?: Periode;
  /** SatisfactionPartnerTaxPurposes */
  voldaanAanFiscaalPartnerschapVoorwaarden?: boolean;
  /** DateMarriage */
  datumTrouwen?: Date;
  /** ObtainsForFiscalPartnershipWholeTaxYear */
  kiestVoorHeleJaarPartnerschap: boolean;

  [key: string]: any;
}

/** ResultsBusinessCollaboration */
export interface ResultaatSamenwerking {
  /** BusinessCapitalTaxpayerPartAccordingContractAmountForIncomeTax */
  aandeelBelastingplichtigeInKapitaalVolgensContract: number;
  /** BusinessCapitalTaxpayerPartOtherAmountForIncomeTax */
  aandeelBelastingplichtigeInKapitaalOverig: number;
  /** BusinessCapitalTaxpayerPartStartAmount */
  aandeelBelastingplichtigeInBeginVermogen: number;
  /** ProfitShareAllowanceWagesTaxpayerIncomeTax */
  vergoedingVoorArbeidBelastingplichtige: number;
  /** ProfitShareAllowanceOtherTaxpayerIncomeTax */
  overigeVergoedingenBelastingplichtige: number;
  /** ProfitShareDivisionRemainderAmountTaxpayerIncomeTax */
  aandeelRestantWinstBelastingplichtige: number;

  [key: string]: any;
}

export interface Rijksmonument {
  adres: Adres;
  /** ImmovablePropertyLawValue */
  woz: number;
  /** ImmovablePropertyLawObjectNumber */
  woznummer?: number;
  /** ObjectIsAppurtenanceToMainResidence */
  aanhorigheid?: boolean;
  /** e.g. 33.33 or 100.00 */
  percentageEigendom: number;
  bewoondePeriode?: Periode;
  leegstand?: RijksmonumentLeegstand;
  /** AcquisitionDate */
  datumGekocht?: Date;
  /** Only if datumGekocht is not null */
  aankoopkosten?: OmschrijvingEnBedrag[];
  /** AlienationDate */
  datumVerkocht?: Date;
  /** Only if datumVerkoop is not null */
  eigenWoningSchuldVerkochteWoning?: number;
  /** Only if datumVerkoop is not null */
  verkoopkosten?: OmschrijvingEnBedrag[];
  /** OwnHouseGroundLeaseBuildingPeriodicPaymentsAmount */
  betaaldeErfpachtCanon?: number;
  verhuurdOfVerpacht?: VerhuurdOfVerpacht;
  /** ListedBuildingNumber */
  monumentnummer?: number;
  /** ListedBuildingNumber */
  betaaldeKosten?: number;
  /** ListedBuildingNumber */
  ontvangenSubsidie?: number;

  [key: string]: any;
}

/** CapitalChangesAndWithdrawals */
export interface SpecificatieOnroerendeZaken {
  adresOnroerendeZaak?: Adres;
  /** ImmovablePropertyValueOfTrade */
  waardeEconomischeVerkeer?: number;
  /** ImmovablePropertyBookValue */
  boekwaardeOpMonentOnttrekking?: number;
  /** ImmovablePropertyWithdrawelTransferToThird */
  transactieMetDerde?: boolean;
  /** ImmovablePropertyEstimationValuer */
  taxateurBetrokken?: boolean;
  /** ImmovablePropertyValuerName */
  naamTaxateur?: string;

  [key: string]: any;
}

/** CapitalChangesAndWithdrawals */
export interface SpecificatiePriveGebruikAuto {
  /** CapitalChangesAndWithdrawals */
  autoWordtPriveGebruikt?: boolean;
  /** CarPrivateUseRegistration */
  kenteken?: string;
  /** CarPrivateUseCataloguePrice */
  catalogusPrijs?: number;
  periodePriveGebruik: Periode;
  /** CarPrivateUseKilometreRecordsExists */
  kilometerAdministratieAanwezig?: boolean;
  /** CarPrivateUseExpensesChargesTaxpayersOwnExpense */
  kostenEnLastenVoorEigenRekening?: number;
  /** CarPrivateUseCalculated */
  priveGebruik?: number;

  [key: string]: any;
}

/** CapitalChangesAndWithdrawals */
export interface SpecificatiePriveGebruikWoning {
  adresWoning: Adres;
  periodeBewoning: Periode;
  /** PrivateUseHousePropertyLawValue */
  wozWaarde?: number;
  /** PrivateUseHouseRightsPercentage */
  percentageGerechtigd?: number;
  /** PrivateUseHouseAdditionWithdrawal */
  berekendeOnttrekking?: number;

  [key: string]: any;
}

/** DiscontinuationBusiness */
export interface Staking {
  /** DiscontinuationBusinessTransferToOtherEntrepeneurExists */
  stakingDoorOverdrachtOnderneming: boolean;
  /** ImmovablePropertyTransferTransitionDiscontinuationExists */
  overdrachtOnroerendeZakenNaarPrive: boolean;
  /** DiscontinuationBusinessTransferToPrivateExists */
  overdrachtOverigeBestanddelenNaarPrive: boolean;
  /** DiscontinuationBusinessTransferToCompanyExists */
  overdrachtNaarBV: boolean;
  /** TransferringBusinessToNaturalPersonWithoutTaxationExists */
  doorschuivenGeruisloosNaarMedeOndernemer: boolean;
  /** TransferringBusinessDeceaseDivorceExists */
  doorschuivenGeruisloosDoorOverlijden: boolean;
  /** TransferringBusinessToLegalPersonWithoutTaxationExists */
  doorschuivenGeruisloosInbrengInBV: boolean;

  [key: string]: any;
}

/** PartyShareJointIncomeParts */
export interface Verdeling {
  /** taxPayerPartyShareOwnHouse */
  aandeelEigenWoning?: number;
  /** taxPayerPartyShareSubstantialInterest */
  aandeelBox2?: number;
  /** taxPayerPartyShareIncomeFromSavingsAndInvestments */
  aandeelBox3?: number;
  /** taxPayerPartyShareSavingsAndInvestmentsAmount */
  aandeelRendementsGrondslag?: number;
  /** taxPayerPartySharePersonAttachedDeductions */
  aandeelPGA?: number;
  /** taxPayerPartySharePersonDividendWithheldTax */
  aandeelDividendbelasting?: number;

  voorstelVerdeling?: boolean;

  [key: string]: any;
}

/** SpecificationRentedRealEstate */
export interface VerhuurdOfVerpacht {
  /** Lease = VERPACHT, rent = VERHUURD */
  status: VerhuurdOfVerpachtStatus;
  /** Agreement for period of at least 12 years. */
  overeenkomstMeerDan12Jaar?: boolean;
  /** Heeft de huurder recht op huurbescherming volgens de Nederlandse civiele wetgeving of vergelijkbare buitenlandse wetgeving? */
  huurbescherming: boolean;
  /** Gross amount of January (or month of acquisition) lease multiple 12 */
  jaarpacht?: number;
  /** Gross amount of January (or month of acquisition) rent multiple 12 */
  jaarhuur?: number;
  /** Gross amount of December (or month of sale) rent multiple 12 */
  directRendement?: number;
  /** LeaseIsNotArmsLength */
  onzakelijkePacht?: boolean;
  /** RentIsNotArmsLength */
  onzakelijkeHuur?: boolean;
  /** Is de verhuurde woning een onderdeel van een groter juridisch complex? */
  zelfstandigDeelVanGroterGebouw?: boolean;
  /** e.g. 33.33 or 100.00 */
  percentageVerhuurd: number;

  [key: string]: any;
}

/** Loss compensation */
export interface VerliescompensatieIb {
  /** UncompensatedFiscalLossesBox1 */
  onverrekendeVerliezenBox1?: OmschrijvingEnBedrag[];
  /** UncompensatedFiscalLossesBox2 */
  onverrekendeVerliezenBox2?: OmschrijvingEnBedrag[];
  /** UnsettledForeignTaxCredits */
  onverrekendeBuitenlandseBronheffing?: OmschrijvingEnBedrag[];
  /** TaxSparingCreditBox2 */
  belastingkortingBox2?: OmschrijvingEnBedrag[];

  [key: string]: any;
}

/** Representative */
export interface Vertegenwoordiger {
  adresVertegenwoordiger?: Adres;
  gegevensVertegenwooriger?: Persoon;
  /** Tax consultant number */
  beconnummer?: number;
  /** TaxConsultantSurname */
  naamDienstVerlener?: string;

  [key: string]: any;
}

/** Art. 9.2 Wet IB 2001 */
export interface Voorheffingen {
  /** Wage tax on wages that form part of the business profits */
  loonheffingOverLoonAlsOnderdeelVanWinst?: number;
  /** Wages that form part of the business profits */
  loonAlsOnderdeelVanWinst?: number;
  /** WithheldDutchDividendTax */
  ingehoudenDividendbelasting?: IngehoudenDividendbelasting[];
  /** WithheldForeignDividendTax */
  buitenlandseBronheffing?: BuitenlandseBronheffing[];
  /** PreliminaryTaxAssessmentIncomeTax */
  voorlopigeAanslag?: number;
  /** PreliminaryTaxAssessmentHealthCarePremium */
  voorlopigeAanslagZvw?: number;

  [key: string]: any;
}

/** SettledAbroad */
export interface Woonland {
  /** ISO 3166 land codes 3-characters */
  landCodeWoonland: string;
  periodeWoonachtigInWoonland: Periode;

  [key: string]: any;
}

export interface AangifteRapport {
  isBeSuNaAr?: boolean;
  isKwalificerendBelastingPlichtige?: boolean;
  speciaficatiePartnerschap?: SpecificatiePartnerschap;
  specificatieWUO?: SpecificatieWUO;
  specificatieJaarrekening?: SpecificatieJaarrekening[];
  specificatieLoon?: SpecificatieLoon;
  specificatieROW?: SpecificatieROW;
  specificatiePU?: SpecificatiePU;
  specificatieEW?: SpecificatieEW;
  specificatieLijfrente?: SpecificatieLijfrente;
  specificatieBox2?: SpecificatieBox2;
  specificatieBox3?: SpecificatieBox3;
  specificatieOWR?: SpecificatieOWR;
  specificatieZorgkosten?: SpecificatieZorgkosten;
  specificatieGiften?: SpecificatieGiften;
  specificatieScholing?: SpecificatieScholing;
  specificatieOverigePGA?: SpecificatieOverigePGA;
  specificatieInkomenBox1?: SpecificatieInkomenBox1;
  specificatieInkomenBox2?: SpecificatieInkomenBox2;
  specificatieInkomenBox3?: SpecificatieInkomenBox3;
  specificatieBelastingBox1?: SpecificatieBelastingBox1;
  specificatieBelastingBox2?: SpecificatieBelastingBox2;
  specificatieBelastingBox3?: SpecificatieBelastingBox3;
  specificatiePVV?: SpecificatiePVV;
  specificatieHeffingskortingen?: SpecificatieHeffingskortingen;
  specificatieVoorheffingen?: SpecificatieVoorheffingen;
  specificatieVerliescompensatie?: SpecificatieVerliescompensatie;
  specificatieZvw?: SpecificatieZvw;

  [key: string]: any;
}

export interface InvesteringsAftrekSpecificatie {
  omschrijving?: string;
  soortInvesteringsaftrek?: string;
  aandeelInInvesteringsbedrag?: number;
  reedsBetaaldDoorAangever?: number;
  datumIngebruikname?: Date;
  meldingsnummer?: string;
  totaleInvesteringsaftrek?: number;
  toegepasteInvesteringsaftrek?: number;
  restantInvesteringsaftrek?: number;
  percentageAftrek?: number;

  [key: string]: any;
}

export interface OgBerekendeWaarde {
  adres?: Adres;
  berekendeWaarde?: number;
  berekendeWaardeEind?: number;
  percentageBelang?: number;
  aandeelBerekendeWaarde?: number;
  schuld?: number;
  waardeNaarTijdsgelang?: number;
  schuldNaarTijdsgelang?: number;
  waardeMinusSchuld?: number;
  waardeMinusSchuldNaarTijdsgelang?: number;
  datumVerkoop?: Date;
  datumAankoop?: Date;

  [key: string]: any;
}

export interface OpbouwAB {
  /** IncomeBox2 */
  inkomenBox2?: number;
  /** SubstantialInterestRegularBenefitsGrossTotal */
  reguliereVoordelen?: number;
  /** SubstantialInterestTransferPriceTotal */
  vervreemdingsVoordelen?: number;
  /** SubstantialInterestAcquisitionPrice */
  verkrijgingsPrijs?: number;
  /** SubstantialInterestRegularBenefitsDeductibleCostsTotal */
  aftrekbareKosten?: number;

  [key: string]: any;
}

export interface OpbouwBelastingBox1 {
  berekendeIB?: number;
  schijf1?: number;
  schijf2?: number;
  schijf3?: number;
  schijf4?: number;
  tariefsaanpassingAftrekEigenWoning?: number;
  voorkomingVerrekenmethode?: number;
  voorkomingVrijstellingsmethode?: number;

  [key: string]: any;
}

export interface OpbouwBelastingBox2 {
  berekendeIB?: number;
  box2VoorVoorkoming?: number;
  voorkomingBox2?: number;

  [key: string]: any;
}

export interface OpbouwBelastingBox3 {
  berekendeIB?: number;
  box3VoorVoorkoming?: number;
  verrekeningBuitenlandseBronheffing?: number;
  vrijstellingBuitenlandsVermogen?: number;
  rendementBanktegoeden?: number;
  rendementBeleggingen?: number;
  rendementSchulden?: number;
  tarief?: number;

  [key: string]: any;
}

export interface OpbouwBox1 {
  winstUitOnderneming?: number;
  belastbaarloon?: number;
  resultaatUitOverigeWerkzaamheden?: number;
  periodiekeUitkeringen?: number;
  inkomstenUitEigenWoning?: number;
  saldoEigenWoning?: number;
  negatieveUitgavenVoorInkomensvoorzieningen?: number;
  negatievePersoonsgebondenAftrek?: number;
  overigeInkomsten?: number;
  aftrekWegensGeenOfGeringeEigenWoningSchuld?: number;
  uitgavenVoorInkomensvoorzieningen?: number;
  verrekendVerlies?: number;

  [key: string]: any;
}

export interface OpbouwBox2 {
  inkomenUitAanmerkelijkBelang?: number;
  verrekendVerlies?: number;
  saldoAanmerkelijkBelang?: number;

  [key: string]: any;
}

export interface OpbouwBox3 {
  voordeelUitSparenEnBeleggen?: number;
  grondslagNaVerdeling?: number;
  grondslagSparenEnBeleggen?: number;
  waardeBezittingenBinnenlandsePeriode?: number;
  waardeSchuldenBinnenlandsePeriode?: number;
  waardeBezittingenBuitenlandsePeriode?: number;
  waardeSchuldenBuitenlandsePeriode?: number;
  rendementsGrondslagBinnenlandsePeriode?: number;
  rendementsGrondslagBuitenlandsePeriode?: number;
  drempelSchuldenBinnenlandsePeriode?: number;
  drempelSchuldenBuitenlandsePeriode?: number;
  grondslagBinnenlandsePeriode?: number;
  grondslagBuitenlandsePeriode?: number;
  aandeelGrondslagBinnenlandsePeriode?: number;
  aandeelGrondslagBuitenlandsePeriode?: number;
  voordeelSparenEnBeleggenVoorVerminderingBinnenlandsePeriode?: number;
  voordeelSparenEnBeleggenVoorVerminderingBuitenlandsePeriode?: number;
  eldersBelasteRechtenOnroerendeZakenBuitenland?: number;
  verminderingVanwegeEldersBelasteRechtenBuitenland?: number;
  bezittingenDieMeetellenVoorTijdsevenredigeHerleidingBinnenlandsePeriode?: number;
  verminderingVoordeelTijdevenredigeHerleiding?: number;
  voordeelUitSparenEnBelegenBinnenlandsePeriode?: number;
  voordeelUitSparenEnBelegenBuitenlandsePeriode?: number;
  rendementsGrondslag?: number;
  heffingsvrijVermogenAangever?: number;
  heffingsvrijVermogenPartner?: number;
  voordeelSparenEnBeleggenVoorVermindering?: number;
  verminderingVoordeelSparenEnBeleggen?: number;
  tijdsEvenredigeVermindering?: number;
  inkomenBox3?: number;
  rendementBanktegoedenNederland?: number;
  rendementBanktegoedenBuitenland?: number;
  rendementBeleggingen?: number;
  rendementOnroerendeZakenNederland?: number;
  rendementOnroerendeZakenBuitenland?: number;
  rendementVorderingen?: number;
  rendementContantGeld?: number;
  rendementCrypto?: number;
  rendementKapitaalverzekeringen?: number;
  rendementPeriodiekeUitkeringen?: number;
  rendementOverigeBezittingen?: number;
  rendementNettoPensioen?: number;
  rendementAftrekbareSchulden?: number;
  banktegoedenNederland?: number;
  banktegoedenBuitenland?: number;
  beleggingen?: number;
  groeneBeleggingen?: number;
  groeneBeleggingenBanktegoeden?: number;
  groeneBeleggingenEffecten?: number;
  vrijstellingGroeneBeleggingen?: number;
  vrijstellingGroeneBeleggingenBanktegoeden?: number;
  vrijstellingGroeneBeleggingenEffecten?: number;
  onroerendeZaken?: number;
  vorderingen?: number;
  periodiekeUitkeringen?: number;
  kapitaalverzekeringen?: number;
  premieDepots?: number;
  bouwDepots?: number;
  contantGeld?: number;
  nettoPensioen?: number;
  crytoBezittingen?: number;
  overigeBezittingen?: number;
  schuldenNederlandsOG?: number;
  schuldenBuitenlandsOG?: number;
  overigeSchulden?: number;
  totaleSchulden?: number;
  schuldenDrempel?: number;
  schuldenNaDrempel?: number;
  // waardePerOGNederland?: OgBerekendeWaarde[];
  // waardePerOGBuitenland?: OgBerekendeWaarde[];
  [key: string]: any;
}

export interface OpbouwOwr {
    werkelijkRendement?: number;
    rendementBankrekeningenNederland?: number;
    rendementBankrekeningenBuitenland?: number;
    rendementBankrekeningenGroen?: number;
    rendementEffecten?: number;
    rendementEffectenGroen?: number;
    rendementOnroerendeZakenNl?: number;
    rendementOnroerendeZakenBtl?: number;
    rendementContantGeld?: number;
    rendementCrypto?: number;
    rendementBouwdepot?: number;
    rendementPremieDepot?: number;
    rendementVorderingen?: number;
    rendementKapitaalverzekeringen?: number;
    rendementPeriodiekeUitkeringen?: number;
    rendementOverigeBezittingen?: number;
    rendementSchuldenOgNederland?: number;
    rendementSchuldenOgBuitenland?: number;
    rendementSchuldenOgOverig?: number;

    [key: string]: any;
}

export interface OpbouwEW {
  /** OwnHousePrincipalResidenceRentalValueTotal */
  eigenWoningForfait?: number;
  /** OwnHouseTaxableBenefitCapitalInsuranceSavingsAccountParticipatingInterestAccount */
  belastDeelKapitaalverzekering?: number;
  /** OwnHouseInterestLoan */
  eigenWoningRente?: number;
  /** OwnHouseGroundLeaseBuildingPeriodicPayments */
  erfpachtcanon?: number;
  personeelsvoordeel?: number;
  /** OwnHouseCostLoan */
  kostenEigenWoningSchuld?: number;
  /** ProvisionsOtherFiscal */
  renteRestschuldEigenWoning?: number;
  /** ProvisionsOtherFiscal */
  kostenRestschuldEigenWoning?: number;
  /** OwnHouseTemporaryLetIncomeTotal */
  huurinkomstenEW?: number;
  /** OwnHouseSellingPriceWithoutCosts */
  verkoopkostenEW?: number;
  /** OwnHousePurchasePriceIncludingCosts */
  aankoopkostenEW?: number;
  /** OwnHouseAcquisitionDebtTotal */
  eigenWoningSchuldUltimo?: number;
  /** OwnHouseAcquisitionDebtTotal */
  eigenWoningSchuldPrimo?: number;
  /** OwnHouseDebtSoldOwnHouse */
  schuldVerkochteWoning?: number;
  /** OwnHouseDisposedRestDebt */
  restschuldEW?: number;
  /** OwnHouseBenefitsPartyFilingTaxReturnPart */
  aandeelInVoordeelEigenWoning?: number;
  /** OwnHouseDeductibleCoststPartyFilingTaxReturnPart */
  aandeelInRenteEnKostenEigenWoning?: number;
  /** ownHouseIncomeSharePartyFilingTaxReturn */
  aandeelInSaldoEigenWoning?: number;

  [key: string]: any;
}

export interface OpbouwGiften {
  aftrekbareGiften?: number;
  gewoneGiften?: number;
  gewoneGiftenCultureel?: number;
  totaalGewoneGiften?: number;
  aftrekbareGewoneGiften?: number;
  periodiekeGiften?: number;
  periodiekeGiftenCultureel?: number;
  totaalPeriodiekeGiften?: number;
  totaleVerhogingCultureleGiften?: number;
  verhogingGewoneCultureleGiften?: number;
  verhogingPeriodiekeCultureleGiften?: number;
  aftrekbarePeriodiekeGiften?: number;
  drempelGiften?: number;
  totaalGiftenaftrek?: number;
  aandeelGiftenaftrek?: number;

  [key: string]: any;
}

export interface OpbouwJaarrekening {
  /** BusinessName */
  naamOnderneming: string;
  /** ProfitAccordingToProfitAndLossAccount */
  winstVolgensResultatenRekening?: number;
  /** ProfitAccordingToProfitAndLossAccountPartyShare */
  aandeelInWinstVolgensResultatenRekening?: number;
  /** NonDeductibleCostsAndExpenses */
  nietAftrekbareKostenEnLasten?: number;
  /** InvestmentDeduction */
  investeringsAftrek?: number;
  /** InvestmentDeductionReverseAmount */
  investeringsBijtelling?: number;
  /** ReInvestmentReserveMutation */
  mutatieHIR?: number;
  /** CostsEqualizingReserveMutation */
  mutatieKER?: number;
  /** OldAgeReserveMutation */
  mutatieFOR?: number;
  /** ProfitPerEnterprise */
  winstPerOnderneming: number;
  /** TurnoverNetFiscal */
  totaleOmzet?: number;
  /** TerminationBusinessProfit */
  totaleStakingsWinst?: number;
  /** ExemptedBusinessProfit */
  totaleVrijgesteldeWinst?: number;
  /** RevenuesOtherReceivablesFiscal */
  totaleFinancieleBaten?: number;
  /** ExtraordinaryIncomeBusinessOtherFiscal */
  totaleBuitengewoneBaten?: number;
  /** RawAncillaryMaterialsPurchasePriceSalesFiscal */
  totaleInkoopkosten?: number;
  /** PersonnelCostsOtherFiscal */
  totalePersoneelskosten?: number;
  /** CarAndTransportCostsFiscal */
  totaleHuisvestingskosten?: number;
  /** AccommodationCostsFiscal */
  totaleAutokosten?: number;
  /** SalesCostsFiscal */
  totaleVerkoopkosten?: number;
  /** CostOtherFiscal */
  totaleOverigeKosten?: number;
  /** TangibleFixedAssetsOtherDepreciation */
  totaleAfschrijvingen?: number;
  /** InterestExpenditureEtcCostsDebtsFiscal */
  totaleFinancieleLasten?: number;
  /** ExtraordinaryExpenditureBusinessOtherFiscal */
  totaleBuitengewoneLasten?: number;
  /** IntangibleFixedAssetsOtherFiscal */
  immaterieelVastActiefOpeningsbalans?: number;
  /** FixedAssetsOtherFiscal */
  materieelVastActiefOpeningsbalans?: number;
  /** FinancialFixedAssetsTotalFiscal */
  fiancieelVastActiefOpeningsbalans?: number;
  /** StockTotalFiscal */
  voorraadActivaOpeningsbalans?: number;
  /** ReceivablesOtherFiscal */
  vorderingenActivaOpeningsbalans?: number;
  /** SecuritiesFiscal */
  effectenOpeningsbalans?: number;
  /** LiquidAssetsTotalFiscal */
  liquideMiddelenOpeningsbalans?: number;
  /** BusinessAssetsExcludingTaxReservesFiscal */
  eigenVermogenOpeningsbalans?: number;
  /** ProvisionsOtherFiscal */
  voorzieningenOpeningsbalans?: number;
  /** ShortTermDebtsOther */
  kortlopendeSchuldenOpeningsbalans?: number;
  /** LongTermDebtsOther */
  langlopendeSchuldenOpeningsbalans?: number;
  /** IntangibleFixedAssetsOtherFiscal */
  immaterieelVastActiefSlotbalans?: number;
  /** FixedAssetsOtherFiscal */
  materieelVastActiefSlotbalans?: number;
  /** FinancialFixedAssetsTotalFiscal */
  financieelVastActiefSlotbalans?: number;
  /** StockTotalFiscal */
  voorraadActivaSlotbalans?: number;
  /** ReceivablesOtherFiscal */
  vorderingenActivaSlotbalans?: number;
  /** SecuritiesFiscal */
  effectenSlotbalans?: number;
  /** LiquidAssetsTotalFiscal */
  liquideMiddelenSlotbalans?: number;
  /** BusinessAssetsExcludingTaxReservesFiscal */
  eigenVermogenSlotbalans?: number;
  /** ProvisionsOtherFiscal */
  voorzieningenSlotbalans?: number;
  /** ShortTermDebtsOther */
  kortlopendeSchuldenSlotbalans?: number;
  /** LongTermDebtsOther */
  langlopendeSchuldenSlotbalans?: number;
  /** AssetsTotalAmountFiscal */
  totaalActiefOpeningsbalans?: number;
  /** LiabilitiesTotalFiscal */
  totaalPassiefOpeningsbalans?: number;
  /** AssetsTotalAmountFiscal */
  totaalActiefSlotbalans?: number;
  /** LiabilitiesTotalFiscal */
  totaalPassiefSlotbalans?: number;
  specificatieZeescheepvaart?: SpecificatieZeescheepvaart[];
  beginVermogen?: number;
  eindVermogen?: number;
  /** WithdrawalsTotal */
  totaleOnttrekkingen?: number;
  /** ContributionsTotal */
  totaleStortingen?: number;
  totaleKIA?: number;
  onbenutteKIA?: number;
  benutteKIA?: number;
  totaleMIA?: number;
  onbenutteMIA?: number;
  benutteMIA?: number;
  totaleEIA?: number;
  onbenutteEIA?: number;
  benutteEIA?: number;
  totaleDIB?: number;
  aftrekPerBedrijfmiddel?: InvesteringsAftrekSpecificatie[];
  maximaleDotatieFor?: number;

  [key: string]: any;
}

export interface OpbouwLijfrente {
  aftrekbareLijfrentePremie?: number;
  jaarruimte?: number;
  reserveringsruimte?: number;
  premieGrondslag?: number;
  reserveringsruimteMinEen?: number;
  reserveringsruimteMinTwee?: number;
  reserveringsruimteMinDrie?: number;
  reserveringsruimteMinVier?: number;
  reserveringsruimteMinVijf?: number;
  reserveringsruimteMinZes?: number;
  reserveringsruimteMinZeven?: number;
  reserveringsruimteMinAcht?: number;
  reserveringsruimteMinNegen?: number;
  reserveringsruimteMinTien?: number;
  /** PremiumsAnnuitiesPaidTotal */
  betaaldePremiesVoorLijfrente?: number;
  benutteJaarrruimte?: number;
  benutteReserveringsruimte?: number;
  benutteReserveringsruimteMinEen?: number;
  benutteReserveringsruimteMinTwee?: number;
  benutteReserveringsruimteMinDrie?: number;
  benutteReserveringsruimteMinVier?: number;
  benutteReserveringsruimteMinVijf?: number;
  benutteReserveringsruimteMinZes?: number;
  benutteReserveringsruimteMinZeven?: number;
  benutteReserveringsruimteMinAcht?: number;
  benutteReserveringsruimteMinNegen?: number;
  benutteReserveringsruimteMinTien?: number;
  /** PremiumsAnnuitiesForDisabledChildrenTotal */
  lijfrenteVoorKind?: number;
  /** PremiumsPrivateInsurancePoliciesTotal */
  premieAovVerzekering?: number;
  /** PremiumsPrivateInsurancePoliciesTotal */
  premieAnwVerzekering?: number;
  /** PremiumsAnnuityTransferredOldAgeReserveDiscontinuationBusinessTotal */
  premieOmzettingForBijStaking?: number;
  /** PremiumsAnnuityTransferredOldAgeReserveContinuationBusinessTotal */
  premieAfstortingFor?: number;
  /** PremiumsAnnuityDiscontinuationProfitWithoutOldAgeReserveTotal */
  premieOmzettingStakingsWinstInLijfrente?: number;

  [key: string]: any;
}

export interface OpbouwLoon {
  belastbaarloon?: number;
  loonUitTegenwoordigeDienstbetrekking?: number;
  loonUitTegenwoordigeDienstbetrekkingBuitenland?: number;
  loonUitTegenwoordigeDienstbetrekkingInternationaleOrganisatie?: number;
  loonUitVroegereDienstbetrekking?: number;
  loonUitVroegereDienstbetrekkingBuitenland?: number;
  loonUitVroegereDienstbetrekkingInternationaleOrganisatie?: number;
  reisaftrekOpenbaarVervoer?: number;
  vergoedingReisaftrek?: number;
  totaalToegepasteArbeidskorting?: number;

  [key: string]: any;
}

export interface OpbouwOverigePGA {
  kwijtgescholdenDurfkapitaal?: number;
  eerderKwijtgescholdenBedrag?: number;
  totaalAftrekbareKwijtschelding?: number;
  aandeelKwijtschelding?: number;
  aftrekPerVerzorgingsdagWeekenduitgaven?: number;
  aftrekReiskostenWeekenduitgaven?: number;
  vergoedingWeekenduitgaven?: number;
  totaalAftrekbareWeekenduitgaven?: number;
  totaleWeekenduitgaven?: number;
  aandeelWeekenduitgaven?: number;
  totaleMonumentenuitgaven?: number;
  percentageAftrek?: number;
  aftrekbareUitgaven?: number;
  totaalMonumentenaftrek?: number;
  aandeelMonumentenaftrek?: number;
  totaalAftrekbareAlimentatie?: number;
  aandeelAftrekbareAlimentatie?: number;
  totaalRestantPga?: number;
  aandeelRestantPga?: number;
  nietToegerekendePga?: number;

  [key: string]: any;
}

export interface OpbouwPU {
  /** PeriodicPaymentsDeductibleCostsTotal */
  berekendeUitkomst?: number;
  /** AlimonyReceivedTotalAmount */
  ontvangenAlimentatie?: number;
  /** AlimonyDeductibleCostsTotal */
  kostenAlimentatie?: number;
  /** PeriodicPaymentsOtherTotalAmount */
  ontvangenPeriodiekeUitkeringen?: number;
  /** PeriodicPaymentsDeductibleCostsTotal */
  kostenPeriodiekeUitkeringen?: number;

  [key: string]: any;
}

export interface OpbouwPVV {
  premieInkomenAOWenANW?: number;
  premieInkomenWLZenAZVW?: number;
  premieAOW?: number;
  premieANW?: number;
  premieWLZ?: number;
  aowPercentage?: number;
  gecombineerdHeffingspercentage?: number;

  [key: string]: any;
}

export interface OpbouwPartnerschap {
  heeftFiscaalPartner?: boolean;
  heelJaarGehuwd?: boolean;
  deelJaarGehuwd?: boolean;
  deelJaarGehuwdHeelJaarZelfdeAdres?: boolean;
  heelJaarSamenwonend?: boolean;
  voldoetAanVoorwaardenPartnerschap?: boolean;
  kiestVoorJaarParterschap?: boolean;
  deelJaarSamenwonenBeginDatum?: Date;
  deelJaarSamenwonenEindDatum?: Date;
  nederlandsePeriodeMigratieJaarGehuwd?: boolean;
  nederlandsePeriodeMigratieZelfdeAdres?: boolean;
  nederlandsePeriodeMigratieVoldaanAanVoorwaarden?: boolean;
  nederlandsePeriodeMigratieGelijk?: boolean;

  [key: string]: any;
}

export interface OpbouwROW {
  /** ActivitiesOtherWorkResults */
  berekendResultaatUitOverigeWerkzaamheden?: number;
  /** ActivitiesWorkResultsGrossTotalAmount */
  inkomstenUitOVerigeWerkzaamheden?: number;
  /** ActivitiesWorkCostsTotalAmount */
  kostenTerZakeVanOverigeWerkzaamheden?: number;
  /** FictitiousActivitiesResultGrossTotalAmount */
  inkomstenUitTBS?: number;
  /** FictitiousActivitiesCostsTotalAmount */
  kostenTerZakeVanTBS?: number;
  /** FictitiousActivitiesExemptionAmount */
  tbsVrijstelling?: number;
  /** ImmovablePropertyInConnectionWithResultsFromActivitiesTotalBegin */
  openingsbalansOG?: number;
  /** ImmovablePropertyInConnectionWithResultsFromActivitiesTotalEnd */
  slotbalansOG?: number;
  /** AssetsOtherInConnectionWithResultFromActivitiesTotalBegin */
  openingsbalansOverig?: number;
  /** AssetsOtherInConnectionWithResultFromActivitiesTotalEnd */
  slotbalansOverig?: number;
  /** DebtsInConnectionWithResultsFromActivitiesTotalBegin */
  openingsbalansSchulden?: number;
  /** DebtsInConnectionWithResultsFromActivitiesTotalEnd */
  slotbalansSchulden?: number;
  /** ResultFromActivitiesOpeningAmount */
  openingsbalansEV?: number;
  /** ResultFromActivitiesClosingAmount */
  slotbalansEV?: number;

  [key: string]: any;
}

export interface OpbouwScholing {
  /** TrainingExpensesNoStudyFundingTotal */
  uitgavenStudieZonderFinancieringAangever?: number;
  /** TrainingExpensesNoStudyFundingTotal */
  uitgavenStudieZonderFinancieringPartner?: number;
  uitgavenStudieMetFinancieringAangever?: number;
  uitgavenStudieMetFinancieringPartner?: number;
  terugbetaaldePrestatiebeursAangever?: number;
  terugbetaaldePrestatiebeursPartner?: number;
  /** TrainingExpensesNoStudyFundingCompensation */
  ontvangenVergoedingenAangever?: number;
  /** TrainingExpensesNoStudyFundingCompensation */
  ontvangenVergoedingenPartner?: number;
  /** TrainingExpensesTaxReturnDeductionTotal */
  totaalScholingsaftrek?: number;
  /** TrainingExpensesDeductionPartyFilingTaxReturnPart */
  aandeelScholingsaftrek?: number;
  /** TrainingExpensesTotal */
  totaleUitgavenAangever?: number;
  /** TrainingExpensesThreshold */
  drempelAangever?: number;
  /** TrainingExpensesDeductibleAmount */
  aftrekbaarAangever?: number;
  /** TrainingExpensesTotal */
  totaleUitgavenPartner?: number;
  /** TrainingExpensesThreshold */
  drempelPartner?: number;
  /** TrainingExpensesDeductibleAmount */
  aftrekbaarPartner?: number;

  [key: string]: any;
}

export interface OpbouwVerliescompensatie {
  verrekendVerliesBox1?: number;
  verrekendVerliesBox2?: number;
  verrekendVerliesBox1JaarMinNegen?: number;
  nogTeVerrekenenVerliesBox1JaarMinNegen?: number;
  verrekendVerliesBox1JaarMinAcht?: number;
  nogTeVerrekenenVerliesBox1JaarMinAcht?: number;
  verrekendVerliesBox1JaarMinZeven?: number;
  nogTeVerrekenenVerliesBox1JaarMinZeven?: number;
  verrekendVerliesBox1JaarMinZes?: number;
  nogTeVerrekenenVerliesBox1JaarMinZes?: number;
  verrekendVerliesBox1JaarMinVijf?: number;
  nogTeVerrekenenVerliesBox1JaarMinVijf?: number;
  verrekendVerliesBox1JaarMinVier?: number;
  nogTeVerrekenenVerliesBox1JaarMinVier?: number;
  verrekendVerliesBox1JaarMinDrie?: number;
  nogTeVerrekenenVerliesBox1JaarMinDrie?: number;
  verrekendVerliesBox1JaarMinTwee?: number;
  nogTeVerrekenenVerliesBox1JaarMinTwee?: number;
  verrekendVerliesBox1JaarMinEen?: number;
  nogTeVerrekenenVerliesBox1JaarMinEen?: number;
  nogTeCompenserenVerliesBox1DitJaar?: number;
  verrekendVerliesBox2JaarMinNegen?: number;
  nogTeVerrekenenVerliesBox2JaarMinNegen?: number;
  verrekendVerliesBox2JaarMinAcht?: number;
  nogTeVerrekenenVerliesBox2JaarMinAcht?: number;
  verrekendVerliesBox2JaarMinZeven?: number;
  nogTeVerrekenenVerliesBox2JaarMinZeven?: number;
  verrekendVerliesBox2JaarMinZes?: number;
  nogTeVerrekenenVerliesBox2JaarMinZes?: number;
  verrekendVerliesBox2JaarMinVijf?: number;
  nogTeVerrekenenVerliesBox2JaarMinVijf?: number;
  verrekendVerliesBox2JaarMinVier?: number;
  nogTeVerrekenenVerliesBox2JaarMinVier?: number;
  verrekendVerliesBox2JaarMinDrie?: number;
  nogTeVerrekenenVerliesBox2JaarMinDrie?: number;
  verrekendVerliesBox2JaarMinTwee?: number;
  nogTeVerrekenenVerliesBox2JaarMinTwee?: number;
  verrekendVerliesBox2JaarMinEen?: number;
  nogTeVerrekenenVerliesBox2JaarMinEen?: number;
  nogTeCompenserenVerliesBox2DitJaar?: number;
  verrekendeBuitenlandseBronheffing?: number;
  nogTeVerrekenenBuitenlandseBronheffing?: number;

  [key: string]: any;
}

export interface OpbouwVoorheffingen {
  totaleVoorheffingen?: number;
  loonbelastingAlsOnderdeelVanWinst?: number;
  loonbelastingTegenwoordigeDienstbetrekking?: number;
  loonbelastingVroegereDienstbetrekking?: number;
  dividendbelasting?: number;

  [key: string]: any;
}

export interface OpbouwWUO {
  /** ProfitExemptionAmountSmallMediumSizedCompanies */
  winstAlleOndernemingen?: number;
  /** ProfitCessation */
  stakingswinstAlleOndernemingen?: number;
  /** JointEntitlementProfitClaimAmount */
  winstAlsMedegerechtigde?: number;
  /** maximumLossProvisionAddition */
  bijtellingMaximumVerlies?: number;
  /** maximumLossProvisionAddition */
  winstUitZeescheepvaart?: number;
  /** ExepmtedProfit */
  vrijgesteldeWinst?: number;
  /** BusinessIncome */
  winstVoorOndernemersaftrek?: number;
  /** SelfEmployedPersonsAllowanceAmount */
  zelfstandigenaftrek?: number;
  /** BeginningEntrepeneurDeductionAmount */
  startersaftrek?: number;
  /** SelfEmployedPersonsAllowanceAmount */
  zelfstandigenaftrekVoorAOWer?: number;
  /** ResearchAndDevelopmentDeductionTotalAmount */
  senoaftrek?: number;
  /** CoWorkingPartnersDeduction */
  meewerkaftrek?: number;
  /** EntrepeneurStartingDeductionOccupationalDisability */
  startersaftrekAO?: number;
  /** DiscontinuationDeduction */
  stakingsaftrek?: number;
  /** SelfEmployedPersonsAllowanceAmountPreviousYears */
  restant?: number;
  /** profitExemptionAmountSmallMediumSizedCompanies */
  mkbWinstvrijstelling?: number;
  /** SelfEmployedPersonsAllowanceAmount */
  nietgerealiseerdezelstandigenaftrek?: number;
  /** DiscontinuationDeductionTotalUsedAmount */
  totaalBenutteStakingsaftrek?: number;
  /** OldAgeTaxAllowanceAddition */
  dotatieFOR?: number;
  /** OldAgeTaxAllowanceWithdrawal */
  vrijvalFOR?: number;
  /** OldAgeTaxAllowanceFiscal */
  eindstandFOR?: number;
  /** ReinvestmentReserveAddition */
  dotatieHIR?: number;
  /** ReinvestmentReserveWithdrawal */
  vrijvalHIR?: number;
  /** ReinvestmentReserveFiscal */
  eindstandHIR?: number;
  /** EqualizationReserveCostAddition */
  dotatieKER?: number;
  /** EqualizationReserveWithdrawalCost */
  vrijvalKER?: number;
  /** EqualizationReserveCostsFiscal */
  eindstandKER?: number;
  /** ReservesBalanceChange */
  mutatieReserves?: number;
  /** BusinessCapitalTotalEndFinancialYearForComparisonMethod */
  totaleBeginvermogen?: number;
  /** BusinessCapitalTotalStartFinancialYearForComparisonMethod */
  totaleEindvermogen?: number;
  /** capitalContributionsTotal */
  totaleStortingen?: number;
  /** CapitalChangesAndWithdrawalsTotal */
  totaleOnttrekkingen?: number;
  /** CostsAndWagesAndPenaltiesNonDeductibleOrSubjectToRestrictedDeductionTotal */
  totaleNietAftrekbareKosten?: number;
  /** BusinessIncome */
  fiscaleWinst?: number;
  /** MaximumAddidtionOldAgeReserveTotal */
  maximaleDotatieFor?: number;

  [key: string]: any;
}

export interface OpbouwZorg {
  behandelKosten?: number;
  medicijnKosten?: number;
  hulpmiddelen?: number;
  extraGezinshulp?: number;
  drempelExtraGezinshulp?: number;
  aftrekbaarExtraGezinshulp?: number;
  reiskostenEigenZorg?: number;
  reiskostenGezinslid?: number;
  kledingEnBeddengoed?: number;
  dieetkosten?: number;
  totaalZorgkostenVoorVerhoging?: number;
  grondslagVerhoging?: number;
  verhogingZorgkosten?: number;
  zorgkostenVoorDrempel?: number;
  drempelZorgkosten?: number;
  aftrekbareZorgkosten?: number;
  aandeelZorgkosten?: number;

  [key: string]: any;
}

export interface OpbouwZvw {
  loonHogerDanMaximumBijdrageInkomen?: boolean;
  /** WagesPartProfit */
  loonWaaroverIsGeheven?: number;
  /** ForeignWagesCalculationHealthInsuranceLaw */
  loonBuitenlandVoorZvw?: number;
  /** CompulsoryHealthInsuranceContributionAdjustmentAmount */
  vrijgesteldLoonVoorZvw?: number;
  alimentatieVoor2006?: number;
  /** WageTaxOnWagesInBusinesIncome */
  loonAlsOnderdeelVanWinst?: number;
  /** OldAgeReserveDiscontinuationBusinessTransferredToAnnuity */
  inLijfrenteOmgezetteForBijStaking?: number;
  /** OldAgeReserveContinuationBusinessTransferredToAnnuity */
  inLijfrenteOmgezetteForNietBijStaking?: number;

  [key: string]: any;
}

export interface SpecificatieBelastingBox1 {
  opbouw?: OpbouwBelastingBox1;

  [key: string]: any;
}

export interface SpecificatieBelastingBox2 {
  opbouw?: OpbouwBelastingBox2;

  [key: string]: any;
}

export interface SpecificatieBelastingBox3 {
  opbouw?: OpbouwBelastingBox3;

  [key: string]: any;
}

export interface SpecificatieBox2 {
  opbouw?: OpbouwAB;

  [key: string]: any;
}

export interface SpecificatieBox3 {
  opbouw?: OpbouwBox3;

  [key: string]: any;
}

export interface SpecificatieOWR {
    opbouw?: OpbouwOwr;

    [key: string]: any;
}

export interface SpecificatieEW {
  opbouw?: OpbouwEW;

  [key: string]: any;
}

export interface SpecificatieGiften {
  opbouw?: OpbouwGiften;

  [key: string]: any;
}

export interface SpecificatieHeffingskortingen {
  opbouw?: OpbouwHeffingskortingen;

  [key: string]: any;
}

export interface SpecificatieInkomenBox1 {
  opbouw?: OpbouwBox1;

  [key: string]: any;
}

export interface SpecificatieInkomenBox2 {
  opbouw?: OpbouwBox2;

  [key: string]: any;
}

export interface SpecificatieInkomenBox3 {
  opbouw?: OpbouwBox3;

  [key: string]: any;
}

export interface SpecificatieJaarrekening {
  opbouw?: OpbouwJaarrekening;

  [key: string]: any;
}

export interface SpecificatieLijfrente {
  opbouw?: OpbouwLijfrente;

  [key: string]: any;
}

export interface SpecificatieLoon {
  opbouw?: OpbouwLoon;

  [key: string]: any;
}

export interface SpecificatieOverigePGA {
  opbouw?: OpbouwOverigePGA;

  [key: string]: any;
}

export interface SpecificatiePU {
  opbouw?: OpbouwPU;

  [key: string]: any;
}

export interface SpecificatiePVV {
  opbouw?: OpbouwPVV;

  [key: string]: any;
}

export interface SpecificatiePartnerschap {
  opbouw?: OpbouwPartnerschap;

  [key: string]: any;
}

export interface SpecificatieROW {
  opbouw?: OpbouwROW;

  [key: string]: any;
}

export interface SpecificatieScholing {
  opbouw?: OpbouwScholing;

  [key: string]: any;
}

export interface SpecificatieVerliescompensatie {
  opbouw?: OpbouwVerliescompensatie;

  [key: string]: any;
}

export interface SpecificatieVoorheffingen {
  opbouw?: OpbouwVoorheffingen;

  [key: string]: any;
}

export interface SpecificatieWUO {
  opbouw?: OpbouwWUO;

  [key: string]: any;
}

export interface SpecificatieZeescheepvaart {
  verrichtBeheerVoorAnder?: boolean;
  naamSchip?: string;
  vlagSchip?: string;
  nettoTonnageSchip?: number;
  aantalDagenExploitatie?: number;
  tariefPerDag?: number;
  percentageDeelnameInSchip?: number;
  schipVaartNa2008OnderNLVlagEnTonnageregime?: boolean;
  schipVoerin5JaarVoorTonnageOnderVlagDerdeLand?: boolean;
  winstPerSchip?: number;
  winstVoorDitSchipVolgensJaarrekening?: number;

  [key: string]: any;
}

export interface SpecificatieZorgkosten {
  opbouw?: OpbouwZorg;

  [key: string]: any;
}

export interface SpecificatieZvw {
  opbouw?: OpbouwZvw;

  [key: string]: any;
}

export interface IncomeTaxEntity {
  id?: number;
  name?: string;
  sstAdminId?: string;
  sstRelationId?: string;
  taxPayerFiscalNumber: string;
  taxPayerPartnerFiscalNumber?: string;
  namePartner?: string;
  taxType?: string;
  year?: number;
  aangifte?: Aangifte;
  via?: Aangifte;
  viaXbrl?: string,
  lastOpeningDate?: Date;
  submissionDate?: Date;
  submissionHerinnering?: boolean;
  submissionAanmaning?: boolean;
  client?: ClientEntity;

  [key: string]: any;
}

export interface IntermediaryEntity {
  id?: number;
  sstPrimaryAdminId?: string;
  licenceName?: string;
  userName?: string;
  officeName?: string;
  officeEmail?: string;
  officePhone?: string;
  officeLogo?: string[];
  taxId?: string;
  beconId?: string;
  gemachtigdeId?: string;
  hasBerichten?: boolean;
  pkiCertificate?: string[];
  certValidUntil?: Date;
  getMachtigingToestanden?: boolean;
  hasIntro?: boolean;
  doScraping?: boolean;
  hasTwofactor?: boolean;
  hasMigrated?:boolean;
  software?: string;
  softwareUserName?: string;
  softwarePassword?: string;
  softwareKey?: string;
  sstRefreshToken?: string;
  hasToken?: boolean;

  [key: string]: any;
}

export interface EnrichAangifte {
  bsn?: string;
  aangifte?: string;
  token?: string;

  [key: string]: any;
}

export interface BtwAangifte {
  /** Tax payer initials */
  initialenBelastingplichtige?: string;
  /** Tax payer prefix */
  tussenvoegselBelastingplichtige?: string;
  /** Tax payer last name */
  achternaamBelastingplichtige?: string;
  /** Tax identification number, e.g. 123456782B01 */
  omzetbelastingNummer?: string;
  /** Tax consultant number, e.g. 123456 */
  beconNummer?: string;
  /** Name contact person */
  naamContactPersoon?: string;
  /** Telephone number contact person e.g. 0612345678 */
  telefoonnummer?: string;
  /** function contact person e.g. Manager */
  functie?: string;
  tijdvak: Periode;
  suppletie: Suppletie;
  omzetHoog?: OmzetEnBelasting;
  omzetLaag?: OmzetEnBelasting;
  omzetOverigTarief?: OmzetEnBelasting;
  privegebruik?: OmzetEnBelasting;
  /** suppliesServicesNotTaxed */
  omzetNul?: number;
  omzetVerlegdBinnenland?: OmzetEnBelasting;
  /** suppliesToCountriesOutsideTheEC */
  leveringenNaarLandenBuitenDeEU?: number;
  /** suppliesToCountriesWithinTheEC */
  leveringenNaarLandenBinnenDeEU?: number;
  /** installationDistanceSalesWithinTheEC */
  installatieOfAfstandsverkopenBinnenDeEU?: number;
  leveringenUitLandenBuitendeEU?: OmzetEnBelasting;
  leveringenUitLandenBinnenDeEU?: OmzetEnBelasting;
  /** calculated output value, valueAddedTaxOwed */
  verschuldigdeOmzetbelasting?: number;
  /** valueAddedTaxOnInput */
  voorbelasting?: number;
  /** smallEntrepreneurProvisionReduction */
  verminderingVolgensDeKleineondernemersregeling?: number;
  /** calculated output value */
  totaal?: number;
  /** output value */
  betalingskenmerk?: string;
  /** send date */
  verzendDatum?: Date;
  /** output value */
  uitersteBetaaldatum?: Date;

  [key: string]: any;
}

/** turnoverFromTaxedSuppliesFromCountriesWithinTheEC and valueAddedTaxOnSuppliesFromCountriesWithinTheEC */
export interface OmzetEnBelasting {
  /** turnover */
  omzet?: number;
  /** turnovertax */
  omzetbelasting?: number;

  [key: string]: any;
}

/** supplemental tax return input */
export interface Suppletie {
  /** calculated output value, ValueAddedTaxAmountTotalNew. Negative means refund */
  totaalNieuweAangifte?: number;
  /** ValueAddedTaxAmountTotalOld, negative amount means refund previous return. */
  totaalOudeAangifte?: number;
  suppletieAangifte?: boolean;

  [key: string]: any;
}

/** List of icp's */
export interface ICP {
  /** Country code */
  landcode: ICPLandcode;
  /** National tax identification number */
  nationaalBtwIdNummer: string;
  /** Amount of the ICP */
  bedrag: number;
  /** Kind of ICP */
  soort: ICPSoort;
  tijdvakCorrectie?: Periode;

  [key: string]: any;
}

/** ICP tax returns */
export interface IcpAangifte {
  /** Tax payer name */
  initialenBelastingplichtige: string;
  /** Tax payer prefix */
  tussenvoegselBelastingplichtige?: string;
  /** Tax payer last name */
  achternaamBelastingplichtige: string;
  /** Name of the contact person */
  naamContactPersoon: string;
  /** Telephone number of the contact person */
  telefoonnummer: string;
  /** Tax payer identification number, e.g. 123456782B01 */
  omzetbelastingNummer: string;
  /** Tax consultant number, e.g. 123456 */
  beconnummer?: string;
  /** Send to authorities */
  verzenden?: boolean;
  /** Send date */
  verzendDatum?: Date;
  tijdvak: Periode;
  /** List of icp's */
  icps: ICP[];

  [key: string]: any;
}

export interface AanslagVpb {
  /** LegalPersonName */
  naamLichaam: string;
  /** TaxIdentificationNumber */
  fiscaalNummer: string;
  /** NoticeOfAssessmentNumber */
  aanslagnummer: string;
  /** NoticeOfAssessmentNumber */
  aanslagJaar: string;
  /** StartDate */
  boekJaarBegindatum: Date;
  /** EndDate */
  boekJaarEinddatum: Date;
  /** NoticeOfAssessmentDate */
  aanslagDatum: Date;
  /** TypeOfAssessment */
  aanslagSoort: AanslagVpbAanslagSoort;
  /** TaxType */
  middel: string;
  /** CompetentUnitNumber */
  eenheidBelastingdienst?: string;
  /** TaxableProfit */
  belastbareWinst: number;
  /** LossesToBeSetOffThisYearTotal */
  verrekendVerliesDitBoekjaar?: number;
  /** CorporationTaxTaxableAmount */
  belastbaarBedrag: number;
  /** CorporationTaxTaxableAmountFunctionalCurrency */
  belastbaarBedragInFunctioneleValuta?: number;
  /** InterestDeductionLimitation */
  aftrekBeperkingRente?: number;
  /** InterestDeductionLimitationConsideredPreviousYears */
  inAanmerkingTeNemenRenteVoorgaandeJaren?: number;
  /** InterestNonDeductibleDockedBalance */
  standGestaldeNietAftrekbareRente?: number;
  /** ParticipatingInterestSetoffToTransferToNextYear */
  naarVolgendJaarOverTeBrengenDeelnemingsVerrekening?: number;
  /** ParticipatingInterestSettledDockedDisposal */
  beschikkingStallingDeelnemingsverrekening?: string;
  /** ForeignBusinessProfitDockedDisposal */
  beschikkingStallingBuitenlandseOndernemingsWinst?: string;
  /** TaxBenefitsControlledCompaniesSettledDockedDisposal */
  beschikkingStallingVerrekendeBelastingVoordelenGecontroleerdeLichamen?: string;
  /** FinancialYearBackwardShiftingLossStartDate */
  boekJaarTerugwentelingVerliesBegindatum: Date;
  /** FinancialYearBackwardShiftingLossEndDate */
  boekJaarTerugwentelingVerliesEinddatum: Date;
  /** FiscalLossesAfterSettledThisFinancialYearBalance */
  saldoOnverrekendVerliesNaDitBoekjaar?: number;
  /** LossSettledDisposalIssued */
  verrekendVerliesBijAfgegevenBeschikking?: number;
  /** TaxAssessmentAmount */
  bedragVanDeAanslag: number;
  /** ProvisionalTaxAssessmentSettled */
  verrekendeVoorlopigeAanslag?: number;
  /** MisdemeanourPenalty */
  vergrijpBoete?: number;
  /** TaxInterest or TaxInterestCompensate */
  belastingrente?: number;
  /** TaxAssessmentAmountToBeReceivedToBePaidBalance */
  teBetalenOfTeOntvangen: number;
  /** DiscountPaymentAtOnce */
  betalingsKorting?: number;
  /** TaxAssessmentAmountAfterUseDiscountBalance */
  teBetalenNaToepassingBetalingsKorting?: number;
  /** TaxInterestCalculatedPeriodStart */
  periodeBelastingrenteBegindatum?: Date;
  /** TaxInterestCalculatedPeriodEnd */
  periodeBelastingrenteEinddatum?: Date;
  /** TaxInterestCompensateCalculatedPeriodStart */
  periodeVergoedeBelastingrenteBegindatum?: Date;
  /** TaxInterestCompensateCalculatedPeriodEnd */
  periodeVergoedeBelastingrenteEinddatum?: Date;
  /** NoticeOfAssessmentExpiringDateFirstAndOnly */
  uitersteBetaalDatum?: Date;
  /** NoticeOfAssessmentMultipleTermsExpiringDate */
  uitersteBetaalDatumMeerdereTermijnen?: Date;
  /** NoticeOfAssessmentExpiringDateLastPeriod */
  uitersteBetaalDatumLaatsteTermijn?: Date;
  /** output value */
  betalingskenmerk?: string;
  /** OfficiallyIndication */
  ambtshalveIndicatie?: boolean;
  /** CarryBackIndication */
  carrybackIndicatie?: boolean;
  /** TaxAssessmentProvisionalAutomatic */
  automatischVoorlopigeAanslag?: boolean;
  /** TaxpayerNameAddress1 */
  naw1Belastingplichtige?: string;
  /** TaxpayerNameAddress2 */
  naw2Belastingplichtige?: string;
  /** TaxpayerNameAddress3 */
  naw3Belastingplichtige?: string;
  /** TaxpayerNameAddress4 */
  naw4Belastingplichtige?: string;
  /** TaxpayerNameAddress5 */
  naw5Belastingplichtige?: string;
  /** TaxpayerNameAddress6 */
  naw6Belastingplichtige?: string;
  /** InterestNonDeductibleSettlementIndication */
  indicatieVerrekeningNietAftrekbareRente?: string;
  /** InterestNonDeductibleDockedIndication */
  indicatieStallingNietAftrekbareRente?: string;
  /** CorporationTax */
  vennootschapsbelasting?: number;
  /** CorporationTaxRateType */
  tariefsoortVennootschapsbelasting?: string;
  /** InnovationBoxDisposalndication */
  indicatieBeschikkingInnovatiebox?: boolean;
  /** InnovationBoxBalanceThresholdEndFinancialYear */
  saldInTeLopenVoortbrengingskostenEindeBoekjaar?: number;
  /** MisdemeanorFineAppliedNotificationDate */
  datumKennisgevingOpleggenVergrijpboete?: Date;
  /** MisdemeanorPenaltyDeferredIndication */
  indicatieUitgesteldeVergrijpboete?: boolean;
  /** FunctionalCurrencyOrEURApplied */
  toepassingEUROfValutacodeFunctioneleValuta?: string;
  /** TaxationElsewhereDeduction */
  totaaAftrekEldersBelast?: number;
  /** ParticipatingInterestSettled */
  verrekendeDeelnemingsverrekening?: number;
  /** TaxForeignBusinessProfitSettled */
  verrekendeBelastingBuitenlandseOndernemingswinst?: number;
  /** ForeignBusinessProfitSettledToTransfer */
  overTeBrengenVerrekBelastingBuitenlOndernemingswinst?: number;
  /** TaxBenefitsControlledCompaniesSettled */
  verrekendeBelastingBoordelenGecontroleerdLichaam?: number;
  /** TaxReductionsTotal */
  totaalBelastingverminderingen?: number;
  /** TaxBalanceWithoutAdvanceLeviesSettlement */
  saldoBelastingZonderVerrekeningVoorheffingen?: number;
  /** AdvanceLeviesSettled */
  verrekendeVoorheffingen?: number;
  /** AdvanceLeviesSettlementToTransfer */
  overTeBrengenVerrekeningVoorheffingen?: number;
  /** ForeignBusinessProfitDockedIndication */
  indicatieStallingBuitenlandseOndernemingswinsten?: string;
  /** ForeignBusinessLossesAccomplishedIndication */
  indicatieInhaalBuitenlandseOndernemingsverliezen?: string;
  /** LossRevisedExplanationAmount */
  herzieningVerliesToelichting?: number;
  /** LossRecovery */
  navorderingVerlies?: number;
  /** SurchargeNotAdequateNoticeTaxReturn */
  verhogingBijNietTijdigeAangifte?: number;
  /** ProvisionalRefundInConnectionWithLossSettled */
  invorderingVoorlopigTeruggaafVerlies?: number;
  /** TaxBalanceBeforeDeduction */
  saldoBelastingVoorToepassingVermindering?: number;
  /** TaxBalanceAfterDeduction */
  saldoBelastingNaToepassingVermindering?: number;
  /** TaxBackDuty */
  nagevorderdeBelasting?: number;
  /** TaxAssessmentAmountToBeSettledToBeReceived */
  teVerrekenenOfTerugTeGevenVoorToerekeningAanslag?: number;
  /** TaxRefundLossSetOffTotal */
  totaalBelastingteruggaafIvmTerugwentelingVerlies?: number;
  /** TaxAssessmentsOtherToBeBroughtTo */
  toeTeRekenenAanAndereAanslagen?: number;
  /** TaxAssessmentToBeBroughtTo */
  toeTeRekenenAanDezeAanslag?: number;
  /** TaxableAmountSettledPreviously */
  eerderVastgesteldBelastingbedrag?: number;
  /** TaxableAmountSettledNew */
  nieuwVastgesteldBelastingbedrag?: number;
  /** NewEstablishedBalanceToBePaidToBeReceived */
  nieuwVastgesteldSaldoTeBetalenOfTerugTeOntvangen?: number;
  /** TaxAssessmentAmountToBePaidToBeReceivedPreviouslyEstablished */
  eerderVastgesteldSaldoTeBetalenOfTerugTeOntvangen?: number;
  /** ProvisionalRefundSettled */
  verrekendeVoorlopigeTeruggaven?: number;
  /** TaxInterestCompensate */
  vergoedeBelastingrente?: number;

  [key: string]: any;
}

export interface AanslagZwv {
  /** FiscalYear */
  aangifteJaar: number;
  /** TaxIdentificationNumber */
  bsn: string;
  /** NoticeOfAssessmentNumber */
  aanslagnummer: string;
  /** NoticeOfAssessmentDate */
  dagtekeningAanslag: Date;
  /** TypeOfAssessment */
  aanslagSoort: AanslagZwvAanslagSoort;
  /** TaxType */
  middel: string;
  /** bd-i:TaxpayerNameAddress1 */
  naw1Belastingplichtige?: string;
  /** bd-i:TaxpayerNameAddress2 */
  naw2Belastingplichtige?: string;
  /** bd-i:TaxpayerNameAddress3 */
  naw3Belastingplichtige?: string;
  /** bd-i:TaxpayerNameAddress4 */
  naw4Belastingplichtige?: string;
  /** bd-i:TaxpayerNameAddress5 */
  naw5Belastingplichtige?: string;
  /** bd-i-ext1:TaxConsultantNameAddress1 */
  naw1Gemachtigde?: string;
  /** bd-i-ext1:TaxConsultantNameAddress2 */
  naw2Gemachtigde?: string;
  /** bd-i-ext1:TaxConsultantNameAddress3 */
  naw3Gemachtigde?: string;
  /** bd-i-ext1:TaxConsultantNameAddress4 */
  naw4Gemachtigde?: string;
  /** bd-i-ext1:TaxConsultantNameAddress5 */
  naw5Gemachtigde?: string;
  /** bd-i-ext1:TaxAssessmentOfficialFinal */
  ambtshalveDefinitieveAanslag?: boolean;
  /** bd-i-ext1:TaxAssessmentProvisionalFirst */
  eersteVoorlopigeAanslag?: boolean;
  /** bd-i-ext1:TaxAssessmentProvisionalManual */
  voorlopigeAanslagHandmatig?: boolean;
  /** bd-i-ext1:TaxAssessmentProvisionalCancellation */
  vernietigingVoorlopigeAanslag?: boolean;
  /** bd-i-ext1:TaxAssessmentProvisionalRequest */
  verzoekVoorlopigeAanslag?: boolean;
  /** bd-i-ext1:TaxAssessmentProvisionalFirstBasisTaxReturn */
  eersteVoorlopigeAanslagObvAangifte?: boolean;
  /** bd-i:TaxAssessmentProvisionalAutomatic */
  automatischeVA?: boolean;
  /** bd-i-ext1:TaxReturnCorrection */
  correctieOpAangifte?: boolean;
  /** bd-i-ext1:ObjectionDeadlineDate */
  uitersteDatumBezwaar?: Date;
  /** bd-i-ext1:AppealDeadlineDate */
  uitersteDatumBeroep?: Date;
  /** bd-i-ext1:SettlementType */
  soortAfhandeling?: string;
  /** bd-i-ext1:ObjectionSatisfied */
  tegemoetkomingBezwaar?: string;
  /** bd-i:CompetentUnitNumber */
  eenheidBelastingdienst?: string;
  /** bd-i-ext1:FiscalYearMinusOne */
  belastingjaarMinusEen?: number;
  /** bd-i-ext1:PresentationMainCalculationCode */
  codePresentatieHoofdberekeningSturing?: number;
  /** bd-i-ext1:RequestOfficialyReductionFinalAssessmentIndication */
  indicatieVerzoekAmbtshalveVerminderingDefinitieveAanslagToegekend?: number;
  /** bd-i:IncomeOtherActivities */
  inkomstenUitOverigeWerkzaamheden?: number;
  /** bd-i-ext1:PeriodicCashBenefits */
  periodiekeUitkeringen?: number;
  /** bd-i:TaxableProfit */
  belastbareWinst?: number;
  /** bd-i:ExemptedWagesInternationalOrganisationSocialInsuranceObligationAmount */
  bedragPremieplichtNietVrijgesteldInkomenInternationaleOrganisatie?: number;
  /** bd-i-ext1:HealthInsuranceTaxAssessmentContributionIncome */
  bijdrageInkomenAanslagZVW?: number;
  /** bd-i-ext1:HealthInsuranceLawWages */
  loonZorgverzekeringswet?: number;
  /** bd-i-ext1:HealthInsuranceTaxAssessmentContributionIncomeApplied */
  toegepastBijdrageInkomenZVW?: number;
  /** bd-i-ext1:HealthInsuranceTaxAssessmentContributionIncomeMaximumApplied */
  toegepastMaximumBijdrageInkomenZVW?: number;
  /** CompulsorylInsuranceHealthInsuranceLawPeriodStart */
  periodeVerplichtVerzekerdZVWBegindatum?: Date;
  /** CompulsorylInsuranceHealthInsuranceLawPeriodEnd */
  periodeVerplichtVerzekerdZVWEinddatum?: Date;
  /** bd-i:WagesPartProfit */
  inWinstBegrepenLoon?: number;
  /** bd-i:ProfitFisherman */
  winstBehaaldAlsDeelvisser?: number;
  /** bd-i:OldAgeReserveContinuationBusinessTransferredToAnnuity */
  inLijfrenteOmgezetteOudedagsreserveNietBijStaking?: number;
  /** bd-i:OldAgeReserveDiscontinuationBusinessTransferredToAnnuity */
  inLijfrenteOmgezetteOudedagsreserveBijStaking?: number;
  /** bd-i-ext1:Alimony */
  alimentatie?: number;
  /** bd-i-ext1:IncomeWorkAbroad */
  buitenlandInkomenUitDienstbetrekking?: number;
  /** bd-i-ext1:HealthInsuranceTaxAssessmentContribution */
  bijdrageZvwAanslag?: number;
  /** bd-i-ext1:EstablishedAmountPreviously */
  eerderVastgesteldBedrag?: number;
  /** bd-i-ext1:TaxAssessmentAmountWithInterest */
  bedragAanslagMetRente?: number;
  /** bd-i-ext1:TaxAssessmentsAmountPreviouslyTotal */
  totaalEerdereAanslagen?: number;
  /** bd-i-ext1:TaxAssessmentAmountPreviously */
  bedragAanslagEerder?: number;
  /** bd-i-ext1:TaxAssessmentAmountWithInterestPreviously */
  vorigBedragAanslagMetRente?: number;
  /** bd-i-ext1:ProvisionalTaxAssessmentAmountNew */
  nieuwBedragVanDeVoorlopigeAanslag?: number;
  /** bd-i:MisdemeanourPenalty */
  vergrijpBoete?: number;
  /** bd-i-ext1:TaxInterestPreviouslyTaxAssessment */
  belastingrenteInEerdereAanslagen?: number;
  /** bd-i-ext1:TaxInterestCalculated */
  belastingrenteBerekend?: number;
  /** bd-i-ext1:TaxInterestCharged */
  belastingrenteInRekeningGebracht?: number;
  /** bd-i:TaxInterestCompensate */
  vergoedeBelastingrente?: number;
  /** bd-i-ext1:TaxInterestChargedReduction */
  verminderingInRekeningGebrachteBelastingrente?: number;
  /** bd-i-ext1:TaxAssesmentAmountExclusiveOfTaxInterestCompensate */
  saldoExclusiefVergoedeBelastingrente?: number;
  /** bd-i-ext1:TaxAssesmentsPreviousAmountsExclusiveOfTaxInterestCompensate */
  saldoEerdereAanslagenExclVergoedeBelastingrente?: number;
  /** bd-i:TaxAssessmentAmountToBeReceivedToBePaidBalance */
  teBetalenTerugTeOntvangen?: number;
  /** bd-i:NoticeOfAssessmentMultipleTermsExpiringDate */
  uitersteBetaalDatumMeerdereTermijnen?: Date;
  /** bd-i:NoticeOfAssessmentExpiringDateFirstAndOnly */
  uitersteBetaalDatum?: Date;
  /** NoticeOfAssessmentExpiringDateLastPeriod */
  uitersteBetaalDatumLaatsteTermijn?: Date;
  /** bd-i-ext1:ProvisionalTaxReturnPaymentNumberOfMonthlyPayments */
  aantalMaandtermijnenBetalingVoorlopigeAanslag?: number;

  [key: string]: any;
}

export interface AanslagBtw {
  omzetBelastingNummer?: string;
  berichtGegevens: BerichtGegevens;
  heffingsGrondslag: HeffingsGrondslag;
  bedragAanslag: BedragAanslag;
}

export interface HeffingsGrondslag {
  datumBesluitAnderOrgaan: string;
  nummerBesluitAnderOrgaan: string;
  naamGerechtsHofOfRechtbank: string;
  verrekeningsTijdvak: string;
}

export interface BedragAanslag {
  bedragBoeteIcp: number | null;
  teBetalen: number | null;
  nieuwVastGesteldeBoete: number | null;
  eerderVastGesteldeBoete: number | null;
  teVerrekenenOfTerugTeOntvangen: number | null;
  teLaatBetaaldeOmzetbelasting: number | null;
  omzetbelastingVerschuldigd: number | null;
  omzetbelastingEersteAanslagSelectie: number | null;
  betaaldOpAangifte: number | null;
  verrekendOpUwVerzoek: number | null;
  openstaandBedrag: number | null;
  boeteWegensNietBetalen: number | null;
  boeteWegensTeLaatBetalen: number | null;
  boeteOmzetbelasting: number | null;
  aangifteBoete: number | null;
  nieuwVastGesteldeOmzetbelasting: number | null;
  nieuwVastGesteldRenteBedrag: number | null;
  nieuwVastGesteldTotaalBedrag: number | null;
  renteBedrag: number | null;
  nietBetaaldeOmzetbelasting: number | null;
  tijdigBetaaldeOmzetbelasting: number | null;
  eerderVastGesteldeOmzetbelasting: number | null;
  eerderVastGesteldRenteBedrag: number | null;
  eerderVastGesteldTotaalBedrag: number | null;
  verschilBedrag: number | null;
}


export enum MiddelBelasting {
  TERUGGAAF = "TERUGGAAF",
  VERMINDERING = "VERMINDERING",
  NAHEFFINGSAANSLAG = "NAHEFFINGSAANSLAG",
}

export interface BerichtGegevens {
  middelBelasting?: MiddelBelasting;
  aanslagNummer?: string;
  tijdvak?: Periode;
  dagTekening?: Date;
  uitersteBetaalDatum?: string;
  berichtSoort: string;
  adresGegevensBelastingPlichtige: AdresGegevensBelastingPlichtige;
  beconNummer: string;
  adresGegevensBelastingConsulent: string;
  indicatieBeschikking: string;
}

export interface AdresGegevensBelastingPlichtige {
  regel1: string;
  regel2: string;
  regel3: string;
  regel4: string;
  regel5: string;
  regel6: string;
}


export interface PdfRequest {
  loonJaar?: number;
  nettoLonenOverzicht?: PdfNettoLonenOverzicht;
  memoriaalBoeking?: MemoriaalBoeking;
  aangifteJaar1?: Aangifte;
  aangifteJaar2?: Aangifte;
  aangifteJaar3?: Aangifte;
  aangifteJaar4?: Aangifte;
  aangifteJaar5?: Aangifte;
  berekeningsJaar1: Toeslagen;
  berekeningsJaar2: Toeslagen;
  berekeningsJaar3: Toeslagen;
  berekeningsJaar4: Toeslagen;
  berekeningsJaar5: Toeslagen;
  bezwaarschrift: Bezwaarschrift
  aanslagIbJaar1?: AanslagIb;
  aanslagIbJaar2?: AanslagIb;
  aanslagIbJaar3?: AanslagIb;
  aanslagIbJaar4?: AanslagIb;
  aanslagIbJaar5?: AanslagIb;
  aanslagZvwJaar1?: AanslagZwv;
  aanslagZvwJaar2?: AanslagZwv;
  aanslagZvwJaar3?: AanslagZwv;
  aanslagZvwJaar4?: AanslagZwv;
  aanslagZvwJaar5?: AanslagZwv;
  aanslagBtwJaar1?: AanslagBtw;
  aanslagBtwJaar2?: AanslagBtw;
  aanslagBtwJaar3?: AanslagBtw;
  aanslagBtwJaar4?: AanslagBtw;
  aanslagBtwJaar5?: AanslagBtw;
  aangifteVpbJaar1?: VpbAangifte | BtwAangifte | undefined;
  aangifteVpbJaar2?: VpbAangifte;
  aangifteVpbJaar3?: VpbAangifte;
  aangifteVpbJaar4?: VpbAangifte;
  aangifteVpbJaar5?: VpbAangifte;
  aanslagVpbJaar1?: AanslagVpb;
  aanslagVpbJaar2?: AanslagVpb;
  aanslagVpbJaar3?: AanslagVpb;
  aanslagVpbJaar4?: AanslagVpb;
  aanslagVpbJaar5?: AanslagVpb;
  opgaafIcp?: IcpAangifte;
  aangifteDivBel?: Dividendbelasting;
  aangifteSchenkBel?: AangifteSchenkbelasting;
  aangifteBtwJaar1?: BtwAangifte;
  aangifteBtwJaar2?: BtwAangifte;
  aangifteBtwJaar3?: BtwAangifte;
  aangifteBtwJaar4?: BtwAangifte;
  aangifteBtwJaar5?: BtwAangifte;
  jaarstukkenJaar1?: JaarrekeningEntity;
  jaarstukkenJaar2?: JaarrekeningEntity;
  jaarstukkenJaar3?: JaarrekeningEntity;
  jaarstukkenJaar4?: JaarrekeningEntity;
  jaarstukkenJaar5?: JaarrekeningEntity;
  toeslagenJaar1?: BerichtSbt;
  toeslagenJaar2?: BerichtSbt;
  toeslagenJaar3?: BerichtSbt;
  toeslagenJaar4?: BerichtSbt;
  toeslagenJaar5?: BerichtSbt;
  loonAangifteDto?: LoonAangifteDto;
  loonAangifte?: string;
  werknemer?: Werknemer;
  loonstaat?: LoonStaat
  werkgever?: Werkgever;
  run?: number;
  loonPeriode?: number;
  personeelsNummer?: string;
  betalingskenmerk?: string;
  partner?: boolean;
  concept?: boolean;
  conceptWatermerk?: boolean;
  taal?: string;
  type?: PdfRequestType;
  optie?: PdfRequestOptie;
  soort?: PdfRequestSoort;
  mumaActivated?: boolean;
  time?: string;

  [key: string]: any;
}

export interface BerichtSbt {
  berichtgegevens?: Berichtgegevens;
  mededeling?: Mededeling;

  [key: string]: any;
}

export interface Mededeling {
  beschikkingstypeHoofdniveau: TypeHoofdniveau;
  beschikkingsjaar: number;
  startDatumMelding: string;
  eindDatumMelding: string;
  bsnAanvrager: string;
  motiveringAmbtshalveBeslissing: string;
  naamAanvrager: string;
  toetsingsinkomenAanvrager: number;
  mededelingReserve1: string;
  mededelingReserve2: string;
  conclusieMededeling: ConclusieMededeling[];
  meldingen: Meldingen[];
  datumOntvangstBezwaar: string;
  beslissingOpBezwaar: Besluit;
  inhoudBezwaar: string;
  bezwaarHoren: Horen;
  datumHorenBezwaar: string;
  motiveringBezwaar: string;
  kostenVergoeding: number;
  motiveringKostenvergoeding: string;
  bedragKostenvergoeding: number;
  datumBeroep: string;
  naamBehandelaar: string;
  telefoonnummerBehandelaar: string;
  verslagHoorzitting: string;
  adresRechtbank: AdresRechtbank[];
  regeling: Regeling[];
}

export enum TypeHoofdniveau {
  VOORSCHOT_EERSTE_AANVRAAG_OF_WIJZIGING = "VOORSCHOT_EERSTE_AANVRAAG_OF_WIJZIGING",
  VOORSCHOT_AUTOMATISCH_CONTINUEREN = "VOORSCHOT_AUTOMATISCH_CONTINUEREN",
  BESLSSING_OP_BEZWAAR = "BESLSSING_OP_BEZWAAR",
  DEFINITIEF = "DEFINITIEF",
  SPECIFICATIE = "SPECIFICATIE",
  HERZIEN = "HERZIEN",
}

export interface ConclusieMededeling {
  conclusieregelMededeling?: string
}

export interface Meldingen {
  bedragVastgesteldInkomen: number;
  berekeningsJaar: number;
  bsnSubjectMelding: string;
  naamSubjectMelding: string;
  meldingnummerInkomen: meldingNummerInkomen;
  aanleidingsTekst: Aanleiding;
  aanleiding: string;
  meldingReserve1: string;
  meldingReserve2: string;
}

export enum Aanleiding {
  PARTNERSCHAP_VASTGESTELD_OF_GEWIJZIGD = "PARTNERSCHAP_VASTGESTELD_OF_GEWIJZIGD",
  HUISHOUDSAMENSTELLIING_VASTGESTELD_OF_GEWIJZIGD = "HUISHOUDSAMENSTELLIING_VASTGESTELD_OF_GEWIJZIGD",
  TOESLAG_BEEINDIGD = "TOESLAG_BEEINDIGD",
  KINDEROPVANGGEGEVENS_GEWIJZIGD = "KINDEROPVANGGEGEVENS_GEWIJZIGD",
  HUUR_GEWIJZIGD = "HUUR_GEWIJZIGD",
  GESCHATTE_INKOMEN_GEWJIZIGD = "GESCHATTE_INKOMEN_GEWJIZIGD",
  IEMAND_IN_HUISHOUDEN_OVERLEDEN = "IEMAND_IN_HUISHOUDEN_OVERLEDEN",
  BIJZONDERE_SITUATIE_ZORGTOESLAG_GEWIJZIGD = "BIJZONDERE_SITUATIE_ZORGTOESLAG_GEWIJZIGD",
  BIJZONDERE_SITUATIE_KOT_GEWIJZIGD = "BIJZONDERE_SITUATIE_KOT_GEWIJZIGD",
  VERMOGEN_GEWIJZIGD_MET_BEDRAG_BIJZONDER_VERMOGEN = "VERMOGEN_GEWIJZIGD_MET_BEDRAG_BIJZONDER_VERMOGEN",
  VERMOGEN_OPNIEUW_VASTGESTELD = "VERMOGEN_OPNIEUW_VASTGESTELD",
  WOONLAND_KIND_GEWIJZIGD = "WOONLAND_KIND_GEWIJZIGD",
  HUURVERHOGING_1_JULI_IS_VERWERKT = "HUURVERHOGING_1_JULI_IS_VERWERKT",
  KINDEROPVANGGEGEVENS_GECONTROLEERD_EN_AANGEPAST = "KINDEROPVANGGEGEVENS_GECONTROLEERD_EN_AANGEPAST",
  TOESLAG_INGETROKKEN = "TOESLAG_INGETROKKEN",
  VERMOGEN_GEWIJZIGD = "VERMOGEN_GEWIJZIGD"
}

export enum meldingNummerInkomen {
  BURGER_HEEFT_NINBI_EN_WERELDVERMOGEN = "BURGER_HEEFT_NINBI_EN_WERELDVERMOGEN",
  BURGER_HEEFT_VERMOGEN = "BURGER_HEEFT_VERMOGEN",
  BURGER_HEEFT_AIG_EN_VERMOGEN = "BURGER_HEEFT_AIG_EN_VERMOGEN",
  BURGER_HEEFT_BIJZONDER_VERMOGEN = "BURGER_HEEFT_BIJZONDER_VERMOGEN",
  BURGER_HEEFT_GEEN_BIJZONDER_VERMOGEN_MEER = "BURGER_HEEFT_GEEN_BIJZONDER_VERMOGEN_MEER"
}

export enum Besluit {
  BEZWAAR_GEGROND = "BEZWAAR_GEGROND",
  BEZWAAR_DEELS_GEGEGROND = "BEZWAAR_DEELS_GEGEGROND",
  BEZWAAR_NIET_GEGROND = "BEZWAAR_NIET_GEGROND",
  BEZWAAR_NIET_ONTVANKELIJK = "BEZWAAR_NIET_ONTVANKELIJK",
}

export enum Horen {
  BEZWAAR_HOREN_KENNELIJK_GEGROND = "BEZWAAR_HOREN_KENNELIJK_GEGROND",
  BEZWAARHOREN_GEEN_GEBRUIK = "BEZWAARHOREN_GEEN_GEBRUIK",
  BEZWAAR_HOREN_GEBRUIK = "BEZWAAR_HOREN_GEBRUIK",
  BEZWAAR_HOREN_KENNELIJK_NIET_ONTVANKELIJK = "BEZWAAR_HOREN_KENNELIJK_NIET_ONTVANKELIJK",
  BEZWAAR_HOREN_KENNELIJK_ONGEGROND = "BEZWAAR_HOREN_KENNELIJK_ONGEGROND",
}

export interface AdresRechtbank {
  adresRechtbank?: string
}

export interface Regeling {
  toeslagType: ToeslagType;
  beschikkingsTypeRegelniveau: BeschikkingsType;
  beschikkingsdatum: string;
  beschikkingsNummer: string;
  jaarBedragPerToeslag: number;
  jaarBedragRentePerToeslag: number;
  jaarBedragBoetePerToeslag: number;
  JaarbedragVorigPerToeslag: number;
  nogTeBetalen: number;
  nogTeOntvangen: number;
  renteTeBetalen: number;
  renteTeOntvangen: number;
  startDatumToeslag: string;
  eindDatumToeslag: string;
  totaalbedragTeBetalen: number;
  totaalbedragTeOntvangen: number;
  bedragDoelmatigheidsgrens: number;
  totaalbedragVoorToepassingDoelmatigheidsgrens: number;
  regelingReserve1: string;
  regelingReserve2: string;
  conclusieRegeling: string;
  conclusieregelVermogen: string;
  vermogensGrens: number;
  vermogensgrensAanvragerMetToeslagpartner: number;
  vermogensgrensMedebewoner: number;
  lidHuishouden: LidHuishouden[];
  deelJaren: Deeljaren[];
}

export interface Deeljaren {
  startdatumDeeljaar: string;
  einddatumDeeljaar: string;
  draagkrachtDeeljaar: number;
  maandbedragTSLDeelJaar: number;
  bsnPartner: string;
  naamPartner: string;
  toetsingsinkomenPartner: number;
  conclusieDeeljaar: string;
  kindgegevens: Kindgegevens[];
  huurobjectHuisnummer: number;
  huurobjectHuisnummertoevoeging: string;
  huurobjectPostcode: string;
  huurobjectStraat: string;
  huurobjectWoonplaats: string;
  kaleHuur: number;
  huurStandplaats: number;
  energieKosten: number;
  schoonmaakkosten: number;
  huismeesterkosten: number;
  dienstEnRecreatieruimtenKosten: number;
  rekenHuur: number;
  Medebewoners: Medebewoners[];
}

export interface Medebewoners {
  bsnMedebewoner?: string;
  naamMedebewoner?: string;
  toetsingsinkomenMedebewoner?: number;
  vrijstellingInkomenThuiswonendKind?: number;
}

export interface Kindgegevens {
  bsnSVBKind: string;
  naamSVBKind: string;
  woonlandSVBKind: string;
  maandbedragSVBKind: number;
  gemiddeldeUurprijsGO: number;
  totaalAantalUrenGO: number;
  gemiddeldeUurprijsKC: number;
  totaalAantalUrenKC: number;
  Opvanggegevens: Opvanggegevens[]; // (context array)
}

interface Opvanggegevens {
  naamOpvang: string;
  straatOpvang: string;
  huisnummerOpvang: number;
  HuisnummerToevoegingOpvang: string;
  postcodeOpvang: string;
  plaatsOpvang: string;
  registratienummerLRKenRBK: string;
  postcodeOCWCodeOpvang: string;
  soortOpvang: string;
  soortInstelling: string;
  urenOpvang: number;
  uurtariefOpvang: number; // BigDecimal can be represented as number in TypeScript
  landBuitenlandseOpvang: string;
  adresBuitenlandseOpvang: AdresBuitenlandseOpvang[];
}

export interface AdresBuitenlandseOpvang {
  AdresregelBuitenlandseOpvang: string
}

export interface LidHuishouden {
  bsnSubject: string;
  naamSubject: string;
  bedragGrondslagSparenEnBeleggen: number;
  bedragGroeneBeleggingen: number;
  bedragBijzonderVermogen: number;
  bedragRendementsgrondslag: number;
  bedragGeschatVermogenVanaf2022: number;
}

export enum ToeslagType {
  KOT = "KOT",
  KGB = "KGB",
  ZORG = "ZORG",
  HUUR = "HUUR"
}

export enum BeschikkingsType {
  VOORSCHOT_EERSTE_AANVRAAG = "VOORSCHOT_EERSTE_AANVRAAG",
  VOORSCHOT_WIJZIGING = "VOORSCHOT_WIJZIGING",
  VOORSCHOT_AUTOMATISCH_CONTINUEREN = "VOORSCHOT_AUTOMATISCH_CONTINUEREN",
  BESLISSING_OP_BEZWAAR_TEGEN_VOORSCHOT = "BESLISSING_OP_BEZWAAR_TEGEN_VOORSCHOT",
  DEFINITIEVE_BESCHIKKING = "DEFINITIEVE_BESCHIKKING",
  HERZIEN = "HERZIEN",
  BESLISSING_OP_BEZWAAR_TEGEN_DT = "BESLISSING_OP_BEZWAAR_TEGEN_DT",
  BESLISSING_OP_BEZWAAR_TEGEN_HDT = "BESLISSING_OP_BEZWAAR_TEGEN_HDT"
}

export interface Berichtgegevens {
  dagtekening?: Date;
  kenmerkMededeling?: string;
  berichtSoort?: Soort;
  Begindatum?: Date;
  Einddatum?: Date;
  toeslagjaar?: number;
  huisNummerGemachtigde?: number;
  huisnummerToevoegingGemachtigde?: string;
  postcodeGemachtigde?: string;
  indicatieSoortVerzending?: SoortVerzending;
  nawGegevens?: NAWGegevens[]

  [key: string]: any;
}

export interface NAWGegevens {
  nawGegevensGemachtigde?: string;

  [key: string]: any;
}

export enum SoortVerzending {
  NIET_ADRESSEERBAAR = "NIET_ADRESSEERBAAR",
  BUITENLANDS_ADRES_BUiTEN_EUROPA = "BUITENLANDS_ADRES_BUiTEN_EUROPA",
  BUITENLANDS_ADRES_BINNEN_EUROPA = "BUITENLANDS_ADRES_BINNEN_EUROPA",
  BINNENLANDS_ADRES_ZONDER_POSTCODE = "BINNENLANDS_ADRES_ZONDER_POSTCODE",
  BINNENLANDS_ADRES_MET_POSTCODE = "BINNENLANDS_ADRES_MET_POSTCODE"
}

export enum Soort {
  BESLISSING_OP_BEZWAAR = "BESLISSING_OP_BEZWAAR",
  EERSTE_AANVRAAG_EN_WIJZIGING = "EERSTE_AANVRAAG_EN_WIJZIGING",
  AUTOMATISCH_CONTINUEREN = "AUTOMATISCH_CONTINUEREN",
  HERZIENE_DEFINITIEVE_BEREKENING = "HERZIENE_DEFINITIEVE_BEREKENING",
  VT_DIRETC = "VT_DIRETC",
  AC_DIRECT = "AC_DIRECT",
  DT_DIRECT = "DT_DIRECT",
  AMBTSHALVE_BESLISSING_VT = "AMBTSHALVE_BESLISSING_VT",
  AMBTSHALVE_BESLISSINGF_AC = "AMBTSHALVE_BESLISSINGF_AC",
  AMBTSHALVE_BESLISING_DT = "AMBTSHALVE_BESLISING_DT"
}

export interface UitstelEntity {
  id?: number;
  year?: number;
  uitstelRequest?: UitstelRequest;
  dateCreation?: Date;

  [key: string]: any;
}

export interface UitstelGegevens {
  /** PostponementRequestType */
  soortUitstelVerzoek: UitstelGegevensSoortUitstelVerzoek;
  /** SpecialMotivationPostponementTaxConsultant */
  motivatieBijzonderUitstel?: string;
  /** TaxName */
  belastingmiddel: UitstelGegevensBelastingmiddel;
  /** TaxpayerIdentificationNumber */
  fiscaalNummer: string;
  /** TaxpayerInitials */
  voorlettersBelastingplichtige?: string;
  /** TaxpayerPrefix */
  tussenVoegselBelastingplichtige?: string;
  /** TaxpayerSurname */
  achternaamBelastingplichtige: string;
  /** FinancialYearStart */
  boekjaarStart: Date;
  /** FinancialYearEnd */
  boekjaarEind: Date;
  /** DatePostponementRequest */
  datumAanvraag?: Date;
  /** DatePostponementResponse */
  datumToegekend?: Date;
  /** SubmissionDate */
  datumUitstelTot?: Date;
  /** DateTaxReturnSubmitted */
  datumIngeleverd?: Date;
  /** Description */
  omschrijving?: string;

  [key: string]: any;
}

export interface UitstelRequest {
  /** FiscalYear */
  jaar: number;
  /** TaxConsultantNumber */
  beconnummer: string;
  /** TaxIdentificationNumberTaxConsultant */
  fiscaalNummerDienstverlener: string;
  /** PostponementSpecification */
  uitstelVerzoekList: UitstelGegevens[];

  [key: string]: any;
}

export interface Reservation {
  startDatum?: string;
  eindDatum?: string;
  jaar?: number;
  profit?: number;
  resultaat?: number;
  reserveringsBedrag?: number;
  winstGeheleJaar?: number;
  verschuldigdOverHeleJaar?: number;
  proRataVerschuldigd?: number;
  year?: number;
  zelfstandigenAftrek?: boolean;
  bedragZelfstandigenAftrek?: number;
  mkbWinstvrijstelling?: number;
  belastbareWinst?: number;
  verschuldigdeIBOverHeleJaar?: number;
  verschuldigdeZVWOverHeleJaar?: number;
  verschuldigdTotaalOverHeleJaar?: number;
  eersteSchijf?: number;
  tweedeSchijf?: number;
  maxEersteSchijf?: number;

  [key: string]: any;
}

/** Enterprises */
export interface BerekendeOnderneming {
  naamOnderneming?: string;
  rsinOnderneming?: string;
  ondernemingsVermogenInVerkrijging?: number;
  waardeOvergedragenOnderneming?: number;
  berekeningPerOpvolger?: BerekendeOpvolger[];

  [key: string]: any;
}

export interface BerekendeOpvolger {
  /** NotaryNumber */
  protocolNummerNotaris?: string;
  /** TaxConsultantNumber */
  beconnummer?: string;
  /** IdentificationNumber */
  bsn?: string;
  /** Initials */
  voorletters?: string;
  /** Prefix */
  tussenvoegsel?: string;
  /** Surname */
  achternaam?: string;
  /** DonorDateOfBirth */
  geboortedatum?: Date;
  /** InstitutionName */
  instellingnaam?: string;
  /** BusinessSuccessionFacilitiesPreservedTaxAssessmentRequestIndication */
  verzoekConserverendeAanslag: boolean;
  /** BusinessSuccessionAgreementObjectiveCompanyTransferredValueNumerator */
  tellerOvergedragenAandeel: number;
  /** BusinessSuccessionAgreementObjectiveCompanyTransferredValueDenominator */
  noemerOvergedragenAandeel: number;
  /** BusinessSuccessionFacilitiesOriginalAcquisitionValue */
  waardeTegenPrestatie: number;
  aandeelWaardeGoingConcern?: number;
  aandeelWaardeLiquidatie?: number;
  beleggingsVermogenInVerkrijging?: number;
  toegerekendBeleggingsVermogenAanOnderneming?: number;
  beleggingsVermogenVoorBOR?: number;
  overgedragenAandeelOndernemingsVermogen?: number;
  verkrijgingsprijsOvergedragenAandeel?: number;
  overgedragenInkomstenbelastingLatentie?: number;
  aandeelLatenteInkomstenbelasting?: number;
  voorwaardelijkVrijgesteldeWaarde?: number;
  geconserveerdeWaarde?: number;

  [key: string]: any;
}

export interface SbBerekening {
  /** Total Cash */
  totaalBedragContanten?: number;
  /** Total Stock */
  totaalBedragEffecten?: number;
  /** Total Immovable Property */
  totaleWaardeGeschonkenOnroerendeZaken?: number;
  /** Total Business Capital */
  totaalGeschonkenOndernemingsVermogen?: number;
  /** Total Exempted Business Capital */
  totaalVrijgesteldOndernemingsVermogen?: number;
  /** Total Trust Capital */
  totaleWaardeGeschonkenApv?: number;
  /** Total Periodical Benefit */
  totaleWaardeGeschonkenPu?: number;
  /** Total Gift Movable Property */
  totaleWaardeGeschonkenRoerendeZaken?: number;
  /** Total Debt Recognition Out Of Generosity */
  totaleWaardeSchuldigErkenning?: number;
  /** Total Debt Remission */
  totaleWaardeKwijtscheldingen?: number;
  /** Total Usufruct */
  totaleWaardeVruchtgebruik?: number;
  /** Total Gift Other */
  totaleWaardeOverigeSchenkingen?: number;
  /** Total Gifts */
  totaleSchenking?: number;
  totaleBasisVrijstellingen?: number;
  totaleVerhoogdeVrijstellingen?: number;
  /** Total Other Exemption */
  totalOverigeVrijstellingen?: number;
  /** Total Exemption */
  totaleVrijstellingen?: number;
  /** Used exemption */
  eerderGebruikteVrijstellingen?: number;
  /** Total Exemption Used */
  benutteVrijstellingen?: number;
  /** Total Taxable Gift */
  totaleVoorwaardelijkeVrijstelling?: number;
  /** Total Taxable Gift */
  totaleBelastbareSchenking?: number;
  /** Total Gift Tax Calculated */
  verschuldigdeSchenkbelasting?: number;
  /** Credit Real Estate Transfer Tax */
  verrekeningOverdrachtsBelasting?: number;
  /** Credit Foreign Tax */
  voorkomingDubbeleBelasting?: number;
  /** Total Gift Tax Due */
  teBetalenSchenkbelasting?: number;
  /** Preserved Assessment Base */
  grondslagConserverendeAanslag?: number;
  /** Preserved Assessment Amount */
  bedragConserverendeAanslag?: number;

  grondslagEersteSchijf?: number;

  grondslagTweedeSchijf?: number;

  tariefEersteSchijf?: number;

  tariefTweedeSchijf?: number;

  belastingEersteSchijf?: number;

  belastingTweedeSchijf?: number;

  verhogingEersteSchijfVanwegeBrutering?: number;

  verhogingTweedeSchijfVanwegeBrutering?: number;

  totaalBelastingEersteSchijf?: number;

  totaalBelastingTweedeSchijf?: number;
  /** Enterprises */
  berekendeOndernemingen?: BerekendeOnderneming[];

  [key: string]: any;
}

export interface SamenvoegRequest {
  viaAangever?: Aangifte;
  viaPartner?: Aangifte;
  aangifte?: Aangifte;

  [key: string]: any;
}

export interface Specificatie {
  januari?: number;
  februari?: number;
  maart?: number;
  april?: number;
  mei?: number;
  juni?: number;
  juli?: number;
  augustus?: number;
  september?: number;
  oktober?: number;
  november?: number;
  december?: number;

  [key: string]: any;
}

export interface ToeslagenBerekening {
  toeslagen?: Toeslagen;
  rechtOpZorgtoeslag?: number;
  alOntvangenZorgtoeslag?: number;
  verschuldigdeZorgtoeslag?: number;
  specificatieZorgtoeslag?: Specificatie;
  rechtOpHuurtoeslag?: number;
  alOntvangenHuurtoeslag?: number;
  verschuldigdeHuurtoeslag?: number;
  specificatieHuurtoeslag?: Specificatie;
  rechtOpKOT?: number;
  alOntvangenKOT?: number;
  verschuldigdeKOT?: number;
  specificatieKot?: Specificatie;
  rechtOpKGB?: number;
  alOntvangenKGB?: number;
  verschuldigdeKGB?: number;
  specificatieKgb?: Specificatie;

  [key: string]: any;
}

export interface BtwBerekening {
  verschuldigdeBtwMaand1?: number;
  verschuldigdeBtwMaand2?: number;
  verschuldigdeBtwMaand3?: number;
  verschuldigdeBtwMaand4?: number;
  verschuldigdeBtwMaand5?: number;
  verschuldigdeBtwMaand6?: number;
  verschuldigdeBtwMaand7?: number;
  verschuldigdeBtwMaand8?: number;
  verschuldigdeBtwMaand9?: number;
  verschuldigdeBtwMaand10?: number;
  verschuldigdeBtwMaand11?: number;
  verschuldigdeBtwMaand12?: number;
  voorbelastingBtwMaand1?: number;
  voorbelastingBtwMaand2?: number;
  voorbelastingBtwMaand3?: number;
  voorbelastingBtwMaand4?: number;
  voorbelastingBtwMaand5?: number;
  voorbelastingBtwMaand6?: number;
  voorbelastingBtwMaand7?: number;
  voorbelastingBtwMaand8?: number;
  voorbelastingBtwMaand9?: number;
  voorbelastingBtwMaand10?: number;
  voorbelastingBtwMaand11?: number;
  voorbelastingBtwMaand12?: number;
  afdrachtMaand1?: number;
  afdrachtMaand2?: number;
  afdrachtMaand3?: number;
  afdrachtMaand4?: number;
  afdrachtMaand5?: number;
  afdrachtMaand6?: number;
  afdrachtMaand7?: number;
  afdrachtMaand8?: number;
  afdrachtMaand9?: number;
  afdrachtMaand10?: number;
  afdrachtMaand11?: number;
  afdrachtMaand12?: number;
  verschuldigdeBtwKwartaal1?: number;
  verschuldigdeBtwKwartaal2?: number;
  verschuldigdeBtwKwartaal3?: number;
  verschuldigdeBtwKwartaal4?: number;
  voorbelastingBtwKwartaal1?: number;
  voorbelastingBtwKwartaal2?: number;
  voorbelastingBtwKwartaal3?: number;
  voorbelastingBtwKwartaal4?: number;
  afdrachtKwartaal1?: number;
  afdrachtKwartaal2?: number;
  afdrachtKwartaal3?: number;
  afdrachtKwartaal4?: number;
  verschuldigdeBtwJaar?: number;
  voorbelastingBtwJaar?: number;
  afdrachtJaar?: number;
  totaalVerschuldigd?: number;
  totaalVoorbelasting?: number;
  totaalAangiften?: number;
  totaalSuppleties?: number;
  verschuldigdeOmzetbelasting?: number;

  [key: string]: any;
}

export interface BtwOverzicht {
  /** tax year */
  jaar: number;
  /** Tax payer initials */
  initialenBelastingplichtige?: string;
  /** Tax payer prefix */
  tussenvoegselBelastingplichtige?: string;
  /** Tax payer last name */
  achternaamBelastingplichtige: string;
  /** Tax identification number, e.g. 123456782B01 */
  omzetbelastingNummer: string;
  /** Tax consultant number, e.g. 123456 */
  beconNummer?: string;
  /** Name contact person */
  naamContactPersoon: string;
  /** Telephone number contact person e.g. 0612345678 */
  telefoonnummer: string;
  /** function contact person e.g. Manager */
  functie: string;
  /** Frequence of filing */
  frequentie: BtwOverzichtFrequentie;
  sstAdminId?: string;
  /** Tax identification number fiscal unit */
  omzetbelastingNummerFE?: string;
  fiscaleEenheidBtwList?: FiscaleEenheidBtw[];
  /** Vat returns for the year */
  btwAangiftes: BtwAangifte[];
  /** Supplemental tax returns */
  btwSuppleties: BtwAangifte[];
  /** ICP tax returns */
  icpAangiftes?: IcpAangifte[];
  cumulatieveAfdrachten?: number;
  berekening?: BtwBerekening;
  teVerzendenAangifte?: BtwAangifte;
  fiscaleEenheid?: boolean;

  [key: string]: any;
}

export interface FiscaleEenheidBtw {
  naamOnderneming?: string;
  omzetbelastingNummer?: string;
  datumOpname?: Date;
  datumEinde?: Date;
  sstAdminId?: string;

  [key: string]: any;
}

export interface ValueAddedTaxEntity {
  id?: number;
  name?: string;
  sstAdminId?: string;
  taxPayerFiscalNumber: string;
  taxPayerFiscalUnityNumber?: string;
  sstRelationId?: string;
  year?: number;
  overzicht?: BtwOverzicht;
  lastOpeningDate?: Date;
  submissionDate?: Date;
  taxPayerId?: ClientEntity;

  [key: string]: any;
}

export interface Activa {
  /** GoodwillFiscal */
  totaalGoodwillBegin?: number;
  /** GoodwillFiscal */
  totaalGoodwillEind?: number;
  /** GoodwillPurchaseCostsFiscal */
  totaalGoodwillKostprijs?: number;
  /** IntangibleFixedAssetsOtherFiscal */
  totaalImvaOverigBegin?: number;
  /** IntangibleFixedAssetsOtherFiscal */
  totaalImvaOverigEind?: number;
  /** IntangibleFixedAssetsOtherPurchaseOrProductionCostsFiscal */
  totaalImvaOverigKostprijs?: number;
  /** IntangibleFixedAssetsTotalFiscal */
  totaalImmvaBegin?: number;
  /** IntangibleFixedAssetsTotalFiscal */
  totaalImmvaEind?: number;
  /** BuildingsAndLandFiscal */
  totaalgebouwenBegin?: number;
  /** BuildingsAndLandFiscal */
  totaalgebouwenEind?: number;
  /** MachineryPurchaseCostsFiscal */
  totaalgebouwenKostprijs?: number;
  /** BuildingsOwnUseResidualValueFiscal */
  totaalgebouwenRestwaarde?: number;
  /** MachinesAndInstallationsFiscal */
  totaalMachinesBegin?: number;
  /** MachinesAndInstallationsFiscal */
  totaalMachinesEind?: number;
  /** MachineryPurchaseCostsFiscal */
  totaalMachinesKostprijs?: number;
  /** MachineryPurchaseCostsFiscal */
  totaalMachinesRestwaarde?: number;
  /** FixedAssetsOtherFiscal */
  totaalAndereVABegin?: number;
  /** FixedAssetsOtherFiscal */
  totaalAndereVAEind?: number;
  /** FixedAssetsOtherPurchaseCostsFiscal */
  totaalAndereVAKostprijs?: number;
  /** FixedAssetsOtherResidualValueFiscal */
  totaalAndereVARestwaarde?: number;
  /** TangibleFixedAssetsFiscalTotal */
  totaalMvaBegin?: number;
  /** TangibleFixedAssetsFiscalTotal */
  totaalMvaEind?: number;
  /** ParticipatingInterests */
  totaalDeelnemingenBegin?: number;
  /** ParticipatingInterests */
  totaalDeelnemingenEind?: number;
  /** LongTermReceivablesGroupCompaniesFiscal */
  totaalLanglopendeGroepsvorderingenBegin?: number;
  /** LongTermReceivablesGroupCompaniesFiscal */
  totaalLanglopendeGroepsvorderingenEind?: number;
  /** LongTermReceivablesGroupCompaniesNominal */
  totaalLanglopendeGroepsvorderingenNominaal?: number;
  /** LongTermReceivablesParticipatingInterestCompaniesFiscal */
  totaalLanglopendeAandeelhoudersvorderingenBegin?: number;
  /** LongTermReceivablesParticipatingInterestCompaniesFiscal */
  totaalLanglopendeAandeelhoudersvorderingenEind?: number;
  /** LongTermReceivablesParticipatingInterestCompaniesNominal */
  totaalLanglopendeAandeelhoudersvorderingenNominaal?: number;
  /** FinancialFixedAssetsOtherFiscal */
  totaalAndereFvaBegin?: number;
  /** FinancialFixedAssetsOtherFiscal */
  totaalAndereFvaEind?: number;
  /** FinancialFixedAssetsOtherTaxNominalFiscal */
  totaalAndereFvaNominaal?: number;
  /** FinancialFixedAssetsTotalFiscal */
  totaalFvaBegin?: number;
  /** FinancialFixedAssetsTotalFiscal */
  totaalFvaEind?: number;
  /** StockExcludingWorkInProgress */
  totaalVoorradenBegin?: number;
  /** StockExcludingWorkInProgress */
  totaalVoorradenEind?: number;
  /** WorkInProgressFiscal */
  totaalOnderhandenWerkBegin?: number;
  /** WorkInProgressFiscal */
  totaalOnderhandenWerkEind?: number;
  /** StockTotalFiscal */
  totaalVoorraadEnOnderhandenWerkBegin?: number;
  /** StockTotalFiscal */
  totaalVoorraadEnOnderhandenWerkEind?: number;
  /** TradeAccountsReceivableFiscal */
  totaalDebiteurenBegin?: number;
  /** TradeAccountsReceivableFiscal */
  totaalDebiteurenEind?: number;
  /** ValueAddedTaxReceivablesFiscal */
  totaalVorderingOmzetbelastingBegin?: number;
  /** ValueAddedTaxReceivablesFiscal */
  totaalVorderingOmzetbelastingEind?: number;
  /** ShortTermReceivablesGroupCompaniesFiscal */
  totaalKortlopendeGroepsvorderingenBegin?: number;
  /** ShortTermReceivablesGroupCompaniesFiscal */
  totaalKortlopendeGroepsvorderingenEind?: number;
  /** ShortTermReceivablesGroupCompaniesNominal */
  totaalKortlopendeGroepsvorderingenNominaal?: number;
  /** ShortTermReceivablesParticipatingInterestCompaniesFiscal */
  totaalKortlopendeAandeelhoudersvorderingenBegin?: number;
  /** ShortTermReceivablesParticipatingInterestCompaniesFiscal */
  totaalKortlopendeAandeelhoudersvorderingenEind?: number;
  /** ShortTermReceivablesParticipatingInterestCompaniesNominal */
  totaalKortlopendeAandeelhoudersvorderingenNominaal?: number;
  /** ReceivablesOtherFiscal */
  totaalOverigeVorderingenBegin?: number;
  /** ReceivablesOtherFiscal */
  totaalOverigeVorderingenEind?: number;
  /** ReceivablesOtherFiscalNominal */
  totaalOverigeVorderingenNominaal?: number;
  /** ReceivablesTotalFiscal */
  totaalVorderingenBegin?: number;
  /** ReceivablesTotalFiscal */
  totaalVorderingenEind?: number;
  /** SecuritiesFiscal */
  totaalEffectenBegin?: number;
  /** SecuritiesFiscal */
  totaalEffectenEind?: number;
  /** LiquidAssetsTotalFiscal */
  totaalLiquideMiddelenBegin?: number;
  /** LiquidAssetsTotalFiscal */
  totaalLiquideMiddelenEind?: number;
  /** AssetsTotalAmountFiscal */
  totaalActivaFiscaalBegin?: number;
  /** AssetsTotalAmountFiscal */
  totaalActivaFiscaalEind?: number;

  [key: string]: any;
}

export interface BelastbaarBedrag {
  /** TaxableProfitChangeInterestsCount */
  winstVoorSplitsingBelangenwijziging?: number;
  /** TaxableIncomeSubstantialInterestNetherlandsPartnership */
  belastbaarInkomenAbNederlandseVennootschap?: number;
  /** TaxableProfitNetherlandsDrivenCompany */
  belastbareWinstNederlandseOnderneming?: number;
  /** TaxableProfit */
  belastbareWinst?: number;
  /** LossesToBeSetoffThisYearNotBeingHoldingLosses */
  teVerrekenenGewoneVerliezenDitBoekjaar?: number;
  /** HoldingLossesCorporationTaxActToBeSetoffThisYear */
  teVerrekenenHoudsterverliezenDitBoekjaar?: number;
  /** LossesToBeSetOffThisYearTotal */
  totaalTeVerrekenenVerlies?: number;
  /** TaxableProfit */
  belastbaarBedrag?: number;
  omrekenfactorFunctioneleValuta?: string;
  grondslagFunctioneleValuta?: number;
  nogTeVerrekenenGewoneVerliezen?: number;
  nogTeVerrekenenHoudsterVerliezen?: number;

  [key: string]: any;
}

export interface BelastbareWinst {
  saldoFiscaleWinst?: number;
  eliminatieVerliesBoekjaar?: number;
  imputatieVerlies?: number;
  vrijgesteldeWinstbestanddelen?: number;
  objectvrijstellingBuitenlandseWinst?: number;
  verliesbruteringBuitenlandseBeleggingsonderneming?: number;
  /** CostsAndWagesAndPenaltiesNonDeductibleOrSubjectToRestrictedDeductionTotal */
  nietAftrekbareBoetes?: number;
  /** CostsAndWagesAndPenaltiesNonDeductibleOrSubjectToRestrictedDeductionTotal */
  beperktAftrekbareKosten?: number;
  winstUitZeescheepvaart?: number;
  /** ProfitANBIFundRaisingActivities */
  fondswerversWinst?: number;
  /** FictitiousPersonnelCostsInstitutionsForGeneralPublicSocialInterestTotal */
  fictievePersooneelskostenANBI?: number;
  totaalbedragKiaInNederland?: number;
  totaalbedragKiaCaribischDeel?: number;
  totaalKiaVoorgaandeJaren?: number;
  totaleKiaDitJaar?: number;
  /** CostsAndWagesAndPenaltiesNonDeductibleOrSubjectToRestrictedDeductionTotal */
  investeringsregelingenTotaal?: number;
  /** EqualizationReserveCostAddition */
  toevoegingKER?: number;
  /** EqualizationReserveWithdrawalCost */
  onttrekkingKER?: number;
  /** ReinvestmentReserveAddition */
  toevoegingHIR?: number;
  /** ReinvestmentReserveWithdrawal */
  onttrekkingHIR?: number;
  /** CompartmentReserveTaxedAddition */
  toevoegingCompartimenteringsreserve?: number;
  /** CompartmentReserveTaxedWithdrawal */
  onttrekkingCompartimenteringsreserve?: number;
  /** ReservesOtherAddition */
  toevoegingOverigeReserves?: number;
  /** ReservesOtherWithdrawal */
  onttrekkingOverigeReserves?: number;
  totaalToevoegingenReserves?: number;
  totaalOnttrekkingReserves?: number;
  mutatieReserves?: number;
  renteEnRoyaltiesDoorstroomvennootschappen?: number;
  nietAfrekbareRente?: number;
  bovenmatigeDeelnemingsrente?: number;
  renteOvernameschulden?: number;
  totaalNietAfrekbareRente?: number;
  aftrekGetemporiseerdeRente?: number;
  totaalGeneriekeRenteAftrekBeperking?: number;
  nietInAanmerkingTeNemenVoordeelInnovatiebox?: number;
  terugnameVoordeelInnovatiebox?: number;
  saldoVoordeelInnovatiebox?: number;
  liquidatieverlies?: number;
  toevoegingAanWinstOpGrondVanArtikel13c?: number;
  toevoegingAanWinstOpGrondVanArtikel13h?: number;
  toevoegingAanWinstOpGrondVanArtikel13lid17?: number;
  saldoNietVrijgesteldeVoordelenUitDeelneming?: number;
  nettoVoordelenUitDeelneming?: number;
  voordelenUitNietKwalificerendeDeelnemingen?: number;
  deelnemingsvrijstelling?: number;
  maximaalAftrekbareGiften?: number;
  giftenAanCultureleInstellingen?: number;
  giftenAanOverigeInstellingen?: number;
  extraAftrekCultureleInstellingen?: number;
  aftrekbareGiften?: number;
  belastbareWinst?: number;

  [key: string]: any;
}

export interface Belasting {
  belastingNaarNormaalTarief?: number;
  saldoBelastingVoorAftrekEldersBelast?: number;
  vermeederingBelastingAfkoopPensioen?: number;
  vermeederingBelastingStamrecht?: number;
  vermeederingBelastingStatusverliesVrijstelling?: number;
  aftrekEldersBelast?: number;
  naarVolgendJaarOverTeBrengenDeelnemingsverrekening?: number;
  verrekendeDeelnemingsverrekening?: number;
  naarVolgendJaarOverTeBrengenOndernemingswinst?: number;
  verrekendeBuitenlandseOndernemingswinst?: number;
  totaleBelastingverminderingen?: number;
  totaalVoorheffingen?: number;
  saldoBelastingDitBoekjaar?: number;
  alBetaaldeVoorlopigeAanslag?: number;
  verschuldigdeVennootschapsbelasting?: number;

  [key: string]: any;
}

export interface BerekendeRenteAftrekBeperking {
  /** DebtsCostsTotalIncomeStatement */
  somKostenVanSchuldenVolgensResultatenRekening?: number;
  /** InterestCostsPreviouslyCapitalizedInterest */
  renteKostenVoorheenGeactiveerdeRente?: number;
  /** CostsOnDebtsCorrection */
  overigeCorrectiesOpRenteVanSchulden?: number;
  /** InterestOnDebtsTotal */
  somKostenVanSchulden?: number;
  /** ReceivablesOnRevenuesTotalIncomeStatement */
  somOpbrengstenVanVorderingenVolgensResultatenRekening?: number;
  /** ReceivablesOnRevenuesTotalCorrection */
  correctiesOpbrengstenVanVorderingen?: number;
  /** InterestOnReceivablesTotal */
  somOpbrengstVanVorderingen?: number;
  /** InterestOnMoneyLoansProductionCostsActivated */
  inBoekjaarGeactiveerdeRente?: number;
  /** InterestNonDeductibleAcquisitionDebts */
  renteAlsBedoeldInArtikel10a?: number;
  /** Test */
  vergoedingenEnWaardemutatiesArtikel10b?: number;
  /** HybridMismatchesInterestNeutralization */
  renteInNeutraliserendeHybridMismatch?: number;
  /** ObjectExemptionInterest */
  renteInObjectVrijstelling?: number;
  /** InterestBalance */
  saldoRente?: number;
  /** ProfitWithoutInterestDeductionLimitation */
  winstVoorToepassingRenteAftrekBeperking?: number;
  /** DepreciationsIncomeStatementTotal */
  somAfschrijvingenVolgensResultatenRekening?: number;
  /** TangibleAndIntangibleFixedAssetsValuationChanges */
  waardeVeranderingActiva?: number;
  /** ProfitCorrected */
  gecorrigeerdeWinst?: number;
  /** TresHold */
  drempel?: number;
  /** InterestDeductionSpace */
  generiekeRenteAftrekBeperking?: number;
  /** InterestTransferForwardShiftingPreviousYears */
  teVerrekenenRenteUitVoorgaandeJaren?: number;
  /** Test */
  maximaalTeVerrekenenRenteUitVoorgaandeJaren?: number;
  /** Test */
  daadwerkelijkTeVerrekenenRenteUitVoorgaandeJaren?: number;

  [key: string]: any;
}

export interface Bronbelastingen {
  /** TaxableProfit */
  totaalVerrekendeBronheffingen?: number;
  /** DoubleTaxationAvoidanceSetoffMethodCarryForwardTotal */
  totaalVerrekeningVoortgewenteldeBronheffingen?: number;
  /** TaxationElsewhereProportionalityMethodAbroadTotal */
  totaalVrijstellingsmethode?: number;
  /** TaxationElsewhereSetoffMethodAbroadTotal */
  totaalVerrekeningsmethode?: number;
  totaalAftrekEldersBelast?: number;

  [key: string]: any;
}

export interface FiscaleWinst {
  eindvermogen?: number;
  /** CapitalChangesAndWithdrawalsTotal */
  onttrekkingen?: number;
  eindvermogenPlusOnttrekkingen?: number;
  beginvermogen?: number;
  /** CapitalContributionsTotal */
  stortingen?: number;
  beginvermogenPlusStortingen?: number;
  vermogensverschil?: number;
  nietAftrekbareBedragen?: number;
  saldoFiscaleWinst?: number;

  [key: string]: any;
}

export interface HFLOActiviteitenOverzicht {
  /** HoldingActivitiesRevenues */
  opbrengstenHoudsteractiviteiten?: number;
  /** LicencingActivitiesRevenues */
  opbrengstenLicentieactiviteiten?: number;
  /** FinancingActivitiesRevenues */
  opbrengstenFinancieringsactiviteiten?: number;
  /** OtherActivitiesRevenues */
  opbrengstenOverigeactiviteiten?: number;
  /** HoldingActivitiesCosts */
  kostenHoudsteractiviteiten?: number;
  /** LicencingActivitiesCosts */
  kostenLicentieactiviteiten?: number;
  /** FinancingActivitiesCosts */
  kostenFinancieringsactiviteiten?: number;
  /** ActivitiesOtherCosts */
  kostenOverigeactiviteiten?: number;
  /** CommercialActivitiesGroupRelatedActivities */
  werkzaamhedenBinnenConcernverband?: boolean;
  /** CommercialActivitiesInterestOrRoyaltyGuidelineAppeal */
  beroepOpVerdragOfRichtlijn?: boolean;
  /** CommercialActivitiesRequirementsPresenceNetherlands */
  vereisteAanwezigheidInNederland?: boolean;
  /** BalanceProfitOnHoldingActivitiesComparisonMethod */
  saldoWinstHoudsteractiviteiten?: number;
  /** BalanceProfitOnLicencingActivitiesComparisonMethod */
  saldoWinstLicentieactiviteiten?: number;
  /** BalanceProfitOnFinancingActivitiesComparisonMethod */
  saldoWinstFinancieringsactiviteiten?: number;
  /** BalanceProfitOnOtherActivitiesComparisonMethod */
  saldoWinstOverigeactiviteiten?: number;
  /** BalanceProfitModelB */
  saldoFiscaleWinstberekeningModelB?: number;

  [key: string]: any;
}

export interface InvesteringenMetAftrek {
  /** BusinessAssetEnvironmentalEnergyInvestmentDescription */
  omschrijving: string;
  /** BusinessAssetEnvironmentalEnergyInvestmentFinancialYearAmount */
  totaleInvesteringInBoekjaar: number;
  /** BusinessAssetMaximumInvestmentAmount */
  maximaleInvesteringBedragBedrijfsMiddel?: number;
  /** yyyy-MM-dd, TaxEntitBusinessAssetEnvironmentalEnergyInvestmentFinancialYearAmountyJoiningDate */
  datumIngebruikname?: Date;
  /** BusinessAssetEnvironmentalEnergyInvestmentPaidThisFinancialYear */
  bedragBetaaldInBoekjaar?: number;
  /** BusinessAssetEnvironmentalEnergyInvestmentNotificationNumber */
  meldingsNummer?: string;
  /** BusinessAssetEnvironmentalInvestmentLetter */
  miaLetter?: string;
  claimKia: boolean;
  claimEia: boolean;
  claimMia: boolean;
  percentageAftrek?: number;
  berekendeAftrekPerInvestering?: number;
  eiaMiaDitJaar?: number;

  [key: string]: any;
}

export interface Jaarstukken {
  activa?: Activa;
  passiva?: Passiva;
  resultaat?: Resultaat;
  omzetBelastingDitBoekjaar?: number;
  omzetBelastingVorigBoekjaar?: number;
  omzetBelastingOudereBoekjaren?: number;

  [key: string]: any;
}

export interface ObjectVrijstellingMetBerekening {
  /** ISO 3166 */
  vestigingsland: string;
  /** ForeignBusinessProfitEuroFunctionalCurrency */
  buitenlandseWinst: number;
  /** LossBefore1January2012ToOvertake */
  inTeHalenVerliezen?: number;
  /** LossCessationForeignCompany */
  stakingsverlies?: number;
  /** ForeignBusinessProfitBalanceCumulative */
  saldoBuitenlandseOndernemingswinsten: number;
  objectVrijstellingDitLand?: number;
  cumulatieveObjectvrijstelling?: number;

  [key: string]: any;
}

export interface Passiva {
  /** PaidCalledUpCapitalFiscal */
  totaalGestortEnOpgevraagdKapitaalBegin?: number;
  /** PaidCalledUpCapitalFiscal */
  totaalGestortEnOpgevraagdKapitaalEind?: number;
  /** InformalCapitalFiscal */
  totaalInformeelKapitaalBegin?: number;
  /** InformalCapitalFiscal */
  totaalInformeelKapitaalEind?: number;
  /** SharePremiumFiscal */
  totaalAgioreserveBegin?: number;
  /** SharePremiumFiscal */
  totaalAgioreserveEind?: number;
  /** RetainedProfitsFiscal */
  totaalWinstreservesBegin?: number;
  /** RetainedProfitsFiscal */
  totaalWinstreservesEind?: number;
  /** EqualizationReserveCostsFiscal */
  totaalKostenEgalisatieReserveBegin?: number;
  /** EqualizationReserveCostsFiscal */
  totaalKostenEgalisatieReserveEind?: number;
  /** ReinvestmentReserveFiscal */
  totaalHerinvesteringsReserveBegin?: number;
  /** ReinvestmentReserveFiscal */
  totaalHerinvesteringsReserveEind?: number;
  /** CompartmentReserveTaxed */
  totaalCompartimenteringsreserveBegin?: number;
  /** CompartmentReserveTaxed */
  totaalCompartimenteringsreserveEind?: number;
  /** TaxReservesOtherFiscal */
  totaalOverigeReservesBegin?: number;
  /** TaxReservesOtherFiscal */
  totaalOverigeReservesEind?: number;
  totaalFiscaalVermogenBegin?: number;
  totaalFiscaalVermogenEind?: number;
  /** WarrantyProvisionFiscal */
  totaalGarantieVoorzieningenBegin?: number;
  /** WarrantyProvisionFiscal */
  totaalGarantieVoorzieningenEind?: number;
  /** ProvisionAnnuityPensionAndRightOfStanding */
  totaalPensioenVoorzieningenBegin?: number;
  /** ProvisionAnnuityPensionAndRightOfStanding */
  totaalPensioenVoorzieningenEind?: number;
  /** OldAgeObligation */
  totaalOudedagsvoorzieningenBegin?: number;
  /** OldAgeObligation */
  totaalOudedagsvoorzieningenEind?: number;
  /** ProvisionsOtherFiscal */
  totaalOverigeVoorzieningenBegin?: number;
  /** ProvisionsOtherFiscal */
  totaalOverigeVoorzieningenEind?: number;
  totaalVoorzieningenBegin?: number;
  totaalVoorzieningenEind?: number;
  /** ConvertibleLoansFiscal */
  totaalConvertiblesBegin?: number;
  /** ConvertibleLoansFiscal */
  totaalConvertiblesEind?: number;
  /** BondsFiscal */
  totaalObligatieleningenBegin?: number;
  /** BondsFiscal */
  totaalObligatieleningenEind?: number;
  /** LongTermDebtsGroupCompanies */
  totaalLanglopendeSchuldenGroepsmaatschappijenBegin?: number;
  /** LongTermDebtsGroupCompanies */
  totaalLanglopendeSchuldenGroepsmaatschappijenEind?: number;
  /** LongTermDebtsParticipatingInterestCompanies */
  totaalLanglopendeSchuldenParticipantenBegin?: number;
  /** LongTermDebtsParticipatingInterestCompanies */
  totaalLanglopendeSchuldenParticipantenEind?: number;
  /** PayablesCreditInstitutionFiscal */
  totaalLanglopendeSchuldenKredietinstellingenBegin?: number;
  /** PayablesCreditInstitutionFiscal */
  totaalLanglopendeSchuldenKredietinstellingenEind?: number;
  /** LongTermDebtsOther */
  totaalLanglopendeSchuldenOverigBegin?: number;
  /** LongTermDebtsOther */
  totaalLanglopendeSchuldenOverigEind?: number;
  totaalLanglopendeSchuldenBegin?: number;
  totaalLanglopendeSchuldenEind?: number;
  /** AccountsPayableSuppliersTradeCreditors */
  totaalKortlopendeSchuldenCrediteurenBegin?: number;
  /** AccountsPayableSuppliersTradeCreditors */
  totaalKortlopendeSchuldenCrediteurenEind?: number;
  /** ValueAddedTaxPayablesFiscal */
  totaalKortlopendeSchuldenOmzetbelastingBegin?: number;
  /** ValueAddedTaxPayablesFiscal */
  totaalKortlopendeSchuldenOmzetbelastingEind?: number;
  /** WageTaxDebt */
  totaalKortlopendeSchuldenLoonheffingenBegin?: number;
  /** WageTaxDebt */
  totaalKortlopendeSchuldenLoonheffingenEind?: number;
  /** ShortTermDebtsGroupCompanies */
  totaalKortlopendeSchuldenGroepsmaatschappijenBegin?: number;
  /** ShortTermDebtsGroupCompanies */
  totaalKortlopendeSchuldenGroepsmaatschappijenEind?: number;
  /** ShortTermDebtsParticipatingInterestCompanies */
  totaalKortlopendeSchuldenParticipantenBegin?: number;
  /** ShortTermDebtsParticipatingInterestCompanies */
  totaalKortlopendeSchuldenParticipantenEind?: number;
  /** ShortTermDebtsOther */
  totaalKortlopendeSchuldenOverigBegin?: number;
  /** ShortTermDebtsOther */
  totaalKortlopendeSchuldenOverigEind?: number;
  totaalKortlopendeSchuldenBegin?: number;
  totaalKortlopendeSchuldenEind?: number;
  totaalPassivaBegin?: number;
  totaalPassivaEind?: number;

  [key: string]: any;
}

export interface ServiceBerichtEntity {
  id?: number;
  year?: string;
  clientName?: string;
  type?: string;
  aanslagnummer?: string;
  aanslagdatum?: Date;
  sstAdminId?: string;
  sstRelationId?: string;
  sstPrimaryAdminId?: string;
  serviceBerichtXbrl?: string;
  isGecontroleerd?: boolean;
  gecontroleerd?: boolean;

  [key: string]: any;

}

export interface Resultaat {
  /** TurnoverNetFiscal */
  nettoOmzet?: number;
  /** StockAndWorkInProgressChangeFiscal */
  wijzigingOnderhandenWerk?: number;
  /** CapitalizedProductionOwnBusinessFiscal */
  geactiveerdeProductieEigenBedrijf?: number;
  /** RevenuesOtherFiscal */
  overigeOpbrengsten?: number;
  /** BusinessRevenuesFiscalTotal */
  totaalBedrijfsopbrengsten?: number;
  /** RawAncillaryMaterialsPurchasePriceSalesFiscal */
  inkoopwaardeVerkopen?: number;
  /** OutsourcedWorkCostsAndOtherExternalCostsFiscal */
  kostenUitbesteedWerk?: number;
  /** WagesSalariesFiscal */
  lonenEnSalarissen?: number;
  /** SocialSecurityCostsFiscal */
  socialeLasten?: number;
  /** PensionCostsFiscal */
  pensioenLasten?: number;
  /** PersonnelCostsOtherFiscal */
  overigePersoneelskosten?: number;
  /** BenefitsAndWageSubsidiesReceivedFiscal */
  ontvangenVergoedingenEnSubsidies?: number;
  /** GoodwillDepreciationFiscal */
  afschrijvingenGoodwill?: number;
  /** IntangibleFixedAssetsOtherDepreciation */
  afschrijvingOverigeImmaterieleActiva?: number;
  /** CompanyBuildingsDepreciationFiscal */
  afschrijvingenGebouwen?: number;
  /** MachineryDepreciationFiscal */
  afschrijvingenMachines?: number;
  /** TangibleFixedAssetsOtherDepreciation */
  afschrijvingenOverig?: number;
  /** CarAndTransportCostsFiscal */
  autoEnTransportKosten?: number;
  /** AccommodationCostsFiscal */
  huisvestingsKosten?: number;
  /** MaintenanceOtherTangibleFixedAssetsFiscal */
  onderhoudsKosten?: number;
  /** SalesCostsFiscal */
  verkoopKosten?: number;
  /** CostOtherFiscal */
  overigeKosten?: number;
  /** BusinessExpenditureFiscalTotal */
  totaalBedrijfslasten?: number;
  /** TurnoverNetFiscal */
  financieleBaten?: number;
  /** TurnoverNetFiscal */
  financieleLasten?: number;
  /** BusinessFinanciaResultFiscalTotal */
  totaalFinancieleBatenEnLasten?: number;
  /** NormalBusinessActivitiesBusinessResultTotalFiscal */
  totaalResultaatUitGewoneBedrijfsuitoefening?: number;
  /** ParticipatingInterestResultTotalFiscal */
  resultaatDeelnemingen?: number;
  /** ExtraordinaryIncomeBusiness */
  buitengewoneBaten?: number;
  /** ExtraordinaryExpenditureBusiness */
  buitengewoneLasten?: number;
  /** ExtraordinaryBusinessResultsFiscal */
  buitengewoneResultaten?: number;
  /** BalanceProfitCalculationForTaxPurposesFiscal */
  saldoFiscaleWinstberekening?: number;

  [key: string]: any;
}

export interface VpbBerekening {
  naamVennootschap?: string;
  jaarstukken?: Jaarstukken;
  fiscaleWinst?: FiscaleWinst;
  belastbareWinst?: BelastbareWinst;
  belastbaarBedrag?: BelastbaarBedrag;
  verrekenbareBronbelasting?: Bronbelastingen;
  belasting?: Belasting;
  totaalVermogenssprongMoederBijVoeging?: number;
  berekendeRenteAftrekBeperking?: BerekendeRenteAftrekBeperking;
  investeringslijstMetAftrek?: InvesteringenMetAftrek[];
  zeescheepvaartlijstMetBerekeningen?: ZeescheepvaartMetBerekening[];
  objectVrijstellingMetBerekeningen?: ObjectVrijstellingMetBerekening[];
  hfloActiviteitenOverzicht?: HFLOActiviteitenOverzicht;

  [key: string]: any;
}

export interface ZeescheepvaartMetBerekening {
  /** WorksInNetherlandsForOtherParty */
  verrichtBeheerVoorAnder: boolean;
  /** ShipName */
  naamSchip: string;
  /** CountryCodeFlagShip */
  landcodeSchip: string;
  /** ProfitRatePerShipPerDay */
  nettoTonnageSchip: number;
  /** ShipExploitationDaysCount */
  aantalDagenExploitatie: number;
  /** ShipParticipatingInterestPercentage */
  percentageDeelnameInSchip: number;
  /** ShipHasDutchFlagAfter2008 */
  schipVaartNa2008OnderNLVlagEnTonnageregime?: boolean;
  /** ShipWas5YearsPriorToDutchFlagNotRegisteredInEUorEER */
  schipVoerin5JaarVoorTonnageOnderVlagDerdeLand?: boolean;
  /** ShipProfitFinancialStatement */
  winstVoorDitSchipVolgensJaarrekening?: number;
  tarief?: number;
  winstPerSchip?: number;

  [key: string]: any;
}

interface MumaRequest {
  bsn: string;
  dienst: MumaRequestDienst;
  activatieToken?: string;
  aanleverkenmerk?: string;
  mutatieType: MumaRequestMutatieType;
  gemachtigdeIdentiteitsNummer: string;

  [key: string]: any;
}

export interface FormDataContentDisposition {
  type?: string;
  parameters?: { [key: string]: string; };
  fileName?: string;
  creationDate?: Date;
  modificationDate?: Date;
  readDate?: Date;
  size?: number;
  name?: string;

  [key: string]: any;
}

export enum ClientEntityMachtigingStatus {
  ONTVANGEN = "ONTVANGEN",
  IN_BEHANDELING = "IN_BEHANDELING",
  AFGEKEURD = "AFGEKEURD",
  ACTIEF = "ACTIEF",
  NIET_ACTIEF = "NIET_ACTIEF",
  CONTROLEREN = "CONTROLEREN",
  UNKNOWN = "UNKNOWN",
}

export enum ClientEntityMachtigingStatusOb {
  ONTVANGEN = "ONTVANGEN",
  IN_BEHANDELING = "IN_BEHANDELING",
  AFGEKEURD = "AFGEKEURD",
  ACTIEF = "ACTIEF",
  NIET_ACTIEF = "NIET_ACTIEF",
  CONTROLEREN = "CONTROLEREN",
  UNKNOWN = "UNKNOWN",
}

export enum ClientEntityMachtigingStatusTsg {
  ONTVANGEN = "ONTVANGEN",
  IN_BEHANDELING = "IN_BEHANDELING",
  AFGEKEURD = "AFGEKEURD",
  ACTIEF = "ACTIEF",
  NIET_ACTIEF = "NIET_ACTIEF",
  CONTROLEREN = "CONTROLEREN",
  UNKNOWN = "UNKNOWN",
}

export enum OpvangPeriodesOpvangVorm {
  KINDERCENTRUM = "KINDERCENTRUM",
  GASTOUDEROPVANG = "GASTOUDEROPVANG",
}

export enum OpvangPeriodesSoortOpvang {
  DAGOPVANG = "DAGOPVANG",
  BUITENSCHOOLSE_OPVANG = "BUITENSCHOOLSE_OPVANG",
}

export enum VerzendGegevensActie {
  AANVRAAG_ZORGTOESLAG = "AANVRAAG_ZORGTOESLAG",
  STOP_ZORGTOESLAG = "STOP_ZORGTOESLAG",
  AANVRAAG_KGB = "AANVRAAG_KGB",
  STOP_KGB = "STOP_KGB",
  AANVRAAG_HUURTOESLAG = "AANVRAAG_HUURTOESLAG",
  STOP_HUURTOESLAG = "STOP_HUURTOESLAG",
  WIJZIG_HUURTOESLAG = "WIJZIG_HUURTOESLAG",
  AANVRAAG_KOT = "AANVRAAG_KOT",
  STOP_KOT = "STOP_KOT",
  WIJZIG_KOT = "WIJZIG_KOT",
  WIJZIG_TOETINGSINKOMEN_AANGEVER = "WIJZIG_TOETINGSINKOMEN_AANGEVER",
  WIJZIG_TOETINGSINKOMEN_PARTNER = "WIJZIG_TOETINGSINKOMEN_PARTNER",
}

export enum EffectenSoortEffecten {
  AANDELEN_BEURS_GENOTEERD = "AANDELEN_BEURS_GENOTEERD",
  AANDELEN_NIET_BEURSGENOTEERD = "AANDELEN_NIET_BEURSGENOTEERD",
  OBLIGATIES = "OBLIGATIES",
  OVERIG = "OVERIG",
}

export enum OndernemingSBRechtsvorm {
  BV = "BV",
  CV = "CV",
  EENMANSZAAK = "EENMANSZAAK",
  MAATSCHAP = "MAATSCHAP",
  NV = "NV",
  VOF = "VOF",
  OVERIG = "OVERIG",
}

export enum PUUitkeringsPeriode {
  JAAR = "JAAR",
  KWARTAAL = "KWARTAAL",
  MAAND = "MAAND",
  WEEK = "WEEK",
}

export enum RoerendeZaakSoortRoerendeZaak {
  INBOEDEL = "INBOEDEL",
  VERVOERSMIDDELEN = "VERVOERSMIDDELEN",
  KUNST_EN_ANTIEK = "KUNST_EN_ANTIEK",
  OVERIG = "OVERIG",
}

export enum SchenkingRelatieBegiftigdeMetSchenker {
  PARTNER = "PARTNER",
  SAMENWONEND = "SAMENWONEND",
  EX_PARTNER = "EX_PARTNER",
  KIND = "KIND",
  STIEFKIND = "STIEFKIND",
  PLEEGKIND = "PLEEGKIND",
  KLEINKIND = "KLEINKIND",
  OVERIG = "OVERIG",
}

export enum AanslagIbAanslagSoort {
  EERSTE_VOORLOPIGE_AANSLAG = "EERSTE_VOORLOPIGE_AANSLAG",
  VOORLOPIGE_AANSLAG = "VOORLOPIGE_AANSLAG",
  DEFINITIEVE_AANSLAG = "DEFINITIEVE_AANSLAG",
  VERMINDERING_DEFINITIEVE_AANSLAG = "VERMINDERING_DEFINITIEVE_AANSLAG",
  VERMINDERING_NAVORDERINGSAANSLAG = "VERMINDERING_NAVORDERINGSAANSLAG",
  VERMINDERING_DEFINITIEVE_AANSLAG_NA_MIDDELING = "VERMINDERING_DEFINITIEVE_AANSLAG_NA_MIDDELING",
  VERMINDERING_DEFINITIEVE_AANSLAG_NA_CARRY_BACK = "VERMINDERING_DEFINITIEVE_AANSLAG_NA_CARRY_BACK",
  NAVORDERINGSAANSLAG = "NAVORDERINGSAANSLAG",
  VERMINDERING_NAVORDERINGAANSLAG_NA_MIDDELING = "VERMINDERING_NAVORDERINGAANSLAG_NA_MIDDELING",
}

export enum AangeverBurgerlijkeStaat {
  GEHUWD = "GEHUWD",
  SAMENWONEND = "SAMENWONEND",
  ALLEENSTAAND = "ALLEENSTAAND",
  SITUATIE_GEWIJZIGD = "SITUATIE_GEWIJZIGD",
}

export enum AangeverSamenwoonSituatie {
  NOTARIEEL_SAMENLEVINGS_CONTRACT = "NOTARIEEL_SAMENLEVINGS_CONTRACT",
  SAMEN_KIND = "SAMEN_KIND",
  KIND_ANDER_ERKEND = "KIND_ANDER_ERKEND",
  SAMEN_EIGENAAR_WONING = "SAMEN_EIGENAAR_WONING",
  PARTNER_PENSIOENREGELING = "PARTNER_PENSIOENREGELING",
  MINDERJARIG_KIND_OP_WOONADRES = "MINDERJARIG_KIND_OP_WOONADRES",
  VORIG_JAAR_FISCAAL_PARTNER = "VORIG_JAAR_FISCAAL_PARTNER",
  GEEN = "GEEN",
}

export enum DieetAandoening {
  GROEIACHTERSTAND_KINDEREN_ENGERGIEVERRIJKT_MET_EIWITVERRIJKT = "GROEIACHTERSTAND_KINDEREN_ENGERGIEVERRIJKT_MET_EIWITVERRIJKT",
  GROEIACHTERSTAND_KINDEREN_ENERGIEVERRIJKT = "GROEIACHTERSTAND_KINDEREN_ENERGIEVERRIJKT",
  ONDERVOEDING_ENGERGIEVERRIJKT_MET_EIWITVERRIJKT = "ONDERVOEDING_ENGERGIEVERRIJKT_MET_EIWITVERRIJKT",
  ONDERVOEDING_ENERGIEVERRIJKT = "ONDERVOEDING_ENERGIEVERRIJKT",
  ONDERVOEDING_EIWITVERRIJKT = "ONDERVOEDING_EIWITVERRIJKT",
  DUCUBITUS_ENGERGIEVERRIJKT_MET_EIWITVERRIJKT = "DUCUBITUS_ENGERGIEVERRIJKT_MET_EIWITVERRIJKT",
  DUCUBITUS_EIWITVERRIJKT = "DUCUBITUS_EIWITVERRIJKT",
  HARTFALEN_NATRIUMBEPERT = "HARTFALEN_NATRIUMBEPERT",
  AIDS_ENGERGIEVERRIJKT_MET_EIWITVERRIJKT = "AIDS_ENGERGIEVERRIJKT_MET_EIWITVERRIJKT",
  COPD_ENGERGIEVERRIJKT_MET_EIWITVERRIJKT = "COPD_ENGERGIEVERRIJKT_MET_EIWITVERRIJKT",
  COPD_ENERGIEVERRIJKT = "COPD_ENERGIEVERRIJKT",
  DUMPINGSYNDROOMN_LACTOSEBEPERKT_LACTOSEVRIJ = "DUMPINGSYNDROOMN_LACTOSEBEPERKT_LACTOSEVRIJ",
  CHRONISCHE_PANCREATITIS_ENGERGIEVERRIJKT_MET_EIWITVERRIJKT = "CHRONISCHE_PANCREATITIS_ENGERGIEVERRIJKT_MET_EIWITVERRIJKT",
  CYSTIC_FIBROSE_ENGERGIEVERRIJKT_MET_EIWITVERRIJKT = "CYSTIC_FIBROSE_ENGERGIEVERRIJKT_MET_EIWITVERRIJKT",
  CYSTIC_FIBROSE_ENERGIEVERRIJKT = "CYSTIC_FIBROSE_ENERGIEVERRIJKT",
  COELIAKI_GLUTENVRIJ = "COELIAKI_GLUTENVRIJ",
  COEKIALI_GLUTENVRIJ_IN_COMBINATIE_MET_LACTOSEVRIJ_LACTOSEBEPEKT = "COEKIALI_GLUTENVRIJ_IN_COMBINATIE_MET_LACTOSEVRIJ_LACTOSEBEPEKT",
  SHORT_BOWEL_EMERGIEVERRIJKT_ICM_MCT_VETVERRIJKT = "SHORT_BOWEL_EMERGIEVERRIJKT_ICM_MCT_VETVERRIJKT",
  SHORT_BOWEL_EMERGIEVERRIJKT_ICM_MCT_VETVERRIJKT_MET_VITAMINEPREPARAAT = "SHORT_BOWEL_EMERGIEVERRIJKT_ICM_MCT_VETVERRIJKT_MET_VITAMINEPREPARAAT",
  PDS_FODMAP = "PDS_FODMAP",
  LACTOSE_INTOLERANTIE_LACTOSEVRIJ_LACTOSEBEPERKT = "LACTOSE_INTOLERANTIE_LACTOSEVRIJ_LACTOSEBEPERKT",
  LEVERCIRROSE_EIWITVERRIJKT = "LEVERCIRROSE_EIWITVERRIJKT",
  OVERIGE_MAAG_LEVER_DARMZIEKTEN_ENEGRIEVERRIJKT = "OVERIGE_MAAG_LEVER_DARMZIEKTEN_ENEGRIEVERRIJKT",
  OVERIGE_MAAG_LEVER_DARMZIEKTEN_ENEGRIEVERRIJKT_MET_VITAMINEPREPARAAT = "OVERIGE_MAAG_LEVER_DARMZIEKTEN_ENEGRIEVERRIJKT_MET_VITAMINEPREPARAAT",
  OVERIGE_MAAG_LEVER_DARMZIEKTEN_ENEGRIEVERRIJKT_ICM_EIWITVERRIJKT = "OVERIGE_MAAG_LEVER_DARMZIEKTEN_ENEGRIEVERRIJKT_ICM_EIWITVERRIJKT",
  OVERIGE_MAAG_LEVER_DARMZIEKTEN_ENEGRIEVERRIJKT_ICM_EIWITVERRIJKT_EN_LACTOSEBEPERKT = "OVERIGE_MAAG_LEVER_DARMZIEKTEN_ENEGRIEVERRIJKT_ICM_EIWITVERRIJKT_EN_LACTOSEBEPERKT",
  HYPERCHOLESTROLEMIE_VERZADIGD_VETBEPERKT_ICM_FYTO_PLANTENSTEROLENVERRIJKT = "HYPERCHOLESTROLEMIE_VERZADIGD_VETBEPERKT_ICM_FYTO_PLANTENSTEROLENVERRIJKT",
  VETSTOFWISELINGSSTOORNIS_VETBEPERKT_ICM_MCT_VETVERRIJKT = "VETSTOFWISELINGSSTOORNIS_VETBEPERKT_ICM_MCT_VETVERRIJKT",
  FRUCTOSE_INTOLERANTIE_FRUCTOSEBEPERKT = "FRUCTOSE_INTOLERANTIE_FRUCTOSEBEPERKT",
  GALACTOSEMIE_GALACTOSEBEPERKT_GALACTOSEVRIJ = "GALACTOSEMIE_GALACTOSEBEPERKT_GALACTOSEVRIJ",
  SACHARALE_INSOMALTASE_DEFICIENTIE_STERK_SACHAROSEBEPERKT_ICM_MALTOSEBEPERKT = "SACHARALE_INSOMALTASE_DEFICIENTIE_STERK_SACHAROSEBEPERKT_ICM_MALTOSEBEPERKT",
  EIWITSTOFWISSELINGSSTOORNIS_STERK_EIWITBEPERKT = "EIWITSTOFWISSELINGSSTOORNIS_STERK_EIWITBEPERKT",
  GLYCOGEENSTAPELINGSZIEKTE_SACHAROSEBEPERKT_FRUCTOSEBEPERKT_LACTOSEBEPERKT_EN_VETBEPERKT = "GLYCOGEENSTAPELINGSZIEKTE_SACHAROSEBEPERKT_FRUCTOSEBEPERKT_LACTOSEBEPERKT_EN_VETBEPERKT",
  INSULINERESISTENTIE_STERK_KOOLHYDRAATBEPERKT_ZONDER_ENERGIEBEPERKING = "INSULINERESISTENTIE_STERK_KOOLHYDRAATBEPERKT_ZONDER_ENERGIEBEPERKING",
  NIERZIEKTEN_NATRIUMBEPERKT = "NIERZIEKTEN_NATRIUMBEPERKT",
  CHRONISCHE_NIERINSUFFIENTIE_MET_HEMODIALYSE_EIWTITVERRIJKT_ICM_NATRIUMBEPERKT = "CHRONISCHE_NIERINSUFFIENTIE_MET_HEMODIALYSE_EIWTITVERRIJKT_ICM_NATRIUMBEPERKT",
  NEFROTISCH_SYNDROOM_NATRIUMBEPERKT = "NEFROTISCH_SYNDROOM_NATRIUMBEPERKT",
  ONCOLOGIE_ENGERGIEVERRIJKT_ICM_EIWITVERRIJKT = "ONCOLOGIE_ENGERGIEVERRIJKT_ICM_EIWITVERRIJKT",
  ONCOLOGIE_ENGERGIEVERRIJKT = "ONCOLOGIE_ENGERGIEVERRIJKT",
  VOEDSELOVERGEVOELIGHEID_KOEMELKEIWITVRIJ = "VOEDSELOVERGEVOELIGHEID_KOEMELKEIWITVRIJ",
  VOEDSELOVERGEVOELIGHEID_KIPPENEI_EIWITVRIJ = "VOEDSELOVERGEVOELIGHEID_KIPPENEI_EIWITVRIJ",
  VOEDSELOVERGEVOELIGHEID_LACTOSEBEPERKT_LACTOSEVRIJ = "VOEDSELOVERGEVOELIGHEID_LACTOSEBEPERKT_LACTOSEVRIJ",
  VOEDSELOVERGEVOELIGHEID_TARWEVRIJ = "VOEDSELOVERGEVOELIGHEID_TARWEVRIJ",
  VOEDSELOVERGEVOELIGHEID_TARWEVRIJ_ICM_KIPPENEI_EIWITVRIJ = "VOEDSELOVERGEVOELIGHEID_TARWEVRIJ_ICM_KIPPENEI_EIWITVRIJ",
  VOEDSELOVERGEVOELIGHEID_KOEMELKEIWITVRIJ_ICM_KIPPENEI_EIWITVRIJ = "VOEDSELOVERGEVOELIGHEID_KOEMELKEIWITVRIJ_ICM_KIPPENEI_EIWITVRIJ",
  VOEDSELOVERGEVOELIGHEID_KOEMELKEIWITVRIJ_ICM_SOJA_EIWITVRIJ = "VOEDSELOVERGEVOELIGHEID_KOEMELKEIWITVRIJ_ICM_SOJA_EIWITVRIJ",
  VOEDSELOVERGEVOELIGHEID_KOEMELKEIWITVRIJ_ICM_KIPPENEI_EIWITVRIJ_EN_SOJA_EIWITVRIJ = "VOEDSELOVERGEVOELIGHEID_KOEMELKEIWITVRIJ_ICM_KIPPENEI_EIWITVRIJ_EN_SOJA_EIWITVRIJ",
  VOEDSELOVERGEVOELIGHEID_KOEMELKEIWITVRIJ_ICM_KIPPENEI_EIWITVRIJ_EN_SOJA_EIWITVRIJ_EN_TARWEVRIJ = "VOEDSELOVERGEVOELIGHEID_KOEMELKEIWITVRIJ_ICM_KIPPENEI_EIWITVRIJ_EN_SOJA_EIWITVRIJ_EN_TARWEVRIJ",
  VOEDSELOVERGEVOELIGHEID_KOEMELKEIWITVRIJ_ICM_GLUTENVRIJ_EN_AL_DAN_NIET_TARWEVRIJ = "VOEDSELOVERGEVOELIGHEID_KOEMELKEIWITVRIJ_ICM_GLUTENVRIJ_EN_AL_DAN_NIET_TARWEVRIJ",
  BRANDWONDEN_ENGERIEVERRIJKT_IN_COMBINATIE_MET_EIWITVERRIJKT = "BRANDWONDEN_ENGERIEVERRIJKT_IN_COMBINATIE_MET_EIWITVERRIJKT",
  LYMFE_LEKKAGE_EIWITVERRIJKT_IN_COMBINATIE_MET_STERK_LCT_VETBEPERKT_EN_MCT_VETVERRIJKT = "LYMFE_LEKKAGE_EIWITVERRIJKT_IN_COMBINATIE_MET_STERK_LCT_VETBEPERKT_EN_MCT_VETVERRIJKT",
  EPILEPSIE_STERK_KOOLHYDRAADBEPERKT_ICM_EIWITBEPERKT_EN_VETVERRIJKT = "EPILEPSIE_STERK_KOOLHYDRAADBEPERKT_ICM_EIWITBEPERKT_EN_VETVERRIJKT",
}

export enum JaarrekeningVenWKostensoort {
  INKOOPKOSTEN = "INKOOPKOSTEN",
  PERSONEELSKOSTEN = "PERSONEELSKOSTEN",
  HUISVESTINGSKOSTEN = "HUISVESTINGSKOSTEN",
  AFSCHRIJVINGEN = "AFSCHRIJVINGEN",
  AUTOKOSTEN = "AUTOKOSTEN",
  VERKOOPKOSTEN = "VERKOOPKOSTEN",
  OVERIGE = "OVERIGE",
}

export enum LeningAanwending {
  WONING_NEDERLAND = "WONING_NEDERLAND",
  WONING_BUITENLAND = "WONING_BUITENLAND",
  OVERIG = "OVERIG",
}

export enum LeningGeldVerstrekker {
  BANK = "BANK",
  PENSIOENFONDS = "PENSIOENFONDS",
  VERZEKERAAR = "VERZEKERAAR",
  NIET_ADMINISTRATIEPLICHTIGE = "NIET_ADMINISTRATIEPLICHTIGE",
}

export enum LeningAflossingsMethode {
  ANNUITAIR = "ANNUITAIR",
  LINEAIR = "LINEAIR",
  OVERIG = "OVERIG",
}

export enum Ondernemingsvorm {
  EENMANSZAAK = "EENMANSZAAK",
  VOF = "VOF",
  MAATSCHAP = "MAATSCHAP",
  CV = "CV",
}

export enum OnroerendeZaakLeegstand {
  VERKOOP = "VERKOOP",
  AANBOUW = "AANBOUW",
  EX = "EX",
  UITZENDING = "UITZENDING",
  VERZORGINGSTEHUIS = "VERZORGINGSTEHUIS",
}

export enum OverigeBezittingSoort {
  PREMIEDEPOT = "PREMIEDEPOT",
  BOUWDEPOT = "BOUWDEPOT",
  VORDERING = "VORDERING",
  CONTANT_GELD = "CONTANT_GELD",
  PERIODIEKE_UITKERING = "PERIODIEKE_UITKERING",
  SANCTIEWAARDE_NETTO_PENSIOEN = "SANCTIEWAARDE_NETTO_PENSIOEN",
  KAPITAALVERZEKERING = "KAPITAALVERZEKERING",
  OVERIG = "OVERIG",
  CRYPTO= "CRYPTO"
}

export enum PrestatiebeursTerugBetaaldOnderwijsJaar {
  JAAR2014 = "JAAR2014",
  JAAR2013 = "JAAR2013",
  JAAR2012 = "JAAR2012",
  JAAR2011 = "JAAR2011",
  JAAR2010 = "JAAR2010",
  JAAR2009 = "JAAR2009",
  JAAR2008 = "JAAR2008",
  JAAR2007 = "JAAR2007",
  JAAR2006 = "JAAR2006",
  JAAR2005 = "JAAR2005",
  JAAR2004 = "JAAR2004",
  JAAR2003 = "JAAR2003",
  JAAR2002 = "JAAR2002",
}

export enum RijksmonumentLeegstand {
  VERKOOP = "VERKOOP",
  AANBOUW = "AANBOUW",
  EX = "EX",
  UITZENDING = "UITZENDING",
  VERZORGINGSTEHUIS = "VERZORGINGSTEHUIS",
}

export enum VerhuurdOfVerpachtStatus {
  VERHUURD = "VERHUURD",
  VERPACHT = "VERPACHT",
}

export enum ICPLandcode {
  AT = "AT",
  BE = "BE",
  BG = "BG",
  CY = "CY",
  CZ = "CZ",
  DE = "DE",
  DK = "DK",
  EE = "EE",
  EL = "EL",
  ES = "ES",
  FI = "FI",
  FR = "FR",
  GB = "GB",
  HR = "HR",
  HU = "HU",
  IE = "IE",
  IT = "IT",
  LT = "LT",
  LU = "LU",
  LV = "LV",
  MT = "MT",
  NL = "NL",
  PL = "PL",
  PT = "PT",
  RO = "RO",
  SE = "SE",
  SI = "SI",
  SK = "SK",
}

export enum ICPSoort {
  INTRACOMMUNAUTAIRE_LEVERING = "INTRACOMMUNAUTAIRE_LEVERING",
  INTRACOMMUNAUTAIRE_DIENST = "INTRACOMMUNAUTAIRE_DIENST",
  INTRACOMMUNAUTAIRE_ABC_LEVERING = "INTRACOMMUNAUTAIRE_ABC_LEVERING",
  CORRECTIE_INTRACOMMUNAUTAIRE_LEVERING = "CORRECTIE_INTRACOMMUNAUTAIRE_LEVERING",
  CORRECTIE_INTRACOMMUNAUTAIRE_DIENST = "CORRECTIE_INTRACOMMUNAUTAIRE_DIENST",
  CORRECTIE_INTRACOMMUNAUTAIRE_ABC_LEVERING = "CORRECTIE_INTRACOMMUNAUTAIRE_ABC_LEVERING",
}

export enum AanslagVpbAanslagSoort {
  VOORLOPIGE_AANSLAG = "VOORLOPIGE_AANSLAG",
  DEFINITIEVE_AANSLAG = "DEFINITIEVE_AANSLAG",
  NAVORDERING = "NAVORDERING",
  VERMINDERING_VOORLOPIGE_AANSLAG = "VERMINDERING_VOORLOPIGE_AANSLAG",
  VERMINDERING_VOORLOPIGE_AANSLAG_BERICHT_GEMACHTIGDE = "VERMINDERING_VOORLOPIGE_AANSLAG_BERICHT_GEMACHTIGDE",
  VERMINDERING_DEFINITIEVE_AANSLAG = "VERMINDERING_DEFINITIEVE_AANSLAG",
  VERMINDERING_DEFINITIEVE_AANSLAG_BERICHT_GEMACHTIGDE = "VERMINDERING_DEFINITIEVE_AANSLAG_BERICHT_GEMACHTIGDE",
  VERMINDERING_NAVORDERINGSAANSLAG = "VERMINDERING_NAVORDERINGSAANSLAG",
  VERMINDERING_NAVORDERINGSAANSLAG_BERICHT_GEMACHTIGDE = "VERMINDERING_NAVORDERINGSAANSLAG_BERICHT_GEMACHTIGDE",
  VOORLOPIGE_TERUGGAVE_IVM_VERLIES = "VOORLOPIGE_TERUGGAVE_IVM_VERLIES",
  INVORDEREN_VOORLOPIGE_TERUGGAVE = "INVORDEREN_VOORLOPIGE_TERUGGAVE",
}

export enum AanslagZwvAanslagSoort {
  EERSTE_VOORLOPIGE_AANSLAG = "EERSTE_VOORLOPIGE_AANSLAG",
  VOORLOPIGE_AANSLAG = "VOORLOPIGE_AANSLAG",
  DEFINITIEVE_AANSLAG = "DEFINITIEVE_AANSLAG",
  VERMINDERING_DEFINITIEVE_AANSLAG = "VERMINDERING_DEFINITIEVE_AANSLAG",
  VERMINDERING_NAVORDERINGSAANSLAG = "VERMINDERING_NAVORDERINGSAANSLAG",
  NAVORDERINGSAANSLAG = "NAVORDERINGSAANSLAG",
}

export enum PdfRequestType {
  VPB = "VPB",
  IB = "IB",
  BTW = "BTW",
  TSL = "TSL",
  ZVW = "ZVW",
  ICP = "ICP",
  BZW = "BZW",
  DB = "DB",
  SB = 'SB',
  LB = 'LB',
  SUPPLETIE = "SUPPLETIE"
}

export enum PdfRequestOptie {
  GeheleRapport = "GeheleRapport",
  Jaarstukken = "Jaarstukken",
  JaarstukkenEnBerekeningen = "JaarstukkenEnBerekeningen",
  Berekeningen = "Berekeningen",
  Specificaties = "Specificaties",
  Aanbiedingsbrief = "Aanbiedingsbrief",
  Salarisspecificatie = "Salarisspecificatie",
  AlleSalarisspecificaties = "AlleSalarisspecificaties",
  Loonaangifte = "Loonaangifte",
  MemoriaalBoeking = "MemoriaalBoeking",
  Loonstaat = "Loonstaat",
  NettoLonen = "NettoLonen"
}

export enum PdfRequestSoort {
  Aangifte = "Aangifte",
  Verzoek = "Verzoek",
  Aanslag = "Aanslag",
  Beschikking = "Beschikking",
  Bezwaar = "Bezwaar",
  Opgaaf = "Opgaaf",
  Via = "Via",
  Werknemer = "Werknemer",
  Werkgever = "Werkgever"
}

export enum UitstelGegevensSoortUitstelVerzoek {
  UITSTELVERZOEK_BECONREGELING = "UITSTELVERZOEK_BECONREGELING",
  VERZOEK_BIJZONDER_UITSTEL = "VERZOEK_BIJZONDER_UITSTEL",
  VERZOEK_INCIDENTEEL_UITSTEL = "VERZOEK_INCIDENTEEL_UITSTEL",
  VERZOEK_INDIVIDUEEL_UITSTEL = "VERZOEK_INDIVIDUEEL_UITSTEL",
  INITIEEL_UITSTEL = "INITIEEL_UITSTEL",
  AANVULLEND_UITSTEL = "AANVULLEND_UITSTEL",
  AFMELDEN_UITSTEL = "AFMELDEN_UITSTEL",
}

export enum UitstelGegevensBelastingmiddel {
  INKOMSTENBELASTING = "INKOMSTENBELASTING",
  VENNOOTSCHAPSBELASTING = "VENNOOTSCHAPSBELASTING",
}

export enum BtwOverzichtFrequentie {
  MAAND = "MAAND",
  KWARTAAL = "KWARTAAL",
  JAAR = "JAAR",
}

enum MumaRequestDienst {
  SBA_IH_2019 = "SBA_IH_2019",
  SBA_IH_2020 = "SBA_IH_2020",
  SBA_IH_2021 = "SBA_IH_2021",
  SBA_IH_2022 = "SBA_IH_2022",
  VIA_2020 = "VIA_2020",
  VIA_2021 = "VIA_2021",
  VIA_2022 = "VIA_2022",
  VIA_2023 = "VIA_2023",
  SBA_OB_2020 = "SBA_OB_2020",
  SBA_OB_2021 = "SBA_OB_2021",
  SBA_OB_2022 = "SBA_OB_2022",
  SBA_VpB_2019 = "SBA_VpB_2019",
  SBA_VpB_2020 = "SBA_VpB_2020",
  SBA_VpB_2021 = "SBA_VpB_2021",
  SBA_VpB_2022 = "SBA_VpB_2022",
  SBA_TSG_2019 = "SBA_TSG_2019",
  SBA_TSG_2020 = "SBA_TSG_2020",
  SBA_TSG_2021 = "SBA_TSG_2021",
  SBA_TSG_2022 = "SBA_TSG_2022",
  Beconuitstel_2020 = "Beconuitstel_2020",
  Beconuitstel = "Beconuitstel",
  DoMa_IH = "DoMa_IH",
  DoMa_OB = "DoMa_OB",
  DoMa_VpB = "DoMa_VpB",
  DoMa_TSG = "DoMa_TSG",
}

enum MumaRequestMutatieType {
  Activeren = "activeren",
  Opvoeren = "opvoeren",
  Intrekken = "intrekken",
  Via_verzoek = "via_verzoek",
}

export interface FileResponse {
  data: Blob;
  status: number;
  fileName?: string;
  headers?: { [name: string]: any };
}

export class SwaggerException extends Error {
  override message: string;
  status: number;
  response: string;
  headers: { [key: string]: any; };
  result: any;

  constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
    super();

    this.message = message;
    this.status = status;
    this.response = response;
    this.headers = headers;
    this.result = result;
  }

  protected isSwaggerException = true;

  static isSwaggerException(obj: any): obj is SwaggerException {
    return obj.isSwaggerException === true;
  }
}

export interface MenuInterface {
  value: number,
  id: string,
  label: string;
  visible: boolean;
  gezamenlijk?: boolean;
  pageMapping?: string;
  subonderdelen?: SubOnderdeel[];
}

export interface SubOnderdeel {
  label: string;
  pageMapping: string;
  visible: boolean;
  value: number;
  subsubonderdelen?: SubSubOnderdeel[];
}

export interface SubSubOnderdeel {
  label: string;
  pageMapping: string;
  visible: boolean;
  value: number;
}

export interface BalansTotalen {
  goodwill: number;
  overigeImmaterieleActiva: number;
  gebouwenEnTerreinen: number;
  machinesEnInstallaties: number;
  andereVasteActiva: number;
  deelnemingen: number;
  vorderingenLangGroepsmaatschappijen: number;
  vorderingenLangParticipanten: number;
  overigeFinancieelVasteActiva: number;
  voorraden: number;
  onderhandenWerk: number;
  vorderingDebiteuren: number;
  vorderingenOmzetbelasting: number;
  vorderingenKortGroepsmaatschappijen: number;
  vorderingenKortParticipanten: number;
  vorderingenOverig: number;
  effecten: number;
  liquideMiddelen: number;
  gestortEnOpgevraagdKapitaal: number;
  informeelKapitaal: number;
  agioreserve: number;
  winstreserves: number;
  kostenEgalisatieReserve: number;
  herinvesteringsReserve: number;
  compartimenteringsreserve: number;
  overigeReserves: number;
  garantieVoorzieningen: number;
  pensioenVoorzieningen: number;
  oudedagsVoorzieningen: number;
  overigeVoorzieningen: number;
  schuldenLanglopendConvertibles: number;
  schuldenLanglopendObligaties: number;
  schuldenLanglopendGroepsmaatschappijen: number;
  schuldenLanglopendParticipanten: number;
  schuldenLanglopendKredietinstellingen: number;
  schuldenLanglopendOverig: number;
  crediteuren: number;
  schuldenOmzetbelasting: number;
  schuldenLoonheffingen: number;
  schuldenKortlopendGroepsmaatschappijen: number;
  schuldenKortlopendParticipanten: number;
  schuldenKortlopendOverig: number;
  nettoOmzet: number;
  wijzigingOnderhandenWerk: number;
  geactiveerdeProductieEigenBedrijf: number;
  overigeOpbrengsten: number;
  inkoopwaardeVerkopen: number;
  kostenUitbesteedWerk: number;
  lonenEnSalarissen: number;
  socialeLasten: number;
  pensioenLasten: number;
  overigePersoneelskosten: number;
  ontvangenVergoedingenEnSubsidies: number;
  afschrijvingenGoodwill: number;
  afschrijvingOverigeImmaterieleActiva: number;
  afschrijvingenGebouwen: number;
  afschrijvingenMachines: number;
  afschrijvingenOverig: number;
  autoEnTransportKosten: number;
  huisvestingsKosten: number;
  onderhoudsKosten: number;
  verkoopKosten: number;
  overigeKosten: number;
  financieleBaten: number;
  financieleLasten: number;
  resultaatDeelnemingen: number;
  buitengewoneBaten: number;
  buitengewoneLasten: number;

  [key: string]: any;
}


function throwException(message: string, status: number, response: string, headers: {
  [key: string]: any;
}, result?: any): Observable<any> {
  if (result !== null && result !== undefined)
    return _observableThrow(result);
  else
    return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
  return new Observable<string>((observer: any) => {
    if (!blob) {
      observer.next("");
      observer.complete();
    } else {
      let reader = new FileReader();
      reader.onload = event => {
        observer.next((event.target as any).result);
        observer.complete();
      };
      reader.readAsText(blob);
    }
  });
}
